// Portuguese (pt-BR) translations
// Key UI strings translated; falls back to Spanish (es) then Chinese (zh) for uncovered keys.
import es from './es';

const ptOverrides = {
  // Common actions
  save: "Salvar", cancel: "Cancelar", delete: "Excluir", edit: "Editar", add: "Adicionar",
  search: "Buscar", loading: "Carregando...", confirm: "Confirmar", close: "Fechar",
  clear: "Limpar", print: "Imprimir", export: "Exportar", all: "Todos",
  actions: "Ações", noData: "Sem dados", noResults: "Sem resultados",
  noSearchResult: "Nenhum produto encontrado",
  operationFailed: "Erro", addSuccess: "Adicionado", updateSuccess: "Atualizado",
  deleteSuccess: "Excluído", deleteFailed: "Erro ao excluir", loadFailed: "Erro ao carregar",
  deleteConfirm: "Confirmar exclusão?", fillCompleteInfo: "Preencha todos os campos",

  // Login page
  username: "Usuário", password: "Senha", login: "Entrar", logout: "Sair",
  deviceVerifyTitle: "Novo dispositivo: enviamos um código ao seu e-mail", deviceVerifyResent: "Código reenviado", deviceVerifyResend: "Reenviar código", deviceVerifyHelp: "Válido 10 minutos. Não chegou? O dono pode autorizar em «Dispositivos confiáveis», ou contate o suporte Sellox.", trustedDevicesMenu: "🔐 Dispositivos confiáveis", adminTabMerchantHint: "Comerciante? Use a aba «Login Comércio» (ID da loja + usuário + senha)", adminLogin: "Admin", tenantLogin: "Comerciante", posLogin: "PDV Caixa",
  posLoginHint: "Caixa - acesso direto ao PDV", enterPos: "Entrar no PDV",
  fillAllFields: "Preencha todos os campos",
  tenantIdLabel: "ID Comerciante", providedByAdmin: "Fornecido pelo admin",
  regFreeTrialLink: "Não tem conta? Teste grátis 7 dias",
  installApp: "Instalar App",
  installAppHint: "Abra no Chrome para instalar como App",
  offlineMode: "Modo Offline",
  offlineNoCache: "Sem conexão e sem cache - conecte e faça login primeiro",
  storeManagement: "Gestão de Lojas",

  // Basic navigation
  dashboard: "Painel", warehouseManagement: "Estoques",
  productManagement: "Produtos", transferManagement: "Transferências",
  customerManagement: "Clientes", supplierManagement: "Fornecedores",
  purchaseManagement: "Compras", salesManagement: "Vendas",
  onlineOrders: "Pedidos Online", reports: "Relatórios",
  exchangeRates: "Taxa de Câmbio", paymentSettings: "Config. Pagamentos",
  salesReport: "Relatório de Vendas",
  todaySales: "Vendas de Hoje", totalProducts: "Produtos",
  pendingOrders: "Pendentes", recentSales: "Vendas Recentes",
  quickActions: "Ações Rápidas",

  // ===== Super Admin · Multi-Country & Industry Switch =====
  scTitle: "🌍 Controle Global de Tenants",
  scTitleSub: "Multi-País / Super Admin",
  scTotalTenants: "Tenants Totais",
  scCountries: "Países Cobertos",
  scMonthRevenue: "Receita Global do Mês (USD)",
  scPluginsLive: "{total} plugins · {live} ativos",
  scMapTitle: "🗺 Mapa Global de Tenants",
  scMapHint: "Tamanho do círculo = Receita do mês (equiv. USD)",
  scTenantsUnit: "tenants",
  scOrdersUnit: "pedidos",
  scThisMonth: "este mês",
  scCurrency: "Moeda",
  scTimezone: "Fuso horário",
  scPluginsTitle: "💳 Registro de Plugins de Pagamento",
  scCountriesLabel: "Países",
  scByCountryTitle: "Tenants por País",
  scRefresh: "Atualizar",
  scThTenant: "Tenant",
  scThStatus: "Status",
  scIndustryPlaceholder: "⚡ Trocar ramo…",
  scIndustryTitle: "Trocar modelo de ramo",
  scIndustryConfirm: "Trocar este tenant para \"{industry}\"?\nSerão criadas categorias + ativados recursos do ramo (restaurante também cria 10 mesas). Dados existentes serão preservados.",
  scIndustryOk: "✅ {tenant} → {industry} (categorias +{cats}, mesas +{tables})",
  scIndustryFail: "Falha ao trocar de ramo",
  scCountryConfirm: "Trocar país do tenant para \"{country}\"?\nSerá sincronizado moeda / fuso / imposto / FX",
  scCountryOk: "Trocado · Novo FX: {fx}",
  scCountryFail: "Falha ao trocar de país",
  scFxRefreshed: "Câmbio atualizado",
  scFxRefreshFail: "Falha ao atualizar",
  scLoadFail: "Falha ao carregar",

  // ===== Industry templates =====
  tplProductsRestaurant: "🍽️ Cardápio / Pratos",
  tplProductsFastFood: "🥡 Cardápio",
  tplProductsClothing: "👕 Estilos",
  tplProductsPharmacy: "💊 Medicamentos",
  tplProductsBeauty: "💅 Serviços",
  tplCategoriesRestaurant: "📋 Categorias do cardápio",
  tplCategoriesClothing: "🏷️ Temporadas",
  tplCategoriesBeauty: "🏷️ Categorias de serviços",
  tplSalesRestaurant: "🧾 Contas de mesas",
  tplSalesBeauty: "🧾 Contas de serviços",
  tplMenuTables: "🍽️ Mesas",
  tplMenuKds: "👨‍🍳 Tela da cozinha",
  tplMenuAppointments: "💅 Agendamentos",
  tplMenuGiftCards: "🎫 Vales de compra",

  dashRestoTitle: "Mesas de hoje",
  dashRestoRevenue: "Receita no salão",
  dashRestoAvgTicket: "ticket méd.",
  dashRestoScanRate: "📱 Taxa de QR",
  dashRestoOnlineCount: "online",
  dashRestoWalkinCount: "POS na mesa",
  dashRestoTopTables: "🏆 Top 5 mesas",
  dashRestoNoData: "Sem dados hoje",
  dashRestoPeak: "⏰ Horários de pico",
  dashRestoUnit: "pedidos",
  dashRestoLoading: "Carregando dados...",

  dashExpiryTitle: "💊 Próximos do vencimento / Vencidos",
  dashExpiryLoading: "Carregando vencimentos...",
  dashExpiryAllGood: "✅ Todos produtos com validade",
  dashExpiryAllGoodSub: "Nada vence nos próximos 30 dias",
  dashExpiryExpired: "Vencidos",
  dashExpiryCritical: "≤ 7 dias",
  dashExpiryWarning: "≤ 30 dias",
  dashExpiryStock: "estoque",
  dashExpiryDays: "dias",
  dashExpiryExpiredDays: "Vencido há {n}d",
  dashExpiryMore: "+ {n} a mais... atender em /admin/products",

  dashApptsTitle: "💅 Agendamentos de hoje",
  dashApptsLoading: "Carregando...",
  dashApptsNone: "Sem agendamentos hoje",
  dashApptsGoto: "Adicionar →",
  dashApptsScheduled: "Pendente",
  dashApptsDone: "Atendido",
  dashApptsNoShow: "Não veio",
  dashApptsCancelled: "Cancelado",

  dashLoyalTitle: "🔄 Clientes fiéis · ≥2 visitas em 30d",
  dashLoyalLoading: "Carregando...",
  dashLoyalEmpty: "Sem fiéis ainda — peça o telefone no caixa!",
  dashLoyalReturning: "recorrentes · total",
  dashLoyalVisits: "visitas",
  dashLoyalAvg: "méd.",

  dashLeaderTitle: "🏆 Vales usados · 30d",
  dashLeaderLoading: "Carregando...",
  dashLeaderEmpty: "Nenhum vale usado em 30 dias",
  dashLeaderTotal: "vales · total aplicado",
  dashLeaderIssue: "usados",
  dashLeaderTopup: "recarga",

  apptPageTitle: "💅 Agendamentos",
  apptPrevWeek: "← Semana anterior",
  apptThisWeek: "Esta semana",
  apptNextWeek: "Próxima semana →",
  apptNew: "Novo agend.",
  apptTotal: "{n} agendamentos",
  apptToday: "Hoje",
  apptAddSlot: "+ Adicionar",
  apptCustomer: "Nome do cliente",
  apptCustomerPhone: "Telefone",
  apptService: "Serviço",
  apptStaff: "Profissional (opcional)",
  apptStart: "Hora de início",
  apptDuration: "Duração (min)",
  apptPrice: "Preço ($)",
  apptNote: "Observação",
  apptCreate: "Criar",
  apptCancel: "Cancelar",
  apptStatusScheduled: "Pendente",
  apptStatusDone: "Atendido",
  apptStatusNoShow: "Não veio",
  apptStatusCancelled: "Cancelado",
  apptCommissions: "Comissões",
  apptServicesDone: "Serviços",
  apptRevenue: "Receita",
  apptCommission: "Comissão",
  apptToPay: "A pagar",
  apptNoCommissionData: "Sem atendimentos concluídos este mês",
  apptCommissionHint: "Altere a % e salva automaticamente. Só contam atendimentos concluídos.",
  apptMarkDone: "Atendido",
  apptMarkNoShow: "Não veio",
  apptMarkCancelled: "Cancelar",
  apptDelete: "Excluir",
  apptUnassigned: "Sem profissional",
  apptMin: "min",
  apptCurrentStatus: "Status atual:",
  apptErrFill: "Preencha nome do cliente e serviço",
  apptOk: "✅ Agendamento criado",
  apptDelConfirm: "Excluir este agendamento?",

  // ===== Online shop =====
  shopErrPickTable: "Selecione sua mesa",
  shopErrNamePhone: "Informe nome e telefone",
  shopBannerDineIn: "No salão · {table}",
  shopBannerDineInUnset: "No salão · sem mesa",
  shopBannerTakeout: "Retirada / Pickup",
  shopBannerDelivery: "Entrega",
  shopPickTable: "escolha a mesa",
  shopTablePrefix: "Mesa {n}",
  shopChange: "alterar",
  shopChkDineInTitle: "{table} · Dados",
  shopChkTakeoutTitle: "Retirar no restaurante",
  shopOrderTypeTitle: "Como deseja seu pedido?",
  shopOrderTypeDineIn: "🍽️ Comer aqui (No salão)",
  shopOrderTypeDineInSub: "Comer em uma mesa do restaurante",
  shopOrderTypeTakeout: "🥡 Retirada (Takeout)",
  shopOrderTypeTakeoutSub: "Retirar no restaurante",
  shopOrderTypeDelivery: "🛵 Entrega (Delivery)",
  shopOrderTypeDeliverySub: "Entregamos no seu endereço",
  shopRetailModeTitle: "Como quer receber sua compra?",
  shopRetailPickup: "🏪 Retirar na loja",
  shopRetailPickupSub: "Peça e retire na loja, sem frete",
  shopRetailDeliverySub: "Entregamos no seu endereço",

  // 📦 Rastreio de Lotes / FIFO
  lotsMenuLabel: "📦 Lotes (FIFO)",
  lotsPageTitle: "📦 Rastreio de Lotes (saída FIFO)",
  lotAdd: "Adicionar lote",
  lotEdit: "Editar lote",
  lotNo: "Nº do lote",
  lotNoAutoGen: "Em branco = auto",
  lotQtyRemaining: "Restante",
  lotQtyUsed: "Usado",
  lotActive: "Lotes ativos",
  lotExpired: "Vencidos",
  lotCritical: "≤ 7 dias",
  lotWarning: "≤ 30 dias",
  lotOk: "OK",
  lotExpiringSoon: "Vencendo (30d)",
  lotProductsTracked: "Produtos com lote",
  lotRecalled: "Recall",
  lotRecallConfirm: "Fazer recall deste lote? A quantidade será zerada.",
  lotTraceability: "Rastreabilidade / Recall",
  lotNoSales: "Este lote ainda não foi vendido.",
  lotSearchPlaceholder: "Buscar produto / lote...",
  lotEmpty: "Sem lotes. Adicione manualmente ou receba uma compra com lote/validade.",
  lotFieldsRequired: "Produto, depósito e quantidade obrigatórios",
  lotCreated: "Lote criado",
  warehouseAll: "Todos os depósitos",
  expiry: "Validade",

  // 🎯 RFM + WhatsApp em massa
  rfmMenuLabel: "🎯 RFM + Disparo",
  rfmTitle: "🎯 Segmentação RFM + Disparo WhatsApp",
  rfmSegment: "Segmento",
  rfmRecency: "Recência",
  rfmFrequency: "Visitas",
  rfmMonetary: "Gasto",
  rfmAllSegments: "Todos os segmentos",
  rfmSegmentHint: "Clique em um segmento para selecionar todos os clientes e pré-carregar uma mensagem.",
  rfmSearchPlaceholder: "Buscar nome / telefone...",
  rfmEmpty: "Sem clientes com vendas no período.",
  rfmShowingFirst: "Mostrando primeiros 500 — afine o filtro para ver mais.",
  rfmBroadcast: "Disparo WhatsApp",
  rfmSelectFirst: "Selecione clientes primeiro",
  rfmWaNotReady: "WhatsApp Web não conectado.",
  rfmWaWarning: "WhatsApp Web não conectado. Escaneie o QR em [📱 WhatsApp Auto] antes.",
  rfmComposeMessage: "Redigir disparo",
  rfmRecipientCount: "Destinatários",
  rfmTemplateHint: "Dica: use {name} para inserir o primeiro nome do cliente.",
  rfmPlaceholder: "Olá {name}! 20% OFF neste fim de semana 🎉",
  rfmPreview: "Pré-visualização (com María):",
  rfmSendNow: "Enviar agora",
  rfmJobRunning: "Disparo em andamento...",
  rfmBroadcastStarted: "🚀 Disparo iniciado",
  rfmBroadcastDone: "✅ Disparo concluído",
  rfmMessageRequired: "Mensagem vazia",
  rfmWindow30: "Últimos 30 dias",
  rfmWindow60: "Últimos 60 dias",
  rfmWindow90: "Últimos 90 dias",
  rfmWindow180: "Últimos 180 dias",
  rfmWindow365: "Último ano",
  rfmAiTitle: "✨ Gerador IA de Mensagens (GPT-5.2)",
  rfmAiSubtitle: "Gera 3 mensagens WhatsApp com base no seu ramo + segmento + comportamento de compra",
  rfmAiHintPlaceholder: "Opcional: Dia das Mães / Novidades / Especial de fim de semana...",
  rfmAiGenerate: "Gerar",
  rfmAiInsightsLabel: "IA viu",
  rfmAvgSpend: "gasto médio",
  rfmAvgVisits: "visitas médias",
  rfmAiNoVariants: "IA não retornou variantes — tente de novo",
  rfmAiError: "IA falhou — verifique saldo da Universal Key",
  rfmAiVariantPicked: "Selecionada",
    rfmSegChampions: "👑 Campeões",
    rfmSegLoyal: "❤️ Fiéis",
    rfmSegPotentialLoyalists: "📈 Potenciais Fiéis",
    rfmSegNewCustomers: "🆕 Novos",
    rfmSegPromising: "✨ Promissores",
    rfmSegNeedAttention: "⚠️ Precisam de Atenção",
    rfmSegAtRisk: "🚨 Em Risco",
    rfmSegHibernating: "🌙 Hibernando",
    rfmSegOthers: "👥 Outros",
  grossSales: "Venda bruta",
  shiftReconcile: "🔧 Reconciliar (do registro)",
  shiftReconcileConfirm: "Recalcular os totais deste turno a partir do registro?",
  shiftReconcileForceClose: "Também forçar fechamento?",
  shiftReconcileDone: "✅ Reconciliado",

  // 🏆 Desempenho da equipe
  staffPerfMenu: "🏆 Desempenho da equipe",
  staffPerfTitle: "🏆 Desempenho da equipe — Detalhe",
  staffPerfEmployees: "Funcionários",
  staffPerfOrders: "Pedidos",
  staffPerfGross: "Vendas brutas",
  staffPerfRefunds: "Devoluções",
  staffPerfNet: "Vendas líquidas",
  staffPerfAvg: "Ticket médio",
  staffPerfRate: "Taxa %",
  staffPerfEarnings: "Comissão $",
  staffPerfCommission: "Comissão total",
  staffPerfTopProducts: "Top 3 produtos",
  staffPerfEmpty: "Sem vendas no período.",
  allStores: "Todas as lojas",
  from: "De",
  to: "Até",
  pointsLookup: "Consulta de Pontos", pointsHistory: "Histórico de Pontos",
  memberCode: "Código de Membro",
  unitPcs: 'e',
  plan_basic: "Básico", plan_pro: "Pro", plan_enterprise: "Empresa",
  plan_lifetime_1: "Básico · 1 loja (vitalício)", plan_lifetime_2: "Negócio · 2 lojas (vitalício)", plan_lifetime_4: "Empresa · 4 lojas (vitalício)", plan_lifetime_6: "Premium · ilimitadas (vitalício)", plan_lifetime_5: "Empresa · 11 lojas (vitalício, legado)",
  plan_trial: 'Teste',
  upgradePlan: 'Plano de atualização',
  upgradePlanCurrent: 'Plano Atual',
  upgradePlanTo: 'Atualizar para',
  upgradePlanConfirm: 'Confirmar atualização',
  upgradePlanSuccess: 'Plano atualizado com sucesso',
  upgradePlanCurrentLimits: 'Limites atuais',
  upgradePlanUsers: 'usuários',
  upgradePlanStores: 'lojas',
  upgradePlanUnlimited: 'Ilimitado',
  deleteTenant: 'Excluir inquilino',
  deleteTenantWarning: 'Todos os dados do inquilino serão excluídos permanentemente e não poderão ser recuperados!',
  deleteEnterPassword: 'Digite a senha do administrador para confirmar',
  deletePasswordWrong: 'Senha incorreta, exclusão cancelada',
  deleteTenantConfirm: 'Confirmar exclusão',
  shopUrl: 'URL da loja',
  paymentSettings: "Configurações Pagamentos", salesReport: "Relatório de Vendas",
  saasManagement: "SaaS Commerce", adminManual: "Manual do administrador", videoTutorials: "Tutoriais em vídeo", userManual: "Manual do usuário",
  productCode: "Código", productName: "Nome",
  unit: "Unidade", costPrice: "Custo", margin: "Margem",
  price1: "Preço 1",
  boxQuantity: "Quantidade/Caixa", status: "Status",
  addProduct: "Adicionar Produto", editProduct: "Editar Produto", priceSettings: "Preços",
  marginFormula: 'Custo x (1 + Margem%)',
  searchProduct: 'Pesquisar produto...',
  importProducts: "Importar Produtos", selectFile: "Selecionar Arquivo",
  supportedFormats: "Formatos Suportados", importSuccess: "Importação bem sucedida",
  importFailed: "Erro de importação", downloadTemplate: "Baixar modelo",
  importCount: "Quantidade", skipDuplicate: "Ignorar duplicatas", overwriteDuplicate: "Substituir",
  duplicateHandling: "Gerenciamento de duplicatas", startImport: "Iniciar importação",
  importing: 'Importando...',
  created: 'novo',
  posTitle: "POS", shift: "Shift",
  openShift: "Abrir turno", openingCashFloat: "Fundo de caixa inicial", openingCashHint: "Quanto dinheiro há no caixa agora para troco? Será descontado ao fechar o turno.",
  startShift: "Iniciar turno", endShift: "Fechar turno", noShift: "Sem turno",
  shiftSince: "Mudança de", salesOrder: "Ordem de Venda",
  products: "Produtos", priceType: "Tipo de preço",
  unitPrice: "P. Unidade.", total: "Total",
  sendToCashier: "📨 Enviar ao caixa", checkout: "Coletar", scanOrSearch: "Verificar código / Pesquisar produto...",
  box: "Caixa",
  paymentMethod: "Forma de pagamento", giftCard: "🎫 Vale de compra",
  received: "Recebido", change: "Alterar", confirmPayment: "Confirmar Pagamento", orderComplete: "Pedido Concluído",
  storeCode: "Código da Loja", storeName: "Nome da Loja", addStore: "Adicionar Loja",
  editStore: "Editar Loja",
  physicalStore: "Loja Física", onlineStore: "Loja Online",
  selectWarehouse: 'Selecione Armazenamento',
  warehouseCode: "Código do Armazém", warehouseName: "Nome do Armazém", addWarehouse: "Adicionar Armazém",
  setMainWarehouse: "Armazém Principal",
  reservedQty: "Quantidade reservada", availableQty: "Qty reservada\". Disponível",
  noInventoryData: "Sem dados de inventário",
  customerCode: "Código do Cliente", customerName: "Nome do Cliente", addCustomer: "Adicionar Cliente",
  searchCustomerPlaceholder: 'Pesquisar cliente...',
  memberLevel: "Nível de associação",
  normal: "Normal", vip: "VIP",
  supplierCode: "Código do Fornecedor", addSupplier: "Adicionar Fornecedor",
  contact: 'Contato',
  createPurchaseOrder: "Nova Ordem de Compra", orderNo: "Não. Pedido", itemCount: "Itens",
  purchaseNoProducts: 'Não há produtos. Adicione produtos primeiro no Gerenciamento de Produtos',
  purchaseBatchSelect: 'Selecione produtos (seleção múltipla)',
  purchaseBatchAdd: 'Adicionar lote ao pedido',
  purchaseAddedItems: 'Artigos adicionados',
  purchaseItemsAdded: 'artigos adicionados',
  purchaseSelectAtLeastOne: 'Selecione pelo menos um produto',
  purchaseNotesPlaceholder: 'Notas (opcional)',
  transferBatchSelect: 'Selecione os produtos a serem transferidos (seleção múltipla)',
  transferBatchConfirm: 'Transferência em lote',
  transferSelectAtLeastOne: 'Selecione pelo menos um produto',
  transferNoStock: 'Não há produtos em estoque neste armazém',
  transferSelectWarehouseFirst: 'Selecione primeiro um armazenamento de origem',
  transferQty: 'Quantidade',
  reportCurrency: 'Moeda',
  reportBoth: 'Ambos',
  reportExchangeRate: 'Taxa de câmbio atual',
  reportUsdSales: 'Vendas em dólares americanos',
  reportBsSales: 'Vendas em Bolívares',
  dbBusinessOverview: 'Resumo do negócio',
  dbPurchaseIn: 'Compras',
  dbTotalPO: 'Total de OCs',
  dbReceived: 'Recebido',
  dbPendingReceive: 'Brincos',
  dbTotalPurchaseItems: 'Total de itens',
  dbTotalPurchaseAmount: 'Montante total',
  dbDamageLoss: 'Danos/Perdas',
  dbLossRecords: 'Registros',
  dbLossQty: 'Valor perdido',
  dbLossValue: 'Valor perdido',
  dbRetailSales: 'Vendas no Varejo',
  dbTotalOrders: 'Total de pedidos',
  dbTotalItems: 'Total de itens',
  dbTotalRevenue: 'Receita total',
  dbWholesale: 'Atacado',
  dbCompleted: 'Concluído',
  dbPending: 'Brincos',
  dbTotalPaid: 'Pago',
  dbUnpaid: 'sem pagar',
  dbPaidToSupplier: 'Pago a fornecedores',
  dbSupplierDebt: 'Dívida com Fornecedores',
  poRecordPay: 'Cadastrar Pagamento',
  poPayAmount: 'Valor do pagamento',
  poPayAll: 'Pague integralmente',
  poPaySuccess: 'Pagamento registrado',
  posStockLookup: 'Consulta de estoque',
  posReserved: 'Reservado',
  posAvailable: 'Disponível',
  posMinStock: 'Estoque Mínimo',
  posOutOfStock: 'Fora de estoque',
  posLowStock: 'Estoque baixo',
  allWarehouses: "Todos os Armazéns", totalQuantity: "Qtd. Total",
  posCartEmpty: 'Clique nos produtos à esquerda',
  posNeedShift: 'Comece um turno antes de receber o pagamento',
  totalAmount: "Total", createTime: "Criado",
  receiveGoods: "Receber",
  selectSupplier: "Selecione Fornecedor", selectProduct: "Selecione Produto",
  receiveWarehouse: "Loja Recebedora", createSuccess: "Criada",
  addItems: 'Adicionar artigos',
  otherPayment: "Outro",
  newTransfer: "Nova Transferência", sourceWarehouse: "Fonte",
  targetWarehouse: "Destino", transferConfirm: "Confirmar",
  inventoryOverview: "Estoque por Armazém", transferHistory: "Histórico",
  stock: "Estoque",
  sameWarehouseError: 'Origem e destino não podem ser os mesmos',
  transferSuccess: "Transferência bem-sucedida", transferFailed: "Erro de transferência",
  salesReportTitle: "Relatório de Vendas", storeFilter: "Filtrar Loja",
  dateFrom: "De", dateTo: "Para", generateReport: "Gerar",
  printReport: "Imprimir Relatório", totalSales: "Total de Vendas", totalOrders: "Total de Pedidos", avgPerOrder: "Média", byCurrency: "Por Moeda", byPaymentMethod: "Por Método de Pagamento",
  totalItems: "Total de Itens", storeSalesDetail: "Detalhe por Loja",
  productSalesDetail: "Detalhe por Produto",
  salesAmount: "Quantidade", topProducts: "Mais vendidos",
  shopTitle: "Loja Online", myOrders: "Meus Pedidos", addToCart: "Adicionar ao Carrinho",
  cart: "Carrinho", checkoutTitle: "Checkout", orderSuccess: "Pedido realizado com sucesso",
  orderLookup: "Pedido de pesquisa", orderNumber: "Não. Pedido",
  shippingInfo: "Envio", paymentInfo: "Pagamento",
  online: "Online", offline: "Off-line", offlineMode: "Modo Off-line",
  cachedData: "Cache", offlineCacheMode: "Modo offline - usando dados em cache, os pedidos são sincronizados na reconexão",
  pendingSync: "Pendente", syncNow: "Sincronizar", syncSuccess: "Sincronizado",
  offlineWarning: 'Modo offline - os dados serão sincronizados na reconexão',
  location: "Localização",
  retail: "Loja",
  name: "Nome", contactPhone: "Telefone", email: "E-mail",
  purchaseOrder: "Ordem de Compra",
  received_status: "Recebido",
  language: "Idioma",
  discount: "Desconto", orderDetail: "Detalhes do pedido",
  paid: "Pago",
  customer: "Cliente",
  systemSettings: "Sistema de configurações", stockAlerts: "Alertas de estoque", stockTaking: "Inventário físico",
  stockLoss: "Encolhimento", stockLossManagement: "Gerenciamento de encolhimento", newStockLoss: "Novo encolhimento", stockLossSuccess: "Encolhimento registrado",
  stockLossSearchProduct: "Pesquisar produto...", stockLossQty: "Quantidade", stockLossReason: "Motivo",
  stockLossNotePlaceholder: "Notas Adicionais (opcional)", stockLossCostEstimate: "Perda Estimada", confirmStockLoss: "Confirmar Perda",
  stockLossOnlyManagers: "Somente gerentes/administradores podem registrar perdas", totalLossRecords: "Registros", totalLossQty: "Quantidade Total",
  totalCostLoss: "Perda total", costLoss: "Perda", allReasons: "Todos os motivos",
  companyName: "Nome da empresa", taxId: "RIF", companyAddress: "Endereço", companyPhone: "Telefone",
  invoiceHeader: "Cabeçalho da fatura", printFormat: "Formato de impressão",
  shopTheme: "Tema da loja online", businessType: "Tipo de negócio", shopDescription: "Descrição da loja (na capa)", shopDescPlaceholder: "Ex: Produtos frescos todos os dias", shopPreview: "Visualização do link",
  themeSupermarket: "Supermercado",
  uploadBackground: "Plano de fundo do upload (recomendado 1920x800, máximo de 5 MB)", selectImage: "Selecionar imagem", uploadSuccess: "Carregado com sucesso",
  autoPrint: "Impressão automática", printSuccess: "Enviado para impressora", scannerEnabled: "Digitalizar",
  printerConfig: "Opções da impressora", posReceiptPrinter: "Impressora de recibos (POS)", reportPrinter: "Impressora de relatório", fiscalPrinter: "Impressora fiscal",
  printerName: "Nome da impressora", connectionPort: "Porta de conexão", paperSize: "Tamanho do papel",
  thermal: "Termica", enableCashDrawer: "Habilitar gaveta de dinheiro", printItemCode: "Imprimir código (apenas impostos)",
  silentPrintTip: "Configurações Impressão silenciosa (sem caixa de diálogo)", setDefaultPrinter: "Definir impressora POS como padrão no Windows", downloadShortcut: "Baixar atalho, colocar na área de trabalho e clicar duas vezes", closeAllBrowserFirst: "Usar processo independente, não há necessidade de fechar outras janelas do navegador",
  chromeKioskTip: "Adicione --kiosk-printing ao atalho do Chrome, por exemplo:", autoPrintTip: "O sistema imprime automaticamente após o pagamento",
  reportPrinterDesc: "Para imprimir relatórios de vendas, inventário e outros documentos A4", testPrint: "Imprimir Teste",
  qzNotConnected: "Impressão silenciosa não conectada - Instale QZ Tray", download: "Download",
  wholesaleEnabled: "Atacado",
  refund: "Return", refundReason: "Motivo", holdOrder: "Colocar de lado", recallOrder: "Recuperar",
  dailySettlement: "Fechamento Diário", grossProfit: "Lucro Bruto",
  permission: "Permissão", canDiscount: "Pode Desconto", canRefund: "Pode Devolver", maxDiscount: "Desconto\". Máximo",
  wholesale: "Atacado", createWholesaleOrder: "Criar pedido de atacado",
  receipt80mm: "Bilhete 80mm", printReceipt: "Imprimir", reprintReceipt: "Reimprimir",
  bestSellers: "Mais vendidos", slowSellers: "Menos vendidos", systemQty: "Qtd. Sistema",
  difference: "Diferença", enterQty: "Insira a Quantidade.",
  systemRates: "Taxas do Sistema", categoryRates: "Taxas por Categoria",
  categoryRateDesc: 'Configurar taxa de câmbio por categoria',
  usdPricingMode: 'Modo de preço em USD',
  originalUsd: 'USD Original (Mercado Negro)',
  bsToUsd: 'Bs÷BCV (taxa oficial)',
  originalUsdDesc: 'Cobranças de PDV em dólares americanos pelo preço original do produto',
  bsToUsdDesc: 'Cobranças de PDV em dólares americanos usando preço Bs ÷ taxa BCV',
  productRate: "Product Rate", productRateDesc: "Taxa para converter preços $ em Bs",
  salesExchangeRate: "Taxa de vendas", salesExchangeRateDesc: "Taxa de PDV/fatura (sincronização BCV)",
  salesRate: "Taxa de Vendas", salesRateDesc: "Ao faturar em $, calcule o valor em USD a ser cobrado (Fórmula: Preço × Taxa de Vendas ÷ Taxa do Produto)",
  noSalesRates: 'Não há taxas de vendas. Clique em Adicionar.',
  localSymbol: "Símbolo Local", saveRates: "Salvar Tarifas",
  quickConverter: "Conversor Rápido",
  bankTransfer: "Transferência Bancária", mobilePay: "Pagamento Móvel",
  bankName: "Banco", accountNumber: "Número da conta",
  accountHolder: "Titular da conta", idNumber: "Cedula",
  selectBank: "Selecione Banco", saveSettings: "Salvar configurações", settingsSaved: "Config. Salvo",
  saveFailed: "Erro ao salvar",
  transferData: "Dados de transferência", mobilePayData: "Dados de pagamento móvel",
  bank: "Banco",
  whatsappContact: 'Contate o WhatsApp',
  whatsappNumber: 'Número do WhatsApp',
  whatsappHint: 'Insira o número com o código do país, sem + ou espaços',
  whatsappEnabled: 'Os clientes poderão entrar em contato com você pelo WhatsApp após fazer um pedido',
  casheaBNPL: "Compre agora, pague depois", casheaDesc: "O cliente parcela sem juros através do Cashea",
  casheaCedula: "ID do Cliente", casheaAmount: "Valor Cashea",
  casheaProcessing: "Processando com Cashea...", casheaSettingsDesc: "Compre agora, pague depois - parcelado sem juros",
  casheaKeyHint: 'Sem chave API funciona em modo de demonstração. Solicite em support@cashea.com',
  casheaDemoMode: "Modo de demonstração ativo - os pagamentos são aprovados automaticamente", casheaLiveMode: "Modo real ativo - conectado com Cashea",
  saving: 'Salvando...',
  notes: 'Notas',
  printReceipt80mm: "Imprimir boleto", printInvoiceA4: "Imprimir fatura",
  printPriceLabels: "Etiquetas de preço", printPreview: "Pré-visualização",
  labelDisplayMode: "Mostrar etiqueta", labelModeP1: "Preço 1 (Detal)", labelModeP3: "Preço 3 (maior)", labelModeWholesale: "Preço à vista (maior)", labelModeP1P3: "Preço 1 + Preço 3", labelModeP1W: "Preço 1 + Preço da caixa", labelModeUsdP1: "Preço USD 1 (Detal)", labelShowForeign: "Mostrar USD ($)", labelNoDecimals: "Sem decimais", labelShowBarcode: "Mostrar código", labelPaperSize: "Papel", labelSize80mm: "80mm Térmico", labelSize50x30: "50x30mm Label", labelBilingual: "Bilíngue (ES+CN)",
  selectProducts: 'Selecione produtos',
  deselectAll: "Desmarcar tudo", selectedCount: "Selecionado",
  printSelected: "Imprimir selecionado",
  connectPrinter: "Conectar impressora", directPrintFailed: "Falha na impressão direta",
  pricingMode: "Modo Preço", margin: "Margem", totalSales: "Total de Vendas",
  pricingLocalBased: 'Calcular a partir do preço local',
  pricingLocalDesc: 'Bs.=Custo×Taxa de departamento, USD=Bs.÷Taxa de vendas (taxa paralela)',
  pricingForeignDirect: 'Use preço direto na moeda',
  pricingForeignDesc: 'Use preços em USD armazenados diretamente (taxa BCV)',
  refundHistory: "Histórico de retorno", refundReason: "Motivo", addExpense: "Adicionar Despesa", totalExpenses: "Despesas Totais", avgOrder: "Tíquete Médio", selectStore: "Selecionar Loja",
  profitAnalysis: "Análise de Lucro",
  profitMargin: "Margem", totalRevenue: "Receita Total",
  totalCost: "Custo Total", totalProfit: "Lucro Total",
  categoryAnalysis: "Análise de categoria/taxa", categoryBreakdown: "Por categoria", dailyBreakdown: "Detalhamento diário",
  govtGoods: "Produtos de taxa oficial", blackMarketGoods: "Produtos do mercado negro", rateLabel: "Taxa:", blackMarket: "Mercado negro",
  salesUsd: "Vendas ($)", salesBs: "Vendas (Bs)", costUsd: "Custo ($)", profitUsd: "Lucro ($)",
  thisWeek: "Esta semana", thisMonth: "Este mês", lastMonth: "Último mês",
  today: "Hoje", allStores: "Todos", categoryName: "Categoria", exchangeRate: "Taxa",
  orders: "Pedidos",
  grossProfit: 'Lucro Bruto',
  expenseBreakdown: "Expense Breakdown", lossBreakdown: "Detalhamento de Danos",
  damage: "Danos", personalUse: "Uso pessoal",
  rateType: "Taxa", selectedRate: "Taxa Selecionada", usdEquivalent: "Equivalente em USD",
  expenseRent: "Aluguel",
  expenseMaintenance: "Manutenção",
  exchangeProfit: "Troco de ganhos", buyUsdCash: "Comprar dinheiro em USD", cardToCash: "Cartão para dinheiro",
  usdAmount: "Valor em USD", buyRate: "Taxa de compra", sellRate: "Taxa de venda",
  cardAmount: "Valor do cartão(Bs)", cashGiven: "Dinheiro dado(Bs)", bsCost: "Custo Bs", bsValue: "Valor Bs",
  profitBs: "Lucro(Bs)", profitUsd: "Lucro($)", commissionPct: "Comissão",
  todayProfitBs: "Lucro de hoje(Bs)", todayProfitUsd: "Lucro de hoje($)",
  exchangeProfitDetail: "Change Gain Detail", cashMustBeLess: "O dinheiro deve ser menor que o valor do cartão",
  note: 'Nota',
  purchaseHistory: "Histórico de compras", totalSpent: "Total gasto", orderCount: "Pedidos",
  addPoints: "Adicionar Pontos", redeemPoints: "Resgatar Pontos", topupBalance: "Recarregar", pointsLog: "Histórico de Pontos",
  balanceLog: "Saldo Histórico",
  auditLog: "Log de auditoria", targetType: "Tipo", targetId: "ID do destino",
  detail: "Detalhe",
  promotions: "Promoções", promoName: "Nome", promoType: "Tipo",
  discount_promo: "Desconto", fullReduction: "Poupança", buyGet: "Buy & Go", flashSale: "Oferta Flash",
  startDate: "Data de início", endDate: "Data de término", minAmount: "Valor mínimo",
  discountValue: "Valor com desconto", addPromotion: "Adicionar promoção",
  accountsReceivable: 'Contas a Receber", contas a Pagar: "Contas a Pagar',
  receivable: "A receber",
  dueDate: "Data de Vencimento", paidAmount: "Pago",
  markPaid: "Marcar como pago", addReceivable: "Adicionar cobrança", addPayable: "Adicionar pagamento",
  partialPaid: 'Parcial',
  dataBackup: "Backup de dados", exportBackup: "Exportar backup", backupDesc: "Exportar dados como JSON",
  salesTrend: "Tendência", trendUp: "Up", trendDown: "Down", trendFlat: "Estável",
  rolePermissions: "Permissões", admin: "Admin", store_manager: "Gerente de loja", price_checker: "Verificador de preços\"", stock_viewer: "Consulta de estoque",
  discountAboveCostOnly: "Não inferior ao custo",
  marketing: 'Comercialização',
  mktDesc: 'Campanhas de e-mail, SMS e notificações de clientes',
  mktNewCampaign: 'Novo sino',
  mktCreateCampaign: 'Criar campanha',
  mktCampaigns: 'Sinos',
  mktNoCampaigns: 'Nenhuma campanha criada',
  mktNameRequired: 'Nome e mensagem são obrigatórios',
  mktCampaignCreated: 'Campanha criada',
  mktSentTo: 'Enviado para {count} clientes',
  mktSendError: 'Erro ao enviar',
  mktDeleted: 'Eliminado',
  mktName: 'Nome',
  mktType: 'Tipo',
  mktSegment: 'Segmento',
  mktSubject: 'Assunto',
  mktMessage: 'Mensagem',
  mktVariablesHint: 'Variáveis: {nome}, {telefone}, {pontos}',
  mktSend: 'Enviar',
  mktRecipients: 'destinatários',
  mktAllCustomers: 'Todos os clientes',
  mktVipCustomers: 'Clientes VIP',
  mktInactiveCustomers: 'Clientes inativos (mais de 30 dias)',
  mktBirthdayToday: 'aniversário hoje',
  mktNamePlaceholder: 'Promoção de fim de semana',
  mktSubjectPlaceholder: 'Oferta especial para você',
  mktMessagePlaceholder: 'Olá {nome}, temos uma oferta especial...',
  mktEmail: 'E-mail',
  mktSms: 'SMS',
  mktWhatsapp: 'WhatsApp',
  mpLoginRequired: 'Faça login',
  mpSearchPlaceholder: 'Pesquisar...',
  mpAllCategories: 'tudo',
  mpLoading: 'Carregando...',
  mpNoResults: 'Nenhum resultado',
  mpItems: 'itens',
  mpTotal: 'Total',
  mpEmpty: 'vazio',
  mpCharge: 'Seja pago',
  mpPaymentTitle: 'Pagamento',
  mpCash: 'Dinheiro',
  mpCard: 'Cartão',
  mpTransfer: 'Transferência',
  mpZelle: 'Zelle',
  mpPagoMovil: 'Pagamento Móvel',
  mpConfirm: 'Confirmar',
  mpSaleComplete: 'Venda concluída',
  exportSalesReport: "Vendas de exportação", exportInventoryReport: "Exportar estoque",
  exporting: 'Exportando...',
  usePoints: "Usar pontos", pointsAvailable: "Disponível", pointsEarned: "Pontos ganhos",
  pointsDiscount: "Pontos de Desconto", pointsIssued: "Pontos Emitidos", pointsRecon: "Conciliação de Pontos", pointsMonthly: "Relatório Mensal de Pontos", pointsVoidClaw: "Estorno por Anulação", pointsRefundClaw: "Estorno por Devolução", pointsRestoreUsed: "Pontos Usados Devolvidos", pointsManualAdjust: "Ajuste Manual", last6Months: "Últimos 6 Meses", pointsRate: "Taxa de Pontos", noCustomerNoPoints: "Selecione o cliente para usar os pontos",
  clerkLimitTitle: "Limite Diário do Atendente AI da Loja", clerkLimitDesc: "Evita que visitantes esgotem seus créditos; acima do limite o cliente é direcionado ao WhatsApp (0 = sem limite)", featBgRemove: "Remover Fundo", featBeautify: "Melhorar Foto Pro", featRetouch: "Retocar Foto Pro", featPoster: "Poster AI", featBanner: "Banner AI", featLegalChat: "Assessor Jurídico", featPayroll: "Folha de Pagamento AI",
  vipRules: "Regras VIP", autoUpgrade: "Atualização automática", minSpent: "Gasto mínimo", pointsMultiplier: "Multiplicador",
  silver: "Prata", vip: "VIP", normal: "Normal",
  wholesaleStats: "Estatísticas de atacado", totalRevenue: "Receita total",
  totalPaid: 'Total pago',
  deliveryAddress: "Endereço de entrega", deliveryDate: "Data de entrega", orderNotes: "Notas",
  markCompleted: "Concluído", markDelivered: "Entregue", cancelOrder: "Cancelar pedido",
  wholesalePrice: "Preço de atacado", paidAmount: "Pago",
  unpaidAmount: "Pendente", recordPayment: "Registrar Pagamento", paymentAmount: "Valor do Pagamento",
  orderCancelled: "Pedido Cancelado", statusPending: "Pendente", statusCompleted: "Concluído",
  statusDelivered: "Entregue", statusCancelled: "Cancelado", printOrder: "Pedido de impressão",
  wholesaleCustomer: "Cliente atacadista", itemCount: "Itens",
  attendance: "Atendimento", clockIn: "Entrada", clockOut: "Saída",
  salesTarget: "Meta de Vendas", targetAmount: "Meta", progress: "Progresso",
  setTarget: "Definir meta",
  purchaseReturn: "Devolução de compra", returnReason: "Motivo",
  bundles: "Combos", bundleName: "Nome do Combo", bundlePrice: "Preço do Combo", originalPrice: "Preço Original",
  fixedItems: "Itens Fixos", addGroup: "Adicionar Grupo",
  addOptionalGroup: "Adicionar grupo opcional", groupName: "Nome do grupo", defaultOption: "Opção padrão",
  optGroupHint: 'Adicione pelo menos 2 opções. O cliente escolhe um por grupo.',
  optGroupNeedTwoOptions: 'Você precisa de pelo menos 2 opções',
  addBundleHint: 'Crie combos para aumentar o ticket médio',
  comboAnalytics: "Análise de Vendas de Combos", comboOrders: "Pedidos Combo", comboRevenue: "Receita Combo",
  comboOrderRatio: "do total de pedidos", activeCombos: "Combos Ativos", avgComboValue: "Valor Médio",
  comboRanking: "Ranking de Vendas Combos", comboSalesDistribution: "Distribuição de Vendas",
  comboTrend: "Tendência de Vendas de Combos", optionStats: "Estatísticas de Opções",
  comboRankingTable: "Detalhe de vendas de combos", noComboSalesYet: "Sem dados de vendas de combos",
  createComboHint: 'Os dados aparecem ao criar combos e vender',
  addToCart: "Adicionar ao carrinho",
  noItems: "Nenhum item fixo", noOptGroups: "Nenhum grupo opcional",
  costHistory: "Histórico de custos", stockLow: "Estoque baixo",
  overdueAccount: "Conta vencida",
  uploadImage: "Carregar imagem", deleteImage: "Excluir imagem", restoreBackup: "Restaurar backup",
  restoreDesc: "Restaurar dados do arquivo JSON", restoreWarning: "A restauração substituirá os dados atuais",
  commission: "Comissão",
  baseTier: "Base", standardTier: "Padrão",
  commissionRate: 'Taxa", estimativa Comissão: "Est. Comissão.',
  totalCommission: "Comissão Total", tier: "Nível", selectMonth: "Selecionar Mês",
  addEmployee: 'Adicionar funcionário',
  role: "Função", deleteEmployeeConfirm: "Excluir este funcionário?",
  rolePresetHint: 'Função (clique para aplicar permissões)',
  permPOS: "POS", permDiscount: "Desconto", permRefund: "Reembolso", permVoid: "Cancelar",
  permProducts: "Produtos", permInventory: "Inventário", permPurchases: "Compras",
  permCustomers: "Clientes", permReports: "Relatórios", permExport: "Exportar",
  permCostPrice: "Preço Custo", permEmployees: "Funcionários", permSettings: "Configurações",
  permEditOrders: 'Editar Pedidos',
  permDescEditOrders: 'Modificar itens de pedidos concluídos (auditado)',
  permTakeOnline: 'Atender Pedidos Online', permDescTakeOnline: 'Aceitar pedidos online/atacado, confirmar, imprimir documentos e despachar no POS',
  permPromotions: 'Promoções',
  permDescPOS: "Use POS Checkout", permDescDiscount: "Aplicar descontos", permDescRefund: "Processar devoluções",
  permDescVoid: "Transações anuladas", permDescProducts: "Adicionar/editar produtos, somar estoque", permDeleteProducts: "Excluir / baixar estoque", permDescDeleteProducts: "Excluir ou desativar produtos, baixar estoque, perdas — sem isso só pode adicionar",
  permDescInventory: "Gerenciar estoque", permDescPurchases: "Criar pedidos de compra",
  permDescCustomers: "Gerenciar clientes", permDescReports: "Ver relatórios de vendas",
  permDescExport: "Exportar dados para Excel", permDescCostPrice: "Ver preços de custo",
  permDescEmployees: "Gerenciar Funcionários", permDescSettings: "Configurações do Sistema", permDescPromotions: "Gerenciar Promoções",
  permGroupPOS: "POS", permGroupCatalog: "Catálogo", permGroupCRM: "CRM",
  permGroupReports: "Relatórios", permGroupSystem: "Sistema",
  passwordKeepHint: 'deixe vazio para guardar',
  enabledCount: 'habilitado',
  maxDiscountPercent: 'Desconto Máximo',
  superAdmin: 'Superadministrador',
  shops: 'Lojas',
  shop: 'Loja',
  changePassword: 'Alterar senha',
  oldPassword: 'Senha atual',
  newPassword: 'Nova senha',
  confirmNewPassword: 'Confirmar senha',
  passwordChanged: 'Senha alterada',
  passwordMismatch: 'As senhas não coincidem',
  taxReport: 'Relatório Fiscal',
  analyticsCenter: 'Centro de Análise',
  acOverview: 'Resumo',
  acCustomerAnalysis: 'Análise do cliente',
  acCategoryAnalysis: 'Análise por categoria',
  acTrendAnalysis: 'Análise de tendências',
  acRevenue: 'Renda',
  acOrders: 'Pedidos',
  acAvgOrder: 'Pedido médio',
  acCustomers: 'Clientes',
  acRevenueTrend: 'Tendência de receita',
  acTotalCustomers: 'Total de clientes',
  acActiveCustomers: 'Clientes ativos',
  acActivityRate: 'Taxa de atividade',
  acTopCustomersChart: 'Os 10 principais clientes por gastos',
  acCustomerRanking: 'Classificação do cliente',
  acTotalRevenue: 'Receita total',
  acCategoryCount: 'Categorias',
  acTopCategory: 'Melhor categoria',
  acCategoryShare: 'Participação por categoria',
  acCategoryRevenue: 'Receita por categoria',
  acCategoryDetail: 'Detalhe por categoria',
  acProductCount: 'Produtos',
  acShare: 'Participação',
  acPeakHour: 'Horário de pico',
  acPeakDay: 'Melhor dia',
  acHourlySales: 'Vendas por hora',
  acWeekdaySales: 'Vendas por dia da semana',
  acExportProfit: 'Ganhos de exportação',
  ac_week: 'Esta semana',
  ac_month: 'Este mês',
  ac_year: 'Este ano',
  acDayUnit: 'd',
  acDays: 'dias',
  acLast: 'Mais recente',
  shiftReports: 'Turnos',
  shiftReport: 'Relatório de turno',
  shiftStart: 'Hora de início',
  shiftEnd: 'Hora de término',
  shiftDuration: 'Duração',
  shiftCount: 'Turnos',
  shiftActive: 'Ativo',
  shiftEnded: 'Concluído',
  shiftTxCount: 'Transações',
  shiftTxCount2: 'transações',
  shiftSalesDetail: 'Detalhe de vendas',
  shiftReconciliationPrint: 'Conciliação detalhada (POS/caixa)',
  printA4: 'Imprimir A4',
  printTicket: 'Imprimir cupom',
  exportExcel: 'Exportar Excel',
  poInvoiceNo: 'Nº fatura / guia do fornecedor (opcional)',
  shiftNetTotal: 'Total líquido',
  shiftEndConfirmMsg: 'Um relatório de reconciliação detalhado será gerado',
  shiftGenerateReport: 'Gerar relatório',
  saTotal: 'Alertas totais',
  saCritical: 'Crítico',
  saWarning: 'Alerta',
  saOutOfStock: 'Fora de estoque',
  saLowStock: 'Estoque baixo',
  saValueAtRisk: 'Valor em risco',
  saCurrentStock: 'Estoque atual',
  saMinStock: 'Estoque mínimo',
  saShortage: 'faltando',
  saSuggestedOrder: 'Ordem sugerida',
  saOrderCost: 'Custo do pedido',
  saLevel: 'Nível',
  saItemsAffected: 'produtos precisam de atenção',
  saTotalSuggestedCost: 'Custo total sugerido',
  saBatchThreshold: 'Limites de lote',
  saBatchThresholdDesc: 'Ajuste os limites mínimos de estoque',
  saUpdated: 'Atualizado',
  saAllGood: 'Tudo de bom',
  saAllGoodDesc: 'Todos os produtos têm estoque suficiente',
  saAlertBanner: 'Alerta de estoque',
  saAutoReorder: 'Pedido Automático',
  saAutoReorderDesc: 'Selecione o fornecedor e o armazém para gerar o pedido de compra automaticamente.',
  saSelectSupplier: 'Selecione o fornecedor',
  saSelectWarehouse: 'Selecione Armazém',
  saSelectSupplierWarehouse: 'Selecione fornecedor e armazém',
  saGeneratePO: 'Gerar pedido de compra',
  saPoGenerated: 'Pedido de compra gerado:',
  supplier: 'Fornecedor',
  dbCustomize: 'Personalizar',
  dbEditing: 'Edição',
  dbResetLayout: 'Redefinir',
  dbDragHint: 'Arraste para mover, cantos para redimensionar',
  emailReports: 'Relatórios por e-mail',
  erSmtpConfig: 'E-mail de configurações',
  erSmtpHost: 'Servidor SMTP',
  erSmtpPort: 'Porto',
  erSmtpUser: 'Usuário',
  erSmtpPassword: 'Senha',
  erSenderEmail: 'E-mail do remetente',
  erSenderName: 'Nome do remetente',
  erTestEmail: 'Enviar teste',
  erTestSent: 'E-mail de teste enviado',
  erConfigSaved: 'Configurações salvas',
  erConfigured: 'E-mail configurado',
  erNotConfigured: 'E-mail não configurado',
  erConfigHint: 'Configure o SMTP para ativar relatórios por e-mail',
  erAddSchedule: 'Adicionar agendamento',
  erReportType: 'Tipo de relatório',
  erFrequency: 'Frequência',
  erRecipients: 'Destinatários',
  erAddRecipient: 'Adicionar destinatário',
  erDaily: 'Diário',
  erWeekly: 'Semanalmente',
  erMonthly: 'Mensalmente',
  erDailySales: 'Resumo diário de vendas',
  erProfitSummary: 'Resumo de ganhos',
  erSendNow: 'Enviar agora',
  erSentTo: 'Enviado para',
  erLastSent: 'Última remessa',
  erDisabled: 'Desativado',
  erNoSchedules: 'Sem programação',
  erNoSchedulesDesc: 'Adicione programações para envio automático de relatórios',
  mobilePOS: 'PDV móvel',
  mpSelectStore: 'Selecione a loja para começar',
  mpViewCart: 'Ver carrinho',
  mpCart: 'Carrinho',
  mpEmptyCart: 'carrinho vazio',
  mpCheckout: 'Pagar',
  mpPayment: 'Pagamento',
  mpConfirmPay: 'Confirmar pagamento',
  backToAdmin: 'Retornar ao administrador',
  transfer: 'Transferência',
  clearCart: 'Vazio',
  acStoreComparison: 'Comparação de lojas',
  acStoreCount: 'Lojas',
  acTopStore: 'Melhor Loja',
  acStoreRevenue: 'Comparação de Renda',
  acStoreDetail: 'Detalhes da loja',
  editQty: 'Editar quantidade',
  editPrice: 'Editar preço',
  uiThemeTitle: 'Tema da interface',
  uiThemeHint: 'Aplica-se a toda a loja: caixas e painel',
  accentColorLabel: 'Cor de destaque (botões / realces)',
  defaultColor: 'Verde padrão',
  customColor: 'Cor personalizada',
  uiThemeSaveHint: '👆 Clique para pré-visualizar. Não esqueça de Salvar para aplicar em toda a loja',
  aiLegalAdvisor: 'Assessor Jurídico IA',
  editPriceNeedAuth: 'Autorização para alterar preço (QR ou senha)',
  usdPriceHint: 'Preço USD (Bs ÷ taxa)',
  bsPriceLabel: 'Preço Bs.',
  usdPriceLabel: 'Preço $ USD',
  priceBelowCostConfirm: 'Preço abaixo do custo! Continuar?',
  shortcutHint: 'Setas para selecionar, F5 editar quantidade, F6 editar preço',
  splitPayment: "Pagamento dividido", addNote: "Nota", itemNote: "Nota do produto", orderNote: "Nota do pedido",
  enterNote: "Insira a nota...", enterOrderNote: "Insira a nota do pedido...", clearNote: "Limpar",
  noSugar: "Sem Açúcar", lessIce: "Little Ice", extraHot: "Extra Spicy", noOnion: "Sem Cebola", takeaway: "Para Levar",
  exact: "Exatamente", addPaymentMethod: "Adicionar forma de pagamento",
  loyaltyProgram: 'Programa de fidelidade',
  loyaltyDesc: 'Gerencie níveis, regras de pontos e recompensas',
  loyaltyTiers: 'Níveis de adesão',
  loyaltyMembers: 'Total de membros',
  loyaltyTotalPoints: 'Total de pontos',
  loyaltyIssued30d: 'Pontos emitidos (30d)',
  loyaltyRedeemed30d: 'Pontos resgatados (30d)',
  loyaltyLevelDist: 'Distribuição por Nível',
  loyaltyTopMembers: 'Classificação de pontos',
  loyaltyRecentActivity: 'Atividade recente',
  loyaltyAddTier: 'Adicionar nível',
  loyaltyTierColor: 'Cor do nível',
  loyaltyPointsConfig: 'Regras de pontos',
  loyaltyEarnRate: 'Taxa de lucro',
  loyaltyPtsPerDollar: 'pontos/$',
  loyaltyRedeemRate: 'Taxa de câmbio',
  loyaltyPtsEqDollar: 'pontos = $ 1',
  loyaltyBonusConfig: 'Configurações de títulos',
  loyaltyWelcomeBonus: 'Bônus de boas-vindas',
  loyaltyWelcomeBonusDesc: 'Ganhe pontos ao registrar um novo cliente',
  loyaltyBirthdayBonus: 'Bônus de aniversário',
  loyaltyBirthdayBonusDesc: 'Ganhe pontos no aniversário do cliente',
  loyaltyReferralBonus: 'Bônus de indicação',
  loyaltyReferralBonusDesc: 'Ganhe pontos por indicar novos clientes',
  salesChannels: 'Canais de vendas',
  salesChannelsDesc: 'Visualize desempenho e tendências por canal de vendas',
  channel_pos: 'Detalhe do PDV',
  channel_online: 'Loja on-line',
  channel_wholesale: 'Atacado',
  channelGrandTotal: 'Total geral',
  channelShare: 'Participação por Canal',
  channelRevenue: 'Receita por canal',
  channelTrend: 'Tendência por canal',
  channelDetails: 'Detalhe do canal',
  channelName: 'Canal',
  loyaltyQrCode: 'Consulta QR Code',
  loyaltyQrCodeDesc: 'Imprima este QR para que os clientes possam consultar seus pontos',
  loyaltyQrLink: 'Link de consulta',
  loyaltyQrPrint: 'Captura de tela e impressão para contador',
  loyaltyNoTenant: 'Primeiro crie um negócio',
  selectTenant: 'Selecione Empresa',
  copied: 'Copiado',
  pointsMall: 'Loja de pontos',
  pointsMallDesc: 'Gerencie produtos resgatáveis e pedidos de resgate',
  mallItems: 'Produtos',
  mallOrders: 'Pedidos',
  mallAddItem: 'Adicionar produto',
  mallEditItem: 'Editar produto',
  mallNoItems: 'Nenhum produto, clique para adicionar',
  mallType_coupon: 'Cupom',
  mallType_gift: 'Presente',
  mallType_balance: 'Recarga de saldo',
  mallStock: 'Inventário',
  mallUnlimited: 'Ilimitado',
  mallRedeemed: 'Resgatado',
  mallFillRequired: 'Preencha o nome e os pontos obrigatórios',
  mallPerLimit: 'Limite por cliente',
  mallCouponSettings: 'Cupom de configurações',
  mallCouponType: 'Tipo de cupom',
  mallDiscountAmount: 'Valor do desconto',
  mallDiscountPercent: 'Porcentagem de desconto',
  mallMinOrder: 'Pedido Mínimo',
  mallValidDays: 'Dias de Validade',
  mallBalanceSettings: 'Recarga de configurações',
  mallBalanceAmount: 'Valor de recarga',
  mallGiftSettings: 'Presente de configurações',
  mallGiftInfo: 'Descrição do presente',
  mallGiftInfoPlaceholder: 'Ex: Retire o presente na loja',
  mallItemName: 'Nome do produto',
  mallComplete: 'Completo',
  mallStatus_pending: 'Pendente',
  mallStatus_completed: 'Concluído',
  mallStatus_cancelled: 'Cancelado',
  active: 'Ativo',
  inactive: 'Inativo',
  mallTimed: 'Limitado',
  mallTimedSale: 'Venda relâmpago',
  mallStartTime: 'Hora de início',
  mallEndTime: 'Hora de término',
  mallUploadImage: 'Carregar imagem',
  mallPendingUpload: 'Carregar ao salvar',
  mallImageHint: 'JPG/PNG/WebP, quadrado recomendado',
  memberNormal: "Membro", memberSilver: "Silver", memberGold: "Gold", memberVip: "VIP",
  memberPhonePlaceholder: "Digite o número de telefone", memberCodePlaceholder: "Digite o código",
  memberInvalidLink: "Link inválido", memberNotFound: "Membro não encontrado", memberSearchFailed: "Falha na pesquisa",
  memberRedeemSuccess: "Resgatado!", memberRedeemFail: "Falha ao resgatar",
  memberInsufficient: "Pontos insuficientes", memberSoldOut: "Esgotado", memberLimitReached: "Limite atingido",
  memberMyProfile: "Perfil", memberMallTab: "Loja de Pontos", memberOrdersTab: "Histórico",
  memberPointsEarn: "Pontos ganhos", memberPointsRedeem: "Pontos resgatados",
  memberTimedEnded: "Terminado", memberTimedNotStarted: "Não iniciado", memberRedeemBtn: "Resgatar",
  memberTrialExpired: "Expirado", memberTrialDays: "Teste {dias}d",
  memberTrialRemaining: '{days} dias restantes',
  memberUpgradeProgress: "Progresso", memberNeedSpend: "Falta gasto", memberMaxLevel: "Nível máximo",
  mallFlashSale: "Venda Flash",
  vidCatPos: "PDV", vidCatProducts: "Produtos", vidCatInventory: "Inventário",
  vidCatSales: "Vendas", vidCatCustomers: "Clientes", vidCatReports: "Relatórios",
  vidCatSettings: "Configuração", vidCatGeneral: "Outros",
  vidRecStart: "Gravação iniciada!", vidRecFail: "Não é possível gravar",
  vidUploadSuccess: "Vídeo enviado!", vidUploadFail: "Erro ao enviar",
  vidDeleteConfirm: "Excluir vídeo?", vidDeleted: "Excluído", vidDeleteFail: "Falha ao excluir",
  vidUpdated: "Atualizado", vidUpdateFail: "Erro ao atualizar",
  vidUploadBtn: "Enviar vídeo", vidUploading: "Enviando...",
  vidRecHint: 'Execute as ações e clique em Parar',
  vidNoData: 'Clique em Gravar para criar um tutorial ou Carregar vídeo',
  vidTitleLabel: "Título", vidDefaultTitle: "Tutorial", vidVideoTitle: "Título do vídeo",
  vidSaveUpload: 'Salvar e fazer upload',
  startRecording: "Iniciar gravação", stopRecording: "Parar gravação",
  vidPreviewTitle: 'Visualização',
  vidGenerating: 'Gerando vídeos tutoriais...',
  vidGenerateBtn: 'Gerar tutoriais',
  vidGeneratingBtn: 'Gerando...',
  vidGenerateSuccess: 'Tutoriais gerados!',
  vidGenerateFail: 'Erro ao gerar',
  vidGenerateDesc: 'Gravação automática de operações e geração de vídeos tutoriais com narração.',
  vidProgress: 'Progresso',
  vidGenerateComplete: 'Gravação completa!',
  done: "Concluído",
  tenantManagement: 'Gestão de inquilinos',
  addTenant: 'Adicionar inquilino',
  totalTenants: 'Total de inquilinos',
  activeTenants: 'Inquilinos Ativos',
  inactiveTenants: 'Locatários Inativos',
  tenantName: 'Nome do inquilino',
  tenantBusinessName: 'Nome comercial',
  contactPerson: 'Pessoa de contato',
  details: 'Detalhes',
  plan: 'Plano',
  subSubscription: 'Assinatura',
  subAlerts: 'Alertas de assinatura',
  subExpired: 'Expirado',
  subExpiringSoon: 'Para vencer',
  subActive: 'Ativo',
  subNone: 'Não configurado',
  subExpiringSoonList: 'Previsto em breve',
  subExpiredList: 'Inquilinos expirados',
  subDaysLeft: 'restante',
  subExpiryDate: 'Data de expiração',
  subRenew: 'Renovar',
  subSuspend: 'Suspender',
  subActivate: 'Ativar',
  subAnnualRevenue: 'Renda Anual',
  subStartDate: 'Data de início',
  subYears: 'Anos de assinatura',
  subYear: 'ânus',
  subAnnualFee: 'Taxa Anual',
  subNote: 'Nota',
  subNotePlaceholder: 'Notas de assinatura...',
  subTrialAccount: 'Conta de teste',
  subTrialDays: 'Dias de teste',
  subAdminAccount: 'Conta de administrador',
  subStatus: 'Status da assinatura',
  subCurrentExpiry: 'Expiração Atual',
  subRenewYears: 'Anos de Renovação',
  subConfirmRenew: 'Confirmar renovação',
  subTrial: 'Teste',
  subDashExpiring: 'Alerta de expiração',
  subDashDesc: 'Os seguintes inquilinos estão prestes a expirar ou já expiraram',
  subCopyReminder: 'Lembrete de cópia',
  subReminderCopied: 'Mensagem de lembrete copiada',
  subRenewReminder: 'Lembrete de renovação',
  subLastReminded: 'Último lembrete',
  trialTitle: 'Fim do período de teste',
  trialSubTitle: 'Assinatura expirando',
  trialExpiredBadge: 'expirou',
  trialRemaining: 'restante',
  trialOverdue: 'derrotado',
  trialExpiredMsg: 'Seu acesso expirou. Entre em contato com seu administrador para renovar e continuar usando todos os recursos.',
  trialExpiringMsg: 'Renove a tempo para garantir um serviço contínuo. Todos os seus dados serão preservados.',
  trialProducts: 'Produtos',
  trialCustomers: 'Clientes',
  trialSales: 'Pedidos',
  trialRevenue: 'Renda',
  trialStores: 'Lojas',
  trialSeeValue: 'Veja as conquistas do seu negócio',
  trialValueTitle: 'Suas conquistas',
  trialValueMsg: 'Tem {produtos} produtos, atendeu clientes de {clientes}, concluiu transações de {vendas} com receita total de ${receita}. Todos esses dados valiosos continuarão a atendê-lo após a renovação.',
  trialAnnualFee: 'Taxa Anual',
  trialContactAdmin: 'Entre em contato com seu administrador para renovar. Todas as funções estarão disponíveis imediatamente. Seus dados estão seguros!',
  regTitle: 'Experimente Sellox grátis',
  regSubtitle: 'Teste gratuito de 7 dias, sem cartão de crédito',
  regCompanyName: 'Nome da empresa/loja',
  regCompanyPlaceholder: 'Digite o nome da sua empresa ou loja',
  regContactPerson: 'Pessoa de contato',
  regContactPlaceholder: 'seu nome',
  regContactPhone: 'Telefone',
  regPhonePlaceholder: 'número de telefone',
  regAccountSection: 'Configure sua conta de administrador',
  regAdminUsername: 'Usuário administrador',
  regUsernamePlaceholder: 'Pelo menos 3 caracteres',
  regPassword: 'Senha',
  regConfirmPassword: 'Confirmar senha',
  regPasswordMismatch: 'As senhas não coincidem',
  regPasswordTooShort: 'A senha deve ter pelo menos 6 caracteres',
  regTrialNote: 'Inscreva-se para um teste gratuito de 7 dias com acesso total. Entre em contato conosco para atualizar ao final do teste.',
  regSubmit: 'Cadastre-se agora',
  regBackToLogin: 'Você já tem uma conta? Voltar ao login',
  regSuccess: 'Cadastro realizado com sucesso!',
  regSuccessTitle: 'Registro concluído',
  regSuccessDesc: 'Sua conta de teste está pronta. Salve as seguintes informações',
  regTrialPeriod: 'Período de teste',
  regDays: 'dias',
  regSaveCredentials: 'Lembre-se do seu ID de comerciante e nome de usuário - você precisará deles para fazer login. Recomendamos fazer uma captura de tela.',
  regGoLogin: 'Vá para Entrar',
  regCopied: 'Copiado para a área de transferência',
  creditManagement: 'Gestão de Crédito',
  referralRewards: 'Recompensas por indicação',
  categoryImportSuccess: 'Departamentos importados com sucesso',
  enterCategoryName: 'Insira o nome da categoria',
  addCategory: 'Adicionar categoria',
  catCode: 'Código',
  catNameRequired: 'Nome',
  catRateLabel: 'Taxa de câmbio',
  catNote: 'Notas',
  systemRate: 'Taxa do sistema',
  usdByRate: 'USD (Taxa',
  receiptSentEmail: 'Recibo enviado para e-mail',
  sendFailed: 'Erro ao enviar',
  changeFailed: 'Erro ao alterar',
  confirmChange: 'Confirmar alteração',
  importDepartments: 'Categorias de importação',
  downloadDeptTemplate: 'Baixar modelo de categoria',
  editWarehouse: 'Editar armazém',
  deleteWarehouseConfirm: 'Confirmar exclusão desta loja?',
  cannotDeleteMainWarehouse: 'Não é possível excluir a loja principal',
  warehouseHasStock: 'O armazém tem estoque, não pode ser excluído',
  credit: 'Crédito',
  creditPayment: 'Crédito',
  selectCustomerForCredit: 'Você deve selecionar um cliente para pagamento de crédito',
  creditRecorded: 'Crédito registrado',
  paymentCurrencyLabel: 'Moeda de pagamento',
  bsPayment: 'Pague em Bs',
  usdPayment: 'Pague em $',
  selectPrinter: 'Selecione a impressora:',
  scanQrReceipt: 'Cliente escaneia QR em busca de recibo digital',
  emailSendReceipt: 'Enviar recibo por correio',
  bsPaid: 'Pagamento em Bs',
  usdPaid: 'Pagamento em $',
  invalidLink: 'Link inválido',
  receiptNotFound: 'Recibo não encontrado ou expirado',
  paymentSuccess: 'Pagamento bem-sucedido',
  orderNoLabel: 'Pedido #',
  customerLabel: 'Cliente',
  discountLabel: 'Desconto',
  subtotalLabel: 'Total',
  bsReference: 'Bs. ref.',
  paymentMethodLabel: 'Método de pagamento',
  thankYou: 'Obrigado pela sua compra',
  pmCash: 'Dinheiro',
  pmCard: 'Cartão',
  pmTransfer: 'Transferência',
  pmMixed: 'Misto',
  creditManage: 'Gestão de Crédito',
  newCredit: 'Novo crédito',
  totalCreditAmount: 'Crédito total',
  creditRecovered: 'Recuperado',
  creditOutstanding: 'Pendente',
  creditPendingCount: 'Brincos',
  debtRanking: 'Classificação da dívida',
  creditCount: 'registros',
  searchCustomerName: 'Pesquisar cliente...',
  creditStatusPending: 'Não pagamento',
  creditStatusPartial: 'Parcial',
  creditStatusPaid: 'Pago',
  creditCustomer: 'Cliente',
  creditAmount: 'Valor do crédito',
  creditPaid: 'Pago',
  creditBalance: 'Equilíbrio',
  creditDate: 'Data',
  creditStatus: 'Estado',
  creditAction: 'Ações',
  repayment: 'Pagamento',
  repaymentRecord: 'Histórico de pagamentos:',
  noCreditRecord: 'Sem registros de crédito',
  selectCustomerRequired: 'Selecione um cliente',
  enterAmount: 'Insira o valor',
  creditAdded: 'Crédito registrado',
  enterRepayAmount: 'Insira o valor do pagamento',
  repaySuccess: 'Pagamento bem-sucedido',
  repayAmount: 'Valor do pagamento',
  repayMethod: 'Método de pagamento',
  remarkLabel: 'Notas',
  remarkPlaceholder: 'Opcional...',
  monthlyGoods: 'por exemplo Mercadoria de março...',
  selectedLabel: 'Selecionado',
  importDemoData: 'Importar dados de demonstração',
  demoDataImported: 'Dados de demonstração importados',
  copyCatalogLink: 'Copiar catálogo de links',
  catalogLinkCopied: 'Link para o catálogo copiado',
  extraBarcodes: 'Códigos de barras extras',
  importProductsLabel: 'Importar produtos',
  deptIdAsRate: 'ID da categoria como taxa',
  deptIdAsRateDesc: 'Use a coluna ID da categoria como taxa de câmbio, converta o preço Bs em $ ($ = Bs / taxa)',
  deptImportFormat: 'Formato da categoria: código, nome, taxa, pedido',
  deptImportExample: 'por exemplo C001, Caixa, 600, 1',
  allOrders: 'Todos os pedidos',
  normalView: 'Visualização normal',
  adminVerify: 'Verificação de administrador',
  enterPinToView: 'Digite o PIN do administrador para visualizar todos os pedidos',
  showAllOrders: 'Mostrar todos os pedidos',
  pinError: 'PIN incorreto',
  refundAmountLabel: 'Valor do reembolso',
  refundReasonPlaceholder: 'Motivo da devolução (opcional)',
  enterOrderNumber: 'Insira o número do pedido',
  refundOnlyManagers: 'Somente gerentes/administradores podem processar devoluções',
  refundSearchHint: 'Ou pesquise seu histórico de pedidos',
  refundKeywordPlaceholder: 'Número do pedido, produto, cliente...',
  refundSearchOrders: 'Pedidos de pesquisa',
  refundResultsFound: 'pedidos encontrados',
  refundClickToSelect: 'clique para selecionar',
  refundSearchTip: 'Insira o número do pedido diretamente ou pesquise por nome do produto, data, etc.',
  back: 'Voltar',
  promoDiscount: 'Desconto',
  promoFullReduction: 'Compre e economize',
  promoBuyGet: 'Compre e leve',
  promoFlashSale: 'Oferta relâmpago',
  promoStatusInactive: 'Inativo',
  promoStatusEnded: 'Concluído',
  promoStatusPending: 'Próximo',
  promoStatusActive: 'Ativo',
  promoEnabled: 'Ativado',
  promoDisabled: 'Desativado',
  promoAllActivities: 'Todas as promoções',
  promoActiveCount: 'Ativo',
  promoUpcomingCount: 'Próximos',
  promoName: 'Nome da promoção',
  promoType: 'Tipo',
  promoContent: 'Detalhes da oferta',
  promoScope: 'Candidatar-se a',
  promoTime: 'Duração',
  promoDiscountTitle: 'Promoção de desconto',
  promoDiscountDesc: 'Desconto percentual em produtos. ex: 20% de desconto',
  promoDiscountFieldVal: 'Desconto (%)',
  promoDiscountFieldValHint: 'Porcentagem de desconto. ex: 20 = 20% de desconto',
  promoDiscountFieldMin: 'Min. Quantidade ($)',
  promoDiscountFieldMinHint: 'Compra mínima necessária. 0 = sem mínimo',
  promoDiscountExample: 'Exemplo: 20% de desconto -> Desligado=20, Mínimo=0',
  promoFullRedTitle: 'Compre e economize',
  promoFullRedDesc: 'Gaste o valor mínimo, receba redução fixa. ex: Gaste $ 100, economize $ 10',
  promoFullRedFieldAmt: 'Poupança ($)',
  promoFullRedFieldAmtHint: 'Valor a ser reduzido em dólares',
  promoFullRedFieldMin: 'Min. Despesa ($)',
  promoFullRedFieldMinHint: 'Despesa mínima exigida',
  promoFullRedExample: 'Exemplo: Gaste $ 50, economize $ 5 -> Poupança = 5, Mínimo = 50',
  promoBuyGetTitle: 'Compre e leve grátis',
  promoBuyGetDesc: 'Compre uma quantidade específica e receba gratuitamente. ex: Compre 2 Ganhe 1',
  promoBuyQty: 'Quantidade de compra',
  promoBuyQtyHint: 'Quantidade para comprar',
  promoGetQty: 'Quantidade grátis',
  promoGetQtyHint: 'Quantidade grátis',
  promoBuyGetExample: 'Exemplo: Compre 3 Ganhe 1 -> Compre = 3, Grátis = 1',
  promoFlashTitle: 'Oferta relâmpago',
  promoFlashDesc: 'Preço especial durante o período. Você deve definir datas',
  promoFlashPrice: 'Preço da oferta ($)',
  promoFlashPriceHint: 'Preço durante a promoção',
  promoFlashMinHint: 'N/A, deixe 0',
  promoFlashExample: 'Exemplo: Fones de ouvido $ 65 -> Oferta = 39,9',
  promoNamePlaceholder: 'ex: 20% de desconto, gaste $ 100, economize $ 10...',
  promoDiscountValLabel: 'Desconto (%)',
  promoPayPercent: 'Pagar',
  promoMinSpendLabel: 'Min. Despesa ($)',
  promoMinAmtLabel: 'Min. Quantidade ($)',
  promoReductionAmtLabel: 'Poupança ($)',
  promoOrigPriceRef: 'Preço Original ($)',
  promoOptionalDisplay: 'Opcional, apenas para exibição',
  promoStartDate: 'Data de início',
  promoEndDate: 'Data de término',
  promoApplyScope: 'Candidatar-se a',
  promoAllProducts: 'Todos os produtos',
  promoByCategory: 'Por categoria',
  promoByProduct: 'Por produto',
  promoSelectCategories: 'Selecione categorias:',
  promoMinOneCategory: 'Selecione pelo menos uma categoria',
  promoSelectProducts: 'Selecione os produtos:',
  promoSearchProduct: 'Pesquise por nome ou código',
  promoSelectedProducts: 'Selecionado',
  promoProducts: 'produtos',
  promoMinOneProduct: 'Selecione pelo menos um produto',
  promoDescription: 'Descrição (opcional)',
  promoDescPlaceholder: 'Notas adicionais...',
  promoPreview: 'Visualização:',
  promoFullDiscountLabel: 'toda a loja',
  promoLimitedOffer: 'Oferta relâmpago',
  promoCategories: 'categorias',
  enterPromoName: 'Insira o nome da promoção',
  setPromoDate: 'Defina datas de início e término',
  endBeforeStart: 'A data de término não pode ser anterior à data de início',
  discountRange: 'O desconto deve estar entre 1-100',
  fullRedMinRequired: 'Comprar e Economizar requer valor mínimo',
  enterReductionAmt: 'Insira o valor da poupança',
  setFlashPrice: 'Definir preço de oferta',
  editPromotion: 'Editar promoção',
  addPromotionDialog: 'Adicionar promoção',
  fullRedLabel: 'Gaste $',
  fullRedOff: 'Economize $',
  buyLabel: 'Comprar',
  getLabel: 'carrega',
  specifiedCats: 'Por categoria',
  merchantId: 'ID do comerciante',
  barcode: 'Código de barras',
  specification: 'Especificação/Peso',
  specPlaceholder: 'ex: 500g, 1L, XL...',
  currentId: 'ID atual',
  merchantIdDesc: 'Usado para links para catálogo, loja online, etc. Você deve fazer login novamente após alterar.',
  changeMerchantId: 'Alterar ID do comerciante',
  newId: 'Novo ID',
  merchantIdRule: '4 a 20 caracteres, apenas letras minúsculas, números, hifens e sublinhados',
  changeIdWarning: 'Você deve fazer login novamente após a alteração. A loja online e os links também mudarão.',
  merchantIdPlaceholder: 'ex: minha-loja-001',
  b2bPortal: "Atacado B2B",
  crossStoreInventory: "Inventário cruzado", pushPrices: "Atualizar preços", topProducts: "Mais vendidos",
  b2bCustomers: "Clientes B2B", creditLimit: "Limite de crédito", paymentTerms: "Prazo de pagamento",
  outstanding: "Pendente", customerType: "Tipo de Cliente",
  retailCustomer: "Varejista",
  totalStores: "Total de Lojas", todaySalesAll: "Vendas Hoje", weekSalesAll: "Semana de Vendas",
  monthSalesAll: "Mês de Vendas", storePerformance: "Desempenho das Lojas", storeName: "Loja",
  storeAddress: "Address", noStoresYet: "Nenhuma loja ainda",
  pushPriceSuccess: "Preços atualizados", selectProductsFirst: "Selecionar produtos",
  batchPriceUpdate: "Preços de lote",
  applyPriceChanges: "Aplicar alterações", priceUpdated: "Preços atualizados",
  smartRestock: "Reabastecer", restockSuggestions: "Sugestões", salesVelocity: "Velocidade de Vendas",
  dailyAvgSales: "Média Diária.", daysUntilStockout: "Dias para Estoque",
  suggestedQty: "Quantidade sugerida", urgencyLevel: "Urgência",
  urgencyCritical: "Esgotado", urgencyUrgent: "Urgente", urgencyWarning: "Alerta", urgencyLow: "Baixo",
  urgencyOk: "Normal", analysisPeriod: "Período",
  totalRestockCost: "Custo Total", restockItems: "Produtos para Reabastecer",
  speedFast: "Rápido", speedMedium: "Médio", speedSlow: "Lento", speedDead: "Sem movimento",
  generatePO: "Gerar Ordem de Compra", exportRestockList: "Exportar Lista",
  currentStock: 'Estoque atual',
  periodSold: 'Vendido no Período',
  importToCategory: "Importar para categoria", importSelectCategory: "Selecionar categoria", importCategoryHint: "Todos os produtos serão atribuídos a esta categoria", noCategoryAssign: "Não atribuído (usar do arquivo)",
  importFieldSelect: "Campos a Importar", importFieldHint: "Informações básicas (código, nome, especificação) são sempre importadas", allCategories: "Todas as categorias",
  storeManagerPanel: "Painel do Gerenciador", dailySummary: "Resumo Diário", viewInventory: "Inventário",
  printDailySummary: "Imprimir Resumo", viewOrderDetail: "Ver detalhes do pedido",
  transferManagement: "Transferências", newTransferOrder: "Nova Transferência", transferOrderNo: "Não. Transferência",
  fromWarehouse: "Armazém de Origem", toWarehouse: "Armazém de Destino", totalQuantity: "Quantidade Total",
  pendingReceive: "Pendente",
  sentQuantity: "Quantidade enviada", confirmReceive: "Confirmar recebimento",
  receiveSuccess: "Recebido", createAndPrint: "Criar e Imprimir", selectWarehouse: "Selecionar Armazém",
  addProducts: "Adicionar produtos", searchProduct: "Pesquisar produto...",
  accountNumber: 'Número da conta',
  accountsPayable: 'Contas a pagar',
  action: 'Ação',
  activeCombos: 'Combos Ativos',
  actual: 'Verdadeiro',
  actualQty: 'Quantidade real',
  add: 'Adicionar',
  addCustomer: 'Adicionar cliente',
  addExpense: 'Adicionar despesa',
  addGroup: 'Adicionar grupo',
  addNote: 'Adicionar nota',
  addPayable: 'Adicionar por pagamento',
  addPaymentMethod: 'Adicionar forma de pagamento',
  addPromotion: 'Adicionar promoção',
  addReceivable: 'Adicionar para coletar',
  addStore: 'Adicionar loja',
  addSuccess: 'Adicionado com sucesso',
  addSupplier: 'Adicionar fornecedor',
  addWarehouse: 'Adicionar armazém',
  address: 'Endereço',
  adminManual: 'Manual do administrador',
  all: 'tudo',
  allCategories: 'Todas as categorias',
  allReasons: 'Todas as razões',
  amount: 'Quantidade',
  amountRequired: 'Quantidade necessária',
  analysisPeriod: 'Período de análise',
  approve: 'Aprovar',
  associatedWarehouse: 'Armazém Associado',
  availableQty: 'Quantidade disponível',
  avgComboValue: 'Valor médio de combinação',
  avgOrder: 'Pedido médio',
  backupDesc: 'Descrição do backup',
  balance: 'Equilíbrio',
  batchDelete: 'Excluir em lote',
  bundleName: 'Nome do combo',
  bundlePrice: 'Preço combinado',
  businessType: 'Tipo de negócio',
  cancel: 'Cancelar',
  cancelOrder: 'Cancelar pedido',
  cancelled: 'Cancelado',
  card: 'Cartão',
  cash: 'Dinheiro',
  casheaAmount: 'Montante de Cashea',
  casheaDesc: 'Cashea parcelado',
  casheaLiveMode: 'Modo Cashea Real - Conectado',
  casheaSettingsDesc: 'Compre agora, pague depois - parcelado sem juros',
  category: 'Categoria',
  categoryManagement: 'Gerenciamento de categorias',
  categoryRates: 'Tarifas por categoria',
  change: 'Mudança',
  checkoutTitle: 'Pagar',
  clearNote: 'Excluir nota',
  cleared: 'Liquidado',
  clockIn: 'Entrada',
  clockOut: 'Sair',
  close: 'Fechar',
  closeAllBrowserFirst: 'Feche todas as janelas do navegador primeiro',
  code: 'Código',
  comboOrders: 'Pedidos combinados',
  comboRevenue: 'Renda combinada',
  comboSalesDistribution: 'Combinação de vendas de distribuição',
  commissionReport: 'Relatório da Comissão',
  commissionRules: 'Regras da Comissão',
  companyAddress: 'Endereço da empresa',
  companyPhone: 'Telefone da Empresa',
  completed: 'Concluído',
  completedStatus: 'Concluído',
  confirm: 'Confirmar',
  confirmClearPending: 'Confirmar pedidos pendentes claros?',
  confirmDelete: 'Confirmar exclusão',
  confirmPayment: 'Confirmar pagamento',
  confirmReceive: 'Confirmar recebimento',
  confirmStockLoss: 'Confirmar perda',
  connectionPort: 'Porta de conexão',
  cost: 'Custo',
  costLoss: 'Custo de perda',
  costPrice: 'Preço de custo',
  couponCode: 'Código de cupom',
  createAndPrint: 'Criar e imprimir',
  createSuccess: 'Criado com sucesso',
  createTime: 'Data de criação',
  createWholesaleOrder: 'Criar pedido de atacado',
  creditLimit: 'Limite de crédito',
  creditor: 'Credor',
  currency: 'Moeda',
  customerName: 'Nome do cliente',
  customerType: 'Tipo de cliente',
  dailySummary: 'Resumo do dia',
  date: 'Data',
  dateTo: 'Até',
  days30: '30 dias',
  days60: '60 dias',
  days90: '90 dias',
  daysUntilStockout: 'Dias até esgotar',
  defaultOption: 'Opção padrão',
  defaultWarehouse: 'Armazém Padrão',
  delete: 'Excluir',
  deleteEmployeeConfirm: 'Confirmar a exclusão deste funcionário?',
  deleteFailed: 'Excluir erro',
  deleteImage: 'Excluir imagem',
  deleteSelected: 'Excluir selecionado',
  description: 'Descrição',
  directPrintFailed: 'A impressão direta falhou',
  discountAboveCostDesc: 'Preço com desconto abaixo do custo',
  downloadShortcut: 'Baixe o acesso direto',
  downloadTemplate: 'Baixar modelo',
  edit: 'Editar',
  editEmployee: 'Editar funcionário',
  editProduct: 'Editar produto',
  email: 'Correio',
  employees: 'Funcionários',
  enableCashDrawer: 'Habilitar caixa registradora',
  endShift: 'Fim do turno',
  enterOrderNote: 'Insira a nota do pedido',
  enterPos: 'Entre no PDV',
  estimatedCommission: 'Comissão estimada',
  example: 'Exemplo',
  excellentTier: 'Excelente nível',
  expenseByStore: 'Despesas da Loja',
  expenseCount: 'Quantidade de despesas',
  expenseDesc: 'Descrição da despesa',
  expenseDescPlaceholder: 'Insira a descrição da despesa',
  expenseManagement: 'Gestão de despesas',
  export: 'Exportar',
  exportBackup: 'Exportar backup',
  exportInventoryReport: 'Relatório de inventário de exportação',
  exportRestockList: 'Lista de reabastecimento de exportação',
  extraHot: 'Extra Picante',
  failed: 'Falha',
  fillCompleteInfo: 'Por favor complete as informações',
  fiscalPrinter: 'Impressora Fiscal',
  franchiseHQ: 'Sede',
  franchiseOverview: 'Visão geral da franquia',
  generateReport: 'Gerar relatório',
  gold: 'Ouro',
  groupName: 'Nome do grupo',
  headquarters: 'Sede',
  holdOrder: 'Manter pedido',
  hours: 'Horas',
  html2canvas: 'html2canvas',
  idNumber: 'Número de identificação',
  iframe: 'iframe',
  importCategoryHint: 'Importar para categoria',
  importFieldHint: 'Selecione os campos para importar',
  importResult: 'Resultado de importação',
  importSelectCategory: 'Selecione a categoria',
  importSuccess: 'Importação bem-sucedida',
  inventoryList: 'Lista de inventário',
  inventoryQty: 'Quantidade de estoque',
  invoiceFooter: 'Rodapé da fatura',
  itemCount: 'Número de itens',
  itemNote: 'Nota do artigo',
  items: 'artigos',
  jspdf: 'jspdf',
  labelModeP1: 'Preço 1 (Detalhe)',
  labelModeP1P3: 'Preço 1 + Preço 3',
  labelModeP1W: 'Preço 1 + atacado',
  labelModeP3: 'Preço 3 (atacado)',
  labelModeUsdP1: 'Preço USD 1 (Detalhes)',
  labelModeWholesale: 'Preço da caixa (atacado)',
  labelNoDecimals: 'Sem decimais',
  labelShowBarcode: 'Mostrar código de barras',
  labelShowForeign: 'Mostrar moeda estrangeira ($)',
  labelShowBs: 'Mostrar Bs.',
  labelPaperSize: 'Papel',
  labelSize80mm: '80mm Térmico',
  labelSize50x30: 'Etiqueta 50x30mm',
  labelBilingual: 'Bilíngue (ES+CN)',
  last30Days: 'Últimos 30 dias',
  last7Days: 'Últimos 7 dias',
  lessIce: 'Menos gelo',
  loadFailed: 'Erro ao carregar',
  loading: 'Carregando...',
  loginExpired: 'A sessão expirou, faça login novamente',
  login: 'Entrar',
  logout: 'Sair',
  loyaltyTierBenefits: 'Benefícios por nível',
  mainWarehouse: 'Armazém Principal',
  margin: 'Margem',
  markDelivered: 'Marca entregue',
  maxDiscount: 'Desconto Máximo',
  memberCodePlaceholder: 'Insira o código de membro',
  memberGold: 'Membro Ouro',
  memberLimitReached: 'Limite de membros atingido',
  memberMallTab: 'Loja de pontos',
  memberMaxLevel: 'Nível Máximo',
  memberNeedSpend: 'preciso gastar',
  memberNotFound: 'Membro não encontrado',
  memberOrdersTab: 'Histórico de pedidos',
  memberPointsRedeem: 'Resgatar pontos',
  memberRedeemBtn: 'Resgatar',
  memberRedeemFail: 'Erro ao resgatar',
  memberSearchFailed: 'Erro de pesquisa',
  memberSilver: 'Membro Prata',
  memberSoldOut: 'Fora de estoque',
  memberTimedNotStarted: 'Evento não iniciado',
  memberTrialDays: 'Dias de teste',
  memberVip: 'Membro VIP',
  minSpent: 'Gasto Mínimo',
  minStockLevel: 'Estoque Mínimo',
  mixed: 'Misto',
  mobilePay: 'Pagamento Móvel',
  monthly: 'Mensalmente',
  newStockLoss: 'Nova Perda',
  newTransferOrder: 'Nova ordem de transferência',
  noCategoryAssign: 'Nenhuma categoria atribuída',
  noComboSalesYet: 'Ainda não há vendas de combos',
  noCustomerNoPoints: 'Sem cliente, sem pontos',
  noData: 'Sem dados',
  noOnion: 'Sem Cebola',
  noOptGroups: 'Nenhum grupo de opções',
  noShift: 'Sem volta',
  noStoresYet: 'Ainda não há lojas',
  notifications: 'Notificações',
  offline: 'Off-line',
  offlineCacheMode: 'Modo de cache off-line',
  onlineOrderTotal: 'Total de pedidos on-line',
  onlineStore: 'Loja on-line',
  operator: 'Operador',
  optionStats: 'Estatísticas de opções',
  optionalGroups: 'Grupos Opcionais',
  options: 'Opções',
  orderComplete: 'Pedido concluído',
  orderCount: 'Quantidade do pedido',
  orderDetail: 'Detalhes do pedido',
  orderNo: 'Pedido nº.',
  orderNote: 'Nota de pedido',
  orderNotes: 'Notas',
  originalPrice: 'Preço Original',
  overallMargin: 'Margem Geral',
  overwriteDuplicate: 'Substituir duplicatas',
  paidAmount: 'Valor pago',
  paperSize: 'Tamanho do papel',
  password: 'Senha',
  payable: 'Pagar',
  paymentAmount: 'Valor do pagamento',
  paymentInfo: 'Informações de pagamento',
  pending: 'Pendente',
  pendingOrdersNotif: 'Notificação de pedido pendente',
  pendingStatus: 'Pendente',
  phone: 'Telefone',
  pieces: 'pedaços',
  plan_enterprise: 'Negócios',
  plan_pro: 'Profissional',
  points: 'Pontos',
  pointsAvailable: 'Pontos Disponíveis',
  pointsEarned: 'Pontos ganhos',
  pointsHistory: 'Histórico de pontos',
  pointsMultiplier: 'Multiplicador de pontos',
  pointsRate: 'Taxa de pontos',
  posLogin: 'Acesso ao PDV',
  posMode: 'Modo PDV',
  posReceiptPrinter: 'Impressora de recibos POS',
  present: 'Atual',
  price: 'Preço',
  price2: 'Preço 2',
  price3Box: 'Preço 3/Caixa',
  priceSettings: 'Configurações de preços',
  priceType: 'Tipo de preço',
  pricing: 'Preço',
  printFormat: 'Formato de impressão',
  printInvoiceA4: 'Imprimir fatura A4',
  printItemCode: 'Imprimir código',
  printMethod: 'Método de impressão',
  printOrder: 'Ordem de impressão',
  printReceipt: 'Imprimir',
  printSuccess: 'Impressão bem-sucedida',
  printTime: 'Hora de impressão',
  printerConnectFailed: 'Falha na conexão da impressora',
  printerConnected: 'Impressora conectada',
  printerGuide: 'Guia da impressora',
  printerModel: 'Modelo de impressora',
  printerReady: 'Impressora pronta',
  printing: 'Imprimindo...',
  processing: 'Processando...',
  product: 'Produto',
  productName: 'Nome do produto',
  profit: 'Lucro',
  progress: 'Progresso',
  providedByAdmin: 'Fornecido pelo administrador',
  pushPrices: 'Enviar preços',
  qty: 'Quantidade.',
  quantity: 'Quantidade',
  quarterly: 'Trimestralmente',
  ratesUpdated: 'Taxas atualizadas',
  recallOrder: 'Recuperar pedido',
  receiptCopies: 'Cópias do recibo',
  receiptDetail: 'Detalhes do recibo',
  receiveTransfer: 'Receber transferência',
  receivedQuantity: 'Quantidade recebida',
  receivedStatus: 'Recebido',
  transferReceived: 'Recebido',
  recordPayment: 'Cadastrar Pagamento',
  recording: 'Gravação',
  records: 'Registros',
  redeemPoints: 'Resgatar pontos',
  ref: 'Referência',
  refundReason: 'Motivo da devolução',
  remaining: 'Restante',
  remainingAmount: 'Valor restante',
  reportPrinter: 'Impressora de relatórios',
  reports: 'Relatórios',
  reprintReceipt: 'Reimprimir recibo',
  restockItems: 'Itens para reabastecer',
  restockSuggestions: 'Sugestões de substituição',
  restoreBackup: 'Restaurar backup',
  restoreWarning: 'A restauração substituirá os dados atuais',
  retailPrice: 'Preço de venda',
  returnReason: 'Motivo da devolução',
  revenue: 'Renda',
  rightClickClear: 'Clique com o botão direito para excluir',
  salesExchangeRateDesc: 'Descrição Taxa de Vendas',
  salesManagement: 'Gestão de Vendas',
  salesOrder: 'Pedido de venda',
  salesRateDesc: 'Descrição Taxa de Vendas',
  salesVelocity: 'Velocidade de vendas',
  saveRates: 'Salvar tarifas',
  saveSettings: 'Salvar configurações',
  scale: 'Equilíbrio',
  scanOrSearch: 'Digitalize ou pesquise',
  scannerEnabled: 'Scanner ativado',
  searchProducts: 'Pesquisar produtos',
  selectAll: 'Selecionar tudo',
  selectCustomer: 'Selecione o cliente',
  selectImage: 'Selecione a imagem',
  selectProduct: 'Selecione o produto',
  selectProductsFirst: 'Selecione os produtos primeiro',
  selectStore: 'Selecione Loja',
  selectedCount: 'selecionado',
  setDefaultPrinter: 'Definir como impressora padrão',
  settingsSaved: 'Configurações salvas',
  shipped: 'Enviado',
  shopDescPlaceholder: 'Ex: Produtos frescos, entrega diária',
  shopDescription: 'Descrição da loja',
  shopPreview: 'Visualização da loja',
  skip: 'Pular',
  skipDuplicate: 'Ignorar duplicatas',
  skipped: 'omitido',
  soldQuantity: 'Quantidade vendida',
  staleDataInfo: 'Os dados podem estar desatualizados',
  staleDataWarning: 'Aviso de dados antigos',
  standardTier: 'Nível Padrão',
  startImport: 'Iniciar importação',
  status: 'Estado',
  statusCancelled: 'Cancelado',
  statusCompleted: 'Concluído',
  statusPending: 'Pendente',
  stockAlerts: 'Alertas de estoque',
  stockLossCostEstimate: 'Estimativa de custos de perda',
  stockLossManagement: 'Gestão de Perdas',
  stockLossQty: 'Quantidade. Perda',
  stockLossReason: 'Motivo da Perda',
  stockLossSuccess: 'Perda registrada',
  stockLow: 'Estoque baixo',
  stockTaking: 'Inventário',
  stopRecording: 'Pare de gravar',
  storeFilter: 'Filtro de loja',
  storeName: 'Nome da loja',
  storePerformance: 'Desempenho da loja',
  stores: 'Lojas',
  suggestedCost: 'Custo sugerido',
  supplierManagement: 'Gestão de Fornecedores',
  supplierName: 'Nome do fornecedor',
  syncPending: 'Sincronização pendente',
  systemQty: 'Quantidade do sistema',
  takeaway: 'Para viagem',
  targetAmount: 'Valor alvo',
  targetType: 'Tipo de objetivo',
  taxId: 'RIF',
  tenantLogin: 'Acesso do comerciante',
  testPrint: 'Teste de impressão',
  themeBakery: 'Padaria',
  themeButcher: 'açougue',
  themeClothing: 'Roupas',
  themeCustom: 'Personalizado',
  themeDepartment: 'Loja de departamentos',
  themeElectronics: 'Eletrônica',
  themeGeneral: 'Geral',
  themePharmacy: 'Farmácia',
  themeRestaurant: 'Restaurante',
  tier: 'Nível',
  time: 'Hora',
  toWarehouse: 'Para o armazém',
  todaySalesAll: 'Vendas totais hoje',
  topProducts: 'Produtos mais vendidos',
  topupBalance: 'Recarregar Saldo',
  total: 'Total',
  totalExpenses: 'Despesas totais',
  totalLossQty: 'Quantidade de perda total.',
  totalLossRecords: 'Registros de perda total',
  totalOrders: 'Total de pedidos',
  totalProducts: 'Total de Produtos',
  totalProfit: 'Lucro total',
  totalQuantity: 'Quantidade total',
  totalRevenue: 'Receita total',
  totalSales: 'Vendas totais',
  totalSpent: 'Total gasto',
  transferOrderNo: 'Ordem de transferência nº.',
  trendFlat: 'Estável',
  type: 'Tipo',
  updateSuccess: 'Atualizado com sucesso',
  updated: 'atualizado',
  uploadSuccess: 'Carregamento bem-sucedido',
  urgencyLevel: 'Nível de urgência',
  urgencyLow: 'Baixo',
  urgencyUrgent: 'Urgente',
  urgencyWarning: 'Aviso',
  urgent: 'Urgente',
  userManual: 'Manual do usuário',
  vidDefaultTitle: 'Tutorial em vídeo',
  vidDeleteFail: 'Erro ao excluir vídeo',
  vidDeleted: 'Vídeo excluído',
  vidRecFail: 'Erro de gravação',
  vidUpdateFail: 'Erro ao atualizar o vídeo',
  vidUploadFail: 'Erro ao enviar vídeo',
  vidUploading: 'Subindo...',
  vidVideoTitle: 'Título do vídeo',
  videoTutorials: 'Tutoriais em vídeo',
  viewInventory: 'Ver inventário',
  viewOrderDetail: 'Ver detalhes do pedido',
  vip: 'VIP',
  vipCustomer: 'Cliente VIP',
  warehouse: 'Armazém',
  warehouseManagement: 'Gestão de Armazéns',
  warehouseName: 'Nome do armazém',
  weekSalesAll: 'Semana total de vendas',
  weeklyAvgSales: 'Média de vendas semanais',
  wholesaleDiscount: 'Desconto no atacado',
  wholesaleMinQty: 'Atacado mínimo. Quantidade',
  wholesaleOrder: 'Pedido por atacado',
  cashBalance: 'Saldo em dinheiro',
  cashUsd: 'Dinheiro em dólares americanos',
  cashVes: 'Dinheiro B',
  cashTransaction: 'Operação em dinheiro',
  cashDeposit: 'Depósito',
  cashWithdraw: 'Aposentadoria',
  cashHandover: 'Entrega',
  cashAdjustment: 'Ajuste',
  recentRecords: 'Registros recentes',
  employeeAccounts: 'Contas de funcionários',
  employee: 'Funcionário',
  newEmpTransaction: 'Transação de novo funcionário',
  selectEmployee: 'Selecione Funcionário',
  loanToEmployee: 'Empréstimo para funcionários',
  goodsCreditToEmployee: 'Crédito de mercadoria',
  employeeRepayment: 'Reembolso de funcionários',
  salaryDeduction: 'Dedução salarial',
  transactionHistory: 'Histórico de transações',
  productInfo: 'Informações do produto',
  productInfoPlaceholder: 'Detalhes de crédito...',
  noEmployeeDebt: 'Sem registros de dívida',
  notePlaceholder: 'Nota...',
  owes: 'deve',
  loans: 'Empréstimos',
  goodsCredit: 'Crédito',
  repaid: 'Pago',
  sale: 'Venda',
  exchange: 'Mudança',
  idCard: 'ID',
  employeeStatement: 'Extrato de conta',
  currentBalance: 'Saldo Atual',
  orderNoLookup: 'Insira o número do pedido',
  staff: 'Pessoal',
  cashier: 'Caixa',
  order_taker: 'Atendente (só pedidos, não cobra)',
  byCashier: 'Por Caixa',
  filterByCashier: 'Filtrar por Caixa',
  storeManager: 'Gerente',
  employeeCredit: 'Crédito de funcionário',
  paySalary: 'Pagar Salário',
  grossSalary: 'Salário Bruto',
  deductFromSalary: 'Descontar do salário',
  netPay: 'Pagamento Líquido',
  deductMax: 'Deduzir máximo',
  noDeduct: 'Sem dedução (tudo em dinheiro)',
  repayByBs: 'Pague em Bs →',
  repayByBsHint: 'O funcionário paga em Bs → converte o carro em dólares americanos e deduz',
  rateManagerCustom: 'Gerente: taxa própria',
  rateStaffBcv: 'Funcionário: Taxa BCV',
  employeeReceivables: 'Funcionários de contas a receber',
  employeeReceivablesNote: 'Pendente',
  totalOwed: 'Dívida Total',
  absencePenalty: 'Multa por Ausência',
  creditLimitWarning: 'Limite de crédito excedido!',
  currentOwed: 'Dívida Atual',
  afterTxn: 'Depois',
  overBy: 'Excede em',
  todayAttendance: 'Atendimento de hoje',
  onDuty: 'Trabalhando',
  offDuty: 'saiu',
  notClockedIn: 'Não marcado',
  fullDay: 'Dia inteiro',
  halfDay: 'Meio dia',
  absent: 'Ausente',
  dailyRate: 'Diária',
  fullDays: 'Dias inteiros',
  halfDays: 'Meio dia',
  absentDays: 'Ausências',
  currentDebt: 'Dívida',
  salaryCalcMode: 'Modo de cálculo',
  autoCalc: 'Carro',
  manualInput: 'manual',
  autoAdjustable: 'Auto+Ajuste',
  salaryAmount: 'Valor do salário',
  payCycle: 'Ciclo de pagamento',
  weekly: 'Semanalmente',
  biweekly: 'Quinzenalmente',
  siteMonitor: 'Monitor do local',
  monitorCheckNow: 'Verifique agora',
  monitorCurrentStatus: 'Status atual',
  monitorUptime24h: 'Disponibilidade (24h)',
  monitorTotalChecks: 'Total de verificações',
  monitorAlertConfig: 'Configuração de alerta',
  monitorAlertEmail: 'E-mail de alerta',
  monitorEmailRequired: 'Digite o e-mail de alerta',
  monitorKeyRequired: 'Insira a chave API de reenvio',
  monitorSettingsSaved: 'Configuração salva',
  monitorConfigured: 'Configurado',
  monitorResendHelp: 'Obtenha sua chave API gratuita em',
  monitorResendHelp2: 'para receber alertas de queda.',
  monitorSendTest: 'Enviar alerta de teste',
  monitorRecentLogs: 'Verificações recentes',
  monitorNoLogs: 'Sem registros. O sistema verifica a cada 5 minutos.',
  storeReceiptInfo: 'Informações da fatura/recebimento',
  storeReceiptInfoHint: 'Se configurado, os recebimentos desta loja usarão essas informações em vez da empresa.',
  storeReceiptName: 'Nome da empresa (fatura)',
  storeReceiptNamePlaceholder: 'Ex: ALFONZO SHOP C.A.',
  storeReceiptAddress: 'Endereço da fatura 1',
  storeReceiptAddress2: 'Endereço da fatura 2',
  storeReceiptPhone: 'Conta de telefone',
  inventoryDownloadTemplate: 'Baixar modelo',
  inventoryImport: 'Importar inventário',
  inventoryTemplateDownloaded: 'Modelo baixado',
  inventoryImportSuccess: 'Importação concluída',
  allowedHours: 'Horário permitido (vazio=ilimitado)',
  allowedHoursHint: 'Horário da Venezuela (UTC-4). Ex: 07:00 ~ 22:00',
  allowedIPs: 'IPs permitidos (vazio=ilimitado)',
  allowedIPsHint: 'Separe os IPs com vírgulas. Administrador/Gerente isento.',
  attendanceHistory: 'Histórico de presença',
  avgPerOrder: 'Média por pedido',
  bsCashGiven: 'Dinheiro em USD ($)',
  bsCost: 'Custo B',
  bsValue: 'Valor Bs',
  buyRate: 'Taxa de compra',
  byCurrency: 'Por moeda',
  byPaymentMethod: 'Por Método de Pagamento',
  cashGiven: 'Dinheiro recebido',
  categoryBreakdown: 'Divisão por categoria',
  categoryName: 'Nome da categoria',
  clockedIn: 'Assinado',
  costUsd: 'Custo (USD)',
  dailyBreakdown: 'Repartição Diária',
  days: 'dias',
  downloadFailed: 'Falha no download',
  exchangeRate: 'Taxa de câmbio',
  expenses: 'Despesas',
  expenseFood: 'Comida',
  expenseSalary: 'Salário',
  expenseSupplies: 'Suprimentos',
  expenseTax: 'Imposto',
  expenseTransport: 'Transporte',
  expenseUtilities: 'Serviços',
  expired: 'Expirado',
  lastDays: 'Últimos dias',
  lastMonth: 'Último mês',
  loadingData: 'Conectando-se ao servidor e enviando dados',
  lossBreakdown: 'Análise de perdas',
  mixedPayment: 'Pagamento Misto',
  netProfit: 'Lucro Líquido',
  nextPage: 'Próximo',
  prevPage: 'Anterior',
  print: 'Imprimir',
  profitUsd: 'Lucro (USD)',
  rateLabel: 'Taxa',
  sales: 'Vendas',
  salesBs: 'Vendas (Bs)',
  schedule: 'Cronograma',
  sellRate: 'Taxa de vendas',
  showing: 'Mostrando',
  split: 'Dividir',
  store: 'Loja',
  subtotal: 'Subtotal',
  thisMonth: 'Este mês',
  todayProfitUsd: 'Ganhando hoje (USD)',
  totalDue: 'Total a pagar',
  totalEmployees: 'Total de funcionários',
  unassignedStore: 'Não atribuído',
  usdCashGiven: 'Dinheiro em USD ($)',
  usdEquivalent: 'Equivalente em dólares americanos',
  selectedRate: 'Taxa selecionada',
  sample: 'Exemplo',
  other: 'outro',
  personalUse: 'Uso pessoal',
  blackMarket: 'Mercado Negro',
  blackMarketGoods: 'Produtos do mercado negro',
  buyUsdCash: 'Compre dinheiro em dólares americanos',
  cardToCash: 'Cartão de dinheiro',
  cashMustBeLess: 'O dinheiro deve ser menor que o total',
  commissionPct: '% Comissão',
  aiFeatures: 'Recursos de IA',
  aiEnabled: 'IA ativada',
  aiDisabled: 'IA desativada',
  aiToggle: 'Troca de IA',
  aiSubscriptionFee: 'Taxa Mensal IA',
  aiFeatureNote: 'Os recursos de IA exigem um custo adicional',
  aiRegDisclaimer: 'Os recursos de IA (assistente inteligente, verificação de recibo de pagamento, etc.) exigem uma assinatura adicional e não estão incluídos no plano básico.',
  aiCostPerMsg: 'por mensagem',
  aiCostPerImg: 'por verificação de imagem',
  aiMonthlyFee: 'Taxa Mensal IA ($)',
  aiToggleOn: 'Ativar IA',
  aiToggleOff: 'Desativar IA',
  authRequired: 'Autorização necessária',
  authAction: 'Ação',
  authScanHint: 'Peça ao gerente para escanear seu código QR',
  authScanPlaceholder: 'Digitalize ou insira o código...',
  verify: 'Verifique',
  verifying: 'Verificando...',
  authSuccess: 'Autorizado',
  authFailed: 'Falha na autorização',
  authorizer: 'Autorizado por',
  authCodeGenerate: 'Gerar código',
  authCodeRegenerate: 'Regenerar',
  authCodePrint: 'Imprimir QR',
  noAuthCode: 'Nenhum código de autorização',
  authCodeGenerated: 'Código gerado',
  priceSwitchNeedAuth: 'Alterar preço requer autorização',
  refundNeedAuth: 'A devolução requer autorização',
  onlyManagerCanSwitch: 'Apenas o gerente/administrador pode alterar o preço',
  boxModeNoStock: 'Estoque insuficiente para uma caixa cheia',
  creditOverdue: 'expirou',
  creditDueSoon: 'Para vencer',
  creditDueDate: 'Data de expiração',
  creditAlerts: 'Alertas de crédito',
  creditOverdaysDays: 'expirou',
  creditDueSoonDays: 'Restante',
  noOverdueCredits: 'Sem créditos expirados',
  priceCheck: 'Consulta de preços',
  priceCheckSearch: 'Digite o nome/código de barras...',
  canViewPrices: 'Ver Preços',
  addProductsFirst: 'Pesquise e adicione produtos ao pedido',
  orderSummary: 'Resumo do pedido',
  confirmOrder: 'Confirmar pedido',
  orderCreated: 'Pedido criado',
  creditLimitExceeded: 'Limite de crédito excedido',
  amountWarning: 'Quantidade incomum',
  largeAmountHint: 'O valor recebido é muito maior que o total. Verifique se está correto.',
  correctAmount: 'Correto',
  confirmCorrect: 'Sim, está correto',
  salesContacts: 'Vendedores',
  addContact: 'Adicionar',
  noContacts: 'Nenhum vendedor',
  contactName: 'Nome',
  contactPhone: 'Telefone',
  editSupplier: 'Editar fornecedor',
  refundSuccess: 'Retorno bem sucedido',
  salesperson: 'Vendedor',
  selectSalesperson: 'Selecione o vendedor',
  salespersonName: 'Nome do vendedor (opcional)',
  noSalesperson: 'Nenhum vendedor',
  filterBy: 'Filtrado por',
  clearFilter: 'Remover filtro',
  voidOrder: 'Cancelar pedido',
  voided: 'Cancelado',
  voidReason: 'Motivo do cancelamento',
  voidReasonPlaceholder: 'Ex: Erro no valor, pedido duplicado...',
  voidWarning: 'Cancelar irá restaurar o inventário. Não pode ser desfeito.',
  confirmVoid: 'Confirmar Cancelar',
  voidSuccess: 'anulado',
  hqTitle: 'Central de Monitoramento',
  hqAutoRefresh: 'Atualizações a cada 60 anos',
  hqRefresh: 'Atualizar',
  hqLoading: 'Carregando...',
  hqNoData: 'Sem dados',
  hqLoadFailed: 'Erro ao carregar',
  hqAiAnalysisFailed: 'Erro na análise de IA',
  hqTotalSales: 'Vendas totais',
  hqToday: 'Hoje',
  hqEmployeeDebt: 'Dívida de funcionários',
  hqOnDutyCount: 'No turno',
  hqActiveShifts: 'turnos ativos',
  hqStockWarning: 'Alerta de estoque',
  hqLowStockItems: 'Produtos em estoque',
  hqAiAssistant: 'Assistente de IA',
  hqStoreMonitor: 'Lojas',
  hqEmployeeStatus: 'Funcionários',
  hqShiftHandover: 'Turnos',
  hqSalesDetail: 'Vendas',
  hqAlerts: 'Alertas',
  hqCashFlow: 'Fluxo de caixa',
  hqAiHqAssistant: 'Assistente Central de IA',
  hqAnalyzing: 'Analisando...',
  hqReAnalyze: 'Reanalisar',
  hqStartAnalysis: 'Iniciar análise',
  hqAiClickToAnalyze: 'Clique em \\"Iniciar análise\\" para que a IA analise os dados de todas as lojas',
  hqAiWillCheck: 'A IA verificará tendências de vendas, estoque, problemas de funcionários e dará sugestões',
  hqAiAnalyzingData: 'A IA está analisando dados de todas as lojas...',
  hqAiAnalyzingIncludes: 'Inclui comparação de vendas, verificação de estoque, dívidas, diferenças de turno, etc.',
  hqViewRawData: 'Ver resumo dos dados',
  hqOperating: 'Abrir',
  hqOrders: 'pedidos',
  hqCurrentOnDuty: 'Atualmente de plantão',
  hqSince: 'Desde',
  hqCashBalanceUsd: 'Saldo em dinheiro em dólares americanos',
  hqCashBalanceBs: 'Saldo de caixa Bs',
  hqTransactionCount: 'Transações',
  hqProductLowStock: 'produtos fora de estoque',
  hqCollapseDetails: 'Esconder',
  hqExpandDetails: 'Ver detalhes',
  hqUsdIn: 'Entrada em USD',
  hqUsdOut: 'Saída em dólares',
  hqBsIn: 'Entrada Bs',
  hqBsOut: 'Saída Bs',
  hqTodayPayments: 'Pagamentos de hoje',
  hqStoreStaff: 'Pessoal',
  hqOnDuty: 'Por sua vez',
  hqOwes: 'deve',
  hqOffline: 'Off-line',
  hqBranch: 'Filial',
  hqClockIn: 'Entrada',
  hqIdCard: 'ID',
  hqPhone: 'Telefone',
  hqLoans: 'Empréstimos',
  hqGoodsCredit: 'Crédito',
  hqRepaid: 'Pago',
  hqDebt: 'Dívida',
  hqSalaryPaid: 'Salário pago',
  hqCurrentActiveShifts: 'Turnos Ativos',
  hqRecentShiftRecords: 'Registros de turnos recentes',
  hqNoShiftRecords: 'Sem registros de turno',
  hqManager: 'Gerente',
  hqDiscrepancy: 'Diferença',
  hqAllStoresSalesSummary: 'Resumo de vendas todas as lojas',
  hqRefund: 'Reembolsos',
  hqTodayDetails: 'Detalhes de hoje',
  hqLowStockWarning: 'Alerta de estoque baixo',
  hqAllStockOk: 'Todos os produtos com estoque suficiente',
  hqStock: 'estoque',
  hqOutOfStock: 'Fora de estoque',
  hqHeadquarters: 'Central',
  hqBorrow: 'Prest.',
  hqCreditShort: 'Crédito.',
  hqRepaidShort: 'Página',
  hqShiftDiscrepancyWarning: 'Alerta de diferença de turno',
  hqCrossStoreTransfer: 'Sugestões de transferência',
  hqTransferSuggestionDesc: 'Esses produtos estão esgotados em uma loja, mas disponíveis em outra',
  hqStockIsZero: 'estoque é 0',
  hqTransfer: 'Transferência',
  hqTime: 'Hora',
  hqType: 'Tipo',
  hqDirection: 'Endereço',
  hqIn: 'Entrada',
  hqOut: 'Sair',
  hqHas: 'tem',
  hqUnits: 'unidades',
  hqPaymentWay: 'Método de pagamento',
  hqTransferNoCash: 'A transferência não afeta o saldo de caixa',
  hqHolidayCalendar: 'Calendário de feriados',
  hqHolidayTip: 'Clique em uma data para marcar/desmarcar como feriado. Trabalhar nos feriados = 1,5x salário (LOTTT)',
  hqHolidaysThisMonth: 'Feriados este mês',
  hqHolidaySet: 'Feriado configurado (pagamento de 1,5x)',
  hqHolidayRemoved: 'Feriado eliminado',
  hqPrefillHolidays: 'Pré-preencher feriados oficiais de 2026',
  hqHolidaysPrefilled: 'Feriados oficiais pré-preenchidos',
  hqNew: 'novo',
  price3: 'Preço 3',
  boxPrice: 'Caixa',
  shopQRPoster: 'Pôster QR da loja',
  shopQRPosterDesc: 'Gere um pôster promocional com código QR para sua loja online',
  shopQRUrl: 'Link da loja',
  managerAuth: 'Autorizar gerente',
  managerApproved: 'Gerente Autorizado',
  managerAuthRequired: 'É necessária autorização do gerente para fechar turno',
  actualCashCount: 'Contagem real de dinheiro',
  cashReconciliation: 'Reconciliação de caixa',
  shiftNotes: 'Notas (explicar diferenças)',
  expected: 'Esperado',
  pendingShiftFound: 'Curva não fechada encontrada, feche primeiro',
  shiftEndAuthHint: 'O fechamento do turno requer digitalização ou senha do gerente',
  passwordAuth: 'Senha',
  scanCode: 'Código de digitalização',
  authorize: 'Autorizar',
  clearInventory: 'Estoque vazio',
  copyFromMain: 'Copiar do principal',
  saveQty: 'Salvar',
  onlyWithStock: 'Somente em estoque',
  noStock: 'Fora de estoque',
  legacyDebt: 'Importar dívida anterior',
  legacyDebtHint: 'Registrar apenas dívidas, sem deduzir dinheiro',
  netCash: 'Caixa Líquido',
  currentShift: 'Turno Atual',
  noActiveShift: 'Nenhum turno ativo',
  addProductHint: 'O produto é adicionado em todas as lojas, somente esta loja terá estoque',
  initStock: 'Valor Inicial',
  overdue: 'expirou',
  partial: 'Parcial',
  paymentVerify: 'Verifique o pagamento',
  priceRequired: 'Insira o preço',
  productNameRequired: 'Digite o nome do produto',
  quickExchange: 'Mudança rápida',
  quickExchangeDesc: 'Converta moeda rapidamente',
  reconciliation: 'Conciliação',
  scanBarcode: 'Digitalize ou escreva código de barras',
  scanOrType: 'Digitalize ou escreva',
  selectCategory: 'Selecione a categoria',
  totalChange: 'Mudança total',
  totalReceived: 'Total Recebido',
  goExchange: 'Vá para Alterar',
  cashReconciliationNote: 'nota de reconciliação',
  rptTitle: 'Relatório de turno',
  rptCashier: 'Caixa',
  rptStore: 'Loja',
  rptStart: 'Página inicial',
  rptClose: 'Fechando',
  rptManager: 'Gerente',
  rptRate: 'Taxa',
  rptSalesByMethod: 'Vendas por Método',
  rptCashRecon: 'Reconciliação de caixa',
  rptSummary: 'Resumo total',
  rptCashUsd: 'Dinheiro em dólares americanos',
  rptCashBs: 'Dinheiro B',
  rptCard: 'Cartão',
  rptTransfer: 'Transferência',
  rptTotalOrders: 'Total de pedidos',
  rptTotalBs: 'Total de Bs',
  rptGrandTotal: 'Venda total',
  rptNet: 'Rede',
  rptRefunds: 'Devoluções',
  rptExpected: 'Esperado',
  rptActual: 'Verdadeiro',
  rptDiff: 'Diferença.',
  rptNote: 'Nota',
  rptMethod: 'Método',
  rptUsdReceived: 'USD recebido',
  rptBsReceived: 'Bs recebidos',
  chkFillShipping: 'Por favor preencha as informações de envio',
  chkRefOrProof: 'Por favor insira a referência ou faça upload do comprovante',
  chkSelectBank: 'Selecione o banco',
  chkOrderPlaced: 'Encomenda realizada!',
  chkTransferencia: 'Transferência',
  chkPagoMovil: 'Pagamento Móvel',
  chkCashea: 'Caxéia',
  chkCasheaSub: 'Compre agora, pague depois',
  chkCredit: 'Crédito',
  chkCredit7or15: '7 ou 15 dias',
  chkWhatsappPay: 'Entre em contato com o vendedor para pagar',
  chkConfirmPedido: 'Confirmar pedido',
  chkSending: 'Enviando...',
  chkCancel: 'Cancelar',
  chkReference: 'Referência',
  chkProof: 'Comprovante de Pagamento (foto)',
  chkUploadProof: 'Carregar recibo',
  orphanCreditsMenu: '🔧 Créditos órfãos',
  orphanCreditsTitle: '🔧 Reparação de crédito órfão',
  orphanCreditsFound: 'Créditos órfãos encontrados',
  orphanCreditsHint: 'O caixa pressionou Crédito, mas não selecionou cliente/funcionário – clique em “Atribuir”.',
  orphanCreditsNone: '✅ Sem créditos órfãos – todos estão bem alocados.',
  orphanCreditsEmpty: 'Nenhum crédito órfão correspondente',
  orphanAssign: 'Atribuir',
  orphanAssigned: '✅ Atribuído',
  orphanPickTitle: 'Atribuir a...',
  orphanPickEmployee: '👤 Funcionário',
  orphanPickCustomer: '🧑‍🤝‍🧑 Cliente',
  orphanSearchPlaceholder: 'Pesquisar pedido/item/caixa...',
  orphanSearchEmp: 'Procure por funcionário...',
  orphanSearchCust: 'Pesquisar cliente/telefone...',
  outOfStock: 'Produto ESGOTADO',
  agotadoHint: 'Reabasteça primeiro ou peça ao gerente para ativar “permitir estoque negativo” para continuar',
  understood: '✓ Entendido',
  pleaseConnectPrinter: 'Conecte a impressora',
  connectPrinterHint: 'Clique em ⚡ para conectar a impressora USB',
  printError: 'Erro de impressão',
  labelPrinted: 'Etiqueta impressa',
  labelsPrinted: 'Etiquetas impressas',
  popupBlocked: 'Pop-up bloqueado',
  printerCheckConnection: 'Verifique se a impressora está ligada e conectada',
  reconciliationMenu: 'Reconciliação Diária',
  apartadosMenu: 'Seções',
  cameraBossMenu: 'Câmara Chefe',
  pointsQrMenu: 'Pontos QR',
  deliveryMenu: 'Motoristas de entrega',
  marketingBlastMenu: 'Difusão em Massa',
  clothingVariantsMenu: 'Variantes de tamanho/cor',
  aiCreditsMenu: 'Créditos de IA',
  waOutboxMenu: 'Brincos WhatsApp',
  waConnectMenu: 'Conexão WhatsApp + Feriados',
  syncQueueMenu: 'Fila de sincronização',
  fxAlertsMenu: 'Alertas de taxas',
  bossPinMenu: 'PIN do WhatsApp do chefe',
  reportsHubMenu: 'Centro de Análise',
  taxReportHint: 'Selecione um intervalo de datas e gere o relatório',
  autoRefresh: 'Atualização automática',
  fixedQRTip: 'QR fixo – imprima e cole na caixa',
  matched: 'Verificado',
  noRef: 'Sem referência',
  paymentVerification: 'Verificação de pagamento móvel',
  printFiscal: 'Imprimir fatura',
  recentUploads: 'Envios recentes',
  saveSchedule: 'Salvar programação',
  searchByOrderNo: 'Nº do pedido de pesquisa',
  verifyPayment: 'Verifique o pagamento',
  waitingCustomerUpload: 'Aguardando o cliente digitalizar e fazer upload...',
  x_7b6a3713: 'sem permissão',
  x_930e724c: 'Insira um preço válido',
  x_58abd523: 'Cache limpo, recarregando dados...',
  x_567717bd: 'Os dados foram atualizados.',
  x_13284485: 'Erro ao atualizar:',
  x_c67c3701: 'A rede foi restaurada e os dados estão sendo atualizados...',
  x_ec64f9ef: 'Conexão restaurada',
  x_97249636: 'Modo off-line',
  x_srv_down: '🔴 Servidor Sellox sem resposta (sua internet está ok). Modo off-line: continue vendendo, sincroniza ao voltar',
  x_de00636b: 'Preço de atacado',
  x_3355b9c9: 'Mudança sincronizada',
  x_cdcb5470: 'O token foi renovado automaticamente',
  x_65deb2f1: 'Falha ao fazer login novamente automaticamente. Faça login manualmente',
  x_066dcc67: 'Seu login expirou. Faça login novamente depois que a rede for restaurada para sincronizar pedidos.',
  x_05b73e1e: 'Encaminhado para fila',
  x_4668b3da: 'Falha ao reenviar:',
  x_cfc81929: 'Tem certeza de que deseja excluir todos os pedidos pendentes?',
  x_59462c81: 'claro',
  x_769d88e4: 'completo',
  x_a3605cd3: 'Um registro de turno não entregue foi detectado. Por favor, entregue a sua vez primeiro.',
  x_d3ab821c: 'O login expirou, faça login novamente',
  x_904b6b66: 'Impressora USB conectada (impressão silenciosa)',
  x_bfff47cd: 'A balança eletrônica está conectada.',
  x_3b0e123b: 'Somente o administrador/gerente da loja pode operar o relatório de perda.',
  x_316b388f: '✅ O pedido foi feito (sem placas novas, sem impressas)',
  x_1c68b907: 'Atualmente existem itens no carrinho de compras. Quer desligar primeiro e depois trocar de mesa?',
  x_bd2ec68d: 'Não foi possível encontrar a ordem das mesas.',
  x_4a61c29a: 'Modo off-line',
  x_87dc2a1a: 'Não é possível fazer login no modo offline; primeiro login on-line',
  x_e4bb7fff: 'Modo offline – usa dados armazenados em cache',
  x_c8d270fe: '⚠️ ATENÇÃO/AVISO\\n\\n',
  x_428684a8: 'O servidor não está respondendo e a classe pode não carregar corretamente. \\n\\n',
  x_990dd915: 'Ele foi salvo temporariamente nesta máquina. Se a rede ainda estiver offline enquanto você continua vendendo produtos, a equipe de vendas será designada para um turno temporário e o chefe será notificado após o trabalho para verificação.',
  x_d04b8716: '⚠️MODO OFFLINE\\n\\n',
  x_58f36ff7: 'Atualmente não há rede. Os turnos só serão salvos localmente. \\n\\n',
  x_59875eda: 'Se a rede continuar indisponível, as vendas de hoje serão relegadas a um turno temporário e a conciliação pós-trabalho demorará mais. \\n\\n',
  x_d1737caf: 'Dica: Aguarde de 1 a 2 minutos para que a rede se recupere antes de tentar novamente. \\n\\n',
  x_05d979dc: 'Continuar mesmo assim? / Você ainda quer continuar?',
  x_3bddf726: 'Por favor, comece a aula primeiro.',
  x_bec775e5: 'Não foi possível carregar os dados de reconciliação',
  x_d31c6a37: '⚠️ Ainda não há registros de vendas para este turno! \\n',
  x_d8e2e78b: 'Tem certeza de que deseja terminar a aula? \\nConfirma sua vez?\\n\\n',
  x_cc49e31b: '(O cancelamento pode continuar o negócio)',
  x_6d35a343: '✅ Todos os pedidos foram carregados no servidor',
  x_ac03942e: '⚠ A API shift falhou e foi adicionada à fila para ser sincronizada. Ele tentará novamente automaticamente depois que a rede for restaurada.',
  x_86c1eb39: 'Alterar conta',
  x_2767058e: 'Cliente adicionado com sucesso',
  x_6452a055: 'Erro ao adicionar',
  x_8b2a8a38: 'Os dados foram sincronizados automaticamente.',
  x_d23f4e73: 'Peso inválido',
  x_b189550a: 'Adicionado',
  x_a5366b92: 'Não redutível ao custo',
  x_c0297a24: 'O turno anterior expirou — abra um novo turno/O voo anterior expirou, inicie o voo primeiro',
  x_da71e1f7: 'Modo offline: aula iniciada automaticamente',
  x_0bb666b2: 'O pedido não pode ser salvo nesta máquina! Por favor imediatamente:\\n\\n',
  x_573ee6e2: '1) Foto do recibo / Tire fotos e guarde o recibo\\n',
  x_f474a85a: '3) Notificar chefe / Notificar chefe para fazer entradas adicionais manualmente\\n\\n',
  x_5e8eda89: '⚠️ Erro ao salvar offline: tire uma foto do recibo e avise o chefe!',
  x_fef4f558: '❌ PEDIDO REJEITADO / Pedido rejeitado\\n\\n',
  x_0eccf7aa: 'Razão/Motivo:',
  x_4187e323: 'O pedido não foi creditado! O carrinho de compras foi reservado. Resolva o problema e receba o pagamento novamente. \\n',
  x_1bc8b552: 'O servidor não está respondendo e o pedido não pode ser salvo localmente! Imediatamente:\\n\\n',
  x_48449982: '3) Notificar o chefe / Notificar o chefe para fazer entradas adicionais manualmente',
  x_8c837c19: '⚠️ Totalmente incapaz de economizar - pegue um recibo e avise o chefe!',
  x_081947d7: 'Erro de impressão:',
  x_93fdb105: 'Enviado para impressora',
  x_a63bd9a0: 'ID do comerciante',
  x_b5caf579: 'Por exemplo: 21da4d91',
  x_ca95bed3: 'Ir ao Painel Admin',
  x_bd0271ed: 'Carregando...',
  x_e6e60286: 'Conexão ao servidor e upload de dados',
  x_81960a3b: 'Vá fundo',
  x_3f685cd2: 'Limpar cliente',
  x_5e3d6f1e: 'Tabelas',
  x_c5b1fdb6: 'Dividir conta',
  x_987d1310: 'Enviado urgentemente',
  x_3e0187a0: 'Cozinha apressada',
  x_4f9af33b: 'Atualmente existem itens no carrinho de compras. Descartar e limpar a mesa? (Recomenda-se pressionar F4 para fazer um pedido primeiro)',
  x_93a34d2b: 'limpar tabela',
  x_2e0d8c60: 'Erro de exportação:',
  x_4429e2af: 'Insira manualmente a taxa de câmbio USD → Bs de hoje (por exemplo, 478)\\nTaxa manual para hoje:',
  x_496630eb: 'Taxa de câmbio inválida',
  x_632d6847: 'A taxa de câmbio foi sincronizada com o servidor.',
  x_e1bbd792: '(Subindo...)',
  x_a66048b8: '(Carregar automaticamente após conectar-se à Internet)',
  x_a5596eed: 'Você não pode exportar pedidos para serem sincronizados',
  x_87bae330: 'Falha na exportação USB:',
  x_0d05c12d: 'Pedidos de pacotes a serem sincronizados em arquivos JSON (você pode levar uma unidade flash USB para um PC com rede para fazer upload)',
  x_483b3198: 'Os arquivos Sellox-usb-*.json exportados de outros PCs são mesclados na fila local para serem sincronizados.',
  x_d6c969fc: 'Falha na importação USB:',
  x_0257f05e: 'Erro de formato',
  x_97072b48: 'Varredura da câmera',
  x_4aeb4434: 'Venda rápida: insira diretamente o preço (cigarros/sacos/produtos a granel)',
  x_c017be6f: 'carrinho de compras',
  x_9897d884: 'mercadoria',
  x_5d7dbac5: 'taxa de serviço',
  x_e92b87e6: 'Nenhuma venda pendente, tudo enviado',
  x_ac05c6e0: 'Selecione um cliente',
  x_822d3b01: 'Erro',
  x_ece89972: 'Avançar',
  x_47c14729: 'Excluir permanentemente?',
  x_c1d0ffe6: 'Venda rápida',
  x_703ccc54: 'Produtos sem código de barras: cigarros/bolsas/produtos a granel, etc., insira o preço diretamente para adicionar ao carrinho de compras',
  x_0e9fd989: 'Preço',
  x_8d70d6cc: 'nome (opcional)',
  x_2ba4914f: 'Por exemplo: Cigarro/Charuto/Saco',
  x_62d36990: 'adicionar ao carrinho',
  x_c542cafa: 'Este produto está esgotado',
  x_cd14d6ac: 'Estoque atual',
  x_f0f7c38e: 'Reabasteça os produtos primeiro ou peça ao gerente para ativar “Permitir estoque negativo” antes de continuar com a venda.',
  x_b6fc6280: '✓ Entendi (Entendi)',
  x_5e3c50d7: 'Cliente:',
  x_79283113: 'Por favor confirme! Ele será excluído automaticamente após você fazer o pedido.',
  x_3a4e7b4a: 'dividir o pedido',
  x_1a3e9cc8: 'pedir vegetais',
  x_5a99b099: 'hoje é',
  x_69eccd2b: 'É seu aniversário. Quer um presentinho/presente/desconto de aniversário? 🎁',
  x_d53b49d4: 'fechar',
  x_71e5e874: '📡 Off-line',
  x_bf349b27: '— A cobrança no caixa está normal, os documentos foram salvos localmente e serão carregados automaticamente após conexão à Internet.',
  x_5326b4f3: '⚠️ Taxa de câmbio BCV expirada',
  x_1d5e15a6: 'Atrasado/Atrasado:',
  x_02117218: 'Em breve / Expirará em breve:',
  x_c4d536c0: '📋Regras/Regras:',
  x_7f038370: '📱 Assistir online / Assistir online:',
  x_56c29a7f: 'Obrigado! / Obrigado pela visita',
  x_f59fbcc6: 'A granel · Insira o peso',
  x_75c7e478: 'Pedidos rejeitados',
  x_9b109b95: 'Não gravado',
  x_261d3371: '🔁 Reenviar',
  x_2300874f: '🗑 Excluir',
  x_faf1993a: 'Tudo processado ✅',
  x_76ddec31: 'Nota: A remoção de produtos afetará todas as filiais! Tem certeza de que deseja remover este produto?',
  x_69b0f684: 'Desativado',
  x_53ace430: 'Habilitado',
  x_5fa802be: 'Operação falhada',
  x_9424cd13: 'Erro de impressão: permitir pop-ups',
  x_e80262e7: 'A impressora está conectada',
  x_ce79f0c8: 'Não foi possível conectar à impressora',
  x_7aa71b32: 'Nota: A remoção de produtos afetará todas as filiais!',
  x_631cd220: 'Confirmar exclusão',
  x_35a7afeb: 'artigos',
  x_0007d170: 'Excluir com sucesso',
  x_7775d70e: 'Nenhum produto com imagem',
  x_d34bd225: 'Créditos de IA insuficientes',
  x_54e5de42: 'Erro ao fazer upload',
  x_7fb62b30: 'Exclusão em lote',
  x_56b318c4: 'Carregar imagens em lotes',
  x_06a90552: 'Tem certeza de que deseja recodificar todos os produtos classificados por nome? (01, 02, 03...)',
  x_9708fbed: 'Reordenação de codificação concluída',
  x_d959452f: 'Reordenação de codificação',
  x_7bf54e28: 'Selecionado',
  x_66eeacd9: 'Selecionar tudo',
  x_a04144e4: 'Desmarcar tudo',
  x_cd0b9aca: 'Excluir selecionado',
  x_3c237c07: 'Conectar impressora',
  x_c5ea9c6a: 'Conectado',
  x_81ba5ea7: 'Imprimindo...',
  x_de2bc1d2: 'Exibição de etiqueta',
  x_693b926b: 'Mostrar moeda estrangeira ($)',
  x_3b64fbff: 'Mostrar B',
  x_80806771: 'Sem decimais',
  x_ac837e75: 'Mostrar código de barras',
  x_55c475bb: 'papel de etiqueta',
  x_b2a6f7ae: 'térmica de 80mm',
  x_9e5dde5b: 'Etiqueta 50x30mm',
  x_a7ad78bd: 'Bilíngue (ES+CN)',
  x_5423e287: 'Sem fotos',
  x_9460a7d0: 'Tamanho × Variações de Cor',
  x_5b02e434: 'Descontinuado (manter em estoque)',
  x_7b6defeb: 'Reativar',
  x_2f4aaddd: 'Excluir',
  x_4d775d4c: 'mostrar',
  x_f4f85316: 'Página anterior',
  x_b4e1b508: 'Próxima página',
  x_8056acb6: 'a granel',
  x_8fe35fdc: 'min',
  x_7d1f14ef: '0 = desligado',
  x_dc90fae8: 'ajuste de estoque',
  x_a59299fc: 'Gestão de transferência de carga',
  x_01dcb2bb: 'Falha na solicitação de imagem, primeiro defina o número do chefe em /admin/whatsapp-settings',
  x_d5124910: 'Remover plano de fundo com IA? (3 créditos)',
  x_cfc6745d: 'Processando... (~15s)',
  x_57553dee: 'Corte AI concluído!',
  x_94c6b3ba: 'Falha no corte de IA',
  x_b4168dc5: 'Usar a imagem original para recortar a imagem com IA? Subtraia outro 1 ponto de IA',
  x_afcaa4ef: 'Reprocessamento de IA...',
  x_b6cd67bb: 'O corte está completo!',
  x_164df077: 'Falha no corte',
  x_48fde72b: 'Restaurar a imagem original antes do corte AI?',
  x_80145d31: 'A imagem original foi restaurada.',
  x_7bd43c80: 'Falha na restauração',
  x_c74e4f1a: 'Selecione a categoria de importação',
  x_5fcb1e4d: 'Selecione a categoria',
  x_45e49ae9: 'Não especificado (usar classificação de arquivo)',
  x_7c60e550: 'Após a seleção, todos os produtos importados serão classificados nesta categoria.',
  x_e111f522: 'Selecione os campos de importação',
  x_41e49b1c: 'Informações básicas (número, nome, especificações) são sempre importadas',
  x_020f1ecd: 'comece a subir',
  x_92cd554e: 'Subindo...',
  x_794a4ecb: 'Todos os produtos',
  x_abaff128: 'Exemplo: 10 = custo aumentado em 10%',
  x_2fff577b: 'Preencha pelo menos um item',
  x_9fce5962: 'Categoria:',
  x_2fb90b05: 'Processando...',
  x_2901ac42: 'Confirmar ajuste de preço',
  x_727dc210: 'Corte de IA em lote',
  x_7385d670: 'Selecione tudo com fotos',
  x_625fb26b: 'Cancelar',
  x_a642d255: 'Nome da loja:',
  x_04870124: 'Etiqueta da loja',
  x_d5acfdec: 'sem rótulo',
  x_6e41198f: 'QUENTE',
  x_46a742e3: 'NOVO',
  x_e1179aa4: 'OFERTA',
  x_47eddf7c: '🥬 A granel / vendido por gramas e quilogramas',
  x_7c88c892: '(A loja online exibirá o rótulo "Em massa" e os clientes poderão comprar decimais como 0,5/1,8)',
  x_28b47633: 'Temporada',
  x_7c8d6872: 'Sem temporada -',
  x_2f1cc7f8: 'Primavera',
  x_e87105bf: 'verão',
  x_dded849e: 'Outono',
  x_7c7a55ef: 'inverno',
  x_6047e490: 'o ano todo',
  x_89f7904f: 'Para descontos de final de temporada.',
  x_9966d712: 'Palco',
  x_61541067: 'Sincronizado -',
  x_efd81299: 'Entrada primeiro',
  x_864dc4dc: 'Prato principal',
  x_125653fe: 'Acompanhamento',
  x_c64f64c1: 'Beber',
  x_c63fb6f7: 'Sobremesa no final',
  x_e091ce54: 'A cozinha votará de acordo com este grupo · Cozinha grupo por etapa',
  x_58b439e0: 'Tempo de preparação',
  x_210974b9: 'É usado para fazer pedidos e fazer pedidos.',
  x_4a2ac468: 'Imprimir na cozinha',
  x_88ca75d5: 'Pedidos feitos após o fechamento não serão enviados para a cozinha (adequado para bebidas/compras ao ar livre)',
  x_ee4e4b38: 'Lote',
  x_e7100153: 'Maturidade',
  x_1ac5191c: 'Produto de prescrição',
  x_52af7df5: 'A identidade do cliente será obrigatoriamente registrada durante as vendas.',
  x_ae0b0527: 'Série',
  x_89d8ab7a: 'Garantia (meses)',
  x_b5e44315: 'Variantes/variações de sabor',
  x_5adfcd10: '(separados por vírgulas)',
  x_72ee7c09: 'Quantidade de atacado de automóveis',
  x_378c05db: '(armazém principal da ALFONZO SHOP)',
  x_c852c3dc: 'Outros armazéns (somente leitura, use "Ajuste de estoque" ou "Gerenciamento de transferência" para modificar)',
  x_5c0c578b: '📱Foto do WhatsApp por favor',
  x_a1773715: '✨ Corte AI',
  x_90f7259e: '🔄 Colheita',
  x_e955fcb2: '↩️Restaurar imagem original',
  x_ae5ad52a: 'Faça upload de imagens de produtos em lotes',
  x_7c5dc935: 'Como usar:',
  x_eabafd4b: '1. Clique no arquivo de imagem',
  x_f9d8b163: 'Código do produto',
  x_25c971d2: 'Nome',
  x_c2654942: 'Por exemplo: código do produto',
  x_d13c1bb8: '→A imagem é chamada',
  x_1aeffd84: '2. Selecione todos os arquivos de imagem e carregue-os de uma só vez.',
  x_3be0aaea: '3. O sistema corresponde automaticamente ao código e atualiza a imagem do produto.',
  x_b226d05e: 'Formatos suportados: JPG, JPEG, PNG, WEBP',
  x_f08afd1f: 'Selecionado',
  x_6d03439d: 'arquivo, clique em "Iniciar upload" para corresponder à codificação do servidor',
  x_7b9de9b7: 'Nenhum produto correspondente encontrado:',
  x_c4390da8: 'Erro:',
  x_b15d9127: 'Fechar',
  x_ec74c566: 'Ajuste maciço',
  x_85f16ef9: 'Categorias/Categoria (deixe em branco = todas)',
  x_7f1fd8fd: 'tudo',
  x_ef7e66eb: 'Aumento de custos (%)',
  x_ebb263a8: 'Nova Margem / Nova Margem (%) — Deixe em branco e não altere',
  x_e93880f5: 'Benefício 1 (P1)',
  x_e105c7e7: 'Benefício 2 (P2)',
  x_af32ce55: 'Benefício 3 (P3)',
  x_3621e3c6: 'Fórmula: novo preço de venda = novo custo × (1 + margem de lucro%)',
  x_0d2f0cb5: 'Exemplo: Custo $ 1 + Lucro 30% = Preço de venda $ 1,30',
  x_fc51faec: 'Tema de plano de fundo da loja online',
  x_1dbb0d24: 'Tipo de loja',
  x_faeff5ef: 'supermercado',
  x_2580b405: 'restaurante',
  x_2ac97357: 'lojas de departamento',
  x_3972c872: 'farmácia',
  x_94f1c5f0: 'padaria',
  x_d2fe24af: 'roupas',
  x_cdce861f: 'produtos eletrônicos',
  x_4c745eb9: 'açougue',
  x_aa05fd09: 'Universais',
  x_b42f3d0b: 'imagem personalizada',
  x_470c8cb6: 'Carregue uma imagem de fundo (recomendado 1920x800, máximo 5 MB)',
  x_ba9fc45d: 'Selecione a imagem',
  x_a7699ba7: 'Carregamento bem-sucedido',
  x_97e448c5: 'Descrição da loja (exibida na página inicial da loja online)',
  x_e90f3dd4: 'placeholder={t(\'shopDescPlaceholder\') || \'Por exemplo: frutas e vegetais frescos entregues diariamente\'} data-testid=',
  x_e4de2708: 'Visualização do link da loja online',
  x_146c214c: '⚡ Cobrança rápida',
  x_847d3492: 'rede de convidados',
  x_0d9614ed: 'Opções de impressora',
  x_a305b265: 'Impressora de recibos comum (POS)',
  x_9d2ae79f: 'Nome da impressora',
  x_37ba4d4d: 'Método de impressão',
  x_e3127cc1: 'Formato',
  x_dc7ac037: 'Termossensível',
  x_8419e5a2: 'Impressão automática',
  x_b815bd61: 'Modo compacto (fonte -40%)',
  x_0a50b98b: 'Número de cópias a serem impressas',
  x_95a11756: 'Impressão de teste',
  x_08d73983: 'Impressora de relatórios',
  x_1822051b: 'tamanho do papel',
  x_086f6c26: 'Usado para imprimir documentos A4, como relatórios de vendas e relatórios de estoque.',
  x_f6c5bb79: 'Impressora Fiscal (Imposto)',
  x_85fc7de8: 'Modelo de impressora',
  x_923f0558: 'porta de conexão',
  x_9ec10f88: 'Ativar controle de gaveta de dinheiro',
  x_46886d25: 'Imprimir número do item (somente documentos fiscais)',
  x_0d1eb73c: 'Configurações de impressão silenciosa (nenhuma caixa de diálogo de impressão aparece)',
  x_c530a752: 'Defina XP-80C como impressora padrão do Windows',
  x_f5dcc91d: 'Baixe o arquivo de atalho abaixo, coloque-o na sua área de trabalho e clique duas vezes para abri-lo.',
  x_34c425af: 'Use o modo de processo autônomo sem fechar outras janelas do navegador',
  x_1f439178: 'Permitir 0 estoque/pedido quando negativo (Permitir sobrevenda)',
  x_d28ccc95: 'Exemplo: 5 = menos 5%',
  x_89b146df: 'Exemplo: 3 = menos 3%',
  x_3b108349: 'Salvo com sucesso',
  x_6de920b4: 'Erro ao salvar',
  x_667519a7: 'Limpando cache...',
  x_715e78ba: 'Limpe o cache, recarregando...',
  x_3d58a3f4: 'Erro durante a limpeza',
  x_635d85ed: 'Método de custeio',
  x_9f3cdb13: 'Último custo',
  x_cdf4510f: 'Média ponderada',
  x_a2361773: '✓ Ao receber mercadorias em lotes mistos com duas taxas de câmbio, o lucro será calculado com maior precisão com base no custo médio.',
  x_8c332c85: 'Salário mínimo legal (Bs/mês) Salário mínimo',
  x_1f1cb126: 'Quando o governo reajustar o salário mínimo, altere aqui. Valor padrão atual: Bs. 130,00',
  x_fcf71823: 'Clientes WiFi escaneiam o código QR para se conectar à Internet',
  x_a4162fc6: 'SSID WiFi (nome da rede)',
  x_93952fec: 'Senha Wi-Fi',
  x_aea862e7: 'Quando os clientes pagam com PagoMovil, um código QR WiFi será exibido na janela de verificação para que os clientes leiam o código para se conectar à Internet.',
  x_764327eb: 'Recomenda-se utilizar a “rede de convidados” do roteador (Guest Network) para configurar a desconexão automática em 2 minutos.',
  x_d38fdd96: 'Quiosque (silencioso - recomendado)',
  x_64ae72e7: 'Conexão direta USB (porta serial COM)',
  x_3ac81273: 'Quiosque (silencioso - compartilhado com ingressos normais)',
  x_a27aa9d2: 'Conexão USB direta (porta serial COM - impressora fiscal independente)',
  x_1fdcab60: '📦 Regras de inventário',
  x_8c0b62d0: '⚠️ "Permitir venda excessiva" foi ativado',
  x_0b98802c: '🛡 Modo estrito (recomendado)',
  x_3469dcde: '🏭 Limite de identificação automática no atacado (peças)',
  x_abe9d5a5: 'Qualquer pedido único ≥ esse valor → será automaticamente considerado um pedido em grandes quantidades',
  x_66b516be: '🏭 Pedidos no atacado: pontos / $ 1',
  x_44cdb632: 'Use esta proporção para pedidos no atacado (geralmente menor que no varejo para proteger os lucros)',
  x_cad2cdb3: '📊 Cálculo de reembolso:',
  x_e9b42d03: 'Desconto na loja online',
  x_c8ebef70: 'Desconto à vista',
  x_b315c033: 'Desconto de crédito de 7 dias',
  x_92f50a16: 'Crédito de 15 dias sem desconto. Os descontos são calculados automaticamente durante a finalização da compra na loja online.',
  x_6a46e901: 'Salvar configurações de desconto',
  x_aecb318e: 'Versão atual:',
  x_fd044b72: 'Limpeza: Service Worker + API de cache + sinalizadores LocalStorage PWA',
  x_c3c63335: 'Verifique o cartão primeiro',
  x_258b5e0a: 'Saldo insuficiente',
  x_6074ad12: 'Erro de carregamento do cartão / Erro de dedução do cartão com valor armazenado',
  x_4091e27c: 'Desconto',
  x_952fe994: 'pagamento dividido',
  x_d9b8f7dc: 'Código (GC-XXXX...)',
  x_df635901: 'Digite o código e PIN',
  x_44efeacf: 'cartão inválido',
  x_cd8992b6: 'verificar',
  x_fbb9242b: 'Justo',
  x_ac770469: 'Desaparecido',
  x_855bfd60: 'lidar com',
  x_a1b49020: 'Não é bom o suficiente',
  x_c993e001: 'mudar',
  x_450efd2f: 'total',
  x_23d0eed8: 'próximo',
  x_aaf7077a: 'dias',
  x_249aba76: 'dia',
  x_1ceaeb7c: 'Pesquisar funcionário / Pesquisar funcionários...',
  x_0c9d2b45: 'Método de pagamento',
  x_e83a256e: 'Confirmar',
  x_bf15f831: 'Subtotal',
  x_954a5f2c: 'Total a pagar',
  x_a2e76886: '% porcentagem',
  x_4ca7ca2e: '$ menos quantia',
  x_62409e5c: '$ preço final',
  x_4ea4474d: 'Escolha qualquer um: Complete 3 → 97% de desconto · ou US$ 1,57 de desconto · ou perca os US$ 50 finais',
  x_f761deae: 'Selecione um cliente / Selecione o cliente primeiro',
  x_719a6f48: 'Prazo de pagamento / Número de dias a crédito',
  x_a2c1dba8: 'Selecione um funcionário / Selecione um funcionário',
  x_203546f6: 'Preço alterado',
  x_2432b575: 'Observações',
  x_a8b0c204: 'tudo',
  x_4c37b31d: 'Atualmente não há produtos nesta categoria.',
  x_d8318796: 'Por favor insira o nome do produto',
  x_2d5bd318: 'Insira custo e margem P1',
  x_3fdaeadf: 'Adicionado com sucesso',
  x_26983664: 'Insira o valor do reembolso',
  x_b58060b3: 'Pagamento salvo off-line',
  x_ae5a8a24: 'Pagamento bem-sucedido',
  x_8b649901: 'Falha no reembolso',
  x_d594b77a: 'Por favor insira o valor',
  x_305091bd: 'Selecione um funcionário',
  x_e2079942: 'Por favor insira o valor do salário',
  x_cdef21ee: 'As deduções não podem exceder os salários.',
  x_43b972b2: 'O pedido não foi encontrado.',
  x_0d66ed02: 'Falha na consulta',
  x_8093e392: 'Por favor insira o nome',
  x_08b1fa13: 'Por favor insira o nome de usuário',
  x_11524166: 'A senha deve ter pelo menos 4 dígitos',
  x_b5e12476: 'Funcionário adicionado com sucesso',
  x_ea340b7c: 'pedir dinheiro emprestado',
  x_3f01df5b: 'mercadorias a crédito',
  x_4c95bf44: 'reembolso',
  x_79ef16e5: 'deduções na folha de pagamento',
  x_ded3cdfb: 'pagar salários',
  x_029d48fa: 'Ausência do trabalho bem',
  x_5ba2fb47: 'Atrasos históricos',
  x_756048fc: 'Declaração do funcionário',
  x_4ff1e74e: 'Data',
  x_226b0912: 'Tipo',
  x_4cf24aba: 'Quantidade',
  x_5a4fcfe2: 'Valor atual devido',
  x_26068dad: 'tempo de impressão',
  x_d0de55dc: 'Perfurado com sucesso',
  x_15ffd5c7: 'Entrei e saí do trabalho com sucesso',
  x_20cdb977: 'Falha ao fazer check-in',
  x_bd4357f9: 'o dia todo',
  x_c31b1b99: 'meio dia',
  x_02efd8b1: 'absenteísmo',
  x_95748d60: '✅ A dívida devida por ausência naquele dia foi automaticamente cancelada.',
  x_40862774: 'Erro de discagem',
  x_b6838383: 'alugar',
  x_0ee0c81c: 'Água e eletricidade',
  x_be11fc04: 'salário',
  x_1f4beff9: 'Consumíveis',
  x_324712a3: 'Reparar',
  x_0f3a252a: 'transporte',
  x_2a0ad6ff: 'restauração',
  x_638e3280: 'impostos',
  x_0d98c747: 'Outros',
  x_fdfd5d5f: 'Selecione um funcionário primeiro',
  x_50bcbd71: 'Falha na folha de pagamento',
  x_36cb9c59: 'Programação de turno salva',
  x_57b08dd4: 'sem equipe',
  x_efafd9a3: 'A solicitação falhou',
  x_8f21b986: 'Por favor insira o nome do modelo',
  x_979b4faf: 'Modelo excluído',
  x_acf0664a: 'Excluir erro',
  x_1603b069: 'segunda-feira',
  x_b5a6a07e: 'terça-feira',
  x_e60725e7: 'Quarta-feira',
  x_170fc8e2: 'Quinta-feira',
  x_eb79cea6: 'sexta-feira',
  x_24575130: 'sábado',
  x_562d7476: 'domingo',
  x_f8fbeae1: 'amanhã',
  x_e2eb289c: 'tarde',
  x_51147c21: 'hugo',
  x_fbcf05da: 'título>',
  x_e1adc7de: 'h2><p class="sub">',
  x_ae2703cb: 'º><º>',
  x_e3e234b4: '<span><span class="box" style="background:#d4edda"></span> O dia todo</span>',
  x_034dcc79: '<span><span class="box" style="background:#fff3cd"></span> Amanhã</span>',
  x_ebdf24a9: '<span><span class="box" style="background:#ffeaa7"></span> Tarde</span>',
  x_13db7d6d: '<span><span class="box" style="background:#f0f0f0"></span> Descanso</span></div></body></html>',
  x_bd626c2f: 'Assinado com sucesso',
  x_2bd5e2ab: 'Erro de assinatura',
  x_c10a6c00: 'Por favor preencha o completo',
  x_1fbd718d: 'O dinheiro deve ser menor que o valor gasto com o cartão.',
  x_c31eabb4: 'cartão magnético',
  x_acaf665f: 'transferir',
  x_b416b575: 'pagamento móvel',
  x_41ce131a: 'misturar',
  x_3df74976: 'crédito',
  x_0319bf13: 'Resumo comercial do dia.',
  x_fbb493d0: 'Número de pedidos',
  x_8bd00685: 'Painel de administração da loja',
  x_9c1d16fc: 'aberto hoje',
  x_cc1987ec: 'Ver inventário',
  x_78d078e8: 'despesas',
  x_29225555: 'Ganhos cambiais',
  x_e7c0908c: 'dinheiro',
  x_2f6805aa: 'conta de funcionário',
  x_d37a7de1: 'Programação',
  x_fa3aee98: 'Adicionar produto',
  x_848704b1: 'Transferir e receber mercadorias.',
  x_94fea5cb: 'Resumo do dia inteiro',
  x_843e649c: 'Mudança atual',
  x_19940592: 'Não há voos ativos',
  x_b1423de3: 'média única',
  x_5bc31fd0: 'Por forma de pagamento',
  x_c2e5a8e2: 'Estatísticas por moeda',
  x_b634ce2e: 'Pedido aberto Bs',
  x_d0af2c40: '$ Abra um pedido',
  x_83958d46: 'solteiro',
  x_aded5d5b: 'receber',
  x_eddd9ee1: 'reconciliação',
  x_d97f0de8: 'coleção total',
  x_be77abaa: 'Estatísticas por caixa',
  x_3960424f: 'Reconciliação de troca de dinheiro',
  x_2e8e048d: 'receber dinheiro',
  x_043d5f39: 'mudança total',
  x_534097e9: 'caixa líquido',
  x_22b91744: 'Somente são contabilizadas as ordens de pagamento com valores recebidos registrados.',
  x_21533faf: 'Imprimir resumo do negócio',
  x_a8e76489: 'Ver detalhes do pedido',
  x_dc9b2ec5: 'tela do caixa',
  x_bfdaebfd: 'caixa',
  x_654522d2: 'Moeda',
  x_0bf60b32: 'Quantidade',
  x_da4abd3e: 'preço unitário',
  x_f599fcd3: 'Subtotal',
  x_26922a58: 'recebido',
  x_56ae8659: 'Todos os armazéns',
  x_adcd38b7: 'Pesquisar + Enter / Pesquisar nome/código do produto...',
  x_0aaf10c2: 'Nenhum produto correspondente encontrado',
  x_d3bc58b6: 'taxa de câmbio',
  x_f155c56c: 'Taxa de câmbio selecionada',
  x_37a3f5ca: 'Convertido para dólares americanos',
  x_ac502247: 'Compre USD em dinheiro',
  x_2feedc17: 'Passe o cartão para receber dinheiro',
  x_2ddd1415: 'Valor em dólares ($)',
  x_735fcb9f: 'taxa de compra',
  x_27cae7b2: 'taxa de vendas',
  x_26431425: 'custo de bs',
  x_9aef4e3c: 'valor em bs',
  x_cb340191: 'benefício',
  x_b58c7549: 'adicionar',
  x_f58a32cd: 'Valor do cartão de crédito roubado (Bs)',
  x_d5dd40af: 'Dê dinheiro (Bs)',
  x_171cc7f8: 'Lucro (Bs)',
  x_f2d612ee: 'Taxa de manuseio',
  x_524d7e11: 'Lucro de hoje (Bs)',
  x_58add0bd: 'Lucro de hoje ($)',
  x_19fcb9eb: 'hora',
  x_f26225bd: 'Detalhes',
  x_e052f520: 'Lucro ($)',
  x_cbe408cd: 'comprar dólares',
  x_a185dea2: 'Passe seu cartão para resgatar dinheiro',
  x_b9db8476: 'Ainda não há registro',
  x_c966e6db: 'Dinheiro em dólares americanos',
  x_d96c0531: 'Bs em dinheiro',
  x_b7b3fa73: 'Câmbio rápido',
  x_1c927ecc: 'Não há necessidade de ir para a guia de câmbio, basta fazê-lo aqui',
  x_b28432d4: 'Vá e troque moeda',
  x_661f8852: 'operações em dinheiro',
  x_4cc6a2f6: 'Depósito',
  x_7be8ae3a: 'tirar',
  x_474a556a: 'vire isso',
  x_1827f06e: 'ajustar',
  x_0367ebd1: 'Observações...',
  x_abe2c5d2: 'Enviando...',
  x_b66b2e82: 'registros recentes',
  x_676e5982: 'operador',
  x_7f0dc5e3: 'vendas',
  x_774e1765: 'trocar',
  x_742440c4: 'Contas de funcionários',
  x_2ef46a5f: 'Adicionar funcionário',
  x_60d0458a: 'nome',
  x_32ffa250: 'número de identificação',
  x_5a93d3f7: 'telefone',
  x_819767ad: 'Nome de usuário',
  x_a8105204: 'Senha',
  x_464f3d4e: 'papel',
  x_3887bfff: 'Funcionários comuns',
  x_bbc407c7: 'inspetor de preços',
  x_586a52f3: 'limite de crédito',
  x_eeb4d5b7: '0 = sem limite',
  x_25cebe66: 'valor do salário',
  x_b5ca1dd9: 'ciclo de pagamento',
  x_09b03b6d: 'semanalmente',
  x_93a158a9: 'a cada 15 dias',
  x_aa3d57c0: 'mensalmente',
  x_5e3640e4: 'Confirme para adicionar',
  x_4c998309: 'Imprimir cartão QR',
  x_8d7eb002: 'Recibo + QR',
  x_2dbf283b: 'Extrato de conta',
  x_e8da0032: 'Atrasados',
  x_bbdd42a0: 'resolvido',
  x_620610c0: 'foi devolvido',
  x_8577b01a: 'Retirada de depósito',
  x_44ba3fed: 'Não foi possível extrair',
  x_7b1df363: 'Atualmente não há registro de dívidas de funcionários.',
  x_7941da94: 'um',
  x_2d8be272: 'dois',
  x_e662ff59: 'três',
  x_21716cf3: 'quatro',
  x_1fcc29d0: 'cinco',
  x_61b45352: 'seis',
  x_3edddd85: 'dia',
  x_93849f29: 'atendimento de hoje',
  x_416b2ef6: 'já está desempregado',
  x_b767d98a: 'no trabalho',
  x_6bc72d59: 'Não registrado',
  x_b4f0388f: 'ir trabalhar',
  x_96ed60cd: 'sair do trabalho',
  x_7b6e413b: 'Adicionar contas de funcionários',
  x_37c140e9: 'Selecione funcionários',
  x_99b437e5: 'Empréstimos a funcionários',
  x_c06881f5: 'Dê bens aos funcionários a crédito.',
  x_fbb40b61: 'Pagamento de funcionário',
  x_783aaf86: 'Importar dívidas históricas',
  x_859e83a6: 'Apenas o valor devido é registrado, nenhum saldo de caixa é deduzido.',
  x_83ba80ef: 'A transferência não afeta o saldo de caixa da loja.',
  x_27622285: 'salário total',
  x_a46225b3: 'Digite o número do pedido para fazer a consulta automaticamente',
  x_bee912d7: 'Consulta',
  x_b433e6c6: 'Informações do produto',
  x_f87737b3: 'Detalhes do produto de crédito...',
  x_2edddab1: 'salário diário',
  x_074eca2c: 'Dedução de salários em atraso',
  x_20b7f99c: 'cabelo de verdade',
  x_39ce9e78: 'Sem dedução (tudo em dinheiro)',
  x_82a6f2f0: 'Os funcionários pagam com Bs → Convertem USD automaticamente para compensar atrasos',
  x_162fe161: 'Gerente de Loja: Preencha você mesmo a taxa de câmbio',
  x_7e21332c: 'Pessoal: taxa de câmbio BCV',
  x_767b82cb: 'Preenchimento automático',
  x_9e3eba91: 'Modo de cálculo',
  x_3aed2c11: 'automático',
  x_2a3e7f5c: 'manuais',
  x_b4b4b75b: 'Ajustável automaticamente',
  x_0a61f1ae: 'Limite de crédito excedido!',
  x_c6403f20: 'Taxa',
  x_28b24262: 'Depois da operação',
  x_2e81e23d: 'além',
  x_07b42ee9: 'histórico de transações',
  x_2ed39222: 'funcionários',
  x_e05e6f34: 'equilíbrio',
  x_e25b7872: 'Adicionar novo produto',
  x_1fd1d5c5: 'Nome do produto',
  x_cc6c35a3: 'codificação',
  x_d0771a42: 'Classificação',
  x_2e2ce286: 'preço de custo',
  x_7a3da957: 'margem de lucro',
  x_2acbbffe: 'O sistema calcula automaticamente o preço.',
  x_650f9201: 'caixa inteira',
  x_3301f812: 'Quantidade por caixa',
  x_2a79a737: 'taxa de imposto',
  x_72993534: 'Quantidade recebida',
  x_39f76a9b: 'código de barras',
  x_257a8023: 'Digitalize/insira o código de barras e pressione Enter',
  x_4347fc1c: 'Os produtos adicionados serão sincronizados com todas as filiais, mas apenas nossa loja possui estoque.',
  x_ae1c4d7f: 'Pesquisar número do cliente/pedido...',
  x_322ade24: 'não pago',
  x_fa25eda2: 'expirou',
  x_13992709: 'Amortização parcial',
  x_480018e8: 'valeu a pena',
  x_4403fca0: 'Excluir',
  x_c624290a: 'registros',
  x_c75e2f5f: 'Aguardando coleta',
  x_ff0b2077: 'Cliente',
  x_1e8dc255: 'Número do pedido',
  x_6ffe81e2: 'valor total',
  x_57b642fc: 'Pago',
  x_499b9a62: 'data de validade',
  x_3fea7ca7: 'Estado',
  x_2b6bc0f2: 'Operação',
  x_45274498: 'parte',
  x_1611cbc7: 'Para ser devolvido',
  x_2722964b: 'Nenhum registro correspondente',
  x_8e6adfe0: 'Valor do reembolso',
  x_37fa12a4: 'Ordem de transferência de mercadorias a receber',
  x_694fc5ef: 'Atualizar',
  x_bf08ab13: 'Não há ordem de transferência para receber',
  x_4933ca41: 'Aguardando recebimento',
  x_04531587: 'Envio',
  x_91bcfc81: 'armazém principal',
  x_8690efe6: 'Número de remessas',
  x_a8974abd: 'Receitas reais',
  x_a18a1f0c: 'Confirmar recebimento',
  x_29825420: 'O armazém não está carregado, tente novamente mais tarde.',
  x_38bbc161: 'Armazém não carregado',
  x_1ba301c3: 'Enviado para aprovação do administrador / Enviado para aprovação do administrador',
  x_72520580: 'esta semana',
  x_9c5f8689: 'Pagar salários aos funcionários selecionados.',
  x_ba4c8037: 'Salvar programação',
  x_f8dfedcd: 'farelo',
  x_0963bb54: 'Modelo de turno',
  x_cb86af8d: '{t(\'nome do modelo\') || \'nome do modelo\'}',
  x_eb347bdb: '+ Novo',
  x_26b5bd49: 'Carregando...',
  x_69a69eb0: 'estimativa salarial semanal',
  x_85a77ddc: 'Clique na grade para percorrê-la',
  x_80da96c6: 'Cronograma',
  x_c59cae5e: 'Horário dos funcionários',
  x_3a991a4c: 'descansar',
  x_10627c90: 'Como calcular o número de entradas e saídas.',
  x_955acdc0: 'Lançamento manual de vendas à vista.',
  x_cd06c6b3: 'Aumento do tanque/ajuste manual',
  x_a9f5d26a: 'Retire/entregue/ajuste a redução manual',
  x_a20bbe5d: 'Pagamento de salário/empréstimo ao funcionário',
  x_d13feaa2: 'Biopagamento/furto/transferência não conta para o saldo em dinheiro (para o banco)',
  x_aaa36041: 'Valor VES = preço do produto USD x taxa de câmbio BCV',
  x_0e59b159: 'Trabalhar de férias = 1,5 vezes o salário (calculado automaticamente)',
  x_63686703: 'Não há feriados este mês',
  x_362bb8be: 'Recibo de pagamento',
  x_79274ddb: 'Estoque/Inventário',
  x_5d855937: 'expirou',
  x_dcc961ae: 'anulado',
  x_a0bf20e8: 'Para sincronizar',
  x_c2c0df04: 'Salvo neste PC',
  x_4650017d: 'Sem rede: as contas de crédito foram salvas localmente e são exibidas na lista (amarelo para sincronizar) e serão carregadas automaticamente após a conexão com a Internet.',
  x_eb3eae91: 'Pagamento salvo neste PC',
  x_fa17371a: 'Sem rede: O pagamento foi registrado localmente (amarelo para sincronizar) e será cobrado automaticamente após conexão com a Internet.',
  x_1c97a7ce: 'Expira em breve',
  x_a44f40d4: 'O número do celular do chefe não está definido, acesse as configurações do WhatsApp para adicioná-lo.',
  x_464208d1: 'Erro ao enviar',
  x_1cf1a230: 'Envie um resumo das contas vencidas para o WhatsApp do seu chefe',
  x_24cc017a: 'Erro ao enviar reivindicação',
  x_6910a681: 'Envie automaticamente lembretes do WhatsApp para todos os clientes atrasados ou atrasados',
  x_aab87728: 'Pago, sem faturas pendentes',
  x_a48948bf: 'Todas as lojas',
  x_a7da9234: 'loja',
  x_6b0cbe98: 'Olhe para o canto superior direito☁️',
  x_832af156: 'Carregar automaticamente on-line',
  x_d2593e04: 'Somente dólares americanos',
  x_8e0be5e5: 'O upload do pagamento foi recusado, clique em ☁️ no canto superior direito para processar',
  x_10efc391: 'Detalhes do produto',
  x_1c40f543: 'Histórico de pagamentos',
  x_d88fb1dd: 'Este crédito deve ser pago em dólares americanos.',
  x_84857e3e: 'Lembrete de expiração de crédito',
  x_43b510ed: 'restante',
  x_bfc2bc5a: 'Ainda não há contas de crédito vencidas/vencidas',
  x_f3737dbf: 'Número do pedido',
  x_7c5f7ff6: '💵 USD não recebido',
  x_139bf01e: '🇻🇪 Bs não recebidos (valor atual em USD)',
  x_23414073: '⚠️ USD e Bs não somam: USD é o dólar americano real recebido; Bs é registrado como um valor em dólares americanos com base na taxa de câmbio instantânea do dia e Bs é convertido usando a taxa de câmbio em tempo real do dia após o recebimento do pagamento.',
  x_7b7d5246: '⚠️ Há inadimplência no pagamento',
  x_b3032ddd: '@aquele dia',
  x_6845ced0: 'Valor total devido',
  x_1302a371: 'Histórico de pagamentos:',
  x_d7e9237c: 'O código de barras não corresponde ao produto.',
  x_ef48633e: 'Selecione um armazém diferente',
  x_dd2124ee: 'Por favor adicione o produto',
  x_1fc560de: 'Salvo off-line',
  x_b56601bf: 'Em seguida, verifique se ele aparece na lista.',
  x_028e7279: 'Ordem de transferência criada com sucesso',
  x_861505e1: 'A ordem de transferência foi cancelada',
  x_8ae6036e: '⚠️ Você inseriu a quantidade real recebida de todos os produtos como 0. \\n\\nIsso significa que nada será adicionado ao armazém de MANUEL. \\n\\nSe os produtos não chegaram, clique em "OK" para continuar. \\nSe for um erro, clique em "Cancelar" para retornar e recarregar.',
  x_d2875199: 'Criar uma nova ordem de transferência',
  x_7c5e97eb: 'Assinado por',
  x_cc1bacb5: 'Artigo',
  x_7031d352: 'Número do pedido de transferência',
  x_b683d031: 'Armazém de emissões',
  x_8dda8a9c: 'armazém de recebimento',
  x_8887e33b: 'valor total',
  x_2111ccbb: 'Cancelado',
  x_e699aa3c: 'Duplicar',
  x_ef091458: 'Cancelar pedido de transferência',
  x_f89fa9b6: 'Selecione o armazém',
  x_6b705e8c: 'Pesquise produtos/digitalize o código QR...',
  x_14545603: 'Código de digitalização da câmera',
  x_b26107b6: 'Criando...',
  x_73de67b8: 'Criar e imprimir',
  x_a9aa4fae: 'Assinar pedido de entrega',
  x_bf09ef8b: 'problema',
  x_15e9238b: 'receber',
  x_6edb92ec: 'Quantidade de chamadas',
  x_7a6e939a: 'Valor real recebido',
  x_7e28d689: 'A quantidade foi ajustada automaticamente à quantidade disponível. Por favor, confirme e envie novamente.',
  x_3e71abd0: 'ordem de transferência',
  x_ea887bd0: 'Especificações',
  x_ebb67faf: 'Assinatura de envio: _______________',
  x_6afdc8b0: 'Assinatura do recibo: _______________',
  x_4c271bd8: 'Ordem de transferência · Ordem de transferência',
  x_8d4312cd: 'De:',
  x_8a90ed66: 'Para:',
  x_cd50b523: 'Data de criação:',
  x_b5e8e5c3: 'Operador:',
  x_55bea7c5: 'Observações:',
  x_0a64548c: 'Produto',
  x_50b98e79: 'Valor da transferência',
  x_031a18b8: 'Assinatura do emissor · Data',
  x_81cb422e: 'Assinatura do destinatário · Data',
  x_90d971c7: 'Estoque insuficiente',
  x_59d31a31: '/obrigatório',
  x_3cd9e10d: 'O armazém de origem apresentará estoque negativo; lembre-se de reabastecer os produtos mais tarde.',
  x_866b795e: 'Erro ao carregar',
  x_acc47889: '✅ Adicionado',
  x_acd5cb84: 'falhou',
  x_c4ebcdbf: 'Tem certeza de que deseja excluir esta tabela?',
  x_cec8924c: '✅ Removido',
  x_fd691fb1: 'Tem certeza de publicar esta tabela? (O link do pedido pendente vinculado será excluído)',
  x_c77aedd7: '✅ Liberado',
  x_23f7319b: 'Erro ao carregar QR',
  x_65e200d3: 'Falha no download',
  x_28d45b55: '✅ ZIP baixado',
  x_b264a9b6: 'Erro de download:',
  x_d3a27772: 'Adicione tabelas primeiro',
  x_16fca75d: '✅ ZIP baixado / baixado',
  x_3317ce8e: 'Número da tabela (deixe em branco para automático)',
  x_f1e3f7fb: 'nome (opcional)',
  x_4af1e6c6: 'Número de assentos',
  x_a7bac223: 'chinês',
  x_806c4388: 'verde',
  x_d088e652: 'vermelho',
  x_b990b42b: 'laranja',
  x_2fc8da52: 'azul',
  x_34e66c72: 'roxo',
  x_9cba5857: 'preto',
  x_4207f36f: 'Tabelas',
  x_be5fbbe3: 'salvar',
  x_904614f6: 'Ainda não há mesa',
  x_55fdd74d: 'Primeiro vá em "⚡Industry Template" e selecione "🍽️Restaurant", o sistema criará automaticamente 10 mesas',
  x_505fcefc: 'Ou clique no botão "Adicionar tabela" acima para adicioná-la manualmente',
  x_d07d6cdf: 'Grátis',
  x_29880b96: 'Uso:',
  x_45e716f0: 'O cliente senta → o garçom seleciona o produto no PDV → pressiona “F4 para fazer o pedido”',
  x_362857a7: 'Insira comentários sobre o número da tabela (como "Tabela 3") ao fazer um pedido ou visite esta página para associar',
  x_5abc3304: 'O cliente deseja adicionar pratos → PDV recupera o pedido → Adiciona novos produtos → Substitui o pedido',
  x_d01b9612: 'O cliente quer pagar → POS recupera o pedido → recebe o pagamento → libera esta tabela',
  x_a889dfa2: 'Digitalize o código QR para fazer pedidos em cada mesa. Imprima ou baixe o ZIP e cole-o na sua área de trabalho.',
  x_56ba8da3: 'Sellox · Digitalize o código QR para pedir comida',
  x_a6bcd7fd: 'Digitalize o código QR para selecionar automaticamente um número de mesa',
  x_bffc3306: 'Ainda não há mesa; vá em "Adicionar tabela" à esquerda',
  x_22342357: 'Idioma',
  x_664bd4c3: 'Cor',
  x_562afa20: 'Selecione o idioma e as cores para ver a visualização',
  x_cdc8aa2a: 'Insira um valor válido',
  x_a6be14ea: '🎉 O cartão pré-pago foi gerado',
  x_a889286a: 'Falha na criação',
  x_d9217d95: 'Falha ao recarregar',
  x_73268407: 'Tem certeza de que deseja desativar este cartão? (O titular do cartão não poderá mais utilizá-lo)',
  x_174bdf89: 'Por favor insira o número do cartão + PIN',
  x_6047d376: 'O pop-up foi bloqueado. Ative o pop-up e tente novamente.',
  x_3671b15c: '4 dígitos',
  x_99c1801d: 'Encontre o nome do cliente/número de telefone/último número do cartão',
  x_ad6b7038: 'Disponível',
  x_9c2b5257: 'Fora de estoque',
  x_5c56a889: 'desativar',
  x_7779a6ac: 'Compre $ 50 e receba $ 5',
  x_81b5d9ee: 'Número do cartão copiado',
  x_a2fd009c: '🎁 Vale-presente/cartão com valor armazenado',
  x_cac30fb8: 'Código/número do cartão',
  x_a93dac50: 'Equilíbrio / Equilíbrio',
  x_fa6c3ef4: 'Por favor, guarde este cupom em um local seguro. É necessário o número do cartão + PIN para consulta e utilização.',
  x_d4334477: 'Cartões-presente',
  x_0e03f74c: 'Consultar saldo',
  x_f9089b58: 'Número do cartão (16 dígitos)',
  x_554b5f0d: 'Número da fila do cartão',
  x_3577a5ae: 'À venda',
  x_584cd195: 'Expirado',
  x_8a6e6c55: 'Ainda não há cartão de valor armazenado',
  x_11344dd6: '🎫 Liberação de cartões com valor armazenado',
  x_39a058d6: 'Insira o valor e os dados do cliente para gerar um novo cartão pré-pago.',
  x_5b90f4f9: 'Valor no cartão ($)',
  x_a10e8516: 'Presente da loja ($)',
  x_8f876263: 'Nome do cliente (opcional)',
  x_b4a12819: 'Número de telefone do cliente (opcional)',
  x_7430e2e0: 'Período de validade (dias, 0 = para sempre)',
  x_1ffb8483: 'gerar cartão',
  x_f0ec8be7: '🎉 Foi gerado um cartão pré-pago: anote o número do cartão + PIN',
  x_76bd513c: 'Copie o número do cartão e o PIN recém-gerados para o cartão físico.',
  x_a614e73a: 'Código',
  x_308111f4: 'Importante:',
  x_b3531d90: 'Número do cartão e PIN',
  x_f2c00976: 'Mostrar apenas desta vez',
  x_bd8ee68a: '🖨️Imprimir',
  x_a6dada89: 'Eu notei ✓',
  x_c5b6c7ba: '💵 Recarregue cartão com valor armazenado',
  x_7a8c087d: 'Adicione fundos adicionais aos cartões com valor armazenado que foram emitidos.',
  x_74fbcc56: 'Número da fila do cartão:',
  x_204538f5: 'Saldo atual:',
  x_1f143c8d: 'Valor da recarga ($)',
  x_7e410409: 'Ativo',
  x_eca18247: 'Concluído',
  x_9809e6f2: 'Cancelado',
  x_b7a2291a: 'Perder',
  x_5a08deaf: 'Erro ao carregar',
  x_63b8f2b2: 'Pesquisar número do pedido/cliente/número de telefone',
  x_e7784a34: 'Salvo',
  x_712939e0: 'A quantidade deve ser maior que 0',
  x_051e1c80: 'Coleção gravada',
  x_3d1f2fcc: 'Erro',
  x_22bbda1e: 'Permitir pop-ups',
  x_d6818f91: '<tr><td colspan="3" style="text-align:center;color:#999">Sem registro</td></tr>',
  x_dd139654: 'Cancelado/Cancelado (o estoque foi revertido)',
  x_5cbad596: '🟢Depósito',
  x_b5a103dc: '💵 Pagamento adicional',
  x_d98fd798: 'Nota/Nota (opcional)',
  x_5769b85a: 'Confirmar assinatura',
  x_a29d3fab: 'Razão',
  x_92b67f7b: 'Devolução do depósito ao cliente',
  x_094590c4: 'O depósito vai para o comerciante (sem reembolso)',
  x_2a33020e: 'Salvando...',
  x_0aa2fd58: 'Ativo',
  x_80e42329: 'Concluído',
  x_443483c9: 'todo o estado',
  x_fb852fc6: 'Em andamento',
  x_fad5222c: 'Concluído',
  x_d6a3df8d: 'confiscado',
  x_08226a9b: 'Itens',
  x_a015434e: 'Produtos',
  x_b9224f27: 'Valores',
  x_0b68090c: 'Total',
  x_8ed12dec: 'Pago',
  x_f085817a: 'Equilíbrio',
  x_7220e4d5: 'caminho',
  x_edd98a05: 'Sem registro',
  x_21a22391: 'Cliente',
  x_9f796492: 'Itens',
  x_3f1e93a5: 'Adicionar fertilizante',
  x_9b7e9298: 'Hoje:',
  x_464ee460: '🔒 Bloqueio de criação:',
  x_15e8601c: 'Dinheiro em dólares americanos',
  x_6aad3987: 'Bs em dinheiro',
  x_3ed4a686: 'Transferência',
  x_25557e0c: 'Cartão',
  x_66a35235: '⚠️ Cancelar pedido (o estoque será reposto automaticamente)',
  x_4253d249: 'regras separadas',
  x_150978ed: 'Ativar funcionalidade Apart',
  x_db82dff0: 'Min. % de pagamento antecipado',
  x_f411a870: 'Prazo (dias)',
  x_bfa32868: 'dias de graça',
  x_89d38266: 'Passado esse número de dias, o depósito será devolvido ao comerciante.',
  x_05e6cff3: 'Lembrete (dias antes)',
  x_780eb764: 'Eu recebo WhatsApp',
  x_ca0e7ab8: '🏭 Modelo específico da indústria',
  x_40a69a97: 'Selecione um setor para ativar recursos correspondentes + predefinições de categoria com um clique',
  x_ce198527: 'modelo de restaurante',
  x_4457ca2a: 'Gerenciamento de mesa · Expositor de cozinha KDS · Taxa de serviço · Impressão de grupo de pratos · Botão de emergência de pratos',
  x_f3bede6c: 'loja de roupas',
  x_31638707: 'Tamanho × variante de cor · Etiqueta sazonal · Redução automática de preço no atacado e varejo · O estoque é contado independentemente por variante',
  x_4b94f7ca: 'fast food/pastelaria',
  x_e4ec5eb2: 'Pedido de refeições · Bilhete de cozinha · 7 categorias pré-estabelecidas (pão/bolo/café)',
  x_f62e3009: 'Supermercado/mercearia',
  x_c6f34300: 'As 10 principais categorias A granel/pesagem habilitada por padrão Vendas de caixas inteiras Distinção da cadeia de frio',
  x_629960fd: 'farmácia',
  x_ba330da8: 'Classificação com/sem prescrição · Número do lote + aviso de data de validade · Rastreabilidade da receita',
  x_0f84be62: 'Hardware/Eletrônica',
  x_17b68710: 'Ferramentas/Pintura/Encanamento 7 Categorias · Rastreabilidade do Número de Série (Eletrônico) · Gerenciamento de Garantia',
  x_7bcbf628: '🛒 Caixa + Vendas',
  x_79223063: 'ATM POS inteligente',
  x_e5cbb127: 'Leitura de código de barras Vários níveis de preços Moeda dupla Bs/USD Teclas de atalho Operação offline',
  x_ed4d7ae6: 'Modo PWA off-line',
  x_c8bc72c1: 'O faturamento continuará a ser emitido mesmo que a rede seja desconectada · Após a restauração, a fila global será carregada automaticamente de forma síncrona',
  x_2e16c12a: 'Aplicativo de área de trabalho do Windows',
  x_44819336: 'Embalagem de elétrons · Sessão longa JWT de 90 dias · Atualizações silenciosas · Pronto para uso',
  x_a6185298: 'Centro comercial online + código QR',
  x_3ff0e9d1: 'A loja online é gerada automaticamente Os clientes escaneiam o código QR para fazer um pedido Pedido de autoatendimento / entrega porta a porta / coleta automática',
  x_c6840e7e: 'CRM do cliente + margem de lucro no atacado',
  x_c98fb10f: 'Reembolso de indicação de conta de pontos/crédito de nível de associação Alteração automática de preço para clientes de atacado',
  x_3a44d260: 'Impressão térmica',
  x_715e4b5e: 'Etiqueta de preço de recibo de 80 mm ESC/POS Conexão direta Configuração de impressora multiloja',
  x_61ac4d4d: '🛵 Entrega + Marketing',
  x_c51eca4b: 'Plataforma de passageiros + envio automático de pedidos',
  x_31439e52: 'Cadastro de passageiros · Rastreamento GPS em tempo real · Envio automático de pedidos com base na distância + disponibilidade · Contagem regressiva de pedidos de 60 segundos',
  x_50e8efc4: 'Desejos automáticos de aniversário no WhatsApp',
  x_a8701246: 'Digitalize os aniversários dos clientes às 09:00 todos os dias · Envie bênçãos automaticamente + códigos de desconto · Recompra gratuita',
  x_157c7c85: 'Mensagens em massa de Natal + programação',
  x_abe4ae61: 'Mensagens em massa com um clique para Natal/Dia das Mães/Dia dos Namorados Horário programado Lista de recordes históricos de feriados nacionais',
  x_1eb970e4: 'promoções',
  x_aef63132: 'Descontos · Descontos totais · Compra de presentes · Vendas flash por tempo limitado · Configuração por categoria/produto único',
  x_a1336484: 'shopping pontos',
  x_193aa1e3: 'Os clientes usam pontos para resgatar cupons, presentes ou recarregar seu saldo Resgate por tempo limitado',
  x_9a3ebc32: '💼Gerenciamento de back-end',
  x_83d7870e: 'Multi-armazém + transferência',
  x_5ca33875: 'Vários armazéns · Atribuir e criar armazéns de origem automáticos · Registrar automaticamente diferenças em recebimentos e relatar perdas · Rastreamento em trânsito',
  x_b3184a0c: 'Relatório de lucros e perdas (USD/Bs separados)',
  x_387e4ccd: 'Lucro bruto · Despesas · Perdas · Receitas cambiais · Cada moeda é exibida de forma independente',
  x_41cdb401: 'Gestão de caixa em agências + infalível',
  x_7c6e4907: 'Saldo em USD/Bs em tempo real · Grandes quantias (>100.000 Bs / $1k) devem ser confirmadas duas vezes · Evite depósitos acidentais',
  x_4bb41a3f: 'transferência de turno',
  x_12e3a178: 'Contagem de dinheiro · Assinatura do cliente · Lista de denominações · Envio automático de WhatsApp para o chefe',
  x_7be86c2c: 'Contas de funcionários + presença + folha de pagamento',
  x_50fa2355: 'Pagamento de crédito de empréstimo LOTTT Seção 106 Conformidade Folha de pagamento A4',
  x_8ddf6808: 'Registro de auditoria + auditoria de inventário',
  x_4d5169cd: 'Registros completos de operações de alto risco · Exportação CSV · Comparação noturna automática de produto.estoque vs armazém real',
  x_c97dba40: '🤖 Bênção da IA',
  x_6d06e53e: 'Embelezamento de imagem de produto AI',
  x_8ed5fef6: 'Gemini Nano Banana remove fundos com um clique + embeleza imagens de produtos Processamento em lote Restaura imagens originais',
  x_b94b644f: 'Assistente de bate-papo com IA',
  x_df5fb097: 'Atendimento ao cliente GPT-5.2 · Responder automaticamente ao status do produto/estoque/pedido · Online 24 horas por dia, 7 dias por semana',
  x_4ec4a23d: 'Verificação de pagamento móvel AI',
  x_56c6972a: 'A captura de tela da IA identifica automaticamente a quantidade/data/número de referência Revisão com um clique pelo caixa Antifalsificação',
  x_32a15937: 'O código de barras cria produtos automaticamente',
  x_875fae32: 'Digitalize ou insira o código de barras · Pesquise automaticamente o banco de dados global de produtos (Open Food Facts / UPCitemdb) · 0 entradas manuais',
  x_10899d94: '🌍 Adaptação multipaíses',
  x_ee7818c0: '8 países configurados automaticamente',
  x_77a6000a: '🇻🇪VE · 🇨🇴CO · 🇧🇷BR · 🇿🇦ZA · 🇩🇴DO · 🇨🇷CR · 🇹🇹TT · 🇵🇦PA · Taxa de câmbio/idioma/canal de pagamento automático',
  x_9dd027aa: '4 troca de idioma',
  x_f6cbc1ec: 'Chinês/inglês/espanhol/português: comutação com um clique',
  x_e3c6859e: 'Liquidação de moeda dupla + taxa de câmbio em tempo real',
  x_6cb9867e: 'Câmbio Bs/USD à vontade · BCV oficial + taxa de câmbio do mercado negro · Relatar câmbio de moeda com um clique',
  x_863683ad: 'PDV inteligente projetado para varejo',
  x_e1828ed2: 'Abrangendo 7 grandes indústrias · 4 idiomas · 8 mercados nacionais',
  x_3665550b: 'Restaurante · Fast Food · Vestuário · Padaria · Farmácia · Beleza: modelos industriais podem ser ativados com um clique · Teste gratuito de 7 dias',
  x_cd1ce731: 'Experimente agora gratuitamente',
  x_0d2a321f: 'Você já tem uma conta? Faça login',
  x_7bf86a2a: 'Todos os recursos',
  x_e539f895: 'Mais de 30 recursos que abrangem caixa, estoque, distribuição, marketing e inteligência artificial · Inscreva-se para aproveitar',
  x_6a4ab7b8: 'Registre-se agora',
  x_660d93f4: 'Experimente todos os recursos gratuitamente por 7 dias sem pagar · Configuração automática opcional para 7 grandes setores',
  x_5a631c6c: 'novo',
  x_402d19e5: 'Faça login',
  x_9ceb77bb: 'Suporte trilíngue · Liquidação em moeda dupla · 7 dias grátis',
  x_021782de: 'Suporte de idioma',
  x_81ea4b71: 'Execute na nuvem',
  x_1d3ba50c: 'Segurança de dados',
  x_2e525185: 'Suporta qualquer dispositivo',
  x_0ec9d3c3: 'Pode ser usado em computadores, tablets e celulares.',
  x_1cfc09aa: 'Cadastre-se para aproveitar todos os recursos',
  x_8e046e99: 'Criado para diversas empresas',
  x_d48f3735: 'loja de varejo',
  x_926a9ffe: 'Adequado para supermercados, lojas de conveniência, mercearias, lojas de roupas, etc.',
  x_cff3dc29: 'negócio atacadista',
  x_5087d5ee: 'Suporte ao sistema de preços de atacado, gerenciamento de contas-chave, contas a receber.',
  x_ce98716f: 'Gestão da cadeia de lojas.',
  x_320fd2de: 'A sede gerencia diversas filiais de forma unificada, com estoques de produtos interligados e atribuídos, e cada loja possui caixas e reportes independentes.',
  x_605629af: 'loja comum',
  x_14079459: '✨ Crie automaticamente 7 categorias de cardápio + 10 mesas + 10% de taxa de serviço',
  x_02d470b4: '✨ Cria automaticamente 8 categorias de roupas + variantes de tamanho e cor',
  x_19c60018: 'Modelo de varejo universal – sem categorias predefinidas, crie a sua própria (adequado para 90% das empresas)',
  x_a93d885f: 'Código de referência (opcional)',
  x_fefc4fec: 'Inscreva-se usando o código de referência para obter um teste extra de 30 dias',
  x_87417e71: 'Tipo de negócio',
  x_f134be36: 'Não é possível fazer login off-line; primeiro login on-line',
  x_80745991: 'Caixa na recepção',
  x_29ee0354: 'Somente caixa - faça login e vá diretamente ao caixa',
  x_2443e297: 'Entre no caixa',
  x_de094deb: 'Instalar aplicativo / Instalar aplicativo',
  x_ea90083b: 'Abra no Chrome para instalar / Abra com o Chrome para instalar',
  x_11afe095: 'Digitalize o código de barras do produto',
  x_570e1531: 'Alinhe completamente o código de barras com a moldura verde · Distância 10-20 cm',
  x_58faba06: 'A câmera não pode ser acessada, verifique as permissões',
  x_bec7e4d6: 'mudar',
  x_17e423b0: 'piscar',
  x_a4c59470: 'Clique na tela para focar manualmente',
  x_3c43c899: '💡 Deixe o código de barras preencher a moldura verde e mantê-lo estável · Ficará embaçado se estiver muito próximo',
  x_5f031153: '📵 Este dispositivo não suporta flash',
  x_22867dc5: 'Digitalize novamente',
  x_lbl_created: 'Criado',
  x_lbl_rejected: 'Rejeitado',
  x_lbl_reason: 'Motivo',
  x_lbl_operator: 'Operador',
  x_lbl_total: 'Total (unid.)',
  x_lbl_notes: 'Notas',
  x_80a36145: '✅ Sincronizado automaticamente',
  x_1eec1e2e: 'Encerrar operações anteriores de interrupção da rede',
  x_e85b2d54: 'Os produtos offline foram sincronizados.',
  x_8cc59319: 'Sincronização de pedido bem-sucedida',
  x_fad33691: 'Falha na sincronização do pedido:',
  x_1fa61c48: 'O histórico de pedidos rejeitados de Zhang foi de pedidos reenviados/recuperados automaticamente',
  x_73ae77ff: 'Modo offline: usa dados em cache (',
  x_8ae9eaca: 'atualização)',
  x_57fa0696: '- lembrado (',
  x_49ae0e5e: 'artigos)',
  x_4068bc35: '⬆️Upload antes do final da aula',
  x_7b697750: 'Ordem para sincronizar...',
  x_cdc0393e: '⚠️Também',
  x_960c577f: 'O pedido não pôde ser carregado (foi salvo nesta máquina e será carregado automaticamente após conexão com a Internet)',
  x_4094833e: ', não mais / esgotado',
  x_b7b8517c: ', máximo / esgotado',
  x_6f630d34: '🥡 Pegue comida #',
  x_edb823f2: '❌ Produto não encontrado:',
  x_45524982: 'O pedido foi exportado para a pasta de downloads.',
  x_498458a5: '✅ A taxa de câmbio de hoje foi fixada em Bs.',
  x_5ec06103: '(apenas esta máquina)',
  x_c6615916: 'dias atrás',
  x_bb39a0c6: 'horas atrás',
  x_9021c675: '📤 Exportado',
  x_1eab1ec2: 'Clique para baixar a pasta (copiável por USB)',
  x_634abe29: '✅ Importação USB concluída:',
  x_b359a569: 'Novo ·',
  x_3af4ed2f: 'Já existe ·',
  x_7030ff64: 'erro',
  x_c6e4b6a0: 'a aula começou',
  x_e7a7a7e2: 'Turnos horários não entregues: Envie os turnos imediatamente para evitar confusão na conciliação entre os dias.',
  x_73559114: 'horas, recomenda-se entregar o turno o mais rápido possível / Turno aberto atrás',
  x_e2efd3fa: '⬇️ Nova versão v',
  x_2d455ce5: 'Baixando',
  x_51a8f63f: '🔄 Nova versão v',
  x_c540ce8f: 'Concluído · Desative a instalação automática de software ·',
  x_4c4d6a98: '📡 Sem internet -',
  x_922a9dca: 'O pedido foi salvo com segurança e será carregado automaticamente após conexão com a Internet / Sem rede, eles serão carregados automaticamente',
  x_8d1c5588: '⬆️ Enviando',
  x_6479a0a7: 'Único... / Enviando',
  x_a53de3a7: '• Após o vencimento, o depósito será devolvido ao comerciante',
  x_c0cd0f67: 'Crédito de troca ativado / Crédito de troca:',
  x_bc4e851c: 'Confirme para desativar',
  x_9cd30436: '? \\nApós a desativação, os produtos desaparecerão do POS/loja online, mas o stock e o histórico de encomendas serão preservados, podendo ser reativados a qualquer momento.',
  x_47bf13b6: 'para',
  x_c9729ffc: 'Se os cortes AI forem feitos em fundo branco para cada produto, será deduzido 1 ponto AI para cada produto (um total de',
  x_69db7ae0: 'ponto). Continuar?',
  x_c70a3c01: 'AI Slash concluído: sucesso',
  x_114d9700: '/falha',
  x_8cac6775: 'Combinando imagens com sucesso',
  x_5d459d55: 'Processamento',
  x_1e1445b3: 'Comece a aparar (',
  x_6242f731: ') · Fivela',
  x_be604f8b: 'ponto',
  x_2ecbd077: '📱O link foi enviado para o WhatsApp do chefe...',
  x_3a17aa8e: 'Link enviado!\\n\\n',
  x_fa407236: '\\n\\nPressione OK para copiar o link para a área de transferência',
  x_cbcbd4e6: 'Confirmar o ajuste do preço de atacado?',
  x_1b92092d: 'atualizado',
  batchNoMatch: '⚠️ Não há produtos na categoria selecionada — escolha outra categoria',
  orderShift: 'Turno',
  viewShiftReport: 'Ver fechamento de turno',
  shiftOpenBadge: 'Aberto',
  shiftClosedBadge: 'Fechado',
  batchAllSkipped: '⚠️ 0 atualizados: os produtos não têm preço de custo, cadastre primeiro',
  x_8c533c4a: '⚠️ O produto já existe:',
  x_d8172b79: '✅ Pré-carregado:',
  x_162d92be: '— Preencha o preço e salve-o',
  x_82978490: 'Cartão de valor armazenado deduzido',
  x_955e88ca: '· Equilíbrio',
  x_d43bd196: 'Salvar off-line:',
  x_eeb31a4e: '(Sincronizado automaticamente após a conexão)',
  x_41c5ecd6: 'exceder',
  x_ed87d0af: 'Limite de segurança. \\n\\nConfirme novamente se o valor está correto.',
  x_94d22b13: '⚠️ Nota:\\n\\nDinheiro real:',
  x_741ca864: '(muito pequeno)\\nDedução de atrasos:',
  x_1a079931: '\\nApós as deduções, você ainda deve:',
  x_e93a7373: '\\n\\nTem certeza?\\n• Pressione [Confirmar] → pagar de acordo com o valor acima\\n• Pressione [Cancelar] → pagar o salário integral',
  x_4f2bb016: 'Todos os atrasos serão deduzidos (pagamento real',
  x_6e11eb39: 'Redefinir: Dedução',
  x_9de6f844: ', cabelo verdadeiro',
  x_8800e34b: '- Dedução',
  x_569ff68a: '= cabelo verdadeiro',
  x_48eb726e: 'Pagamento de salário bem-sucedido: pagamento real',
  x_4c117f20: 'Pedido',
  x_f6348db9: 'Pedido encontrado:',
  x_692d69b4: 'artigos,',
  x_3b5e93d8: 'Marcado como [Dia inteiro]\\n\\nO salário é calculado com base no dia inteiro. \\nTem certeza?',
  x_1f623127: 'Marcado como [Meio Dia]\\n\\nO salário é calculado como meio dia (50%) e a ausência será registrada automaticamente com atraso. \\nTem certeza?',
  x_0064a575: 'Marcado como [Absenteísmo]\\n\\nO sistema registrará automaticamente 1 dia de atraso no salário! \\nTem certeza?',
  x_dc49966b: '💰 A dívida foi registrada',
  x_e897afe2: 'Você confirma o pagamento dos seguintes funcionários? \\n\\n',
  x_87c3b869: '\\n\\nTotal',
  x_465afe3c: 'pessoas',
  x_70e23b2c: 'Folha de pagamento -',
  x_a657f46f: 'semana',
  x_247b6518: 'O salário foi pago',
  x_d051c48c: 'as pessoas falham',
  x_59cf15fe: 'Modelo',
  x_1463e88d: 'Aplicado',
  x_d846c018: 'a empresa deve',
  x_b52d1753: 'Saldo de depósito:',
  x_6a34412a: '\\n\\nInsira o valor a gastar (deixe em branco = Todos',
  x_5f3fd382: 'O montante deve',
  x_f3221016: '0 e ≤',
  x_c66b7456: '✅ Pago',
  x_37186b95: 'dar',
  x_92ff3137: 'Dedução máxima (= min(salário, atrasos) =',
  x_ff06778b: 'solteiro)',
  x_9d074fc7: '📱 Enviado para',
  x_be509224: 'telefone celular · expirado',
  x_e6c92b78: '· Expira em breve',
  x_59359c92: 'Tem certeza de que deseja enviar lembretes do WhatsApp para todos os clientes atrasados ou atrasados? \\n\\n(O mesmo cliente será enviado apenas uma vez em 7 dias e não será incomodado repetidamente)',
  x_03e25cc4: '✅ Enviado',
  x_f6614467: 'lembretes do cliente (pular',
  x_6eb87074: 'Artigo · Falhou',
  x_feebfd78: 'artigo)',
  x_a80efbb5: 'Não enviado (total',
  x_60c5bacd: 'registros, salto',
  x_fcc7ee2d: ', falhou',
  x_7e1fefa7: ')——Verifique se o cliente possui um número de celular + assinatura',
  x_88fe7ca5: 'Declaração completa A4 ·',
  x_fe78a84f: 'Recibo de 80 mm · Somente resumo de pagamento ·',
  x_758ec925: 'a maioria',
  x_cf4a812f: 'Totais/Totais:',
  x_f7edf5ac: 'pedaços',
  x_2c117f7f: '✓ Pedido copiado',
  x_01d7aa49: 'de',
  x_4e4008f8: 'produtos, selecione a loja de destino',
  x_53952782: 'Confirme para cancelar a ordem de transferência',
  x_26671096: '? \\n\\nApós o cancelamento, o estoque será devolvido ao armazém de origem.',
  x_128b1e7c: 'mesa',
  x_2e3a36de: 'minutos atrás',
  x_2de0d491: 'horas',
  x_73c826e5: '✅ Recarga bem-sucedida · Novo saldo',
  x_7e2720b4: 'Cliente/cliente:',
  x_a423e73c: 'Data/Data:',
  x_1a608891: 'dias para expirar',
  x_182da4c4: '💳 Histórico de pagamentos/pagamentos (',
  x_24d9bec1: '⚠️ A taxa de câmbio aumentou hoje',
  x_2e29f312: '% — O pagamento Bs é convertido com base na taxa de câmbio atual (o valor é menor do que quando foi bloqueado)',
  x_b1848125: '✅ A taxa de câmbio caiu hoje',
  x_be793e09: '% — O pagamento Bs é convertido com base na taxa de câmbio atual (o valor é maior do que quando foi bloqueado)',
  x_d6420ec0: '— Última atualização',
  x_603f7892: '⬆️Carregue agora (',
  x_d6f5f3c9: '🚫Lidar com pedidos rejeitados (',
  x_365c6e84: '🔄 Crédito de troca $',
  x_cd600b9e: '), a conversão Bs pode ter um grande desvio',
  x_b61b86ae: 'Aguardando sincronização',
  x_4827c1f8: 'A solicitação foi rejeitada pelo servidor (não creditada)',
  x_ff503ba7: '(atuais Bs.',
  x_7d68b4e3: 'Atual:',
  x_2be10f11: 'A quantidade deste produto no PDV é ≥',
  x_41ae38b5: 'Partida bem sucedida:',
  x_13ddc197: 'Selecionados · Consulte apenas produtos com fotos',
  x_bec8b787: 'Alterar automaticamente o preço 2 quando',
  x_74714605: '🛒 Varejista de varejo -',
  x_bb255d74: '🛒 Varejo:',
  x_f84bb79f: '🏭 Atacado:',
  x_530afc78: '% de reembolso',
  x_30f580f1: 'Desconto / Desconto',
  x_06772a76: 'Dedução de Pontos / Pontos (',
  x_66525fb9: 'Preço original$',
  x_ae89baf7: '🛡️ mais',
  x_f93a3192: '⚠️ Desconto máximo alcançado (custo $',
  x_98e21b6a: 'Saldo insuficiente para pagar $',
  x_f2c67994: '$ será deduzido',
  x_b682eb31: 'Maturidade/Maturidade:',
  x_dcbed21c: '% (proteção de custos)',
  x_9f93459b: ', você não poderá baixá-lo ou perderá dinheiro)',
  x_64e6defd: '· Equilíbrio/equilíbrio:',
  x_2a7a6a6b: '→ Pagar $',
  x_128029c2: '· $ restantes',
  x_eeedcd26: '💵 Retirar Depósito / Retirar $',
  x_aedc526b: 'fivela',
  x_41cbd47f: 'Folha de pagamento (',
  x_a71e4358: 'Ainda não existe um modelo. Após agendar seu turno, clique em "',
  x_0d2fb245: '"Salvar como modelo',
  x_4ce4ef96: 'informação',
  x_b4ebe3f5: 'Não',
  x_25aa5d7d: '/ Por favor adicione primeiro',
  x_fbd2b1fb: 'total',
  x_2187d87a: 'Pedido · Recebido $',
  x_cc09dc10: 'Especificações:',
  x_a0d921b3: '(Escassez',
  x_c37f6a62: 'Código QR da tabela · Total',
  x_914e2a75: 'Baixe todos os pôsteres da tabela ZIP (',
  x_6499fc74: 'zhang',
  x_c2c92c19: 'Zhang)',
  x_e93c8f7b: 'Ocupado · Total atual $',
  x_87ba5064: 'Recarregar $',
  x_31180e95: 'Erro ao carregar:',
  x_36ea3e81: 'Para coletar $',
  x_fdf80fc9: 'Cobrar $',
  x_b34de51a: 'Pago $',
  x_0c6c45ae: 'Histórico de pagamentos/pagamentos (',
  x_e3bc8fa5: 'Convertido para USD (Bs.',
  x_7f4bb1d6: 'dias de graça',
  x_48b0dec0: '·Sim$',
  x_27720067: '✕ Excluir',
  x_8decf585: '💱 Defina manualmente a taxa de câmbio de hoje',
  x_80272374: '📥 Exporte o resumo offline de hoje',
  x_b2abad7a: '📤 Exportar tudo por USB',
  x_68771e30: '📥 Importação USB',
  x_7ca39c26: 'Fechar turno',
  x_2ce5a620: 'Esses pedidos foram rejeitados pelo servidor durante a sincronização.',
  x_d8e901bc: 'Quando for 0, use o mercado negro; caso contrário, use BCV.',
  x_f47fc941: '— Clique no botão à direita para visualizar a causa e corrigi-la.',
  x_1faae5c2: 'Alteração do preço do lote',
  x_ee2b9ce1: '📷 Digitalize o código QR para adicionar',
  x_d0c1006c: 'O pagamento/transferência móvel segue a maior parte da verificação. / Imprima automaticamente o recibo após o pagamento e inicie o próximo pedido diretamente (exceto Pagamento/transferência móvel)',
  x_f3131239: 'Ao cobrar em USD (dinheiro/Zelle), o POS adiciona automaticamente 3% de IGTF e imprime no recibo. / Ao receber dólares americanos, o imposto IGTF de 3% será adicionado automaticamente e impresso no recibo.',
  x_f09933aa: 'Você não vê o novo botão? Clique aqui → O sistema limpará automaticamente o cache antigo → Carregue a versão mais recente imediatamente.',
  x_f40cbd21: 'Lembre a todos os funcionários que após clicar neste botão, todos os funcionários sincronizarão automaticamente com a versão mais recente em 5 segundos.',
  x_3a04c76e: '• O PDV ainda pode efetuar o pagamento quando o estoque for 0 ou negativo',
  x_8250b510: '• O estoque será convertido para um número negativo (por exemplo, -5 significa que 5 peças estão fora de estoque)',
  x_121b783a: '• Adequado para: O produto físico está na loja, mas o inventário do sistema é impreciso, o atacadista muitas vezes vende antecipadamente e novos produtos acabaram de ser lançados, mas o inventário não é registrado.',
  x_4fbdd3a8: '• ⚠️ NOTA: Vá regularmente',
  x_694ccb6b: '• O PDV se recusa a fazer pedidos quando o estoque é insuficiente',
  x_959932ab: '• Evite overbooking e caos de dados',
  x_f34c6c1f: 'Contagem de páginas, eliminação de números negativos',
  x_59637fe6: 'Ajuste o número de páginas ou ative temporariamente esta opção',
  x_684ee9b5: 'Forçar atualização',
  x_140d6e9a: 'Atualizar agora',
  x_32415951: 'Cliente',
  x_85fc0b89: 'Funcionário',
  x_vale_label: 'Vale de compra',
  x_vale_placeholder: 'Escaneie / digite o código, Enter',
  x_vale_apply: 'Aplicar',
  x_vale_applied_ok: 'aplicado',
  x_vale_forfeit: 'Vale maior que a compra; perde-se:',
  x_vale_earned_title: 'Cliente ganhou um vale!',
  x_vale_earned_rule: 'Compra ≥',
  x_vale_valid_until: 'Válido até',
  x_vale_later: 'Depois',
  x_vale_print: 'Imprimir vale',
  x_f676b12b: 'Cartão de saldo',
  x_d5109b1f: '📱 Resuma e envie para o chefe',
  x_f6a5aaac: '🔔 Envie lembretes para cada cliente',
  x_e87e3fba: '⏳ Para sincronizar',
  x_c66a65a3: '💵 Você deve pagar apenas em dólares americanos/USD — Pagamento em Bs não disponível',
  x_4ef6283c: 'Falha Requer processamento',
  x_7ab62e2e: 'Os seguintes produtos não possuem estoque suficiente no armazém de origem. Escolha como lidar com:',
  x_f75eee5f: '✅ Continuar ajustando a mercadoria / Continuar (inventário negativo permitido)',
  x_58c10a18: 'Ajustar para disponível',
  x_9cc890a7: 'Cancelar',
  x_c16cdc6d: '🎨 Embelezar pôsteres',
  x_cbdcabad: 'liberar',
  x_1b8de39d: '⚙️ Integrar automaticamente a interface do usuário “Seleção de mesa → Fazer pedido” na próxima rodada. Atualmente, use notas de pedidos pendentes para associar.',
  x_5b3aaade: 'ℹ️ Após a impressão, recorte e cole o protetor em cada placa; Os convidados podem digitalizar para entrar na página de pedidos de sua própria mesa (o número da mesa é selecionado automaticamente)',
  x_7559ce8e: '🎨 Cartazes de mesa · Cartazes de marca',
  x_2601cd44: 'ℹ️ Poster tamanho A5 (1240×1748 @ 200 DPI), que inclui barra superior com o nome da loja + placa com o número da mesa + QR grande + slogan em vários idiomas + barra inferior com dados de contato.',
  x_81567a16: 'Basta imprimir na impressora, cortar, proteger e colar na mesa. O convidado escaneia o código QR → entra automaticamente na página do pedido → o número da mesa foi preenchido.',
  x_7be49895: '📱 Tabela QR',
  x_727c86c9: 'Adicionar uma tabela',
  x_fbac2d7f: 'Imprimir diretamente',
  x_c12a29c0: 'Baixe ZIP (cada PNG separadamente)',
  x_46c8a671: 'Lançamento de novos cartões.',
  x_e50663b2: 'Recarregar',
  x_79d3abe9: 'Copiar',
  x_b1fe43e8: '. Escreva no cartão físico/imprima o recibo e entregue ao cliente. Em caso de perda do cartão, o cliente deverá apresentar o número do cartão + PIN para o verificar/utilizar.',
  x_fd924ff0: '🏷️ Reserve',
  x_f20ccb10: 'Nenhuma seção',
  x_e8606af7: 'Confirmar cancelamento',
  x_45f2c9a0: 'Expira:',
  x_616c68e6: 'Configuração de regras',
  x_132c5cdc: 'tente novamente',
  x_5c52b0fd: 'Expira em 7 dias',
  x_12aabd94: 'Atrasado',
  x_ad3cd23a: 'Imprimir',
  x_1cb2b4b8: 'Cancelar',
  x_fix_bulk_hint: '(A loja online mostrará etiqueta "A granel"; o cliente pode comprar 0.5 / 1.8, etc.)',
  x_fix_otherwh_hint: 'Outros armazéns (somente leitura; use Ajuste de estoque ou Transferências para modificar)',
  x_fix_upload_hint: 'arquivos; toque em "Iniciar upload" e o servidor fará a correspondência por código',
  x_fix_rejected_hint: 'Verifique o motivo: exclua duplicados; se for uma venda real toque em "Reenviar".',
  x_fix_guestwifi_tip: 'Dica: use a Rede de Convidados do roteador com desconexão automática de 2 minutos.',
  x_cd509648: 'Pesquisar produtos...',
  x_26b5bd49: 'Carregando...',
  x_d5faf486: 'a loja não existe',
  x_a8b0c204: 'tudo',
  x_e3a7209e: 'Ainda não há produtos',
  x_1bd84635: 'Seleção diária de alimentos frescos.',
  x_663af409: 'Encomende comida deliciosa online',
  x_c76203b6: 'Seleção de lojas de departamentos, tudo que você precisa',
  x_9450139e: 'Vida saudável, cuidado cuidadoso.',
  x_fb289d60: 'Recém-assado e perfumado',
  x_13f0b75a: 'Roupas da moda saboreiam a vida.',
  x_a6ef79b6: 'Todas as inovações tecnológicas mais recentes estão ao seu alcance',
  x_a03f1a4b: 'Garantia de qualidade de carne fresca',
  x_21f9dcf0: 'Compras on-line Entrega em domicílio',
  x_54e5de42: 'Erro ao fazer upload',
  x_18e80613: 'WhatsApp do comerciante não configurado',
  x_aed1dfbc: 'em',
  x_b71301e1: 'Escolher / Selecionar',
  x_0288e6a2: 'O navegador não suporta GPS',
  x_12cffd73: '📍Localizando...',
  x_48b05582: '✅ Sua localização foi registrada para que o passageiro possa entregá-lo com maior precisão',
  x_9ccbd711: 'Não é possível obter a localização. Preencha o endereço manualmente',
  x_2f6911f3: 'Minha localização foi registrada ✓',
  x_1499f061: 'Usar minha localização atual (a entrega é mais precisa)',
  x_dc715bb8: 'Confirmar pedido',
  x_0d0bc2bc: 'Copiado / Copiado',
  x_dac8225e: 'Escolha a opção (tamanho/cor/sabor)',
  x_9f9cbc48: '1,8 OK)',
  x_7f6e80a6: 'Clique em "Confirmar"',
  x_27c05b27: 'O WhatsApp abrirá automaticamente com os dados do pedido já preenchidos e você poderá simplesmente enviar a forma de pagamento ao lojista.',
  x_3a9be7db: 'Envie o pagamento para / Por favor transfira para:',
  x_f65ce56a: 'Banco emissor/banco',
  x_ed4ea468: 'Número de telefone do emissor/remetente',
  x_bb58400a: 'Verifique o preço',
  x_619fd86c: 'Insira o nome do produto/código de barras...',
  x_1d7a5330: 'Produto não encontrado',
  x_fb852fc6: 'Em andamento',
  x_cd8c77d3: 'Concluído/Concluído ✅',
  x_2111ccbb: 'Cancelado',
  x_6a0abbb7: 'Expirado / Confiscado ⚠️',
  x_1ea78d47: 'fatura',
  x_ff0b2077: 'Cliente',
  x_6ffe81e2: 'valor total',
  x_57b642fc: 'Pago',
  x_931f1f80: 'pagar',
  x_9897d884: 'mercadoria',
  x_474cd02d: 'pagamento',
  x_b0fae043: 'regras',
  x_499b9a62: 'data de validade',
  x_8c1bc4ba: 'termo',
  x_98ffc82c: 'Depósito mínimo',
  x_82188307: 'Caso não seja pago dentro do prazo, o depósito pertencerá ao comerciante.',
  x_e2eb6313: 'Por favor pague na loja',
  x_6f83193b: 'Assinatura do cliente',
  x_e9bd1d12: 'Termos aceitos',
  x_c281ff84: 'Termos não aceitos',
  x_affa4d0e: 'Carregando... / Carregando...',
  x_c6dd0ab3: '• Caso não seja pago dentro do prazo, o depósito será do lojista.',
  x_8deff26f: 'Tire fotos casualmente',
  x_866b795e: 'Erro ao carregar',
  x_7683487f: '✅ Concluído, continue com o próximo.',
  x_82bae6ba: 'Pesquisar nome/código/código de barras',
  x_bbd24cc2: '📷 Tire fotos',
  x_2a3114f2: '🔄 Substituição',
  x_c0588fd1: 'Você negou a permissão da câmera. Permita a câmera nas configurações do seu navegador.',
  x_efb8ad19: 'Dispositivo de câmera não encontrado',
  x_c9ece2f8: 'O embelezamento da IA falha, você pode usar a imagem original diretamente',
  x_d1f9b309: 'Não foi possível salvar, imagem original preservada',
  x_8705e16b: 'Disponível apenas para chefes e gerentes/Administrador/gerente individual',
  x_77dbf376: 'Chefe da câmera',
  x_42eae5c2: 'Todos os produtos possuem fotos!',
  x_d2a53af5: 'Nenhum produto',
  x_3fe62d01: 'Primeiro encontre o produto que deseja substituir',
  x_5fbe1b26: 'Tirando fotos...',
  x_36152aa9: 'Embelezamento de IA...',
  x_bfeacb2a: '~15 segundos',
  x_95d9b747: '📸 Imagem original',
  x_3fb7e372: '✨AI Embelezamento (fundo branco)',
  x_3f981012: 'Recomendado',
  x_997c7a5d: 'Função',
  x_6adafe27: 'Indústria',
  x_a95dd3e1: 'tecnologia',
  x_d38a089e: 'Contato',
  x_402d19e5: 'Faça login',
  x_248f81e2: 'Teste grátis',
  x_3ab22098: 'Sistema PDV em nuvem',
  x_e06f69f5: 'faça o seu negócio',
  x_cc15c20a: 'Vá para o próximo nível',
  x_2852a028: 'Assuma o controle total de sua loja, restaurante ou farmácia. USD/VES multimoeda, fatura eletrônica, disponível off-line.',
  x_dd88cfbf: 'Teste grátis por 7 dias',
  x_8a81d8ca: 'Ver recursos',
  x_b52b8c1f: 'Seguro e estável',
  x_d255512b: 'VER',
  x_1d8d47a1: 'Verificação automática de pagamento móvel',
  x_84b0b2a1: 'Disponível off-line',
  x_6fcc5a76: 'Segurança na nuvem',
  x_0cee3341: 'Comerciante ativo',
  x_55131659: 'volume diário de negociação',
  x_b67495ee: 'taxa on-line',
  x_f0fbeece: 'Suporte técnico',
  x_176ca494: 'Um sistema para todas as necessidades',
  x_b4fa6629: 'De pagamentos rápidos a relatórios inteligentes, a Sellox tem todas as ferramentas para ajudar seu negócio a crescer.',
  x_f1c5a568: 'Pagamento extremamente rápido',
  x_adc03f83: 'Pesquisa inteligente, leitura de código de barras e atalhos de teclado concluem as vendas em segundos. Também funciona off-line.',
  x_c0c97799: 'inventário em tempo real',
  x_40483407: 'Inventário em tempo real, combinações de pacotes, avisos de estoque baixo e transferências entre armazéns.',
  x_3c1a2842: 'relatório inteligente',
  x_1aa9589f: 'Vendas, lucros, produtos mais vendidos e análise de embalagens, visualizados com um único clique.',
  x_ab572bf7: 'Pague em pedidos separados',
  x_c677e641: 'Vários métodos de pagamento são aceitos para uma transação: dinheiro, cartão bancário, transferência.',
  x_42081db9: 'fidelização do cliente',
  x_a1c08c39: 'Programas de pontos, níveis de adesão, preços especiais por tipo de cliente.',
  x_3f70a475: 'Impressão de ingressos',
  x_f5fbde12: 'Compatível com impressoras térmicas convencionais (Bixolon, HKA) e suporta impressão dupla de recibos e faturas.',
  x_47acae77: 'Gestão da sede da cadeia',
  x_ae346bda: 'Visão geral do desempenho de várias lojas, exibição de estoque entre lojas, preços unificados e gerenciamento de crédito de clientes B2B.',
  x_9eb1059d: 'Reabastecimento inteligente',
  x_77e17012: 'Analise automaticamente a velocidade de vendas, preveja tempos de falta de estoque e gere uma lista de sugestões de reposição.',
  x_c14027b7: 'Adapte-se ao seu tipo de negócio',
  x_0c5bd351: 'varejo',
  x_e37fda71: 'Lojas e varejo',
  x_1752dd18: 'Controle de estoque abrangente: aviso de estoque baixo, leitura de código de barras, preços diferenciados para clientes, impressão de etiquetas de preços e gerenciamento de fornecedores.',
  x_9d39de37: 'leitura de código de barras',
  x_8bc3ace8: 'Preços escalonados',
  x_a297a148: 'Gestão de estoque de diversos armazéns.',
  x_9e4e8242: 'Pacotes e Promoções',
  x_37346312: 'Impressão de etiqueta de preço',
  x_faeff5ef: 'supermercado',
  x_87dc671e: 'Supermercados e lojas de conveniência.',
  x_312dc180: 'Lide com eficiência com grandes volumes de transações, integrando balanças eletrônicas, leitura de código de barras, paralelização de múltiplos checkouts e gerenciamento de prazo de validade.',
  x_3e6c0601: 'Processamento de transações de alta frequência',
  x_73b2dfdf: 'Vários caixas eletrônicos em paralelo',
  x_b4157847: 'Integração de balança eletrônica',
  x_e9bb592c: 'Gerenciamento de vida útil',
  x_58936f4b: 'Preços de atacado e varejo',
  x_2a0ad6ff: 'restauração',
  x_d2010d15: 'Restaurantes e cafés',
  x_26b82bf3: 'Plataforma abrangente para gerenciamento de mesas, recibos de cozinha, anotações de pratos, dicas e faturamento separado.',
  x_450fec16: 'Gerenciamento de área de trabalho',
  x_58adcc1a: 'Tela/impressão de cozinha',
  x_8c1b8588: 'Faturamento separado',
  x_6c7083d9: 'Despejo automático',
  x_537efc66: 'mandar tirar',
  x_53b4b807: 'beleza',
  x_98a53972: 'Salões de beleza e cabeleireiro',
  x_24fbec85: 'Gerenciamento de compromissos, registros de atendimento ao cliente, comissões de funcionários e programas de fidelidade de membros.',
  x_220e22c6: 'Gerenciamento de compromissos',
  x_9c4df083: 'Comissão de Funcionários',
  x_b78043c0: 'Perfil do cliente',
  x_cc98eba1: 'Programa de pontos',
  x_cceccce5: 'Lembrete automático',
  x_068d9237: 'Pode ser usado com ou sem conexão à Internet.',
  x_495aee53: 'Projetado para a Venezuela. Mesmo que falte energia e rede, o PDV continuará funcionando.',
  x_f0527d8a: 'Os dados são copiados automaticamente e podem ser acessados a qualquer momento em qualquer dispositivo.',
  x_4a61c29a: 'Modo off-line',
  x_b5b0394e: 'As vendas continuarão normalmente mesmo se a rede for desconectada e os dados serão sincronizados automaticamente depois que a rede for conectada.',
  x_b0404c0b: 'Sincronização inteligente',
  x_ad79d5c5: 'Os dados são salvos no IndexedDB local e não serão perdidos mesmo se a rede ficar desconectada por vários dias.',
  x_30504e20: 'Suporte para vários dispositivos',
  x_6d6042f2: 'Pode ser utilizado em computadores, tablets e celulares, e a interface se adapta perfeitamente a diversas telas.',
  x_f3de96c1: 'Computador como caixa principal',
  x_a123f815: 'Verifique os dados de vendas a qualquer momento no seu celular',
  x_18e45612: 'Vários terminais online ao mesmo tempo',
  x_2ed39222: 'funcionários',
  x_9c7d7a67: 'ilimitado',
  x_654522d2: 'Moeda',
  x_97b835a4: 'Disponibilidade',
  x_17927e12: 'Funcionalidade completa',
  x_a8b6d749: 'Mais completo que qualquer PDV',
  x_ac84ee55: 'fatura eletrônica',
  x_bdb58c39: 'Atualizações automáticas da taxa de câmbio',
  x_8242ec7e: 'Programa de fidelidade para membros',
  x_3e751fda: 'Pacotes e combos',
  x_bb84d6ea: 'Notas de pedido',
  x_b612cf7a: 'Gestão de turnos',
  x_dbc12902: 'impressão térmica silenciosa',
  x_e81ee1fe: 'Gerenciamento de vários armazéns',
  x_87821b0d: 'relatório de vendas',
  x_46756e70: 'análise de lucro',
  x_c791eec3: 'Gestão de fornecedores',
  x_f5a29430: 'Controle de compras',
  x_8cca9955: 'centro comercial on-line',
  x_93befa62: 'pedido on-line',
  x_9f08dc32: 'loja virtual',
  x_be37ebc5: 'Devoluções e reembolsos',
  x_baa125c4: 'Estoque entre lojas',
  x_42b52276: 'Gestão de clientes B2B',
  x_b9ee7355: 'Sugestões inteligentes de reposição',
  x_d4d37b95: 'Análise de velocidade de vendas',
  x_46cf89f9: 'Previsão esgotada',
  x_ebff97ec: 'Gestão de empréstimos/créditos para funcionários',
  x_28d629c1: 'Sistema de cartão perfurado de atendimento',
  x_67580600: 'Cálculo automático da folha de pagamento',
  x_a4e9168d: 'Horário de férias (1,5 vezes o salário)',
  x_cb4588c2: 'Verificação de pagamento móvel AI',
  x_f348c3f7: 'Gerenciamento de câmbio (compre dólares americanos/cartões magnéticos para trocá-los por dinheiro)',
  x_4e3c5d06: 'Gerenciamento de pedidos de compra',
  x_52f264a7: 'Contagem de dinheiro em turnos',
  x_28f364b2: 'Modelo multipreço (varejo/atacado/contêiner completo)',
  x_7253b11c: 'Pedidos de PWA off-line',
  x_df5a934f: 'Prepare-se para fazer o seu negócio',
  x_47db59fb: 'Levando isso para o próximo nível?',
  x_267335fb: 'Junte-se a centenas de comerciantes na Venezuela que confiam na Sellox.',
  x_2673904b: 'Comece gratuitamente',
  x_65300d22: 'Não é necessário cartão de crédito, configura em 5 minutos.',
  x_1a69cc94: 'Comece agora',
  x_4d9b70e1: 'Eficiência aprimorada',
  x_0e9fd989: 'Preço',
  x_a7bac223: 'chinês',
  x_a132c42f: 'Baixar para Windows',
  x_a825a5b0: 'Você tem alguma dúvida? pergunte',
  x_92248c47: 'atendimento ao cliente ou',
  x_c984d4fd: '✨ Recursos mais recentes de IA',
  x_01ff215e: 'IA ajuda você a fazer negócios',
  x_f5299c8e: 'Imagens lindas de nano banana',
  x_7fa9308c: 'Transforme fotos desfocadas de produtos tiradas com seu celular em fotos profissionais com apenas um clique (Gemini Nano Banana)',
  x_e9a8de17: 'Marketing de IA do WhatsApp',
  x_ed2f6b2f: 'Saudações automáticas de aniversário + marketing de Natal + respostas em quatro idiomas (chinês, inglês, espanhol e português)',
  x_576c046d: 'caixa de voz',
  x_8f395150: 'Diga "Adicionar 3 Cocas" para fazer seu pedido (Whisper STT)',
  x_99d6e6c1: 'Mordomo de IA',
  x_627f661f: 'Analise automaticamente as vendas todas as noites e forneça sugestões de estoque para amanhã',
  x_1f7b6ef8: 'Taxa de câmbio multinacional',
  x_d1529f52: 'BCV + Parallel + Frankfurter atualizações automáticas em tempo real (compatível com 7 países)',
  x_c0373da5: 'A anuidade inclui servidores em nuvem, backups automáticos e atualizações de sistema – quanto mais lojas, maior será o uso da nuvem.',
  x_3a80619c: 'Não tem certeza de qual recurso é ideal para você? pergunte',
  x_5d6e903d: 'atendimento ao cliente, ou',
  x_423811c2: 'Pacote simples, todas as funções.',
  x_86cb3a40: 'Sem taxas ocultas, cancele a qualquer momento. Comece com um teste gratuito de 7 dias.',
  x_55b728d1: 'mais popular',
  x_890e3707: 'Versão básica',
  x_f9205ad4: 'Versão comercial',
  x_94ac1fb3: 'Edição Empresarial',
  x_5ad3f664: 'Ano Nuvem + Taxa de Manutenção',
  x_a3e93bd5: '✅ Verificar automaticamente a chegada da conta Mobile Payment',
  x_8242103b: 'USD/VES multimoeda + taxa de câmbio automática',
  x_b7815b8e: 'Disponível offline + backup na nuvem',
  x_af2ed285: 'Suporte ao cliente WhatsApp',
  x_dc65864a: '🛒 Inclui loja online (centro comercial online)',
  x_01efcb04: 'Não inclui loja online',
  x_7a5eaa76: 'Você precisa ativar ou renovar? Contato',
  x_49707f5f: 'Você tem dúvidas?',
  x_b69517e9: 'atendimento ao cliente /',
  x_2f312b31: 'originais$',
  x_c87b05f9: 'Loja/loja:',
  x_d6b71ccb: 'Todas/Todas as lojas',
  x_91c1ffb2: 'Bs/BCV (compra de taxa de câmbio governamental)',
  x_06510ba7: 'estoque de peças',
  x_12448e37: 'Custo:',
  x_6c694f7b: 'Varejo:',
  x_b0c1f4e6: '$ original (compra no mercado negro)',
  x_450efd2f: 'total',
  x_f6f1d40b: 'Custo total:',
  x_724210ee: 'Vendas totais no varejo:',
  x_61406e63: 'Margem de lucro:',
  x_652be256: 'Detalhes de classificação',
  x_d0771a42: 'Classificação',
  x_f0789e79: 'modo',
  x_040dd10a: 'Número de itens',
  x_0eac8802: 'inventário',
  x_671e045d: 'Custo$',
  x_4c5d80a5: 'Varejo$',
  x_1fc64a84: 'Lucro$',
  x_bd4357f9: 'o dia todo',
  x_c31b1b99: 'meio dia',
  x_02efd8b1: 'absenteísmo',
  x_3cdcbdf0: 'Festival cancelado',
  x_15dd9319: 'Definido como feriado (pagamento em dobro)',
  x_2a2338ae: 'Gestão de presença',
  x_583cc547: 'total de funcionários',
  x_1c6f494e: 'Já cadastrado',
  x_a7da9234: 'loja',
  x_93849f29: 'atendimento de hoje',
  x_87bd8d0d: 'calendário de férias',
  x_3ccfeac0: 'Registro de perfuração',
  x_464f3d4e: 'papel',
  x_b4f0388f: 'ir trabalhar',
  x_96ed60cd: 'sair do trabalho',
  x_3fea7ca7: 'Estado',
  x_6bc72d59: 'Não registrado',
  x_f5360872: 'Clique na data para marcar/cancelar o feriado e trabalhar durante o feriado será contabilizado como 1,5 vezes o salário (LOTTT)',
  x_8fb52fe0: 'Feriados pré-carregados',
  x_a7a9b5d0: 'novo',
  x_9087937f: 'Preencher feriados legais de 2026',
  x_29a98994: 'feriados do mês',
  x_046c6233: 'recentemente',
  x_249aba76: 'dia',
  x_4ff1e74e: 'Data',
  x_2b6bc0f2: 'Operação',
  x_19fcb9eb: 'hora',
  x_676e5982: 'operador',
  x_b3755e33: 'Filial Diária',
  x_0c9d2b45: 'Método de pagamento',
  x_c633a333: 'esperado',
  x_06f26e9d: 'verdadeiro',
  x_5fdfbade: 'diferença',
  x_1f11f332: 'O PIN deve ter 4 ou 6 dígitos',
  x_6a6dfeb1: 'Duas entradas são inconsistentes',
  x_7a6d647f: 'PIN salvo',
  x_6de920b4: 'Erro ao salvar',
  x_175377c0: 'Alterar PIN',
  x_cbbd1f37: 'Definir PIN',
  x_2a33020e: 'Salvando...',
  x_fd7c0215: 'Confirme com PIN',
  x_b070fd2b: 'PIN do Boss WhatsApp / PIN de comando do Boss WhatsApp',
  x_66bff1f9: 'Usado para confirmar alterações de preços, reembolsos, exclusões de pedidos e outras **operações perigosas** via WhatsApp',
  x_44e60789: 'Já configurado',
  x_fe2d26a2: 'não estabelecido',
  x_e81c6450: 'bloqueado',
  x_ed6c2836: 'Tentativas falhadas:',
  x_1b87b102: 'Novo PIN (4 ou 6 dígitos)',
  x_df21533b: 'Confirmar PIN',
  x_359986fb: 'Atualizar PIN',
  x_6b08b3ce: 'Salvar PIN',
  x_8513ad10: 'Como usar',
  x_32fa6a1b: '1. Envie o WhatsApp do número do chefe na lista de permissões para o número Meta vinculado ao Sellox.',
  x_cb43e349: '2. Responda diretamente às perguntas (vendas de hoje, estoque, crédito).',
  x_20f82d05: '3. Para modificações (alteração de preço/reembolso/ajuste de estoque/emissão de cobrança), será respondido "Confirmar com PIN".',
  x_8f4e84c9: '4. Você responde apenas com um PIN de 4 dígitos, válido por 5 minutos. O sistema será executado e reportado.',
  x_1c3b9af4: 'Todas as operações são gravadas no log de auditoria (audit_logs) e 5 PINs incorretos são bloqueados automaticamente por 15 minutos.',
  x_61f6d70f: 'Dinheiro',
  x_798d879e: 'Cartão',
  x_3ed4a686: 'Transferência',
  x_3dd2ecf9: 'Crédito',
  x_b0559b3d: '✅ Visualização gerada',
  x_6a3a5ef0: 'Erro de visualização',
  x_3bd0272f: 'Por favor, insira primeiro o número do celular do membro.',
  x_9ca6a344: 'Falha no envio',
  x_ac52a991: '(sem nome)',
  x_b93fce3d: '📆 1 de cada mês',
  x_f493a608: '📅 Todos os dias às 21h',
  x_11e80f95: 'tudo',
  x_ba1a3a35: 'Enviando...',
  x_07d0b32a: 'Enviar',
  x_2b5c1e95: '✅ Salvo',
  x_bec9ee92: 'Salvar',
  x_fe56e486: '🤝 AI envia contas para o codiretor',
  x_1c2e02ce: 'Ainda não ativado',
  x_2b05c552: 'Co-proprietário:',
  x_e6f32bcc: 'Frequência:',
  x_7b03c3e6: 'Filtrar por (relatar apenas estes):',
  x_2a0331b4: 'Último enviado:',
  x_6b4a51fc: 'Mensagem de IA',
  x_4c117f20: 'Pedido',
  x_28866da4: 'dólares totais',
  x_de742acb: 'Filtrar USD',
  x_3d9ffcbf: 'Coproprietário',
  x_c716dbd4: 'Ativar',
  x_149265c0: 'Nome do coproprietário',
  x_0d0635b6: 'Seu WhatsApp (incluindo código do país, formato 58XXXXXXXXXX)',
  x_ba2b6eee: 'Frequência',
  x_6d5a3b51: 'Enviado automaticamente às 21h.',
  x_3253cde4: 'Emitido automaticamente no dia 1',
  x_79218550: 'Informar apenas esses métodos de pagamento (vazio = todos, ambos os chefes veem os detalhes desses métodos)',
  x_a41cf705: 'Tom',
  x_b19cbde8: 'Envie para mim também',
  x_55aa6366: 'Atualização bem-sucedida',
  x_e2f2ba57: '✅ Habilitar',
  x_0031dd8b: '⛔ Desativar',
  x_8ff8cf44: '🗑 Lixeira',
  x_47508121: 'limite$',
  x_7acbbda8: 'Varejo',
  x_79c4a31e: 'Atacadista',
  x_f17d31b7: 'Clientes de atacado (preço de atacado automático P2 + 0,5 pt/US$ 1)',
  x_4c998309: 'Imprimir cartão QR',
  x_5fa802be: 'Operação falhada',
  x_2ffea779: 'Desativar cliente',
  x_b2cdaef5: 'Reativar o cliente',
  x_5c56a889: 'desativar',
  x_7854b52a: 'habilitar',
  x_e5323bab: 'Mover para a lixeira (recuperável)',
  x_45f778d7: '✏️ Editar cliente',
  x_95e5011c: 'Exemplo: 05-14',
  x_3df74976: 'crédito',
  x_dd694c71: '🏭 Atacado',
  x_36cd3fdb: '🎂 Aniversário (MM-DD ou AAAA-MM-DD)',
  x_e8228d38: '📱 WhatsApp (se diferente do telefone)',
  x_84a6c65b: '📨 Assine notificações do WhatsApp (recibos eletrônicos + votos de aniversário + marketing)',
  x_766084e7: '🏭 Clientes atacadistas (pontos baixos)',
  x_6f76107e: '👤 Para uso próprio do funcionário (pontos baixos)',
  x_193fd90d: '🏭 Atacado / 👤 Funcionários → De acordo com a proporção de pontos de atacado (0,5 pt/$1); desmarcado = varejo (1 ponto/US$ 1)',
  x_2e0d8c60: 'Erro de exportação:',
  x_080e4cdb: '\\nUse o botão Imprimir para salvar como PDF.',
  x_617fe407: 'Permita pop-ups e tente novamente',
  x_8b05bd24: 'Falha na impressão:',
  x_402193e1: '\\nUse o botão "Baixar PNG" para salvar e imprimir.',
  x_d2f8e650: 'imprimir',
  x_20b916e7: 'Fechar',
  x_1f1edd2f: 'Tema:',
  x_2c3a24c3: 'Ganhe pontos e aproveite descontos',
  x_9954e58a: 'Digitalize-me para verificar seu saldo de pontos',
  x_27210b8c: '🎯 Como funciona?',
  x_70e4ea74: 'Abra a câmera do seu celular',
  x_f486f0e3: 'Escaneie este QR',
  x_7baa65a2: 'Digite seu telefone',
  x_b624f658: 'Veja seus pontos!',
  x_dfdc6590: '💡 Sugestões de uso',
  x_5df80e61: 'Baixe PNG → Imprima e cole em **balcão de checkout/entrada da loja/parede da loja**',
  x_106fdc25: 'Envie este link para clientes regulares e deixe-os salvá-lo - verifique os pontos a qualquer momento',
  x_56f67f86: 'Você também pode imprimi-lo em um pequeno pôster A4 e colá-lo na parede.',
  x_5972e86f: 'Os clientes escaneiam o código QR e inserem seu **número de telefone celular** ou **número de cliente** (como C123456) para verificar',
  x_049346a3: '🤖 Créditos de IA',
  x_fa6ec9d1: '💳 Aluguel mensal de SaaS',
  x_90b1c915: '👑 Compra única',
  x_712596c1: '🛠 Taxa anual de manutenção',
  x_52e6abbe: 'Copiado',
  x_86516aa6: 'Moeda de pagamento',
  x_c1e2c9b2: '⚠️ Modo sandbox',
  x_ed25395f: 'Modo de produção ao vivo',
  x_4f0bae34: 'Já recebido (USD)',
  x_aeb63c16: 'Total de faturas',
  x_fad5222c: 'Concluído',
  x_072ece17: 'Aguardando pagamento',
  x_28efb5bd: 'Renda criptográfica',
  x_694fc5ef: 'Atualizar',
  x_c459d386: 'Por tipo',
  x_21efd88b: 'Ainda não há dados',
  x_d071be88: 'Faturas recentes',
  x_4787d633: 'inquilino',
  x_226b0912: 'Tipo',
  x_f9b45f5c: 'Valor (USD)',
  x_def802c1: 'Recebido (USDT)',
  x_4572d0ec: 'Ainda não há fatura',
  x_50de5a30: 'estou aqui',
  x_74d3ba48: '= o estado é',
  x_1dea3af7: 'e',
  x_92a99777: 'total de faturas',
  x_bfa852da: '💡 Ele irá automaticamente para NowPayments 5 a 15 minutos após o cliente efetuar o pagamento → ele irá transferi-lo automaticamente para sua carteira TRON',
  x_730aa550: '💡 Se quiser ver os detalhes específicos de cada transação, vá diretamente para',
  x_351912e9: 'verificar',
  x_8c25dee1: 'laranja vibrante',
  x_3c683341: 'oceano azul verde',
  x_a45a3ac7: 'verde fresco',
  x_46341dc6: 'elegante ouro violeta',
  x_e64084df: 'ouro negro moderno',
  x_db29972a: 'Código QR de promoção da loja online',
  x_32a67e3c: 'Gere lindos pôsteres, imprima-os e publique-os nas lojas para atrair clientes para escanear o código QR e fazer pedidos.',
  x_e414473c: 'Imprimir',
  x_0657ba7c: 'Link da loja on-line',
  x_6a9e5785: 'entrega porta a porta',
  x_0060e3d3: 'Faça um pedido a qualquer momento',
  x_f973aa04: 'Ofertas exclusivas',
  x_7864d864: 'chegue rapidamente',
  x_68d89d0b: 'Gama completa de produtos',
  x_ee79ba4c: 'Vários pagamentos',
  x_72f59366: 'Não há necessidade de sair, bons produtos serão entregues na sua porta!',
  x_ccb69e71: 'Desconto no primeiro pedido para novos clientes + ganhe pontos ao fazer um pedido!',
  x_dd35f3aa: 'QZ Tray é um serviço de impressão local gratuito. Após a instalação, o site pode enviar instruções de impressão diretamente para a impressora.',
  x_227b88f4: 'A caixa de diálogo Imprimir não aparece',
  x_ee173ce8: 'Etapas:',
  x_e1eb333e: 'Clique para baixar:',
  x_ff7bbf67: 'Baixe o Windows (.exe), instale',
  x_a3c49496: 'Clique em “Avançar” durante a instalação',
  x_e0e27701: 'O ícone QZ aparecerá na bandeja do sistema',
  x_0671c916: 'Remover janela de segurança:',
  x_ea015cf2: 'Se a janela "Site não confiável" aparecer sempre que você imprimir a bandeja QZ, siga as etapas abaixo para instalar o certificado:',
  x_e43c62e9: 'Baixe o certificado:',
  x_d3f866d8: '2. Coloque o baixado',
  x_0457c44a: 'Copie o arquivo para:',
  x_be76a70e: '3. Clique com o botão direito no ícone QZ na bandeja do sistema → Selecione',
  x_84b2bd4a: 'entrar',
  x_1094f3fa: 'Histórico de gerenciamento → Configuração do sistema → Opções da impressora',
  x_f643af46: ', preencha o nome da impressora.',
  x_ce1cca4a: 'Impressora PDV',
  x_1708461e: 'Usado para imprimir recibos de vendas diários (recibos falsos/recibos internos)',
  x_b627c3dc: 'Exemplo:',
  x_1bd554fc: 'Impressora Fiscal',
  x_6f3305bc: 'Utilizado para impressão de notas fiscais oficiais (genuínas/originais)',
  x_17f83847: 'Como encontrar o nome?',
  x_69c9ff65: 'Configurações do Windows → Dispositivos → Impressoras e scanners',
  x_b769e4ff: 'Você só tem uma impressora? Basta preencher os dois nomes da mesma maneira.',
  x_49e382b0: 'Nota Fiscal',
  x_53299d30: 'Insira o valor',
  x_23ad596c: 'Imprimir em impressora fiscal | A ordem aparece no relatório.',
  x_0597a697: 'Recibo Interno',
  x_748da81b: 'Imprimir em impressora POS | Ordem oculta no relatório',
  x_43f28ccd: 'Basta registrar-se',
  x_f523f020: 'Não imprima | Ordem oculta no relatório',
  x_339fbb54: 'P: Um botão cinza "QZ" é exibido na parte inferior do PDV?',
  x_850263a4: 'R: A bandeja QZ não está funcionando. Verifique se há um ícone QZ na bandeja do sistema. Caso contrário, reabra a bandeja QZ.',
  x_3c7cc6d8: 'P: A caixa de diálogo "Permitir/Bloquear" aparece?',
  x_a008acbd: 'R: Marque "Lembrar esta decisão" e clique em "Permitir", e ela não aparecerá mais.',
  x_5c8ae7a8: 'P: Não consegue encontrar a impressora?',
  x_ed2b395c: 'R: Certifique-se de que o nome da impressora nas configurações seja exatamente o mesmo do Windows. Vá para Configurações do Windows → Dispositivos → Impressoras para visualizar.',
  x_60ca8330: 'P: Como configurar apenas uma impressora?',
  x_4042778b: 'R: Preencha o mesmo nome para a impressora POS e para a impressora fiscal (por exemplo, preencha XP-80C).',
  x_d1b45389: 'P: Posso imprimir sem instalar a bandeja QZ?',
  x_0a468501: 'R: Sim, mas uma caixa de diálogo do navegador aparecerá sempre que você imprimir. Com a bandeja QZ instalada, a impressão é totalmente silenciosa.',
  x_231206dd: 'caixa',
  x_f7edf5ac: 'pedaços',
  x_d3bc58b6: 'taxa de câmbio',
  x_93a17a92: '🧾 Recibo do pedido',
  x_79730766: '💰 Aviso de reclamação',
  x_3b380a1e: '🎂Desejos de aniversário',
  x_4438a544: '📢 Anúncios promocionais',
  x_1a6b4e12: '⚠️ Alerta ao patrão',
  x_88a1edb1: '💬 Personalizar',
  x_5e89ee46: 'Marcado como enviado',
  x_02c1633a: 'ignorado',
  x_f2b4dbf5: 'Nenhum ponto de cliente ≥100, nenhum VIP ainda',
  x_490b3a34: 'Nenhum cliente fez pedidos nos últimos 30 dias.',
  x_0ea30aad: 'Nenhum cliente faz aniversário hoje',
  x_79eb3367: 'Não há cliente ou o cliente não preencheu o número de telefone',
  x_bc21bd22: 'Não há clientes sob a condição.',
  x_cc989ba6: 'Falha na exportação',
  x_e73fb531: 'Caixa de saída',
  x_1ce32b39: 'Nenhuma mensagem pendente',
  x_218e94e7: 'Pedidos/créditos/aniversários aparecerão aqui automaticamente',
  x_a9550e64: '🚀 Como usar o CSV exportado:',
  x_e75ae49a: '1. Baixar',
  x_82190c17: 'APP oficial (gratuito, não requer RIF)',
  x_976bdc5e: '2. Configurações → Ferramentas →',
  x_c32cb069: 'Lista de transmissão',
  x_4d238b59: '→ Novo',
  x_df804a38: '3. Importe CSV via Google Contacts/iCloud (ou adicione contatos manualmente)',
  x_df02ca90: '4. Envie mensagens para a lista de transmissão - todos recebem um bate-papo individual (não um bate-papo em grupo)',
  x_f4d94d4b: '⚠️ Uma única lista de transmissão pode ter até 256 pessoas; se você tiver muitos clientes, poderá exportá-los várias vezes em lotes',
  x_1603b069: 'segunda-feira',
  x_b5a6a07e: 'terça-feira',
  x_e60725e7: 'Quarta-feira',
  x_170fc8e2: 'Quinta-feira',
  x_eb79cea6: 'sexta-feira',
  x_24575130: 'sábado',
  x_562d7476: 'domingo',
  x_2e5d828a: 'Nenhum compromisso concluído este mês / Nenhum agendamento concluído este mês',
  x_89a676e4: 'Altere a% e salve automaticamente. Somente os compromissos marcados como concluídos contam. / A percentagem modificada é guardada automaticamente e apenas as reservas "completas" são contabilizadas',
  x_685f370b: '📴 Offline: O pedido de entrega foi salvo e será carregado automaticamente online.',
  x_d0c68f0b: '📴 Offline: O recibo foi gravado e será automaticamente armazenado online.',
  x_93c4b017: 'Pedido de compra excluído',
  x_41722aa3: 'O pedido de compra foi arquivado e oculto',
  x_dbc210d6: 'Por favor preencha o código e nome',
  x_a889286a: 'Falha na criação',
  x_535bef11: 'As categorias foram atualizadas.',
  x_930442e2: 'Falha na atualização',
  x_44e7120c: 'Ocultar concluído',
  x_9779a11a: 'Programa concluído',
  x_1a750305: 'Todas as categorias',
  x_37c419ae: 'Anexar código de barras',
  x_f2996845: 'unidade',
  x_ea887bd0: 'Especificações',
  x_c5855564: 'preços',
  x_d0e857e9: 'Fórmula da taxa de lucro',
  x_cb340191: 'benefício',
  x_c6e41d42: 'Preço do FCL',
  x_d4229e8a: 'Regulamentos de dinheiro',
  x_51829073: 'inventário inicial',
  x_a45686c0: 'Alerta de estoque',
  x_dce5379c: 'esconder',
  x_2f4aaddd: 'Excluir',
  x_ecf7ebb5: 'Sem categoria',
  x_8ec0438a: 'Histórico de pagamentos',
  x_bce9f7d6: 'Adicione produtos rapidamente (compras e armazenamento)',
  x_625fb26b: 'Cancelar',
  x_730bfc36: 'pago integralmente',
  x_8ec00711: 'O pedido de compra foi pago integralmente!',
  x_9698ab8c: 'Escolha como processar este pedido de compra:',
  x_83ef2b4d: 'Dinheiro',
  x_90f94c19: 'Cartão',
  x_f1a5d025: 'Transferência',
  x_2fc44ed8: 'Crédito',
  x_4fa3a2eb: 'O código de referência foi gerado.',
  x_7f7de8a2: 'Erro de compilação',
  x_10173e90: 'Código de referência copiado',
  x_a95b0fa6: 'Link de registro copiado',
  x_fe32def4: 'ativo',
  x_69b0f684: 'Desativado',
  x_5947a2a4: 'Recompensas por indicação',
  x_62ea3c2c: 'Educadamente recomendado',
  x_838b386f: '1. Compartilhe o código de referência',
  x_d6ade6c8: 'Compartilhe seu código de referência exclusivo com outros comerciantes',
  x_07cff2ae: '2. Cadastro de amigos',
  x_af47e408: 'Amigos usam código de indicação para se inscrever para um teste de 44 dias',
  x_6019e1c3: '3. Ambas as partes ganham prêmios',
  x_a250368b: 'Você também recebe uma extensão gratuita de 30 dias',
  x_c6c4ba10: 'Você ainda não tem um código de referência, clique para gerar um',
  x_83e0c4f0: 'Meu código de referência',
  x_6e1519ad: 'Número de pessoas que foram recomendadas',
  x_2964d77d: 'Número de dias para receber o bônus',
  x_f3ce8bc2: 'Registros recomendados',
  x_23733df5: 'Não há registro de vendas nos últimos 30 dias e não pode ser calculado automaticamente.',
  x_0b1cc5f0: 'O cálculo falhou',
  x_0d667672: 'Calculando...',
  x_0868b4ed: 'Definir inventário mínimo automaticamente',
  x_88b16782: 'Falha no reparo',
  x_e596edd9: 'Aplicando...',
  x_5921137f: 'Resultados calculados automaticamente (com base nos últimos 30 dias de vendas + 7 dias de estoque de segurança)',
  x_b409f53c: 'Inventário e comparação',
  x_e7c0908c: 'dinheiro',
  x_c31eabb4: 'cartão magnético',
  x_acaf665f: 'transferir',
  x_2432b575: 'Observações',
  x_cd1cff20: 'Vendas totais (brutas)',
  x_6b587c75: 'Reconciliar esta alteração (recalcular o total da biblioteca de pedidos)?',
  x_a8336884: 'As aulas devem terminar no mesmo horário?',
  x_f0407e01: '✅ Reconciliado',
  x_769a6bb0: '🔧Reconciliar (do banco de dados de pedidos)',
  x_d342fac8: 'Reimprimir o relatório',
  x_a6240224: 'Detalhes de desempenho dos funcionários',
  x_a235c0c8: 'Agrupamento de clientes RFM + envio de grupo em um clique do WhatsApp',
  x_0cd126ef: 'O WhatsApp Web não está conectado. Vá para “📱 WhatsApp se conecta automaticamente” para escanear o QR antes de transmitir.',
  x_1e664d6e: 'Clique em Grupo para selecionar rapidamente todos os clientes do grupo → Preencher previamente a cópia promocional com um clique',
  x_c7b27363: 'mensagens de grupo do WhatsApp',
  x_792f9eb2: '✨Geração de copywriting com IA (GPT-5.2)',
  x_1aa19423: 'Escreva automaticamente 3 textos do WhatsApp com base no seu setor + segmento selecionado + comportamento de compra do cliente',
  x_e4234194: 'Opcional: Promoção Dia das Mães / Novidades / Promoções de fim de semana...',
  x_4dfe7036: 'gerar',
  x_48853792: 'Dados vistos pela IA',
  x_baea39ef: 'consumo per capita',
  x_de4db8d2: 'Visitas per capita',
  x_b6838383: 'alugar',
  x_0ee0c81c: 'Água e eletricidade',
  x_be11fc04: 'salário',
  x_1f4beff9: 'Consumíveis',
  x_324712a3: 'Reparar',
  x_0f3a252a: 'transporte',
  x_638e3280: 'impostos',
  x_0d98c747: 'Outros',
  x_d594b77a: 'Por favor insira o valor',
  x_3fdaeadf: 'Adicionado com sucesso',
  x_0719d4e5: 'Tem certeza de que deseja excluir?',
  x_3fef31de: 'gerenciamento de despesas',
  x_e5d6c826: 'novas despesas',
  x_07d77a1b: 'despesas totais',
  x_3d2a964f: 'Número de canetas',
  x_6b63c89c: 'Despesas de cada loja',
  x_3bdd08ad: 'Descrição',
  x_f9ac4b2a: 'operador',
  x_86c5708d: 'Selecione a loja',
  x_16a097d2: 'Contas de água, contas de luz, despesas de logística, etc.',
  x_de5f6c72: 'equivalente',
  x_1e49734c: 'recibo real',
  x_1993ed26: 'Resumo',
  x_78d078e8: 'despesas',
  x_80170f62: 'lucro líquido',
  x_e9caa1e9: 'Digitalizar imediatamente todos os inquilinos em busca de produtos, estoque versus estoque, desvios de quantidade e corrigi-los automaticamente? \\n\\nAuditar desvio de inventário e autocorreção?',
  x_3859c850: 'Variação zero de estoque – tudo se alinha ✓',
  x_e6c2d5d3: 'Digitalizando...',
  x_8f7072ac: 'auditoria de inventário',
  x_66411a09: 'mensagem de teste',
  x_6e4f4b33: 'Por favor insira o número do celular',
  x_12020cd0: '✅ Ativado: os clientes receberão automaticamente um recibo do WhatsApp após fazer um pedido',
  x_ad859563: '⏸ O recebimento automático está desativado',
  x_1668b5ee: '⏸ A reivindicação automática foi desativada',
  x_f562ea82: 'Selecione a loja padrão primeiro',
  x_9f276dd7: '✅ Habilitado: Quando os clientes enviarem capturas de tela do pagamento para o seu WhatsApp, o pedido será automaticamente reconhecido e comparado.',
  x_08f2f5b8: '⏸ O cancelamento automático está desativado',
  x_207fff73: 'Tem certeza de que deseja sair do WhatsApp? Depois de sair, você precisa escanear o código QR para fazer login novamente.',
  x_a58b3a30: 'Saí, esperando por um novo código QR...',
  x_3d7c933b: 'Erro de logout',
  x_c5ea9c6a: 'Conectado',
  x_9fde5e83: 'Aguardando digitalização',
  x_61536d6b: 'Certificação em andamento...',
  x_7f3a55b2: 'Não conectado',
  x_4c7bf874: 'Conflito (faça login em outro dispositivo)',
  x_fbecd9e3: 'exceção de serviço',
  x_e12b354d: 'ATIVADO',
  x_3b6ed28d: 'Fechar',
  x_be5fbbe3: 'salvar',
  x_7657f76c: 'seu número',
  x_65026c6a: 'Status da conexão:',
  x_9db7a84f: 'Já ativado',
  x_d4909dab: 'recebido automaticamente',
  x_5d855937: 'expirou',
  x_0d041ace: 'Expira em 3 dias',
  x_0e4b660d: 'O intervalo mínimo entre dois lembretes para o mesmo cliente:',
  x_30b38123: 'Enviado para seu número de WhatsApp',
  x_6134f524: 'correspondência automática',
  x_f3a2348c: 'Os hóspedes não precisam abrir o site ou escanear o código QR, assim como enviar uma mensagem no WeChat.',
  x_12e45b5a: 'Armazenamento de propriedades padrão:',
  x_f26bedc7: '(sem loja)',
  x_abfc9ba9: 'Feche primeiro antes de mudar de loja.',
  x_c363b9ec: 'Digitalize o código QR para se conectar ao seu WhatsApp',
  x_dfaf8682: 'Abra o WhatsApp no seu telefone',
  x_3fafc6fe: 'Cardápio →',
  x_4a4c2cf7: 'Dispositivos vinculados',
  x_a7ad104b: 'dispositivo de ligação',
  x_e0290bd7: 'Digitalize o código QR abaixo com sua câmera',
  x_6d81d254: 'Aguarde de 5 a 10 segundos até que “Conectado” apareça.',
  x_0d280386: 'Aguardando a geração do código QR...',
  x_008fe1ba: 'Geralmente leva entre 10 e 20 segundos',
  x_b8a25309: 'Conectado com sucesso ✅',
  x_b71dbebc: '📤 Teste de envio',
  x_565ea0b6: 'Número do destinatário (formato E.164)',
  x_b87b7756: 'Conteúdo da mensagem',
  x_eb0bd897: '💡 Dicas de uso',
  x_0fb5c8cf: 'Esta conexão é',
  x_01e161e9: 'grátis',
  x_22d65176: ', não consome crédito Twilio',
  x_d01f9a4f: 'Envie uma mensagem para qualquer cliente',
  x_52c58309: 'Não há necessidade de aderir',
  x_332247f3: ', assim como o envio de grupo WeChat',
  x_83320746: 'Você não precisa manter o WhatsApp aberto no seu celular, o VPS mantém você logado automaticamente',
  x_fcf8348a: 'Se aparecer “conflito”, você está usando o WhatsApp Web em outro lugar; basta sair do outro dispositivo',
  x_0f4dfafd: 'Caso você saia, basta retornar a esta página e escanear o código novamente (1 minuto)',
  x_f27d2855: '👉Cortar',
  x_167fc20b: '"🎂Marketing de Festival/Aniversário"',
  x_525ce8d5: 'Tags, você pode enviar mensagens de grupo de feriados/aniversários para o WhatsApp com um clique, a IA grava automaticamente uma cópia',
  x_4fe8cddc: 'Defina lojas ilimitadas',
  x_7b9796b4: 'O diagnóstico falhou:',
  x_c1e4fc86: 'Reparo concluído',
  x_24c6a887: 'Falha no reparo:',
  x_105c8a51: 'Exportação bem-sucedida',
  x_dd51ab50: 'Falha na exportação',
  x_80070ef8: 'Sem limite de loja',
  x_104faff3: 'Limite da loja',
  x_7fa365e7: 'Diagnóstico/Reparo',
  x_9344b89b: 'Exportar backup',
  x_0719aa2b: 'redefinir senha',
  x_bdd21b3d: 'Alterar ID',
  x_9171e387: 'Quantidade personalizada (deixe em branco = sem limite)',
  x_a94b953e: '→ Crie mesas automaticamente, habilite tickets de cozinha, etiquetas de cenário de serviço e taxa de serviço de 10%',
  x_1b89e094: '→ Abra o número para retirada de refeições, emissão de tickets de cozinha e pedidos de autoatendimento',
  x_5d960ff3: '→ Habilitar variantes de tamanho × cor, etiquetas sazonais, redução automática de preços de atacado e varejo',
  x_3fc4b6fb: '→ Habilitar gerenciamento de número de lote e data de validade',
  x_db15472a: '→ Iniciar vendas/pesagem a granel e caixas completas',
  x_609adbd2: '→ Varejo geral (sem funções específicas do setor)',
  x_72d55e89: 'Digite uma nova senha',
  x_fbc026c9: 'saúde',
  x_fe3d61c1: 'com aviso',
  x_ab9512ba: 'Há um problema sério',
  x_e2e27a87: 'sério',
  x_900c70fa: 'aviso',
  x_8f3d0f51: 'Tem certeza de que deseja excluir todos os pedidos? Esta ação é irreversível!',
  x_b97b6c51: 'Defina o número máximo de lojas que este comerciante pode abrir com base no pacote (preço correspondente: 1 loja $ 50 / 2 lojas $ 80 / 3 lojas $ 110 / 5 lojas $ 160 / 8 lojas $ 230). Deixe em branco = sem limite.',
  x_8441b348: 'Sem limite',
  x_6258bb14: '— Inicialize automaticamente a classificação do setor + recursos',
  x_9e0124e8: 'Varejo Geral',
  x_8bc59f0c: '🍽️ Restaurante (mesa + telão de cozinha + taxa de serviço)',
  x_2306dfd6: '🍔 Fast food / Fast food (número do pedido + tela da cozinha)',
  x_03d614a2: '👕 Loja de roupas/roupas (tamanho × cor + estação + atacado)',
  x_9357f511: '💊 Farmácia/Farmácia (número do lote + gerenciamento de vencimento)',
  x_ef343e19: '🥕 Supermercado/Supermercado (granel + pesagem)',
  x_e44ccd80: 'Padaria',
  x_1464330c: 'loja de ferragens',
  x_08460537: '📱 Eletrônicos / Eletrônicos (número de série)',
  x_eebcf410: '💄Beleza/Beleza (citação)',
  x_89d569a1: 'Redefinir senha do comerciante',
  x_0644dad5: 'Digite seu nome de usuário e nova senha. Caso o usuário não exista, o sistema o criará automaticamente.',
  x_bf7da0bf: 'nova senha',
  x_80cfc33c: 'Confirmar reinicialização',
  x_316a4683: 'Oficina de diagnóstico e reparação.',
  x_44d50e5a: 'Diagnosticando...',
  x_a519dc2a: 'Problemas encontrados',
  x_95ab9037: 'operação de reparo',
  x_bab268d5: 'fornecedor',
  x_e54ee345: 'Atrasado!',
  x_edae78fd: 'empréstimo',
  x_c3704da5: 'Crédito de mercadorias',
  x_ebe86a1f: 'Reembolso',
  x_03531769: 'Dedução salarial',
  x_756048fc: 'Declaração do funcionário',
  x_4cf24aba: 'Quantidade',
  x_5a4fcfe2: 'Valor atual devido',
  x_90ea8d11: 'crédito de funcionário',
  x_5a611987: 'Loja não atribuída',
  x_ad83f8e5: 'valor total devido',
  x_bd3616ee: 'Recibo + QR',
  x_2dbf283b: 'Extrato de conta',
  x_bbdd42a0: 'resolvido',
  x_ea340b7c: 'pedir dinheiro emprestado',
  x_3f01df5b: 'mercadorias a crédito',
  x_620610c0: 'foi devolvido',
  x_8577b01a: 'Retirada de depósito',
  x_44ba3fed: 'Não foi possível extrair',
  x_7b1df363: 'Atualmente não há registro de dívidas de funcionários.',
  x_4c95bf44: 'reembolso',
  x_79ef16e5: 'deduções na folha de pagamento',
  x_006deeed: 'Crédito PDV',
  x_d2f88894: 'Aquisições',
  x_e6119529: 'Recibo de pagamento + QR',
  x_ef9ec7c0: 'Contate o suporte',
  x_acf0664a: 'Excluir erro',
  x_ec25deba: 'Erro ao excluir',
  x_a2339865: 'Agora o armazém principal.',
  x_5154ae17: 'Falha na cópia',
  x_d6fecfb2: 'Insira um valor válido',
  x_956ef5ad: 'Aprovado/Aprovado',
  x_786c8fe1: 'Rejeitado / Rejeitado',
  x_7e237e94: 'custo',
  x_4eb4b061: 'Copiar do repositório principal',
  x_b6eea70f: 'Falha ao carregar níveis',
  x_81bbad14: 'Custo não estabelecido',
  x_901a44b7: 'Não estabelecido',
  x_55fadf3b: 'custo unitário',
  x_7e0457bb: 'Configurações salvas',
  x_c330679b: 'O limite é muito alto e o teste não é ativado (o limite atual',
  x_82b783f0: 'ignorado',
  x_d06adee8: 'Aviso de flutuação da taxa de câmbio',
  x_46d3ff51: 'Configurações de alerta',
  x_5659fd6c: 'Habilitar alertas FX',
  x_839db71f: '— é ativado quando esta porcentagem é excedida',
  x_3a62401d: 'Recomendado 5% (as flutuações diárias regulares do BCV são de 1-3%, exceder 5% é anormal)',
  x_4ab817d3: '—Com código do país, sem +',
  x_eae0f4d8: 'Número configurado automaticamente com Boss PIN quando vazio',
  x_0468089c: 'Histórico de alertas',
  x_317dbe0f: 'Não alerte ainda',
  x_c4677828: 'hora',
  x_8bd0b918: 'Fonte',
  x_609a902e: 'antigo → novo',
  x_34d0195a: 'mudar',
  x_41dfb0bf: 'Razão',
  x_6ef780bf: 'danificado',
  x_584cd195: 'Expirado',
  x_a6a652d7: 'uso pessoal',
  x_42e0c46b: 'amostra',
  x_fe299b11: 'Relatório de classificação/análise de taxa de câmbio',
  x_1e355e1f: 'mercado negro',
  x_800dfdd9: 'hoje',
  x_72520580: 'esta semana',
  x_0ec94a37: 'este mês',
  x_c5d35890: 'mês passado',
  x_6da06b0c: 'Todas as lojas',
  x_bee912d7: 'Consulta',
  x_72d76618: 'Taxa de câmbio:',
  x_4cbae8f6: 'vendas totais',
  x_9719978c: 'custo das mercadorias',
  x_bae6c9ba: 'lucro bruto',
  x_7bfa923d: 'despesas diárias',
  x_cea67413: 'Danos/perdas relatados',
  x_29225555: 'Ganhos cambiais',
  x_33fa2d30: 'Contas a receber de funcionários',
  x_4fbe97e5: 'Para ser removido',
  x_fbb493d0: 'Número de pedidos',
  x_eee785b1: 'Obtenha produtos com a taxa de câmbio do governo',
  x_9ae44464: 'vendas',
  x_f5acfdc9: 'Bens do mercado negro',
  x_bc41ea8b: 'Estatísticas por categoria',
  x_bfec3534: 'Modelo de preços',
  x_27a504ee: 'Vendas ($)',
  x_2d4ec760: 'Vendas (Bs)',
  x_eae13adc: 'Custo ($)',
  x_e052f520: 'Lucro ($)',
  x_7a3da957: 'margem de lucro',
  x_e4f48bf4: 'número de peças',
  x_dda07873: 'Detalhes de despesas',
  x_030808e9: 'Detalhes do relatório de danos/perdas',
  x_65cccb1c: 'Detalhes da receita cambial',
  x_ac502247: 'Compre USD em dinheiro',
  x_2feedc17: 'Passe o cartão para receber dinheiro',
  x_0d91478b: 'Estatísticas por dia',
  x_d6ddd835: 'Rastreamento de lote/lote (FIFO)',
  x_e06e4a15: 'Adicionar novo lote',
  x_a6eefa41: 'Recuperar a rastreabilidade',
  x_f7414a41: 'Preparando',
  x_a2d94b67: 'Pronto',
  x_362f791f: 'Erro',
  x_a7cf3c19: 'Novo',
  x_641fb174: 'Comece',
  x_6062f967: 'Pronto',
  x_c7664439: 'Listas',
  x_d9d86061: 'reversão',
  x_4f5b356a: 'Expositor de cozinha',
  x_f05d50fe: 'Sem pedidos',
  x_ebedad8a: 'Aguardando pedidos no PDV...',
  x_8f9d8f83: 'Conta/E-mail (PayPal/Wise/Zelle)',
  x_6ee9e469: 'Endereço da carteira (USDT/BTC/ETH)',
  x_6a069dc9: 'Revolução)',
  x_436d77df: 'Pagamento Binance)',
  x_03c32ab3: 'Número da conta bancária (transferência bancária)',
  x_f8dfedcd: 'farelo',
  x_a9ca9fd6: '+58 424-8476761 (中文/Espanhol/Inglês)',
  x_274c1e1b: 'TU_USDT_TRC20_HERE (espaço reservado)',
  x_ed7823b1: '+ adicionar',
  x_ac92f4c5: 'Nome (por exemplo, Wise/Zelle/Binance Pay)',
  x_76254a13: 'Conta/endereço/link (como your-wise@email.com)',
  x_61860e54: 'Instruções de pagamento aos clientes (opcional)',
  x_908a649e: 'Exemplo: Após o pagamento, faça uma captura de tela e envie para o atendimento ao cliente do WhatsApp. Ativaremos sua conta Sellox e enviaremos suas credenciais de login em 30 minutos.',
  x_921915b6: 'Salvar todas as configurações',
  x_fb4ca1cf: 'Carregando…',
  x_f19e59a5: '🌍 Configuração de pagamentos internacionais (cobrança internacional)',
  x_4290f0a0: 'Defina a forma de pagamento para clientes estrangeiros (África do Sul/Brasil/Colômbia e 7 outros países) para pagar $199/$499/$999. As informações serão exibidas no pop-up “Comprar” na página inicial.',
  x_8009051e: 'Habilitar pagamentos internacionais',
  x_e90bdf1a: 'Após o fechamento, o botão Comprar na página inicial mostra apenas o WhatsApp de atendimento ao cliente.',
  x_17fb55f0: 'Número do WhatsApp (com código do país, sem +)',
  x_45ffbd9d: 'Exemplo: 5804248476761 (Venezuela)',
  x_f3864065: 'Mostrar rótulo (opcional)',
  x_d04bbc0e: 'E-mail do PayPal',
  x_0fed3f6b: 'Link paypal.me (recomendado: pagamento com um clique para clientes)',
  x_0b36d1a2: 'TRC20 (Tron): taxa de administração ≈ $1, recomendado ⭐',
  x_67ebc935: 'ERC20 (Ethereum): taxa de administração de US$ 5 a US$ 20',
  x_51e8a79c: 'BEP20 (Binance Smart Chain): taxa <$1',
  x_e71d5f47: 'Ainda não adicionado. Clique em "+Adicionar" no canto superior direito para adicionar qualquer método de pagamento (Wise/Revolut/Zelle/Binance Pay/Pix/Western Union, etc.)',
  x_0380d11f: '💰 Preço do pacote (USD)',
  x_dcf9f3db: 'Compra única em USD',
  x_92d28a70: '📝 Instruções de pagamento aos clientes (opcional)',
  x_37ef8c61: 'registro paypal',
  x_a094a4a9: '(Conta pessoal pode cobrar o pagamento)',
  x_9b3c8bf1: 'paypal.me criado',
  x_d149282b: 'Carteira USDT TRC20 (recomendado)',
  x_b9f4d9f0: 'Wise (remessas transfronteiriças)',
  x_42c062bf: '🛒 Loja comum',
  x_b0c7322a: 'Comércio varejista em geral como mercearias, lojas de ferragens, lojas de conveniência, papelarias, lojas de cosméticos, etc. Não existem categorias pré-estabelecidas, crie a sua de acordo com sua necessidade.',
  x_e69533ce: '✓ Moeda dupla (USD + Bs)',
  x_5c26623b: '✓Várias lojas',
  x_348c3c42: '✓ Publicação da loja online',
  x_c971b497: '✓ Adequado para 90% das empresas comuns',
  x_d5ebb7de: '🍽️ Restaurante',
  x_c85301d4: 'Restaurantes de chá, fast food, churrasqueiras, cafés, bares, etc. Crie categorias de menu, posicionamento de mesa e pedidos de cozinha com apenas um clique.',
  x_74efa0b8: '✓ 7 categorias de menu criadas automaticamente',
  x_03fb8ea8: '✓ 10 mesas disponíveis imediatamente',
  x_01cdb4fc: '✓ Faça pedidos automaticamente na cozinha',
  x_05474198: '✓ Taxa de serviço 10%',
  x_6229e580: '👕 Loja de roupas',
  x_66682a68: 'Roupas, sapatos e chapéus, roupas infantis, acessórios. Cada peça pode ter tamanho (S/M/L/XL) × cor (vermelho/azul/preto) e múltiplas variações em estoque.',
  x_57dd3ef7: '✓ 8 categorias de roupas',
  x_2b54dfae: '✓ Variações de tamanho + cor',
  x_7d9f9b66: '✓ Etiquetas sazonais',
  x_72c05d38: '✓ Dobrar o preço de atacado e varejo',
  x_f9003331: 'Já nesta indústria',
  x_acd5cb84: 'falhou',
  x_66342ccc: '✓ Indústria atual',
  x_3f86ef3c: 'Aplicar este modelo',
  x_e2662ca4: 'Serviço',
  x_8da5aff6: '✅ Salvo: o pagamento no PDV funcionará imediatamente',
  x_cea028d0: 'Modelo de indústria',
  x_cd790081: 'Defina o tipo de loja com um único clique: categorias, tabelas e variações, tudo de uma vez',
  x_a22b06e7: 'Dicas:',
  x_605629af: 'loja comum',
  x_686dbf3b: 'Taxa/gorjeta de serviço (serviço)',
  x_3b858549: 'Taxa de serviço habilitada por padrão',
  x_2420b778: 'Porcentagem da taxa de serviço (%)',
  x_f0d6cce2: 'O nome que aparece no recibo.',
  x_0bfa1205: '🛵 Entregadores',
  x_00a0e92f: '⚙️ Configuração de taxas',
  x_6af35899: '📦 Pedido de entrega',
  x_696bc73f: '✅ Aprovado, passageiros já podem aceitar pedidos',
  x_28687aeb: 'Tem certeza que deseja rejeitar este entregador? Não poderá aceitar pedidos.',
  x_81233d75: 'Rejeitado',
  x_3bddf714: 'Suspender este entregador? Não poderá aceitar novos pedidos.',
  x_a2d930fd: 'suspenso',
  x_30a59161: '✅ Restaurado e podendo aceitar encomendas.',
  x_a431ba4e: 'Pesquise por nome/telefone',
  x_75eb29d6: '🛵 Motocicleta',
  x_f534abbc: '🚲 Bicicleta',
  x_b590db5d: '🚗 carro',
  x_56d6a939: '🚶 caminhando',
  x_5c2ee4b5: '📍 Obtendo localização...',
  x_88a5387f: '✅ A localização atual foi obtida como coordenadas da loja.',
  x_1b925959: 'Não é possível obter a localização. Insira-a manualmente',
  x_77322d90: '✅ Configurações salvas',
  x_6620698d: 'Grupo de pedidos de captura',
  x_68905cf3: 'on-line',
  x_cb2806df: '⏳ Pedidos pendentes',
  x_fc6e17a5: '🛵 Recebido',
  x_107d8896: '📦 Recolhido',
  x_e0ae219c: '🚀 Entregando',
  x_16661b98: '✓ Entregue',
  x_9d77d772: 'Gestão de entregadores',
  x_bce11e3f: 'Motoristas de entrega · Analisar passageiros / definir taxas / monitorar pedidos',
  x_c612876e: 'Ainda não há entregadores cadastrados',
  x_a37a9be7: 'colocar',
  x_25e4e975: 'Envie o link para seus usuários e peça que se cadastrem com o código da loja.',
  x_809476e2: 'Compartilhe com seus entregadores:',
  x_6cab0af7: 'Taxa de entrega',
  x_14289a36: 'Taxa inicial (USD)',
  x_7de56a40: 'Aumento de preço por quilômetro (USD)',
  x_b25f1d80: 'Maior distância de entrega (km)',
  x_73bb91d6: 'Localização da loja (usada para calcular a distância)',
  x_039e0dfc: 'Latitude Latitude',
  x_05e720b2: 'comprimento comprimento',
  x_3fd0fc33: 'Endereço da loja (exibido aos passageiros)',
  x_fa8ee2c3: 'Atribuição automática',
  x_28b2a26f: 'Atribuído automaticamente ao passageiro online mais próximo',
  x_f2418716: 'Distância × 50 - Número de pedidos × 30',
  x_58714e73: 'Ainda não há pedidos',
  x_86ce4ab5: 'Entregador:',
  x_9f911a7c: 'Nenhum pedido foi aceito ainda',
  x_188bff11: '🔴 Expirado',
  x_6314a940: '🟠Dentro de 7 dias',
  x_fc95d888: '🟡Dentro de 30 dias',
  x_3aae3aea: '🆓 Experimente',
  x_d7bfdc78: '🟢 Saúde',
  x_d94c64e8: '👑 A compra é permanente',
  x_4a5421bb: '❔ Sem data de validade',
  x_32137a91: 'A geração de IA falhou',
  x_3b5acbf9: 'A mensagem não pode ficar vazia',
  x_1a70e8dc: 'Inscreveu-se no Outbox + Abra o WhatsApp',
  x_4d5ccd01: 'Expirado',
  x_d3cf0210: 'Expira em 7 dias',
  x_56ee9094: 'Expira em 30 dias',
  x_cda88e69: 'compra permanente',
  x_1a5e9603: '😊 Amigável',
  x_489fd45e: '⏰ urgente',
  x_c6863be8: '💎Compra de atualização',
  x_0e223ebb: 'Não concluído',
  x_05e9dc7b: 'Enviar WhatsApp',
  x_de815854: 'Painel de assinatura/renovação de locatário',
  x_ecb48dd6: '🤖 Lembrete inteligente de IA',
  x_ee3f5585: 'país',
  x_927babb3: 'Dias restantes',
  x_fd5561f7: 'pagamento final',
  x_a522f3ba: 'Atualmente não há inquilinos nesta categoria.',
  x_46ca8fe7: 'sem telefone',
  x_59cf15fe: 'Modelo',
  x_0f0c4077: '😊 Reescrever (amigável)',
  x_849ced1d: '⏰ Reescrever (urgente)',
  x_28e51c71: '💎 Reescrever (atualizar)',
  x_6b2b61c1: 'Ao clicar em "Enviar WhatsApp", ele entrará automaticamente na Caixa de saída e abrirá o aplicativo/web WhatsApp ao mesmo tempo. Você só precisa clicar em ➤ Enviar seta.',
  x_8fe83636: 'Por favor insira o número de telefone da recepção',
  x_b8c17683: 'Meta está bloqueado e foi adicionado à fila wa.me.',
  x_8384ee76: 'Enviado via Meta API',
  x_e98c5780: 'Configuração',
  x_e1c652bc: 'Envio de teste',
  x_8b608503: 'Qual é o lucro hoje?',
  x_780a3ce3: 'Copiado da página de configurações do Meta WhatsApp',
  x_dfc26b0a: 'Se precisar atualizar, cole o novo token',
  x_14ae8f5b: 'Gerado a partir do usuário do metassistema',
  x_4323be72: 'Salvar configurações',
  x_1b709fcc: 'Receber chamadas +584...',
  x_ff6d830a: 'Enviar mensagem de teste',
  x_1c00c645: '💡 Demora entre 15 e 20 minutos. Configure-o uma vez e você nunca mais terá que se preocupar com isso.',
  x_5a3044a7: 'Todas as etapas são gratuitas, a menos que as mensagens comerciais do WhatsApp excedam o limite Meta gratuito.',
  x_d9917a0f: 'Etapa 1 / Etapa 1: Crie uma conta de meta desenvolvedor',
  x_18305c0e: 'Abrir:',
  x_f9056348: 'Faça login com sua conta do Facebook/WhatsApp',
  x_7d427d3d: 'Clique no canto superior direito',
  x_9c11804f: 'começar/começar',
  x_a3c972b7: '→ Siga as instruções para concluir o registro (gratuito)',
  x_63d5e90b: 'Passo 2 / Passo 2: Crie uma conta comercial',
  x_be604f8b: 'ponto',
  x_86165c96: 'Criar negócios',
  x_34bc86ed: '→ Preencha o nome da loja, seu nome e endereço de e-mail',
  x_ff5d264e: 'Passo 3 / Passo 3: Crie o aplicativo WhatsApp Business',
  x_b140dd92: 'voltar para',
  x_abb2b8f6: 'Criar aplicativo / Criar aplicativo',
  x_e90efab1: 'Opção de caso de uso',
  x_7d394eff: 'outro / outro',
  x_9c2b1541: '→ Seleção de tipo',
  x_eaa0a8e3: 'Negócios/Negócios',
  x_36a6d4b9: 'Link para a conta empresarial criada na etapa anterior → Criar',
  x_de9dda75: 'Entre no Painel do Aplicativo → Pesquisar no menu esquerdo',
  x_2ac93ee6: '→ ponto',
  x_700677b3: 'Instalar/configurar',
  x_ca3908a1: 'Etapa 4 / Etapa 4: Obtenha o ID do número de telefone + token temporário',
  x_2fcc28b3: 'Entre no WhatsApp → clique à esquerda',
  x_b1d07643: 'Configuração de API',
  x_593a1499: 'No topo da página você verá',
  x_542bd2bd: '(começando com `EAA...`) → Copiar',
  x_0c4c68c7: 'Você verá no meio',
  x_2868963d: 'ID do número de telefone/número de telefone',
  x_1ff9d199: '(uma sequência de números) → copiar',
  x_9a3f0a43: '⚠️ O token temporário dura apenas 24 horas e será usado posteriormente como token permanente para o usuário do sistema (veja a próxima etapa).',
  x_1743a4bd: 'Etapa 5 / Etapa 5: Token Permanente (recomendado)',
  x_d7098f50: 'aberto',
  x_5b1bc0f8: 'adicionar/adicionar',
  x_04bb0f86: '→ Nome "Sellox Bot" → Seleção de personagem',
  x_7635736a: 'Digite o usuário do sistema → clique',
  x_6effb00e: 'Adicionar ativos/Adicionar ativos',
  x_0c143e9a: '☑ Aplicativos → Aplicativo de Gancho →',
  x_d0a5ba88: '☑ Contas do WhatsApp → Gancho WABA →',
  x_609f8cf0: 'Gerar novo token/Gerar novo token',
  x_373a96ca: '→ Selecione o aplicativo →',
  x_be153369: 'Gerar →',
  x_d600945c: 'Copie agora',
  x_e9b20985: '(Você não pode ver se fechar a janela)',
  x_eeb6320c: 'Etapa 6 / Etapa 6: Configure o Webhook (para que o Meta possa nos enviar mensagens)',
  x_9ce48b57: 'Configuração"',
  x_99539f07: 'Página de meta configurações',
  x_4d572586: 'Editar / editar',
  x_bdc858dc: 'Cole os dois valores acima',
  x_fae01bc0: 'Verifique e salve / Verifique e salve',
  x_7701988b: '→ Uma marca verde aparece ✅',
  x_c348bfce: 'Campos de webhook abaixo →',
  x_bc2153d1: '→ Inscrever-se',
  x_ab20cc42: 'e',
  x_8f2b0cd1: 'Etapa 7 / Etapa 7: Conclua o backend do Sellox (esta é a página abaixo)',
  x_5ce0ecbc: 'para baixo',
  x_95805797: '② Suas credenciais do WhatsApp Business',
  x_87bff178: 'Token de acesso permanente (ou token temporário)',
  x_c4d93fb8: 'Número de telefone (opcional)',
  x_c8c135f6: 'Lista de permissões de telefones celulares Boss (+ formato 584xxxxxxxxxx)',
  x_142f5856: 'gancho',
  x_97c38974: 'Etapa 8/Etapa 8: Teste',
  x_eb2ec6d7: 'Depois de salvar, aparecerá o seguinte',
  x_f94ea898: '"Envio de teste"',
  x_d87f215d: 'cartão',
  x_742be581: 'Digite o número do celular do seu chefe e tente enviar uma mensagem.',
  x_4ee03501: 'Após recebê-lo, responda “Qual é o lucro hoje?” no WhatsApp → A IA responderá com dados reais 🎉',
  x_7d5267db: '⚠️ Limite de número de teste',
  x_7509351d: 'Os números de teste meta-free (+1 555 662 4521) só podem ser emitidos para um máximo de 5 destinatários verificados manualmente. Para enviá-lo a qualquer pessoa, você precisa adicionar o número da sua empresa no Meta (a verificação da empresa levará alguns dias).',
  x_20c5cf28: '💬Você tem algum problema?',
  x_fd4d3093: 'Entre em contato com o administrador da plataforma para ajudá-lo a configurar sua plataforma ou clique no assistente de IA no canto inferior direito para solicitar etapas específicas.',
  x_3f58e45d: '① Configurações do Meta Webhook (preencha o painel Meta App)',
  x_d025f0d5: 'Campos de assinatura:',
  x_01f35594: 'Número de telefone (E.164)',
  x_60eae7be: '(salvo, não mostrado)',
  x_372c24bf: 'Lista de permissões de telefones celulares Boss (separadas por vírgulas de meia largura, múltiplas)',
  x_bb28c476: 'Somente com números de celular na lista de permissões a IA responderá aos dados de negócios (lucros, estoque, dívida, etc.)',
  x_01b59ca9: '③ Comportamento de IA',
  x_e6a08432: 'Modo IA',
  x_639ebc3f: 'Somente o chefe - somente a lista branca pode conversar, outros não responderão',
  x_31d7946b: 'Somente clientes: os clientes verificam os produtos, mas o chefe ainda pode solicitar dados',
  x_4ea5a5ee: 'Ambos: os clientes verificam os produtos, os chefes verificam os dados',
  x_20339501: 'Envie automaticamente um recibo eletrônico para o WhatsApp do cliente após cada pagamento.',
  x_f679838d: 'O perfil do cliente tem "📨 Inscrever-se para receber notificações do WhatsApp" marcado',
  x_f4cfb985: 'Ou seja, cada cliente pode escolher individualmente se deseja receber',
  x_185c0503: 'Selecione um cliente',
  x_dd2124ee: 'Por favor adicione o produto',
  x_9923d1e2: 'Pedido aberto com sucesso',
  x_21263321: 'Faturamento no atacado',
  x_d166bb06: 'Sede',
  x_abfecaae: 'adicionar cliente',
  x_c6403f20: 'Taxa',
  x_ec3fb565: 'Selecione o cliente',
  x_b042c052: 'Pesquisar produto (nome/código de barras)...',
  x_57c89bca: 'Encontre itens e adicione-os ao pedido',
  x_fedff361: 'Resumo do pedido',
  x_0367ebd1: 'Observações...',
  x_e7814437: 'Confirmar faturamento',
  x_0706515e: 'Adicione clientes rapidamente',
  x_18401477: 'Limite de crédito ($)',
  x_a48948bf: 'Todas as lojas',
  x_be3565c4: 'Correspondência do número de referência',
  x_a0e50b0e: 'correspondência de pedidos',
  x_c95d6f32: 'equalização de quantidade',
  x_1622dc9b: 'desconhecido',
  x_ed0ad119: 'Relatório diário de reconciliação',
  x_8e600fc0: 'emparelhado',
  x_8567bca1: 'Nenhuma verificação correspondente',
  x_728bf491: 'Vendas incomparáveis',
  x_1e8dc255: 'Número do pedido',
  x_ca2944f0: 'quantidade de IA',
  x_093c45aa: 'valor de vendas',
  x_5c4caeaf: 'Número de referência',
  x_f3d55d6b: 'remetente',
  x_f14b4f28: 'banco',
  x_d47a0207: 'Reconciliação automática diária',
  x_6ea41b97: 'Registro de verificação de IA versus vendas por pagamento eletrônico – verificação automática de correspondência',
  x_dd09a5da: 'Número total de verificações de IA',
  x_193911c6: 'Nenhum pedido de venda correspondente foi encontrado nesses registros de verificação de IA. Pode ser que o cliente tenha carregado, mas o caixa não tenha confirmado.',
  x_396a3453: 'Nenhuma verificação de IA correspondente foi encontrada para essas vendas de pagamento eletrônico. O cliente pode não ter carregado capturas de tela de pagamento.',
  x_d4c1ecd7: 'Todos concordam! Todos os pagamentos eletrônicos do dia foram verificados.',
  x_82e96463: 'O inventário deve ser um número ≥ 0',
  x_6e5907ee: '🔄 Atualização',
  x_1db180af: 'Pesquisar produto/cor/tamanho/SKU',
  x_105b1395: 'Estoque ≤5',
  x_b12876c8: 'Fora de estoque',
  x_ad9238d4: 'Nenhum produto com tamanhos',
  x_36094e1c: 'Nenhuma correspondência',
  x_afcc3e34: '💾 Salvar',
  x_5c94144d: 'SKU total da variante',
  x_0e076143: 'Produto',
  x_f1daf080: 'Tamanho',
  x_6b36c6f7: 'Cor',
  x_dd56adce: 'Tem certeza de que deseja criar/associar automaticamente perfis de clientes para todos os funcionários? \\nDesta forma você pode acumular pontos fazendo crédito ou gastando.',
  x_f10dfc69: 'Cadastra automaticamente todos os funcionários como ‘clientes’ (is_staff=true) para que possam acumular pontos na hora de fazer empréstimos ou compras.',
  x_f33656e1: 'carteira de identidade',
  x_881a9bd5: 'Número de identificação (Cédula)',
  x_69b8571e: 'Salário ($)',
  x_b5ca1dd9: 'ciclo de pagamento',
  x_09b03b6d: 'semanalmente',
  x_9104c0c5: 'a cada duas semanas',
  x_aa3d57c0: 'mensalmente',
  x_72b3c2be: 'Lista de permissões de IP (deixe em branco = sem restrições)',
  x_ba15d1d2: 'Exemplo: 190.205.1.100, 200.44.32.50',
  x_9cf8e8f2: 'Separe vários IPs com vírgulas. Administradores e diretores estão isentos desta restrição.',
  x_e6d7c138: 'Tempo de login permitido (deixe em branco = sem limite)',
  x_d18b4c06: 'Horário da Venezuela (UTC-4). Exemplo: 07:00 ~ 22:00',
  x_3eb2b5e8: 'Não pode ser inferior ao preço de custo.',
  x_6bde6f81: 'O preço após o desconto não pode ser inferior ao preço de custo.',
  x_a6f3ec47: 'Atendimento ao cliente de IA da loja online',
  x_e7454268: 'Contagem de chefes de IA',
  x_10f8a322: 'mensagem',
  x_bb364b6d: 'Voz do WhatsApp',
  x_6af959ee: 'Tire fotos e salve-as em um local de armazenamento.',
  x_e50663b2: 'Recarregar',
  x_34ce201c: 'doar',
  x_85f42dcd: 'consumo',
  x_51d2fc74: 'Cancelar o pedido atual? Você pode recarregar novamente após o cancelamento. \\nCancelar este pedido?',
  x_f3955e88: 'Pedido cancelado',
  x_2b8fa5ac: 'Já pago',
  x_98308839: 'Créditos de IA adicionados ✓',
  x_655c5610: 'Nenhum endereço de pagamento',
  x_326e34ed: 'As informações de pagamento foram geradas / Informações de pagamento prontas: leia o código QR para pagar',
  x_efad9fe0: 'Não foi possível criar a fatura',
  x_46ccee5b: 'Copiado',
  x_2e3006a9: 'Endereço copiado',
  x_9790e47c: 'Créditos de IA',
  x_ae190ef1: 'Saldo atual',
  x_8af6c290: 'Recarga acumulada',
  x_5c9bc81a: 'Consumo acumulado',
  x_34dccb6b: 'Custo por recurso',
  x_7efdc4e4: 'História',
  x_b9db8476: 'Ainda não há registro',
  x_833cba67: 'Pagando USDT TRC-20',
  x_1833a9ec: '💰 Valor / Valor do Pagamento (USDT-TRC20) ⚠️ Entrada manual',
  x_9d3931f8: 'Direção (TRON TRC-20)',
  x_900ee05e: 'Processo de digitalização',
  x_30d4a272: '(Qualquer carteira USDT funcionará):',
  x_bf863bf8: '1. Clique em “Enviar” em Binance/OKX/Trust Wallet → selecione USDT → Rede',
  x_4c6c1bd8: '2. Digitalize este código QR → o endereço será preenchido automaticamente',
  x_550c9aef: 'Valor inserido manualmente',
  x_46703262: '✓ Já recebido',
  x_f4e8f238: 'Ordem pendente antiga',
  x_3d75129d: 'créditos',
  x_3f60cc81: 'Compre com USDT',
  x_e6b9334f: 'Acompanhamento de boas-vindas',
  x_4f3f45b3: 'Olá {nome}! Obrigado por se inscrever para o teste do Sellox. Eu sou o fundador. Se você tiver alguma dúvida, pergunte-me diretamente. Você ainda tem {days} dias para testar. Este é o endereço de login:\\nhttps://backup.sellox.shop',
  x_1b556750: 'Lembrete de expiração',
  x_b8e14961: 'Olá {name}, você ainda tem {days} dias para testar o Sellox. Para continuar usando, escolha um pacote:\\n• Padrão US$ 29/mês (5 pessoas em 1 loja)\\n• Pro US$ 49/mês (15 pessoas em 3 lojas + IA)\\n\\nLink de renovação: https://backup.sellox.shop/saas/checkout',
  x_0cc0a930: 'Convidar demonstração',
  x_8787d76d: 'Olá {nome}, gostaria que eu fizesse uma demonstração remota de 15 minutos? Podemos importar seus produtos juntos e permitir que você comece a pagar com POS em 1 hora.',
  x_9639c829: 'Sem número de telefone',
  x_558b5ced: 'O WhatsApp está aberto e o rastreamento é registrado',
  x_cdcef6e3: 'WhatsApp está aberto',
  x_e984172c: 'telefone copiado',
  x_5255b7ec: 'Total',
  x_30aeeb9b: 'Ativar',
  x_a337d612: 'Expirando',
  x_f7656c12: 'Expirado',
  x_2ba7855c: 'Pendente',
  x_80d9ba9e: 'Pesquisar comerciante/contato/telefone/ID...',
  x_c41ac297: 'Expira em breve',
  x_9246fe88: 'pagar',
  x_f2992715: 'Clique para copiar',
  x_fb4174dd: 'Inscrições de teste',
  x_4740f413: 'Todos os países',
  x_f10c9104: 'Não há resultados correspondentes',
  x_5bf2e3d5: 'Inquilino',
  x_52409da5: 'Pessoa de contato',
  x_5a93d3f7: 'telefone',
  x_56526d93: 'Registrado em',
  x_43b510ed: 'restante',
  x_b0d7b92a: 'Modelos',
  x_56cfacad: 'Conteúdo da mensagem (editável)',
  x_a66e77ec: 'Loja única',
  x_6feaed50: '1 loja',
  x_792d962f: '3 caixas',
  x_f2e24124: 'Nenhuma loja online',
  x_8a77db1e: '🎁 Novos inquilinos não precisam de manutenção no primeiro ano',
  x_9a61b1d7: '1 loja principal + 2 filiais',
  x_4463f4a6: '12 caixas eletrônicos',
  x_dab7b561: 'Loja on-line',
  x_a0eac492: 'Empresa · 1+10 · Recomendado',
  x_fe8cdaef: '1 loja principal + 10 filiais',
  x_63c7540a: 'Caixas eletrônicos ilimitados',
  x_1e7614cb: '✅ Loja online + entrega + relatório multiloja',
  x_b934c4e3: 'Cancelar este pedido?',
  x_d16fd88d: 'Cancelado',
  x_2276b3e8: 'Ativação com sucesso!',
  x_92a13409: 'Não foi possível gerar o endereço de pagamento',
  x_33486076: 'O código de pagamento foi gerado/digitalize o código ou copie o endereço para pagar',
  x_1c017415: 'O código de pagamento foi gerado',
  x_d988ff0f: 'Endereço copiado',
  x_65dd9ef1: 'esperando',
  x_fafc7219: 'Ativação de Plano · taxa anual de serviço',
  x_e2841a14: 'Quantidade',
  x_d41c514e: 'rede',
  x_93ba918d: 'Somente rede TRON',
  x_13b5c750: 'Estado:',
  x_b21b5ec9: 'Cancelar pedido',
  x_228a7d81: '⭐ Recomendado',
  x_d65904be: 'Inclui 1º ano de serviço · depois taxa anual',
  x_39e6803b: 'Compra de USDT',
  x_b36b9c5e: '/ano',
  x_16bcce59: 'Inclui: Servidor · Atualizações automáticas · Atendimento ao cliente · Backup de dados · Atualizações mensais do PWA',
  x_338e96c9: '🎁 O primeiro ano para novos inquilinos é gratuito na compra · A renovação começa a partir do segundo ano',
  x_2962f3d5: 'comprar pacote',
  x_d1fdc613: 'Existe um limite máximo para o número de lojas.',
  x_9823244e: '. Se você precisar adicionar uma loja, entre em contato diretamente com o atendimento ao cliente do WhatsApp para obter um orçamento. Não será atualizado automaticamente no sistema.',
  x_29aca265: 'Apenas rede USDT TRC-20. Quaisquer outras moedas ou correntes serão perdidas permanentemente.',
  x_8428cdf2: 'Ativação automática entre 5 e 15 minutos após o pagamento. Se você tiver alguma dúvida, atendimento ao cliente do WhatsApp:',
  x_1f1c7645: 'Grupos opcionais requerem pelo menos 2 opções.',
  x_5b530127: 'Por favor preencha as informações completas',
  x_a3033ebf: '(Copiar)',
  x_79d3abe9: 'Copiar',
  x_ea15ae2b: 'Opções',
  x_839a578d: 'Crie combinações de pacotes para aumentar o preço unitário por cliente',
  x_c901f681: 'Nome do pacote',
  x_cc6c35a3: 'codificação',
  x_cc949910: 'Itens fixos',
  x_abba9357: '🔍 Digite o nome para pesquisar, menu suspenso de filtro automático...',
  x_2cad29d6: 'Ainda não há produtos fixos',
  x_9a982d0f: 'Acessórios opcionais',
  x_2e363fc9: 'Adicionar grupo opcional',
  x_8243c74a: 'Atualmente não há grupos opcionais (os clientes podem escolher um de cada grupo)',
  x_c6db8605: 'Preços',
  x_75c8703e: 'Preço do pacote',
  x_8690ee2e: 'salvar',
  x_c12c079a: 'Nome do grupo (por exemplo, seleção de bebidas)',
  x_d2ea9e05: 'Opções padrão',
  x_ae648cba: 'Adicione pelo menos 2 opções, o cliente pode escolher uma delas na compra do pacote',
  x_348f1b33: 'Selecione uma imagem primeiro',
  x_4dc3f98d: 'Falha no OCR',
  x_17710b35: 'Nenhuma linha para importar',
  x_9190cc22: 'Nome do fornecedor',
  x_1fd1d5c5: 'Nome do produto',
  x_39f76a9b: 'código de barras',
  x_5f99f6a8: 'preço de venda',
  x_1981be5f: 'Receba um pedido de compra e a IA irá identificá-lo automaticamente → Alinhar produtos → Atualizar estoque + preço de venda recomendado',
  x_bfd77887: '① Faça upload de fotos de pedidos de compra',
  x_5324ed82: 'Clique para tirar uma foto ou selecionar uma imagem',
  x_346a0f2f: 'Suporta JPG/PNG, máximo de 15 MB',
  x_da7e7127: 'Reconhecimento de IA em andamento, cerca de 5 a 10 segundos...',
  x_4eb51d8f: 'Comece a identificar',
  x_3f2f5467: '② Verifique os resultados do reconhecimento',
  x_a24b9d90: 'Já tenho um fornecedor (opcional)',
  x_7b8bc49d: '-- use o nome acima --',
  x_9452920c: 'Armazém de entrada',
  x_dcffc8fa: 'Número do pedido:',
  x_7501567a: 'Data:',
  x_dbcbbf20: 'Totais:',
  x_01be458f: '③ Cada linha de produto: selecione a ação',
  x_d32fc7ef: 'Nenhuma linha de produtos reconhecida',
  x_c58187fe: 'Reconhecimento de OCR',
  x_e514d3ef: 'Quantidade:',
  x_3bf6cfdd: '× preço unitário',
  x_c500cfab: 'ação',
  x_f504986f: 'festa',
  x_26bb8418: 'Novo',
  x_92636e8c: 'pular',
  x_ba30d5cc: '-- Classificação --',
  x_6a9e619b: 'Confirmar armazenamento',
  x_1d46b01c: '✅ Armazenamento concluído',
  x_bb3502bb: 'Número do pedido de compra:',
  x_4a049640: 'Itens em estoque:',
  x_29645b50: 'artigo',
  x_art_pl: 'artigos',
  x_d909d882: 'Valor total:',
  x_c28d24cc: 'Selecione um banco',
  x_f821a75d: 'Por favor insira o número da conta',
  x_5d813f65: 'Por favor insira o número de telefone',
  x_d467588f: 'Já adicionado, lembre-se de clicar em Salvar',
  x_e742ab60: 'Exemplo: 0199 Meu Banco Pessoal',
  x_8d1a5254: 'Por favor insira o nome do banco',
  x_c3441b0e: 'O banco já existe',
  x_1796b0b6: 'Recebendo contas',
  x_2fae4dfd: 'O número da conta bancária do beneficiário visualizado quando o cliente faz um pedido. Podem ser adicionados múltiplos (Transferência + Pagamento Móvel).',
  x_4edfb958: 'Ainda não há conta de cobrança. Adicione o primeiro abaixo.',
  x_9c3929ba: 'Conta:',
  x_343c39bd: 'Telefone:',
  x_468507f3: 'Titular do cartão:',
  x_a315035f: 'Adicionar conta',
  x_b7887785: 'Tipo',
  x_c75632b1: 'Banco',
  x_d9d63df2: 'Conta',
  x_ccfc0579: 'Suporte',
  x_b87b58ea: 'Telefone',
  x_f1e36d48: '+ Adicionar conta de pagamento',
  x_3a24d652: 'Bancos na Loja Online',
  x_9bdee3a3: 'O banco selecionado pelo cliente ao fazer o pedido. Desmarque qualquer = mostrar tudo (padrão). Bancos personalizados podem ser adicionados.',
  x_3036d714: 'Adicionar banco',
  x_de8733ca: 'tudo',
  x_7c589a7b: 'Nenhum',
  x_4d915d93: 'Assinatura estendida ✓',
  x_9d6a7ced: 'Não foi possível criar fatura',
  x_4e16c811: 'meses',
  x_5beef376: 'mês',
  x_91d63f7f: 'Renovar assinatura',
  x_bc8a11d1: 'Inquilino:',
  x_9b9a6730: 'Plano:',
  x_5f06418b: 'Aguardando confirmação do USDT…',
  x_516de1ba: '· Estado:',
  x_1bcf2f98: 'Economize 2 meses',
  x_e27e83d3: 'Renovação do USDT',
  x_77de9017: 'Carteira: Somente USDT da rede TRON, envio de outras moedas não poderá chegar.',
  x_ef6a3fe2: 'Assim que o pagamento for concluído, a página retornará automaticamente aqui e mostrará “A assinatura foi renovada”. Se não saltar automaticamente, você pode voltar manualmente e clicar em “Atualizar”.',
  x_da8f9e35: 'caixas/caixa',
  x_77862e71: 'Erro de sincronização. Verifique a rede e tente novamente',
  x_ad41fef2: 'Falha na sincronização do BCV',
  x_12d0d88a: 'Erro de sincronização paralela',
  x_b4b5434b: 'BCV = oficial/relatório | Binance = dinheiro/troco em dólares americanos | mercado negro = preço de venda',
  x_536911f7: 'Sem internet/sem internet – aguarde o retorno da conexão',
  x_b2fbbabf: 'Nada para sincronizar/Nenhum item para sincronizar',
  x_aece3f5d: 'Descartar esta alteração? Não será recuperável / Tem certeza de que deseja abandonar esta operação? não pode ser recuperado',
  x_912a4250: 'Excluído/Excluído',
  x_cb4d2044: 'Nenhum item com falha / Nenhuma missão com falha',
  x_10b526fb: 'O turno terminou: o pedido de venda foi realmente salvo; esta é uma solicitação de contagem duplicada e pode ser descartada com segurança',
  x_5f01f33d: 'A ordem pendente não existe mais; Ele pode ter sido liquidado ou excluído, então você pode descartá-lo com segurança.',
  x_d10bff45: 'Estoque insuficiente',
  x_57e7ae15: 'Estoque insuficiente no armazém de origem',
  x_8496514a: 'O armazém de origem não possui estoque suficiente: a ordem de transferência não foi criada! Reduza a quantidade e faça um novo pedido ou reabasteça o estoque primeiro. Este pedido preso pode ser descartado',
  x_4eb6919a: 'autoridade de crédito',
  x_fee56ee3: 'O cliente não abriu a autorização de crédito; primeiro abra enable_credit em "Gestão de Clientes" ou descarte o pedido e refaça com dinheiro ou transferência.',
  x_b5bda5aa: 'Solicitação duplicada: o servidor a processou e pode ser descartada com segurança',
  x_f17d4674: 'A rede está normal.',
  x_01f3782e: 'Rede desconectada',
  x_8b9a1e80: '— sincronizando automaticamente / Sincronizando automaticamente',
  x_9e50fc79: '🔄 Sincronize agora / Sincronize agora',
  x_1a62aebf: 'Descartar/desistir',
  x_bcb61127: 'Nada pendente/Nenhum item para carregar',
  x_78e8a2f9: '✅ A conta foi publicada',
  x_ccc63b24: '🔧 Reparação de conta de crédito sem proprietário',
  x_97ce76db: 'O caixa clicou em “Crédito” mas não selecionou cliente/funcionário; Clique em “Crédito” à direita para transferir o crédito para a pessoa correta.',
  x_2a4cb867: '✅ Nenhuma conta de crédito sem proprietário encontrada, todas as contas de crédito foram vinculadas com sucesso a contas de clientes/funcionários',
  x_b7a67cb8: 'Pesquisar pedido/item/número do caixa...',
  x_faa34bbd: 'Não há conta de crédito sem um proprietário correspondente',
  x_87633dad: 'Dívida pendente',
  x_bdc278a2: 'Pague a conta para...',
  x_d84f39b4: '👤 Funcionários',
  x_796638a3: '🧑‍🤝‍🧑 Clientes',
  x_69632a49: 'Encontre funcionários...',
  x_4b93385f: 'Encontre clientes...',
  x_ce2242ff: 'É estritamente proibido misturar a receita real em dólares americanos e a conversão em moeda local em um único total; A natureza e o risco de cobertura dos dois são diferentes.',
  x_0b0fad08: 'Análise de vendas de pacotes.',
  x_b061a19e: 'Número de pedidos de pacotes',
  x_761c7bd5: 'Participação no total de pedidos',
  x_e0674456: 'Receita de pacote',
  x_8bdec340: 'Número de pacotes ativos',
  x_a789726b: 'Preço médio do menu fixo',
  x_221340da: 'Classificação de vendas de pacotes',
  x_794b4643: 'Ainda não há dados de vendas de pacotes',
  x_da518fe1: 'Após a criação de um pacote, os dados de vendas serão exibidos aqui.',
  x_398265e4: 'Distribuição de vendas de pacotes.',
  x_956aaaf0: 'Tendências de vendas de pacotes',
  x_9c4738fa: 'Pedido de pacote',
  x_c2ee20c6: 'Estatísticas de seleção de acessórios',
  x_d7bbccf6: 'Detalhes de vendas do pacote',
  x_46cd403a: '💵 Recibos em USD · Recibos em USD',
  x_9a2602b9: 'fluxo de caixa real',
  x_b5091ee6: '💰 Conversão de moeda local · VES → Instantâneo do USD',
  x_3989b42a: 'Bloqueie o preço em $ para o dia',
  x_840a3569: '(referência)',
  x_d22c8252: 'Amostra/Teste',
  x_2ba8df79: 'Perda/sobrevenda',
  x_1a6387e4: 'Registro de danos bem-sucedido',
  x_8f2328a2: 'Gestão de relatórios de perdas',
  x_20d8ea7f: 'Crie um novo relatório de perdas',
  x_6e2c4471: 'Registro de relatório de perda',
  x_1a9a9b5c: 'Quantidade de perdas relatadas',
  x_6c3b96c6: 'valor da perda',
  x_2e51c1e9: 'todas as razões',
  x_7074d50c: 'perda',
  x_531401ac: 'Substituir',
  x_c270fc6f: 'armazém',
  x_cb29982e: 'Armazém padrão',
  x_748662a5: 'Motivo para relatar perda',
  x_da086f20: 'Instruções adicionais (opcional)',
  x_6966f4a1: 'perda esperada',
  x_3303f395: 'Confirmar relatório de perda',
  x_607e7a4f: 'Veja',
  x_30eb1c49: 'há esta semana',
  x_0c6ff5f3: 'Aniversário do cliente – clique para visualizar o centro de marketing',
  x_35bd0636: 'Mantenha pelo menos um item',
  x_dadc0335: 'Modificação do pedido',
  x_5badb3ba: 'Falha na modificação',
  x_1229b861: 'Ocultar pedidos não legítimos ativado',
  x_dc78ab4d: 'Fechado para ocultar pedidos não originais - Mostrar tudo',
  x_a2290676: 'Ocultar pedidos não legítimos: ativado',
  x_3d0512c9: 'Ocultar pedidos não legítimos: desativado',
  x_027d489f: 'Pedido médio do cliente',
  x_77678b5c: 'Todas as lojas',
  x_565955cb: 'Todos os caixas eletrônicos',
  x_bfdaebfd: 'caixa',
  x_41ce131a: 'misturar',
  x_966038af: 'voltou',
  x_7623803b: 'Marcação concluída',
  x_1512dcd4: 'Editar pedido',
  x_9567eef9: 'dinheiro em dinheiro',
  x_838effc3: 'Deslizar ponto',
  x_32005a19: 'Transferência Transferência',
  x_30bee6f5: 'Pagamento misto',
  x_5939657d: 'pagamento dividido',
  x_1e9b1d5d: 'Dinheiro$',
  x_26954cc9: 'Bs em dinheiro',
  x_26922a58: 'recebido',
  x_c993e001: 'mudar',
  x_4091e27c: 'Desconto',
  x_c8b8ba24: 'pagamento real',
  x_c5575b3f: 'Salvar alterações',
  x_7a8a35ec: 'Todos os métodos de pagamento',
  x_25557e0c: 'Cartão',
  x_9f6bb100: 'Misto',
  x_04330953: 'Crédito',
  x_974470ef: 'Pagamento:',
  x_da4abd3e: 'preço unitário',
  x_0bf60b32: 'Quantidade',
  x_f599fcd3: 'Subtotal',
  x_669e3a20: 'Configurações salvas',
  x_9e144231: 'Enviar os desejos de aniversário de hoje agora?',
  x_6193e011: 'mensagem muito curta',
  x_0ef8caa0: 'Selecione um horário de entrega agendado',
  x_50525e3d: 'A hora não pode ser anterior à hora atual.',
  x_a5a64f69: '${blastForm.campaign_name || \'Festival\'}',
  x_4dc5ca8d: 'Falha na programação',
  x_370f2e2c: 'Cancelar esta tarefa agendada?',
  x_482e8539: 'Falha no cancelamento',
  x_5ae7b19b: 'Hoje!',
  x_71325692: 'Exemplo: Dia das Mães 2026',
  x_2fb90b05: 'Processando...',
  x_2ae98dbc: '⏰ Agendado',
  x_846a6e3b: 'Envie para a missa imediatamente',
  x_917f9004: '🎂 Aniversário/Feriado WhatsApp Auto Marketing',
  x_2e7a63e4: 'Enviado automaticamente para clientes com aniversários às 9h (VE) todos os dias',
  x_81b7205c: 'Cada cliente é desduplicado automaticamente uma vez por ano.',
  x_8f6280a1: 'Prefixo do cupom',
  x_429d5967: 'Porcentagem de desconto (%)',
  x_f81c3d04: 'Dias válidos',
  x_d3276905: 'Nenhum ainda. Primeiro preencha a data de nascimento (MM-DD) nas informações do cliente.',
  x_8483ed13: 'aniversário',
  x_3ec2bba0: 'distância',
  x_02daf71f: 'Inscrever-se',
  x_7001dd63: 'Cancelar assinatura',
  x_3e744a9b: 'Inscrever-se',
  x_1fd094a7: '📅 Seleção rápida de férias (classifique por data, clique para selecionar)',
  x_919bf6ba: 'Selecione um modelo de bênção → preencha automaticamente o formulário abaixo (pode ser editado)',
  x_83f2b3fe: 'Não existe um modelo padrão para este feriado, insira-o manualmente',
  x_53eab0ee: 'Nome do evento (usado para remover duplicatas, o mesmo nome só será enviado uma vez por dia)',
  x_baa7d2f5: '⏰ Envio programado (opcional)',
  x_a69942de: 'Selecione a data e hora de envio (no seu fuso horário local)',
  x_afea4271: '✨O sistema irá enviá-lo automaticamente no horário que você especificar. Por exemplo, se definido uma semana antes do Dia das Mães, o envio será automático às 9h. a partir de 10 de maio.',
  x_04ab3e0f: 'Após ativá-lo, você pode especificar um horário futuro para que ele seja enviado automaticamente (por exemplo, 09h00 do Dia das Mães).',
  x_f9c3ed43: 'Ainda não há registro de envio',
  x_db8a4b9a: 'Conclua tudo',
  x_4177fcbd: 'Bem vindo',
  x_b6076a05: 'Erro de login',
  x_459db148: 'Ex: codigo-loja',
  x_d89bbf9f: 'Código da loja/telemóvel/senha/nome obrigatório',
  x_817f3912: '✅ Cadastro realizado com sucesso! Espere o chefe aprovar o pedido antes de aceitá-lo.',
  x_1c56d8c5: 'Falha no registro',
  x_c5864848: 'Código *',
  x_a3006784: 'Telefone *',
  x_0b7dd959: 'Senha *',
  x_552fd502: 'Pelo menos 4 pessoas',
  x_914a33ec: 'Nome *',
  x_3f1613aa: 'Prato',
  x_e33cbc27: '🎉Compra bem sucedida! Vá até a loja para retirar a mercadoria o mais rápido possível.',
  x_ecb6d7f9: 'A ordem não pôde ser tomada',
  x_5cc14c3c: 'Aceito',
  x_c92aaa37: 'Erro de confirmação',
  x_74cc7a41: 'Passado para o próximo revendedor',
  x_52690cab: '🚀Iniciar entrega',
  x_1d6ecc64: '✅ Entregue, o custo do frete foi creditado na conta',
  x_e319cca8: 'Tirar uma foto do comprovante de entrega?\\n(Você pode pular e cancelar diretamente)',
  x_ead2daed: 'Entre em contato com o proprietário para obter detalhes.',
  x_757bc40a: 'Depois de passar na revisão, o pedido disponível será exibido aqui.',
  x_a830777b: 'O pedido não pode ser aceito',
  x_b720a69a: 'Em revisão',
  x_4a9428f9: '✓ Certificado',
  x_c9d929e0: '✗ Rejeitado',
  x_1ef6f1db: 'aguardando pedidos',
  x_10f8cbf4: 'Recebi o pedido e fui buscá-lo.',
  x_f8a40394: 'Apanhado',
  x_d409c4ea: 'distância desconhecida',
  x_e91aeee2: 'Pedidos concluídos',
  x_9af2659b: 'Renda acumulada',
  x_f061db1c: 'Veículo',
  x_108db12e: 'Avaliação',
  x_ad77bf1d: 'Sellox Entregador',
  x_dec20a6b: 'Código da loja',
  x_8e362599: 'Telefone',
  x_a6eabe9b: 'Senha',
  x_58caca00: 'Cadastro de entregador',
  x_1c3a8565: 'Tipo de veículo *',
  x_8db8ee8e: 'Motocicleta',
  x_201504a8: 'Bicicleta',
  x_cc31ee5d: 'Carro',
  x_fbba6044: 'a pé',
  x_6c78bebb: 'Aguardando aprovação',
  x_4a798e43: 'A conta foi desativada',
  x_d6991a83: 'Concluído ✓',
  x_9890f97b: 'Assistente de configuração de impressão',
  x_cff3211b: 'Conclua a configuração da impressão silenciosa em 3 etapas, imprimindo sem pop-ups',
  x_26590e3f: 'Etapa 1: definir a impressora padrão',
  x_8fb52e11: 'Abra Configurações do Windows → Bluetooth e dispositivos → Impressoras e scanners',
  x_86219510: 'Desative "Permitir que o Windows gerencie a impressora padrão"',
  x_d82f67dd: 'Clique na sua impressora térmica (como a XP-80C)',
  x_476e0586: 'Clique em "Definir como padrão"',
  x_b26839a0: 'Etapa 2: copie o comando de inicialização',
  x_89eff51a: 'Clique no botão abaixo para copiar o comando',
  x_e63a8355: 'Etapa 3: crie um atalho na área de trabalho',
  x_4a7e4b2f: 'Siga estas etapas',
  x_39dca51d: 'Clique com o botão direito em um espaço vazio da área de trabalho → Novo → Atalho',
  x_f89fc87a: 'Cole o comando que você acabou de copiar na caixa “Onde”',
  x_8f932a07: 'Clique em Avançar e insira Sellox POS como o nome',
  x_631effbe: 'Clique em Concluído. No futuro, clique duas vezes no ícone para abrir o sistema de caixa.',
  x_e45ed499: 'Copie o comando de inicialização do Edge',
  x_a28aa67f: 'Copiado!',
  x_e541bfc7: 'Copiar comando do Chrome',
  x_eedf4bbd: 'Dica: Se você imprimir no OneNote ou PDF, verifique se a impressora padrão está configurada corretamente na etapa 1.',
  x_797d0e09: 'Após a conclusão da configuração, clique duas vezes no ícone "Sellox POS" na área de trabalho e a impressão será enviada automaticamente para a impressora sem que nenhuma caixa de diálogo apareça.',
  x_f394cfe1: 'Conta de atacado / conta de atacado',
  x_95e3ad97: 'Cliente/cliente',
  x_a702e3be: 'Pontos / Pontos',
  x_b29b209c: 'crédito/crédito',
  x_0170732a: 'Resumo da dívida / Visão geral das dívidas pendentes',
  x_39ee196f: 'Pedidos por atacado / pedidos por atacado',
  x_4ccb2222: 'Compras recentes/compras recentes',
  x_5f2a9420: 'código de digitalização',
  x_ecd041a0: 'Redirecionando / Redirecionando…',
  x_9a8ed80b: 'Pagamento recebido/pagamento bem sucedido',
  x_e7268001: 'Erro ao carregar / Erro ao carregar',
  x_b37d1896: 'Comprimindo... / Comprimindo imagens...',
  x_bd703be1: 'Processando... / Processando...',
  x_67c3bc10: 'O bônus foi enviado.',
  x_96d7970c: 'Pagamento confirmado',
  x_0cb0251b: 'Pagamento rejeitado',
  x_ea4ccc53: 'Voucher enviado ao caixa',
  x_8a6643a7: 'Referência/número de referência',
  x_88e9e55d: 'Quantidade/quantidade',
  x_230397c0: 'Data/Data',
  x_e10ba955: 'remetente/nome',
  x_e222bb0c: 'Telefone/telemóvel',
  x_248a9885: 'ID/ID',
  x_e4f17ebf: 'banco / banco',
  x_31bde601: 'Tipo / Tipo',
  x_2faded9f: 'Faça upload de uma captura de tela do seu comprovante de pagamento',
  x_ff5f2a1f: 'Por favor, espere / Por favor, espere...',
  x_ee8d09d1: 'Clique para tirar uma foto ou selecione uma imagem para fazer upload',
  x_e893f6b1: 'Dados identificados/resultados de reconhecimento de IA',
  x_c7c7b829: '✓ Conta receptora correta / A conta receptora está correta',
  x_aa855a32: '⚠️ A conta NÃO corresponde – a conta de revisão/recebimento não corresponde',
  x_2f1745ef: 'Carregar outro recibo / Carregar outro',
  x_1b056098: 'O caixa pode ver esse resultado em tempo real.',
  x_7eef492b: 'Digite seu telefone ou código / Por favor, insira seu número de celular ou número de cliente',
  x_rider_push_banner: 'Ative alertas de pedidos em segundo plano (toca mesmo bloqueado)',
  x_rider_push_btn: 'Ativar',
  x_rider_push_on: 'Alertas em segundo plano ativados!',
  x_rider_push_denied: 'Notificações bloqueadas — ative nas configurações',
  x_rider_push_fail: 'Falha ao ativar, tente novamente',
  x_rider_new_order: 'Novo pedido!',
  x_5b4d6f56: 'Não encontrado/não encontrado',
  x_ba825d88: 'Falta de loja/falta de lojas',
  x_163d4734: 'Nome muito curto/nome muito curto',
  x_d8d5dbd4: 'Erro de formato de telefone/número de celular inválido',
  x_61d1e909: 'Erro no registrador/erro no registro',
  x_9e478700: '🎁 Clube de Pontos / Clube de Pontos',
  x_4f4ed4a8: 'Loja/ID da loja',
  x_e223e6f8: '📱 Telefone ou Código/Número ou número de telemóvel',
  x_400ea289: '📋 Regras/Regras',
  x_f4ae4ba2: '1 minuto',
  x_e41c8f96: 'Receba desejos e ofertas de aniversário/feriado no WhatsApp',
  x_472eeea6: 'Olá / Olá',
  x_e0ad1b59: 'pontos / pontos',
  x_b6d516c1: 'Regras/regras',
  x_3207b63d: 'Penalidade de ausência',
  x_366edeab: 'dedução salarial',
  x_1eb00e63: 'A empresa deve a você / A empresa deve a seus funcionários',
  x_ecd32f47: 'Saldo pendente/pagamento pendente',
  x_a93dac50: 'Equilíbrio / Equilíbrio',
  x_e37433ef: 'Para ser retirado na finalização da compra / pode ser retirado na finalização da compra',
  x_c72b5c9e: 'Programação semanal/programação de turnos esta semana',
  x_2c7d6de7: 'Movimentos recentes/registos recentes',
  x_4536f3e5: 'es / chinês',
  x_98961d8e: '⏰ Link expirado / link expirado',
  x_13cd19da: '📸 Imagem original/original',
  x_855e9d6c: '✨ Versão aprimorada com IA / versão embelezada com IA',
  x_8cd3793f: 'div>',
  x_9f2178d0: 'div>',
  x_261541dd: '⏳ Aguardando o passageiro anotar o pedido.',
  x_b886ab95: '🛵 O entregador aceitou o pedido e está indo à loja.',
  x_a2d70627: '📦 O passageiro retirou a mercadoria.',
  x_168a78b9: '🚀 O entregador está a caminho',
  x_c5febde0: '✅ Entregue',
  x_4babc22d: '❌ Cancelado',
  x_f07cecdb: 'Não foi possível obter o status do pedido',
  x_69deca2b: 'Pedido não encontrado',
  x_638959b3: 'Loja',
  x_9b16789f: '🏪 Loja',
  x_341cb93c: '📍você',
  x_3934104b: 'Entregador',
  x_b1862ef3: 'Valor do pedido',
  x_1138a92b: 'taxa de entrega',
  x_2541ca48: 'Atualizar agora',
  x_153942db: 'Até a próxima',
  x_78f2095f: 'nova versão encontrada',
  x_9b601b8e: 'Versão atual',
  x_9ee20a30: 'versão mais recente',
  x_49009569: '📝 Atualizar conteúdo',
  x_4a07f0c8: 'A assinatura expirou',
  x_db45a2da: 'Sua assinatura Sellox expirou. Para evitar afetar os negócios, renove o mais rápido possível.',
  x_5eeb04af: 'A assinatura está prestes a expirar',
  x_8dd2a3dc: 'O julgamento termina em breve',
  x_01059b1d: 'A avaliação gratuita terminou',
  x_26a5e5a8: 'Renove para desbloquear todos os recursos e continuar administrando seu negócio.',
  x_0ea5b9f4: 'O pagamento anual é de apenas $ 500 (economize $ 100 e ganhe 2 meses grátis) O pagamento mensal é de $ 50',
  x_39bb592b: 'Renove agora (WhatsApp)',
  x_dc017114: 'lembrete mais tarde',
  x_7693a3c0: 'Olá, gostaria de renovar minha assinatura do Sellox. Comerciante:',
  x_4a6ea4ec: 'Não há mais avisos dentro de 7 dias',
  x_feea9211: 'Baixe o código QR',
  x_04c8c8a8: '📱 Lançamento do aplicativo móvel Sellox',
  x_faf8c169: 'Digitalize o código QR com impressão Bluetooth da câmera Verifique suas vendas a qualquer momento - clique aqui para digitalizar o código QR para fazer o download',
  x_053877ee: 'Digitalize o código QR para baixar o aplicativo móvel Sellox',
  x_d73e6673: '📱 Digitalize com a câmera do celular ou WeChat',
  x_9f9d3632: 'telefone celular',
  x_5c980c4f: 'câmera',
  x_a7185263: 'ou',
  x_767c7df9: 'Digitalizar no WeChat',
  x_d17430c7: 'Alinhe o código QR',
  x_15067f6d: 'Clique para aparecer',
  x_17dbbc8e: 'Baixar link',
  x_69350bb6: '→ APK começa a baixar',
  x_86e36e8c: 'Após a instalação, haverá um ícone Sellox adicional - faça login diretamente',
  x_6d876a09: 'Ver página inteira',
  x_a75406c6: 'Olá, superadministrador 👑\\nVocê pode me pedir para fazer o seguinte:\\n• "Recarregar 500 pontos para Andy"\\n• "Observar o total de locatários e o uso de IA da plataforma"\\n• "Os 10 principais locatários com o maior saldo de IA"\\n• "Informações detalhadas sobre Andy"',
  x_720f0600: 'O serviço de IA não está disponível',
  x_d21e1fb6: 'Visão geral da plataforma',
  x_dc45b9fc: 'Listar todos os inquilinos',
  x_1c101627: '10 principais saldos',
  x_922f1ff2: 'Recarregue Andy com 500 pontos',
  x_40e77bcc: 'me diga o que fazer...',
  x_ee98d830: 'Controle de nível de plataforma GPT-5.2',
  x_dbd5f6e5: 'Escolha uma variante',
  x_9cc890a7: 'Cancelar',
  x_b4a55bb3: 'Permitir pop-ups / Ative pop-ups',
  x_45546304: 'Enviar para WhatsApp (~$0,01)',
  x_3835157d: 'Envio duplo com um clique: imprimir papel QR + caixa pop-up do WhatsApp',
  x_e0caf262: 'Reconciliação rápida',
  x_fccab93a: 'coletar',
  x_6e2a13a0: 'Requer confirmação do gerente para encerrar o turno',
  x_4349b878: 'O gerente confirma',
  x_49dfdd8b: 'Gerente confirmado',
  x_04070c1f: 'Quantidade real de contagem',
  x_57680d2c: 'Dinheiro a receber',
  x_4acec17e: 'Observações (se houver alguma diferença, explique os motivos)',
  x_5f411223: 'Retorno',
  x_1e576858: 'Pedido off-line sincronizado / Transmissão de pedido suplementar off-line',
  x_b15d9127: 'Fechar',
  x_240ce88f: 'O gestor deve escanear o código QR ou digitar a senha para confirmar a mudança de turno.',
  x_26201f40: 'Verificação de pagamento móvel:',
  x_eec5e9de: '💡 O sistema "Contas a Receber" foi concluído por padrão. Simplesmente modifique a linha que não corresponde à contagem real (geralmente apenas a linha do dinheiro).',
  x_77f4b22c: 'Caixa inicial:',
  x_cf80dc01: '(Adicionado a "caixa a receber")',
  x_3b2cc96c: 'É normal que a diferença seja proveniente de tarifas bancárias, gorjetas ou câmbio. Se os números não corresponderem, verifique se você cometeu um erro de digitação ou perdeu alguma coisa.',
  x_81ab69b9: 'Alterar tabelas/compartilhar tabelas/forçar fechamento de tabela',
  x_555dcd4d: 'Sem tabelas',
  x_7188b57a: 'Primeiro vá para Administrador → Modelo de Indústria → Restaurante para criar uma mesa automaticamente, ou → Gerenciamento de Mesa para adicionar uma mesa manualmente',
  x_21f69613: 'Tabela: Abra um novo pedido. ponto',
  x_b19d83e5: 'Alterar tabela',
  x_6f52c7c0: 'mesa compartilhada',
  x_cecf0ca3: 'Forçar o fechamento da mesa',
  x_2435f5bd: 'Comentários sobre o produto',
  x_0fa5956e: 'Insira notas...',
  x_da36e122: 'sem açúcar',
  x_d8a56361: 'shaobing',
  x_358cbe41: 'picante',
  x_81f4307e: 'sem cebola',
  x_7e1d3c25: 'tirar',
  x_bc8d758c: 'urgente',
  x_11db356c: 'Insira notas do pedido...',
  x_4403fca0: 'Excluir',
  x_2b6c52ae: 'Não há novos pedidos',
  x_8131eb5e: 'O som está desligado · Clique para ativar',
  x_7d1a9279: 'O som está ligado · Clique para desligar',
  x_e2392cc3: 'Ainda não há pedidos de mesa',
  x_60ce5286: 'Produto prescrito:',
  x_2c475e48: 'Você deve primeiro registrar o cliente (nome + telefone) antes de poder efetuar o pagamento.',
  x_8e5fdd7c: '⚠️Itens imediatos/expirados:',
  x_c15301ed: 'Expira hoje',
  x_abfc8ce7: 'Abrir turno',
  x_9f22fdc1: 'Caixa inicial',
  x_561e47de: 'Quanto dinheiro está na gaveta agora? Eu costumava fazer mudanças. O sistema deduzirá automaticamente esse valor para conciliação no final do turno.',
  x_b250b8da: 'Pular',
  x_e2f5ed34: 'Abrir',
  x_d43f28df: 'Etiquetas de preço',
  x_cb08c979: 'Pesquisar...',
  x_6ff3aa66: 'Preço',
  x_b7704c27: 'Tamanho',
  x_eb10f492: 'Térmica 80mm (1 foto por pedido)',
  x_bc3c00b4: 'A4 (grade de 3 colunas, economia de papel)',
  x_3f5cee0a: 'Sobretaxa de Cashea%',
  x_248bf378: 'Nenhum resultado',
  x_8821f767: 'Pesquisar nome ou telefone',
  x_aed44ac1: 'Assinatura do Cliente *',
  x_1c5dca75: 'Valor total/total',
  x_a306d0a4: 'Cliente *',
  x_b21d8bb4: 'Nenhum resultado',
  x_15e8601c: 'Dinheiro em dólares americanos',
  x_6aad3987: 'Bs em dinheiro',
  x_edf32545: 'Ref. do Banco',
  x_a31b8b65: 'Insira o número de referência da transferência do cliente e o sistema verificará automaticamente se o banco recebeu o pagamento.',
  x_868e4ac3: 'Prazo (dias)',
  x_9da7a7b8: 'contrato de crédito',
  x_6c6d1878: 'eu mesmo',
  x_0f76a0c9: 'Confirmar recebimento da mercadoria descrita, valor total.',
  x_7221fd2a: ', Chengruozai',
  x_d959b5d4: 'liquidar o saldo',
  x_96553cea: '. Os comerciantes com atrasos nos pagamentos têm o direito de tomar medidas legais.',
  x_e2b5c6cc: 'Nome do produto',
  x_b10acb59: 'receber pedido',
  x_a5e0e12d: 'UM FAVOR DO FUNCIONÁRIO / A empresa deve aos seus funcionários',
  x_17ea5dd2: '📱 Extrato de conta digital/fatura eletrônica',
  x_4e743c6d: 'Saldo real/saldo atual',
  x_4ae414d7: 'Empréstimos e créditos / Empréstimos e reembolsos',
  x_c7d9aa03: 'Mercadoria em crédito/registro de crédito',
  x_8815c25b: 'Salários pagos / histórico salarial',
  x_6cb22de0: '✅ A empresa deve a você / A empresa deve depósitos aos funcionários',
  x_66ea4390: '📱 Digitalize para ver seu extrato digital / Digitalize o código QR para ver a fatura eletrônica',
  x_443de421: 'Relatar perda',
  x_bb54122e: 'Reimprimir recibo',
  x_50c099f4: 'Registro de perdas',
  x_a1ed3194: 'Pesquise o nome ou código do produto...',
  x_7959f6f5: 'clientes atacadistas',
  x_e2e1c3c9: 'Pesquisar membros (nome/telefone celular)',
  x_0c9545b4: 'Nome do cliente *',
  x_8098e2b4: 'Número de celular',
  x_6ecea67c: 'Cartão de número de identificação',
  x_67f6a89e: 'Observações (opcional)',
  x_df3c5cbe: 'USB está conectado',
  x_d685a4d5: 'Conectar impressora USB',
  x_bfff47cd: 'A balança eletrônica está conectada.',
  x_2864a729: 'Conecte balança eletrônica',
  x_912cc1e7: 'lista de verificação',
  x_4b8e471b: 'à parte',
  x_05cee7de: 'Imprimir etiquetas de preços',
  x_6441bd25: 'Refrescante...',
  x_498519d1: 'Atualizar dados',
  x_066ae8d7: 'bastidores',
  x_b9431793: 'Alterar usuário',
  x_c3992269: 'Sair',
  x_f98a4911: 'Entrega antecipada de dinheiro',
  x_953a783e: 'Modo offline: Os pedidos podem ser feitos normalmente e os pedidos serão sincronizados automaticamente assim que a rede for restaurada.',
  x_4080c16f: 'Off-line e sem dados em cache: primeiro conecte-se à Internet para fazer upload de dados',
  x_8bcfc934: 'Os dados armazenados em cache têm mais de 24 horas, os preços e o estoque podem ter sido atualizados. Ele será atualizado automaticamente após a restauração da rede.',
  x_a75ed77e: 'Se os dados armazenados em cache excederem 1 hora, é recomendável conectar-se à Internet para atualizar.',
  x_333142e1: 'Digite para pesquisar / Enter para pesquisar mais...',
  x_7ffacc1a: '🎂 Aniversário Aniversário',
  x_787b5677: 'gênero',
  x_6a0ee6bd: 'Use o modo de impressão quiosque do Chrome para imprimir silenciosamente na impressora padrão (XP-80C) sem configuração adicional',
  x_8dc32ae4: 'Dinheiro',
  x_14add33c: 'Cartão',
  x_a474b44e: 'Transferência',
  x_80263dad: 'Misto',
  x_7f3933e2: 'Crédito',
  x_86aa4552: 'Consulta de pedido/reimpressão de fatura',
  x_36bcb2a1: 'Localizar o número do pedido...',
  x_0cc05f42: 'de',
  x_d716f1e8: 'chegar',
  x_83958d46: 'solteiro',
  x_85ab5250: 'sem ordem',
  x_9109ea1e: 'adicionar pagamento',
  x_16a3cf1d: 'Alterar pagamento',
  x_d8b294d0: 'imprimir fatura',
  x_15a6696e: 'Nota pequena de 80mm',
  x_62d36990: 'adicionar ao carrinho',
  x_e90b99bd: 'Queda antecipada',
  x_6cbe5ffa: 'USD (Dólar dos Estados Unidos)',
  x_7559edad: 'Insira o valor',
  x_06508433: 'É necessário PIN de administrador',
  x_731c658b: 'Anular esta queda?',
  x_dcc961ae: 'anulado',
  x_267fa274: 'Selecione o administrador',
  x_3700ec74: '4-8 dígitos',
  x_e20efdec: 'Exemplo: a gaveta está muito cheia',
  x_e39ec276: 'Confirmar entrega',
  x_563e10ba: 'Vazio',
  x_43c80a9b: 'Entregue antecipadamente a grande quantia de dinheiro na gaveta ao gerente. O sistema irá deduzir automaticamente no final do turno e simplesmente contar o dinheiro restante.',
  x_2ed7e4e2: 'Moeda',
  x_ae59a48e: 'Gerente',
  x_a87ce55a: 'Gerenciador de PINs',
  x_3a14c9f8: 'Notas/Notas (opcional)',
  x_b72845a8: 'Ainda não há check-in',
  x_db16fe15: '✅ Completo',
  x_de040917: '⚠️ Confiscado',
  x_56673f3a: 'Erro',
  x_f15ea525: 'Encontre o número do pedido/cliente/número de telefone',
  x_712939e0: 'A quantidade deve ser maior que 0',
  x_e1308cbe: '✅ Pagamento recebido com sucesso',
  x_1d5381c2: 'Cancelado, o estoque foi revertido',
  x_a29d3fab: 'Razão',
  x_92b67f7b: 'Devolução do depósito ao cliente',
  x_4c2db86d: 'O depósito vai para o comerciante.',
  x_0aa2fd58: 'Ativo',
  x_80e42329: 'Concluído',
  x_f3f6aad1: 'Cancelado',
  x_9f5fa600: 'Perder',
  x_7cf73f3d: 'Todos',
  x_4865eb9a: 'não separados',
  x_76898534: 'equilíbrio',
  x_d941a5be: '⚠️ Expirado',
  x_3a291eca: 'Seja pago',
  x_0959981b: '✅ Apagado',
  x_353048bb: 'Pode ser enviado aos clientes.',
  x_e91d829e: 'O cancelamento de pedidos requer permissões de administrador',
  x_e8606af7: 'Confirmar cancelamento',
  x_d2dbc37e: 'não cancele',
  x_de1ec1b5: 'Dividir por / dividir igualmente',
  x_32cd3100: 'Erro ao alterar a tabela',
  x_26e78ec2: 'Não foi possível ingressar na tabela',
  x_ae1573f2: 'Falha na liberação',
  x_be163dfd: 'Alterar tabela',
  x_010a57e3: 'Transferir a conta desta mesa para outra mesa vazia',
  x_f4b63ba2: 'Combinar contas',
  x_57c68729: 'Mesclar contas de outra tabela com esta tabela',
  x_dee2caa5: 'Tabela de lançamento',
  x_145ac83c: 'Sem liquidação, apenas lançamentos de tabela são liberados (cenário de reconciliação manual)',
  x_5a43d675: 'Selecione mesa livre:',
  x_88f3038b: 'O WhatsApp será enviado para',
  x_b787eaf7: 'O número é muito curto, pelo menos 8 dígitos',
  x_1a5e2d7a: 'um clique)',
  x_a62f3804: 'USDT (TRC20) · Tron · Taxa de administração ≈$1 ⭐',
  x_e9868cc5: 'Copiado ✓',
  x_48eb1f6c: 'Mais rápido)',
  x_50a13126: 'Toque para conversar com mensagem pré-preenchida',
  x_067ff847: 'Métodos de pagamento',
  x_57c296c9: 'Instruções de pagamento',
  x_422c8df2: 'faturamento',
  x_96575b5a: 'único',
  x_2ab9e7e1: 'Dinheiro sem receita',
  x_9627644f: 'Retorno',
  x_598fb8ab: 'Método de pagamento',
  x_5d5de3a9: 'O que foi vendido?',
  x_9902bd0f: 'Pesquisar nome do produto...',
  x_729c413f: 'bens',
  x_f965fea3: 'vezes',
  x_b68919a3: 'virar',
  x_6f862984: 'Dinheiro para começar uma aula.',
  x_3788667e: 'recebimentos de dinheiro',
  x_8fbe97e2: 'remover',
  x_769b69c5: 'deveria agora',
  x_27e303bd: 'Não há aulas abertas (sem detalhes de dinheiro no balcão)',
  x_3e586351: 'Não há registro do dia.',
  x_244b0c8f: 'pedido original',
  x_ea9fedcb: 'renda bruta',
  x_211d2fdf: 'Câmera não disponível:',
  x_2637e51a: 'Erro ao iniciar a câmera',
  x_2cbd6249: 'O código não está em bancos de dados públicos — preencha manualmente',
  x_3016cebc: 'Falha na pesquisa',
  x_2a3e7f5c: 'manuais',
  x_092a15aa: 'Digite o código (EAN-13, UPC...)',
  x_9ebf3950: 'Use e crie',
  x_82cafd5c: 'Continuar com o código',
  x_c0079539: 'Procurando...',
  x_eba9d01c: 'Código não encontrado',
  x_913fcd49: 'Sem alterações',
  x_9216d1be: 'Tamanhos',
  x_bbbbab6e: 'Cores',
  x_f297d54c: 'Passo 2: Insira o inventário por linha → Salvar',
  x_2f88548e: 'Tamanho\\Cor',
  x_3e616117: 'Digite seu telefone / Digite seu número de celular registrado',
  x_925ff2fa: 'Insira o código / Insira o código de verificação',
  x_798b1cb7: 'Senha mínima de 6 caracteres / A senha deve ter pelo menos 6 caracteres',
  x_8052ef2a: 'As senhas não correspondem/Duas senhas são inconsistentes',
  x_8049f1c7: 'Enviar código / Enviar código de verificação',
  x_9d936c0f: 'Redefinir/Redefinir senha',
  x_a850638e: 'Um código de verificação será enviado para o WhatsApp cadastrado da loja.',
  x_6c546734: 'Telefone cadastrado/Registrar número de celular',
  x_b3382444: 'Código/código de verificação',
  x_a25bd352: 'Nova senha / Nova senha',
  x_134cc560: 'Repetir senha/perder novamente',
  x_72138076: 'Redefinição de senha! / Redefinir senha',
  x_35973a26: 'Loja/ID da loja:',
  x_0c58a4d9: 'Usuário/Nome de usuário:',
  x_871b1e0c: 'Nova versão pronta',
  x_77dbaf27: 'Atualizando...',
  x_edf4de14: 'oficial)',
  x_c9dc4ffd: 'Suporte ao sistema legado Firefox ESR',
  x_39400df4: '🌍 Mapa global de inquilinos',
  x_ef8318a7: '💰 Visão geral dos pagamentos criptográficos',
  x_09636666: '🔔 Lembrete de renovação (AI)',
  x_542ce2f8: 'Inscrições de teste',
  x_408009cf: 'Pagamento Internacional',
  x_5910639f: '📦 Número do lote/lote (FIFO)',
  x_b1381d19: '🎯 Agrupamento RFM + envio em massa',
  x_559dca3c: '🏆 Detalhes de desempenho dos funcionários',
  x_6e1ce46a: 'manual da impressora',
  x_03a9825e: 'Olá chefe! Eu sou seu assistente de negócios de IA. Você pode me perguntar “Quanto é o lucro hoje?”, “Produto mais vendido”, “Estoque insuficiente”, “Quem me deve dinheiro”, etc.',
  x_b26b0699: 'O serviço de IA está temporariamente indisponível',
  x_0a0092b7: 'Os 5 produtos com maior bilheteria',
  x_b23a6752: 'Quais ações estão fora de estoque?',
  x_19a63387: 'Quem me deve mais dinheiro?',
  x_9445221f: 'Assistente de negócios de IA',
  x_a6f1ba27: 'Faça uma pergunta...',
  x_20448d20: 'GPT-5.2 · Consultar dados em tempo real',
  x_943201f9: 'subir/subir',
  x_caecf5b4: 'cair / cair',
  x_f345932a: 'Dispensar',
  x_1c4d65a8: 'Alerta FX',
  x_2a9db7a6: '✓ Conta do chefe do WhatsApp enviada',
  x_b2a5c20e: '⚪ WhatsApp não está ativado (defina o número do chefe nas configurações FX)',
  x_4f100f54: 'Olá Selox! Estou interessado no seu PDV.',
  x_0cbf83cc: 'Contate-nos',
  x_e9e8054f: 'correspondência',
  x_73325cad: 'cheio',
  x_41f5f6ef: 'menos',
  x_8be34d50: 'comprar',
  x_040f3943: 'enviar',
  x_9aacc1c5: 'oferta especial',
  x_3fcde29c: 'Não foi possível enviar o comprovante de pagamento:',
  x_bf7669aa: '. Tente usar uma captura de tela mais clara.',
  x_b4c3bd30: '无图 / Sem imagem',
  x_3cf48c32: 'imagens existentes (podem ser substituídas) / Com imagem',
  x_f653eca8: 'A câmera não está disponível (',
  x_90b6a7dd: '), retornar ao álbum de fotos',
  x_52983340: 'Lojas funcionários ilimitados',
  x_a40aedb7: '✅ Enviado',
  x_791333be: 'WhatsApp',
  x_3083efed: 'Certifique-se de que o cliente',
  x_97bbb919: '"Mover para a lixeira?" \\nAs contas e o histórico não serão perdidos e poderão ser restaurados a qualquer momento.',
  x_8d6e3b74: 'Movido para o lixo',
  x_b70e8e43: 'Restaurado',
  x_3580b741: 'Reativado',
  x_4a561e6f: 'caracteres (a assinatura foi testada e aprovada)',
  x_f30d10af: 'caixa x',
  x_cdf08038: 'certifique-se',
  x_a24c6f3f: 'Marcar todas as postagens como publicadas?',
  x_5c51c3b8: 'Exportado',
  x_c0a515b2: 'clientes / Exportados',
  x_2d4c5dcc: 'Criado',
  x_6c0b9fed: 'Estoque mínimo de itens.',
  x_ddfcb2be: 'Corrigido',
  x_b1418bb8: 'Estoque negativo de mercadorias.',
  x_fe4c8813: '\\n...Também',
  x_930882bb: 'um',
  x_8cfef109: 'compartilhar',
  x_896a955f: 'Itens sem preço de custo:\\n\\n',
  x_6b73316d: '\\n\\nConfirmar para excluir tudo? Esta operação é irreversível!',
  x_5cc23262: 'Excluído',
  x_db0a9f72: 'mercadorias sem preço de custo',
  x_a2aaa24e: 'Aplique todos eles (',
  x_fc4d75f6: 'descobrir',
  x_1e2b2923: 'produtos à deriva, total',
  x_e86ee821: 'unidade. Reparar imediatamente?',
  x_992bce69: 'produtos (',
  x_e2f9c4d8: 'unidade)',
  x_e213f3ac: '✅Enviado! identificação:',
  x_30fae0dd: '✅ Ativado: Lembrete automático às 9h30. todos os dias (mesmo cliente',
  x_ed0dbd12: 'Não se repete depois de alguns dias)',
  x_04501e0e: '✅ Salvo: número mínimo de mesmos clientes',
  x_99c19d88: 'O gênio irá lembrá-lo novamente.',
  x_11c0bdd6: 'Dê"',
  x_04b02a3b: '》Definir novo ID de login\\nAtual:',
  x_951c3597: '\\n(4 a 20 dígitos, letras/números/hífens/sublinhados)',
  x_ec9f4837: 'Confirmar',
  x_eb7706ac: 'Mudar para',
  x_61bbc1d1: '?\\n⚠️ Todos os funcionários deste comerciante devem fazer login novamente com novos IDs e o link da loja online também se tornará /loja/',
  x_f0bb4cec: 'O limite da loja foi definido para',
  x_a6cdd2a0: 'casa',
  x_4a368d87: 'Confirmar exclusão',
  x_f8789f6e: 'Registros de estoque?',
  x_4d8a497e: 'Aceitar para excluir',
  x_52f6f1b8: 'de todo o inventário? Esta operação é irreversível!',
  x_61682ed3: 'Confirme novamente: exclua',
  x_9a5e3bc8: 'Todos os registros de inventário?',
  x_3683077f: 'Apagado',
  x_4deb231b: 'registros de inventário',
  x_d5d53fcf: 'Certifique-se de copiar todo o estoque do armazém principal para',
  x_1b3f235d: 'Já desde',
  x_06363f80: 'os itens chegam',
  x_dd78ca49: '✅ Recarga com sucesso! +',
  x_19e9aae9: 'O aviso de teste foi ativado:',
  x_adfefb8e: 'Mude para "',
  x_0258b3da: '”? \\nAs categorias correspondentes serão criadas automaticamente (as existentes não serão repetidas). Você pode voltar a qualquer momento.',
  x_6341a6f1: 'mesa',
  x_2cf87b31: '✅ Alterado - Novo',
  x_2cd6fde3: 'categorias',
  x_f64a9820: '· Concluído',
  x_8983c664: 'risco de rendimento',
  x_b8f4e941: 'Relatório de reconciliação',
  x_822ac472: 'Correspondido (',
  x_268173c2: 'Nenhuma validação correspondente (',
  x_172d9095: 'Vendas incomparáveis (',
  x_d03e7311: '✅ Processado: Novo',
  x_11e6be8e: '· Associação',
  x_b06b30ab: '·Associado',
  x_1b16b10a: '· O número do celular está faltando',
  x_26b59f52: 'pagar',
  x_fddfa6c6: 'Reconhecimento de IA concluído:',
  x_6def8122: 'Já em estoque:',
  x_2ef72bb3: 'Item/pedido de compra',
  x_97695dd1: 'há muito tempo',
  x_be72b0b9: 'enviado com sucesso / enviado',
  x_b0ef9048: 'descartar',
  x_24406e3e: 'A operação foi rejeitada pelo servidor?\\n\\n',
  x_8d893e60: '⚠️ Estas operações não têm efeito no servidor. Por favor, confirme se você precisa operar novamente antes de descartar)',
  x_61cef91b: 'excluído/limpo',
  x_9fb4dafd: 'caneta',
  x_5526ee20: 'Conta de crédito sem titular, total',
  x_13743a01: 'Determine imediatamente até hoje.',
  x_1eca306b: 'Enviar bênçãos via WhatsApp para um aniversariante?',
  x_939d7902: '…etc.',
  x_2b689f7b: 'Modificado',
  x_0a66a2c4: 'Antevisão: disponível hoje',
  x_27e4f2f4: 'aniversário do cliente',
  x_bff5e1f3: 'Enviado:',
  x_8e141b21: '· Falha:',
  x_2517df74: '· Pular:',
  x_9127c4b7: 'Prévia: será enviada para',
  x_e61704c3: 'clientes (excluindo',
  x_e1967cf6: 'planejado em',
  x_ed33b3f4: 'enviartr(',
  x_00c0b64d: ')? Confirmar?',
  x_05235460: 'Programado:',
  x_bab46d2e: 'enviará tr(',
  x_6912b561: ') mensagem, confirmação?',
  x_f43d612e: 'Envio de lote concluído:',
  x_8891f2c6: 'Sucesso ·',
  x_c3342602: 'Falha ·',
  x_17fbc240: 'rainha do céu',
  x_d5b805a6: 'diva ·',
  x_3b8c1c81: 'Modelo completo:',
  x_e46f5031: '% / Subindo',
  x_1f06712c: 'rejeitado — revisão/rejeitado, precisa ser processado',
  x_35b7c240: 'Sua assinatura também tem',
  x_aa277e9b: 'Quando o período expirar, renove a tempo para evitar a interrupção do uso.',
  x_7dc5867e: 'O teste gratuito permanece',
  x_1d74fc6c: 'dias. Renove para continuar usando todos os recursos.',
  x_613c2e78: '⚠️ Descubra',
  x_81764eb3: 'Há uma grande diferença entre os artigos, verifique antes de encerrar a aula.',
  x_86103e41: '⚠ Descubra',
  x_473bed24: 'pequenas diferenças',
  x_3aa832e9: 'Encomende através da loja online #',
  x_1cda5086: 'Pedido de mesa pendente',
  x_1b95ed0e: 'depósito',
  x_641e1071: '≥ mínimo',
  x_1c73433c: 'inferior',
  x_1ecba8c2: '🏷️ Criar Aparta (assinado)',
  x_793d5c95: '🏷️ Criar Aparta',
  x_4ffc9e7c: '✅ Já na bolsa',
  x_ced2e82c: '⬆️ Carregar',
  x_2180077a: 'Único / Carregar',
  x_b6f69d33: 'Único para passar · pecado vermelho',
  x_0e6f5c6c: 'contas mescladas em',
  x_d8817d65: '🤝 Fusão concluída ·',
  x_dce1d1f6: 'Artigo ·',
  x_09e8990d: 'Confirmar fechamento forçado',
  x_7e05053e: '? Esta ordem pendente não será liquidada automaticamente. / Soltar a mesa sem carregar?',
  x_7f673278: 'lançado',
  x_050ed17c: '✅ Encontrado/Encontrado:',
  x_3bdece77: '✅ Gerar',
  x_7a656cfc: 'variantes',
  x_271f3942: 'inventário de linha',
  x_c53f6031: 'Aceitar · Falhar',
  x_2d5aef4f: 'OK',
  x_b491196a: 'Bug da interface do usuário:',
  x_296304f1: 'hoje',
  x_d8886c56: 'Aniversários de clientes – Envie desejos de grupo com um clique',
  x_e292789d: 'Status/Estado',
  x_6165a875: 'Bloqueado para:',
  x_ba1267f0: 'Última atualização/Última atualização:',
  x_65d9f49b: 'Mensagem para enviar (',
  x_764665c3: 'tudo (',
  x_028a9628: 'Criar "',
  x_a0f73e03: 'Modificar classificação —',
  x_fa5bee02: '⚠️ Excluído:',
  x_dce0ab9f: '— Não serão emitidos pontos para encomendas efetuadas através destes métodos de pagamento.',
  x_27651c15: 'Venda de 30 dias',
  x_1b3ba792: 'Estoque mínimo:',
  x_04d8e11a: '(Atualmente:',
  x_efa4cb5c: 'pessoas/média diária',
  x_6f7909ea: 'Envie recibos do WhatsApp automaticamente',
  x_0141c048: 'Reivindicação automática (devido ao WhatsApp)',
  x_041a7a49: 'Dias: Após a solicitação do cliente, mesmo que ainda não tenha pago, ele ainda terá que aguardar.',
  x_72f50f4b: '🤖 WhatsApp garante pagamentos automaticamente',
  x_4c0d90b0: 'Atualmente o wa-web está ocupado por outros inquilinos (',
  x_5250451c: 'Sellox já está disponível através do seu WhatsApp (',
  x_24d49a39: 'Enviado apenas uma vez por dia',
  x_97f6b93d: ') — Um servidor só pode ser habilitado por um locatário por vez',
  x_4d4bb206: ') Envie mensagens automaticamente para qualquer cliente.',
  x_6dcb77fd: 'Limite da loja',
  x_2fd10482: 'Estoques pendentes de aprovação / Estoques pendentes de aprovação (',
  x_49f610ec: 'Não há preço de custo estabelecido para este produto.',
  x_22261f15: 'Salvar configurações / Salvar',
  x_b45c0413: 'Enviar alerta de teste / Enviar teste',
  x_4d2afcd3: 'Concluído (últimas 2h)',
  x_e0385134: 'Para produzir ·',
  x_d7104c13: 'Em produção ·',
  x_c02e8b6b: '💡 O botão Comprar será mostrado na página inicial: Atendimento ao Cliente WhatsApp',
  x_889e1514: '· Outros',
  x_6f2e8e74: 'Indústria atual:',
  x_26f914e7: 'Definir hora:',
  x_9657acc8: '💡 Exemplo: Cliente pede $20 → Adicione $ automaticamente',
  x_dc0ccfb0: 'Taxa de serviço → Total $',
  x_6690b55c: '⏳ Revisão pendente (',
  x_a6b994c5: '✓ Certificado (',
  x_0a4b9139: 'Desativado (',
  x_c7c68337: 'Envie este link para os entregadores que deseja recrutar →',
  x_bb5bb60d: 'Salvar configurações / Salvar',
  x_81cf7805: 'Lista de inquilinos (',
  x_a2b4e1d9: 'Rascunho do lembrete de renovação da IA',
  x_b6733812: '· País',
  x_e852c9a4: 'loja',
  x_a2cf4af4: '· Telefone',
  x_4b2603c3: 'Nome do Aplicativo Preencha um nome aleatório (por exemplo:',
  x_bccb0533: 'Resumo do turno (',
  x_80a13d4d: 'Transferência:',
  x_f576986b: 'Iniciar reconciliação',
  x_ad131c12: 'Caneta$',
  x_54213898: 'detalhes (',
  x_4209a9ba: '1 tubo = $',
  x_7a2c820b: '(Copie o acima',
  x_184b4831: '4. Confirme o envio → 1-2 minutos de créditos de IA automaticamente +',
  x_8b2a4731: 'Ordem:',
  x_0b463505: 'A função USD AI será suspensa quando o saldo for insuficiente Entre em contato com o administrador da plataforma para recarregar',
  x_be11172d: 'comerciantes de teste',
  x_8ae8f95e: 'A taxa anual é válida até:',
  x_d3d43df8: 'Aguardando a chegada do USDT',
  x_30c0ee04: 'Taxa de renovação anual USDT$',
  x_1a810c50: 'Versão da loja',
  x_f8f63ea1: '(Vendido por $',
  x_ea6914b3: '/Digite$',
  x_8f3599b6: 'confiança',
  x_02456a77: 'Código de barras:',
  x_b4fdcd01: 'Atualizar preço de custo (original',
  x_a3f28012: 'Preço de varejo sugerido (+',
  x_8375f775: 'Caixa ×',
  x_2c0e9a33: 'Na fila / Junte-se à equipe:',
  x_b8bfc6ea: 'Alterações pendentes de upload/itens a serem carregados',
  x_f15ef0a0: 'Caneta·O cliente paga em dólares americanos',
  x_fadfbb89: 'Caneta · ≈',
  x_8e52492c: 'Envie com um clique',
  x_777ba9db: 'artigos',
  x_60c22af0: 'Modelo de mensagem (suporta variáveis',
  x_2aabd245: 'Visualização dos resultados:',
  x_32e0b823: 'Aniversários nos próximos 30 dias (',
  x_4e1abb5c: 'Conteúdo da mensagem (suporta',
  x_122c804a: 'Planeje ser enviado (',
  x_d0176d3e: 'Enviar registros (quase 50 artigos no total',
  x_f2b7c51d: 'pronto para ir',
  x_fb9b45b1: '· Cupons',
  x_8e9b7f87: 'festa',
  x_4ca669c7: 'Enviado ·',
  x_7100dc7a: 'Salte ·',
  x_ff8318c2: '⚡ ATRIBUÍDO A VOCÊ / ATRIBUÍDO A VOCÊ',
  x_f1f28de8: 'Entrar / Entrar',
  x_ed2d1a22: 'Enviar Cadastro / Enviar',
  x_618ab9b1: 'Confirme dentro de s',
  x_49074539: 'Salário semanal estimado: $',
  x_9013fa6e: 'Pedido #',
  x_1b3e5894: 'entregador',
  x_d7d4b3fc: 'Enviando',
  x_875225ef: '— Selecione a especificação / Selecione o tamanho e a cor',
  x_8dcf5483: '📤 Enviado ao gerente / Entregas antecipadas (',
  x_69a49f6a: '📩 Novos pedidos da loja online (',
  x_532e7e2f: 'Artigo · #',
  x_f38a0357: 'Clientes de medicamentos prescritos se registraram:',
  x_2105a088: 'Expira após dias',
  x_f77c9383: 'Mais...',
  x_56f0d339: 'Data de validade ≈',
  x_4727e7e1: 'Dólares americanos',
  x_4b8b23a7: 'em alguns dias',
  x_100bd194: 'artigos ·',
  x_56ec6c2c: '% Depósito Mínimo = $',
  x_338f8935: 'Inventário:',
  x_dd8e89b9: 'Mais produtos... Insira palavras-chave para pesquisar',
  x_698818eb: 'Para sincronizar:',
  x_2751b59b: 'Quantidade / Quantidade (',
  x_423485d6: '📜 Este voo foi ensacado (',
  x_9fb8b1b7: '🏷️ Gerenciamento de reserva/retenção —',
  x_f9659c1d: 'eu $',
  x_e7feb554: '💯 Colete saldo $',
  x_d127a089: 'Selecione a tabela a ser mesclada (a contagem desta tabela será mesclada em',
  x_d0846a09: '✓ em',
  x_1e68d525: 'Consulta/Pesquisa',
  x_d7b1fd5f: 'encontrado',
  x_5f6ef156: 'Gerar combinação / Gerar',
  x_29953c6f: 'ser salvo',
  x_50918dbc: 'variações ·',
  x_fc461ac5: 'salvar inventário (',
  x_e468fa4f: '⚠️ Seu navegador está desatualizado —',
  x_9ba1a642: '(limiar',
  x_f876a49c: '% · Recomenda-se consultar o preço de venda do produto)',
  x_795eaf50: '🖨️ Imprimir',
  x_8059771f: 'Nenhuma imagem',
  x_cec3f014: 'Substituir',
  x_532c8856: 'Tirar foto',
  x_207eb32c: 'Da galeria',
  x_2425155d: '💡 Coloque o produto sobre uma superfície brilhante, a frente será a mais clara',
  x_9cf1afed: 'Focando, mantenha firme por aproximadamente 1 segundo',
  x_77abc2a1: '👇 Escolha qual manter',
  x_2d86ed95: 'Usar originais',
  x_82fc4841: 'Iniciando a câmera...',
  x_8df3213a: 'Use a versão AI',
  x_781f0d75: 'Retomar',
  x_dd740dc5: 'Os dois coproprietários recebem as contas igualmente. A IA envia automaticamente relatórios de vendas detalhados para ambos os chefes via WhatsApp, diariamente ou mensalmente.',
  x_2eb1e982: '📅Diário',
  x_d5ac2190: '📆 Mensalmente Mensal',
  x_b5c8b0a2: 'Profissional',
  x_3706b4d0: 'Amigável',
  x_e366ccf1: 'configurações',
  x_0a9c8842: 'Visualização',
  x_c7db6d4f: 'restaurar',
  rider_reset_pw: 'Redefinir senha',
  rider_navigate_btn: 'Navegar',
  rider_navigate_addr: 'Por endereço',
  rider_forgot_hint: 'Esqueceu a senha? Peça ao dono da loja para redefini-la em Entregadores',
  x_5fb1fd09: 'Pôster QR',
  x_aba55e6b: 'Link de digitalização:',
  x_6f7fff38: 'Baixar PNG',
  x_bc96a998: 'Configuração',
  x_4fc91b55: 'Digitalize e compre facilmente',
  x_c154a693: 'Manual de impressoras',
  x_6b78e860: 'Instale a bandeja QZ',
  x_75688f20: 'Configurar impressoras',
  x_12ee3d19: 'Fluxo de impressão',
  x_90167330: 'Perguntas frequentes',
  x_433baf5e: 'Baixar',
  x_27db0784: 'Baixar certificado',
  x_5482983f: '🔥Ativo por 30 dias',
  x_01b2a86b: '🎂 Aniversário de hoje',
  x_6810ae91: '📱 Exportar lista de clientes CSV → Importar',
  x_59556b40: 'Mark Allsent',
  x_1535fcfa: 'enviar',
  x_b1731af3: 'Exportar CSV para WhatsApp Business',
  x_58f4fc4b: 'APP → Criar Lista de Transmissão (256 pessoas por vez) → Promoção em Massa/Aniversário',
  x_28cfe557: 'Reservado por enquanto',
  x_23532881: 'nova mercadoria',
  x_ed3046c5: 'Criar e adicionar ao pedido de compra',
  x_71e9bba3: 'Excluir (excluir permanentemente)',
  x_846e5470: 'Oculto (registros de retenção de arquivos)',
  x_a9818765: 'Métodos sem pontos',
  x_e1d9e1d6: 'Biopagamento.',
  x_00155faf: 'Gerar meu código de referência',
  x_040f51a6: 'copiar código',
  x_879058ce: 'Copiar link',
  x_db07affa: 'Redefinindo o estoque negativo para zero',
  x_8f9b2023: 'Excluir itens sem preço de custo',
  x_07c8a48c: 'Conexão de autoatendimento WhatsApp (frete grátis/ilimitado)',
  x_ed2be317: 'Digitalize o código QR uma vez para montar permanentemente sua conta WhatsApp no sistema Sellox. Envie mensagens automáticas para todos os clientes/funcionários sem aderir.',
  x_8277b145: 'Após ativá-lo, caso o cliente possua número de celular + tenha se inscrito para receber notificações do WhatsApp durante a finalização da compra,',
  x_301c285f: 'Os caixas não precisam mais clicar manualmente em wa.me.',
  x_4fa7c9cc: 'Evite assediar a mesma pessoa todos os dias.',
  x_fdbb8738: '⚙️Intervalo de 1 a 60 dias. Recomendação: 3 dias para pequenos grupos de clientes, 7 dias para clientes normais, 14-30 dias para grandes clientes.',
  x_bbe42801: '🔒 Cada captura de tela deduzirá 1 voucher AI de forma independente; O envio repetido da mesma imagem dentro de 5 minutos será automaticamente ignorado.',
  x_9eba1d0b: 'O código QR é atualizado automaticamente a cada 25 segundos; Não se preocupe em não conseguir digitalizá-lo.',
  x_a3ac5646: 'Montado:',
  x_5319c74b: 'será em 30 segundos',
  x_78623eae: 'todos os dias',
  x_b036b784: 'mesmo cliente',
  x_2ee44035: '💡 Por exemplo, suponha',
  x_ef49a64e: 'O cliente fez uma captura de tela da transferência.',
  x_676ea371: 'Também responderá automaticamente ao cliente “✅ Pagamento confirmado/pedido confirmado”.',
  x_69893eef: '💡 Neste caso, quando o pedido correspondente exato não for encontrado após o reconhecimento da IA, o voucher será registrado na lista de “Verificação de Pagamento” da loja para o funcionário processar manualmente.',
  x_1b037636: 'Conexão',
  x_771d235b: '🎂Marketing de festival/aniversário',
  x_75c856b1: 'Sair',
  x_2abe9e2c: 'Link do recibo eletrônico —',
  x_2b9efa91: 'Atualmente fechado: o efeito entrará em vigor imediatamente após ser ativado',
  x_acabef73: 'Digitalize automaticamente todos os registros de crédito - Dê',
  x_e30c7cd7: 'dos clientes enviam lembretes via WhatsApp.',
  x_5a445658: ', isso não irá incomodá-lo repetidamente. Também disponível em',
  x_95de8c70: '"Reivindicação manual com um único clique na página.',
  x_8ee2848b: ', o AI identifica automaticamente o número/quantia de referência,',
  x_53eb1951: 'Pedidos pendentes nas últimas 48 horas e marcados como pagos,',
  x_01276a67: 'Indústria',
  x_60624b98: 'Limpar inventário órfão',
  x_1c74acdb: 'Registros completos de inventário',
  x_01702b13: 'Exclua todos os pedidos (perigoso)',
  x_fcc3d39a: 'Reparo automático',
  x_be0ade04: 'Índice de reconstrução',
  x_fd76118e: 'Exportar dados de backup',
  x_aac9e1d1: 'Recarga de créditos AI',
  x_a8fc5824: 'Defina o preço de custo na gestão de produtos e verifique novamente.',
  x_67c6118c: 'BCV',
  x_a2084b07: 'Limite',
  x_66bfebe7: 'Telefone do chefe',
  x_c0d5d68f: 'ignorar',
  x_e38cac91: 'Reabrir',
  x_842010db: 'F11',
  x_a24983d8: '📞WhatsApp de atendimento ao cliente (obrigatório)',
  x_48912e07: '🪙 USDT (stablecoin, aceito globalmente)',
  x_1d7f3562: '🧩 Outros métodos de pagamento (Wise/Zelle/Binance Pay...)',
  x_bad080e4: '📍 Após mudar para a loja de roupas, você pode preencher as variantes de tamanho/cor na página de edição do produto.',
  x_7f9f889d: 'Quando ativado, o caixa do PDV do restaurante adicionará **automaticamente** uma taxa de serviço de X% após o subtotal na finalização da compra.',
  x_9dad4122: 'O caixa pode cancelar uma única transação. O recibo do cliente também mostrará esta linha.',
  x_47bd55cf: 'Se você já possui categorias de produtos, é recomendável usar "',
  x_7b6d74a4: '📍 Após mudar para o restaurante, aparecerá “🍽️ Gestão de Mesa” no menu esquerdo.',
  x_78841a5c: 'Mudar de setor** apenas adiciona categorias** e não excluirá seus produtos/categorias existentes.',
  x_6c525ddf: '”E então use apenas os recursos que você precisa (como mesas de restaurante).',
  x_8d63ef38: 'pausar',
  x_e7c3bc5c: 'O entregador informa o código da loja ao se cadastrar.',
  x_7037508b: '💡 Regras de classificação:',
  x_23c1f399: 'Passe',
  x_7173f809: 'rejeitar',
  x_a5978c43: '(ou seu ID de inquilino), você verá "revisão pendente" nesta página e ele poderá aceitar o pedido após aprová-lo.',
  x_70f983d4: 'Usar localização atual (clique aqui na loja)',
  x_13e8fee8: '· Quanto mais próximo + mais livre, é dada prioridade ·',
  x_929fc89b: 'Estilo de mensagem de IA:',
  x_144db44b: 'Lembrete de IA',
  x_9d6f026a: '📖 Primeira vez que usa? Clique aqui para ver o tutorial de configuração completo',
  x_7bd0aecf: 'Custo: ~$0,01/item (API Meta Cloud, janela de serviço de mais de 24 horas)',
  x_9fe61acb: 'Após o fechamento, o funcionário ainda pode clicar manualmente no botão [WhatsApp] para enviar na janela pop-up “Pedido Concluído”.',
  x_1dcf3bf4: 'Copie os dois valores a seguir para a página Meta Webhook (menu esquerdo',
  x_a4e7978d: 'Condições: ① O chefe verifica esta opção ② O WhatsApp está configurado e habilitado ③ O cliente criou um perfil + possui um número de celular ④',
  x_defd4e63: '→ Verifique três permissões:',
  x_31aadde4: 'Preencha o cartão:',
  x_922a7731: 'resposta automática',
  x_85849d21: 'Recibo automático',
  x_83413c5e: '— Basta verificar quando for em Gestão de Clientes/Criar um novo cliente.',
  x_88b8d068: 'Imprimir relatório',
  x_88ae41b0: 'Estoque por tamanho e cor',
  x_1af9ab5b: '🔗 Conecte arquivos do cliente com um clique',
  x_0563df42: 'Recarregue com USDT (TRC-20)',
  x_6ae048ae: 'Cancelar',
  x_6503c16e: 'Suporta USDT TRC-20 (taxa de manuseio muito baixa) Creditado automaticamente na conta cerca de 1-2 minutos após o pagamento Sem KYC',
  x_3eb35747: 'Estado:',
  x_90ef892d: 'Copiar endereço',
  x_4f8d48ef: 'atualizar status',
  x_5b9fc057: 'Página de pagamento alternativo',
  x_c4ab90ae: 'rastreamento de whatsapp',
  x_f1d9634a: 'abra o WhatsApp',
  x_81930d76: 'Compra ativada:',
  x_69774c73: 'Copiar endereço',
  x_84f49b2a: 'Manutenção Anual',
  x_1ecf95c4: 'Foto da fatura',
  x_075b05f1: 'Atualizar preço de venda →',
  x_1d447944: 'pegue um pedido',
  x_ae765162: 'Escolha seu plano · USDT TRC-20',
  x_b610fd7a: 'Assinatura Atual',
  x_04a54e6d: '✅ Tudo sincronizado',
  x_f9885395: 'tarefas rejeitadas pelo servidor',
  x_4606c263: '— ⚠️ Essas operações não surtiram efeito! Veja os motivos abaixo: Precisa ser corrigido, reoperado e descartado após a confirmação de que é inútil.',
  x_2395acb4: '🗑️ Descarte todos os que falharam',
  x_8dd7df98: 'Quaisquer modificações que você fizer off-line (adicionar produtos, crédito, inventário, etc.) aparecerão automaticamente aqui e serão carregadas automaticamente quando a rede for restaurada.',
  x_a1ef1534: 'valor em dólares',
  x_70f80ce3: '🎂 Disponível hoje',
  x_5248ea19: 'Um aniversariante!',
  x_49bc061f: 'Cliente:',
  x_e6c8ab7b: 'use este modelo',
  x_115028a6: 'Desejos de aniversário automáticos',
  x_ae8e4235: 'Visualizar hoje',
  x_bb4c3061: 'Envie agora hoje',
  x_f45f7f98: 'Envio em massa de feriados/promoções',
  x_8e4d1d3b: 'Prévia do número de pessoas',
  x_acac71c9: 'Sem conta? Inscreva-se',
  x_b7074575: '← Faça login novamente',
  x_7f8fb4ff: '⚠️ Após o cadastro, você deverá aguardar a aprovação do dono da loja em segundo plano antes de começar a receber pedidos. Seja paciente e espere cerca de 30 minutos.',
  x_1c88cdf2: 'Seu registro foi recebido. Assim que o dono da loja aprovar o pedido, você poderá visualizá-lo e recebê-lo. Geralmente de 5 a 30 minutos, por favor, seja paciente.',
  x_f0d22726: '📋 Disponível para levar',
  x_3d0cf184: '🛵 Entregando',
  x_24eee8a8: '👤 meu',
  x_79646591: 'Não há novos pedidos no momento, aguarde e atualize novamente.',
  x_7957b16f: 'Aceitar',
  x_2f3b0a05: 'Passe',
  x_350d4758: 'Faça o pedido',
  x_edc9f0b4: 'Ainda não há pedidos',
  x_6cb26531: 'Eu peguei o pedido',
  x_26407f6e: 'Iniciar entrega',
  x_285135ae: '✅ Entregue, pagamento concluído',
  x_3f53cc4a: 'Após o registro, o dono da loja deverá aprová-lo antes que você possa aceitar pedidos.',
  x_4a566f8e: 'Navegue com o Google Maps',
  x_e33fe8b5: 'Sair',
  x_52dc2f55: 'Faça login',
  x_d839dff6: 'Verificando IA...',
  x_70654539: 'Você ainda não é membro de nossa loja. Preencha o seguinte formulário',
  x_ae1f9579: 'Cadastre-se gratuitamente e comece a acumular pontos imediatamente para sua próxima compra 🎁',
  x_295a203d: 'Cadastre-se gratuitamente Cadastre-se gratuitamente',
  x_3e869d4a: 'Sem programação esta semana',
  x_c7a3ad5d: 'Conta em dia',
  x_fa9a9ed5: 'Esqueceu sua senha?',
  x_5dac1074: 'Coloque o produto sobre um fundo claro · Melhor tirar fotos com um fundo claro',
  x_b2d24a53: '👇 Escolha qual versão usar',
  x_ab4a66f9: 'Usar originais',
  x_cd32a3bc: 'Tirar foto',
  x_d978ee93: 'Use melhorado ✨',
  x_ad7db97f: 'pegue outro',
  x_757bfeeb: 'Rastreamento',
  x_b01f7e91: 'Buscando o entregador mais próximo... Geralmente 1-3 minutos',
  x_f2dec5f3: 'Atualizações a cada 5 segundos',
  x_c1558ab2: 'Prova',
  x_b426bb47: '⚠️ Esta versão deve ser atualizada para continuar a usá-la',
  x_f26ef914: 'Baixar',
  x_4ddef578: 'Download direto',
  x_2905f1e3: 'Adicionar',
  x_fa8d0ac2: 'Redefinir',
  x_cf5fddcb: '💡 pontos',
  x_4bf93975: '⋮ Toque longo ou o pequeno ícone no canto superior direito:',
  x_1f15f435: 'Mesa: Transfira o pedido desta mesa para o carrinho de compras.',
  x_d432ce48: 'Mostrar $USD',
  x_910a7387: 'Mostrar Bs.',
  x_fdf6f7f6: 'nome de exibição',
  x_37c233bc: 'Especificações da tela',
  x_b8da42c6: 'Código',
  x_eaeef91b: 'rótulos',
  x_288f0c40: 'Excluir',
  x_e429696c: 'Imprimir',
  x_61a0eed9: '🏷️ Criar Aparta',
  x_bcc9eb9f: 'ℹ️ Deduza o estoque imediatamente após a criação e o WhatsApp enviará recibos automaticamente aos clientes',
  x_13b83977: 'Assinatura do cliente',
  x_2fe011c2: 'Contrato de Crédito',
  x_7c82e213: 'O cliente leu e aceita os termos',
  x_ba00b607: 'Avançar',
  x_4d28eb40: '🔄 Atualização',
  x_28a2f60d: '📨 Permitir notificações do WhatsApp (recibos + votos de aniversário)',
  x_5698e78f: 'Entrega antecipada de dinheiro',
  x_c052324e: 'Expiração:',
  x_e56c9982: 'Confirmar pagamento',
  x_386c1cb4: 'Cancelar pedido (restaurar estoque)',
  x_e6a96594: '💡 Este é um “recibo separado” para clientes - o pagamento efetivo será liquidado com base no preço total.',
  x_eb695f9f: 'Tudo enviado',
  x_ba769ad1: '← Voltar',
  x_50d1e443: '⏳O pagamento online está abrindo. Por favor, suba',
  x_9747fec8: 'Após o pagamento, envie a captura de tela para o atendimento ao cliente do WhatsApp → Ative sua conta Sellox em 30 minutos ✅',
  x_d6e0b32d: 'Entre em contato com o atendimento ao cliente para concluir sua compra e ativar sua conta em 30 minutos.',
  x_2070ff11: 'Digitalizar código de barras',
  x_a9cebdd2: 'Aponte o código de barras para a câmera',
  x_0e626263: '💡 Digitalize o código de barras com a pistola de código de barras USB → a caixa de entrada será preenchida automaticamente e entrará automaticamente',
  x_b779b5fc: 'Basta preencher o nome + preço manualmente. Clicar em “Usar este código de barras” preencherá previamente os campos do código de barras e a IA pode ajudá-lo a gerar imagens de produtos.',
  x_1ee3ff57: 'Câmera',
  x_5f78052a: 'Arma de entrada manual/código de barras',
  x_c600be33: 'Variantes Tamanho × Cor',
  x_0c240da9: '⚠️ A geração substituirá as variantes existentes (o tamanho/cor serão migrados automaticamente se os dados do inventário permanecerem inalterados)',
  x_443da31a: 'Etapa 1: insira o tamanho e a cor (use vírgulas',
  x_e0baad05: 'separados), clique em "Gerar" para criar a combinação',
  x_fc14f592: 'Recuperar senha',
  x_2a86dd91: '← Alterar número',
  x_49f38495: 'Faça login',
  x_ffcd6690: 'Alguns recursos (como pagamento offline, instalação de PWA, leitor de código QR, etc.) podem não funcionar. Recomenda-se atualizar para os seguintes navegadores:',
  x_a415f6c2: 'Erro de IU',
  x_d470d3d3: 'A tela falhou. A venda PODE NÃO estar registrada! Clique em Fechar, verifique em «Últimas vendas» e, se não existir, cobre novamente.',
  x_8d2f4bdd: 'Liberar',
  x_5428abef: 'Recarregar',
  x_f1a0be3e: 'Ver histórico/definir limites',
  x_fix_shop_confirm: 'Toque no botão "Confirmar pedido" abaixo',
  x_fix_bosspin_3: '3. Ações de modificação responderão "PIN do chefe necessário".',
  x_fix_profit_warn: ', o cálculo de lucro não é preciso (mostrado como "?").',
  x_fix_intlpay_empty: 'Ainda não adicionado. Toque em "Adicionar" no canto superior direito.',
  x_fix_rider_flow: 'Novo pedido → o sistema escolhe o entregador livre mais próximo → 60 s para confirmar → passa ao próximo se recusar → volta ao "envio manual" só se todos recusarem',
  x_fix_rider_gps: 'O entregador precisa de sinal GPS nos últimos 5 minutos para contar como "online"',
  x_fix_super_outbox: 'Ao tocar em "Enviar" adiciona ao Outbox e abre o WhatsApp; basta tocar na seta ➤.',
  x_fix_pin_lock: '5 tentativas falhas = bloqueio de 15 min',
  x_fix_none: '—',
  x_fix_agotado_tip: '• Se o sistema mostrar "ESGOTADO" mas houver estoque físico → vá para ',
  x_fix_days_remind: 'dias antes de lembrar novamente.',
  x_fix_rider_fee_example: '💡 Ex.: base $1.0 + $0.3/km, 5 km → entrega $1 + $0.3×5 =',
  x_fix_all: 'Todos',
  x_fix_wa_reply_tip: 'Ao receber, responda "relatório" no WhatsApp → a IA responde com dados reais 🎉',
  x_fix_usdt_note: 'Aceita USDT TRC-20 (taxa mínima) · Assinatura estendida automaticamente · 1 mês = 30 dias · Sem KYC',
  x_fix_apk_download: 'Ao tocar em "Baixar" o navegador abrirá para baixar o novo APK',
  x_fix_shift_prefill: '💡 O "valor esperado" já foi preenchido. Edite apenas a linha diferente da contagem real (geralmente dinheiro).',
  x_fix_added_expected: '(adicionado ao "valor esperado")',
  x_fix_usb_scanner_tip: '💡 O leitor USB também usa modo "teclado"',
  x_m0: '',
  x_m1: 'Janeiro',
  x_m2: 'Fevereiro',
  x_m3: 'Março',
  x_m4: 'Abril',
  x_m5: 'Maio',
  x_m6: 'Junho',
  x_m7: 'Julho',
  x_m8: 'Agosto',
  x_m9: 'Setembro',
  x_m10: 'Outubro',
  x_m11: 'Novembro',
  x_m12: 'Dezembro',
  x_fix_all_stores: 'Todas as lojas',
  next: 'próximo',
  priceEdited: 'Preço alterado',
  noProducts: 'Produto não encontrado',
  spec: 'Especificações',
  cedula: 'Cartão de número de identificação',
  goToAdmin: 'Ir ao Painel Admin',
  switchAccount: 'Alterar conta',
  refresh: 'Atualizar',
  addPayment: 'adicionar pagamento',
  editPayment: 'Alterar pagamento',
  transfers: 'Transferir e receber mercadorias.',
  submitting: 'Enviando...',
  marginPercent: 'margem de lucro',
  autoCalcPrice: 'O sistema calcula automaticamente o preço.',
  taxRate: 'taxa de imposto',
  pendingTransfers: 'Ordem de transferência de mercadorias a receber',
  noTransfers: 'Não há ordem de transferência para receber',
  saved: 'farelo',
  scheduleTemplates: 'Modelo de turno',
  new: '+ Novo',
  weeklySalaryEstimate: 'estimativa salarial semanal',
  morningShift: 'amanhã',
  afternoonShift: 'tarde',
  off: 'hugo',
  clickToToggle: 'Clique na grade para percorrê-la',
  noPermission: 'sem permissão',
  invalidPrice: 'Insira um preço válido',
  noNewKitchenItems: '✅ O pedido foi feito (sem placas novas, sem impressas)',
  addCustomerSuccess: 'Cliente adicionado com sucesso',
  quickPriceTooltip: 'Venda rápida: insira diretamente o preço (cigarros/sacos/produtos a granel)',
  quickSell: 'Venda rápida',
  quickSellHint: 'Produtos sem código de barras: cigarros/bolsas/produtos a granel, etc., insira o preço diretamente para adicionar ao carrinho de compras',
  priceInCurrency: 'Preço',
  itemNameOptional: 'nome (opcional)',
  itemNamePlaceholder: 'Por exemplo: Cigarro/Charuto/Saco',
  barcodeNotFound: 'O código de barras não corresponde ao produto.',
  creating: 'Criando...',
  reprintReport: 'Reimprimir o relatório',
  customers: 'Cliente',
  equivalent: 'equivalente',
  summary: 'Resumo',
  orderDetails: 'Detalhes do produto',
  deleteProductWarning: 'Nota: A remoção de produtos afetará todas as filiais!',
  confirmResequence: 'Tem certeza de que deseja recodificar todos os produtos classificados por nome? (01, 02, 03...)',
  labelPaperSize: 'papel de etiqueta',
  salary: 'Salário ($)',
  x_fix_iva_enabled: 'IVA habilitado',
  x_fix_iva_included: 'IVA incluído no preço',
  x_fix_igtf_label: 'IGTF 3% — pagamentos em divisas (USD)',
  x_fix_min_salary_note: 'Salário mínimo vigente conforme o Diário Oficial. Usado no recibo de pagamento mensal.',
  x_fix_404: 'Página não encontrada',
  x_fix_404_home: '← Voltar ao início',
};

const pt = { ...es, ...ptOverrides, bankLedgerMenu: "Contas e Bancos", wholesaleQtyLabel: "Qtd. mínima de atacado",
  // E1_POS_I18N_V1
  pmVerifyTitle: 'Verificar pago',
  pmRefPlaceholder: 'Nº de referencia (mín 4 dígitos)',
  pmRefMin4: 'Mínimo 4 dígitos',
  pmVerifyBtn: 'Verificar',
  pmMustVerify: '🔒 Verificación obligatoria: el pago debe estar confirmado y cubrir el total',
  pmReused: 'Referencia YA USADA',
  pmVerdictOk: 'PAGO CONFIRMADO',
  pmInfoBank: 'Banco',
  pmInfoTime: 'Hora',
  pmInfoFrom: 'De',
  pmInfoRef: 'Referência',
  pmAmountShort: 'Monto menor al total:',
  pmNotFoundTitle: 'NO ENCONTRADO',
  pmNotFound: 'El pago aún no llega. Si el cliente acaba de transferir, espera unos segundos y verifica otra vez.',
  pmMarkPendingBtn: '⚠️ Sin SMS del banco — cobrar como PENDIENTE de verificar',
  pmMarkPendingConfirm: '¿El SMS del banco no llegó? La venta quedará marcada ⚠️ PENDIENTE y el encargado debe verificarla al cerrar el turno.',
  pmPendingToast: '⚠️ Venta marcada PENDIENTE de verificar',
  pmPendingBanner: 'Puedes cobrar; el encargado debe verificar este pago al cerrar el turno.',
  pmBlockToast: 'Verifica el pago o márcalo PENDIENTE primero',
  pvTitle: 'pago(s) PENDIENTE(S) de verificar',
  pvHint: 'El SMS del banco no llegó al cobrar. Verifica si el dinero realmente entró antes de cerrar el turno.',
  pvOk: 'Llegó',
  pvBad: 'No llegó',
  pvBadConfirm: '¿Confirmar que el pago NO llegó? Quedará marcado para reclamar.',
  pvStillNo: '❌ Aún NO aparece',
  sx_cost: 'Custo',
  sx_taxable_base: 'Base Tributável',
  sx_exempt: 'Isento',
  sx_iva: 'IVA',
  sx_total: 'TOTAL',
  sx_gravado_sales: 'Vendas tributadas',
  sx_exento_sales: 'Vendas isentas',
  sx_iva_due: 'IVA a pagar (16%)',
  sx_tax_card_title: 'IVA / Resumo fiscal',
  sx_pkg_title: 'Pacotes de Sessões',
  sx_pkg_new: 'Novo pacote',
  sx_pkg_defs: 'Definição de pacotes',
  sx_pkg_sold: 'Pacotes vendidos',
  sx_pkg_sell: 'Vender ao cliente',
  sx_pkg_redeem: 'Resgatar 1 sessão',
  sx_pkg_left: 'Restam',
  sx_pkg_times: 'sessões',
  sx_pkg_name_hint: 'Nome (ex: Corte x10)',
  sx_pkg_sessions: 'Sessões',
  sx_pkg_price: 'Preço $',
  sx_pkg_days: 'Dias válidos',
  sx_pkg_customer: 'Cliente',
  sx_pkg_paymethod: 'Método de pagamento',
  sx_pkg_confirm: 'Confirmar venda',
  sx_pkg_none: 'Sem pacotes ainda',
  sx_pkg_sold_none: 'Sem pacotes vendidos',
  sx_menu_packages: 'Pacotes de sessões',
  sx_note_no_spicy: 'Sem pimenta',
  sx_note_no_sauce: 'Sem molho',
  sx_note_egg: 'Com ovo',
  sx_note_well_done: 'Bem passado',
  sx_note_less_salt: 'Pouco sal',
  sx_note_no_cheese: 'Sem queijo',
  sx_usd_toggle: '💵 Cobrança em USD',
  sx_usd_off_info: 'O POS ocultará o modo USD; cobrança apenas em Bs (taxa BCV visível como referência)',
  sx_cashea_pct: 'Acréscimo Cashea %',
  sx_cashea_pct_hint: 'Adicionado ao total ao pagar com Cashea (0 = nenhum)',
  sx_variant_pick: 'Escolha a opção (tamanho/cor/sabor)',
  sx_recargo: 'acréscimo',
  sx_customer: 'Cliente',
  sx_subtotal: 'Subtotal (sem IVA)',
  sx_discount: 'Desconto',
  sx_promo: 'Promoção',
  sx_promo_incl: 'já incluída no preço',
  sx_cost_usd: 'Custo $',
  sx_cost_bs: 'Custo Bs',
  sx_profit: 'Lucro',
  sx_sales_summary: 'Resumo de Vendas',
  sx_loading_orders: 'Carregando pedidos, aguarde…',
  sx_loss_alert: 'Com prejuízo',
  sx_stale_alert: 'Preço vencido',
  sx_loss_hint: 'Preço líquido (sem IVA) abaixo do custo',
  sx_stale_hint: 'Bs com taxa antiga ou sem atualizar há +30 dias',
  sx_net_price: 'Líquido sem IVA',
  sx_loss_each: 'Prejuízo c/u',
  sx_current_bs: 'Bs atual',
  sx_expected_bs: 'Bs esperado',
  sx_days_no_update: 'Dias sem atualizar',
  sx_reason_rate: 'taxa antiga',
  sx_reason_old: 'sem atualizar',
  sx_production_date: 'Data de produção',
  sx_expiry_alert: 'A vencer',
  sx_expiry_hint: 'Vence em 30 dias ou já vencido',
  sx_days_left: 'Restam',
  sx_expired: 'Vencido',
  sx_batch_expiry: 'Validade do lote',
  sx_export_products: 'Exportar Excel',
  sx_payment_breakdown: 'Detalhamento de Pagamentos',
  sx_orders_count: 'N° de pedidos',
  sx_items_count: 'Itens',
  sx_total_bs: 'Total Bs',
  sx_cash_usd: 'Dinheiro $',
  sx_cash_bs: 'Dinheiro Bs',
  sx_avg_ticket: 'Ticket médio',
  sx_gravado: 'Tributável',
  sx_exento_short: 'Isento',
  sx_subtotal_short: 'Subtotal',
  sx_tax_total: 'Total imposto',
  sx_pay_total: 'Total a pagar',
  sx_printer_default: 'Impressora padrão',
  sx_fiscal_machine: 'Máquina Fiscal',
  sx_fiscal_already: '🧾 Este pedido já foi fiscalizado — não pode duplicar',
  sx_fiscal_done: 'Fiscalizado',
  sx_fiscal_desktop_only: 'Máquina fiscal disponível apenas no app de desktop (COM)',
  sx_pretax: 'Base',
  sx_customer_display: 'Tela do cliente',
  sx_ws_mode: 'Modo Atacado (B2B)',
  sx_ws_mode_desc: 'Ao ativar: visitantes da loja não veem preços; o cliente deve se registrar e ser aprovado por você. Pedidos por dúzia/fardo.',
  sx_ws_locked: 'Preços visíveis apenas para atacadistas registrados',
  sx_ws_apply: 'Solicitar conta atacadista',
  sx_ws_pending: 'Sua conta atacadista está em análise. Os preços aparecem após a aprovação.',
  sx_ws_pending_badge: 'Aguardando aprovação',
  sx_ws_moq: 'Pedido mínimo',
  sx_ws_moq_hint: 'MOQ padrão (dúzia); a quantidade por fardo do produto tem prioridade',
  wsx_zone: 'Zona Atacado',
  wsx_go_retail: 'Ir à loja varejo',
  wsx_go_mayor: 'Entrada atacado',
  wsx_closed_retail_title: 'Somente atacado',
  wsx_closed_retail_sub: 'A loja varejo está fechada. Entre na zona de atacado.',
  wsx_closed_mayor_title: 'Atacado indisponível',
  wsx_closed_mayor_sub: 'Esta loja ainda não aceita pedidos de atacado. Visite a loja varejo.',
  wsx_tier_ge: '≥{n} pçs',
  wsx_mix_hint: '✨ Sortido: combine estilos até {n} pçs no total para preço de atacado',
  wsx_mix_need: 'Faltam {n} pçs para o mínimo sortido',
  wsx_mix_ok: 'Mínimo sortido alcançado',
  wsx_mix_progress: 'Progresso sortido',
  wsx_vip_badge: 'Preço VIP -{n}%',
  wsx_moq_multi: 'Mínimo {n} pçs, em múltiplos de {n}',
  wsx_moq_min: 'Mínimo {n} pçs',
  wsx_settings_title: 'Loja Atacado Online (B2B)',
  wsx_retail_toggle: 'Loja varejo',
  wsx_ws_toggle: 'Loja atacado (/mayor)',
  wsx_copy_link: 'Copiar link',
  wsx_link_copied: 'Link copiado',
  wsx_default_moq: 'MOQ padrão (pçs)',
  wsx_retail_ws_qty: 'Qtd. atacado loja varejo (global)',
  wsx_retail_ws_qty_hint: '0 = desativado; a qtd. do produto tem prioridade',
  sx_boss_confirm: '✔ Confirmar',
  sx_boss_confirm_ask: 'Confirmar que este pagamento foi verificado?',
  wsx_mix_enable: 'Permitir sortido (combinar estilos)',
  wsx_mix_min: 'Mínimo total sortido (pçs)',
  wsx_vip_pct: 'Desconto extra VIP %',
  wsx_ai_desc: 'O cliente pergunta no WhatsApp "Tem Harina PAN? Quanto custa?" — a IA consulta o estoque, cota, registra a intenção de compra e responde (em espanhol). Cada resposta usa 1 crédito IA.',
  wsx_ai_setup: 'Primeiro conecte o WhatsApp da loja escaneando o QR (cartão verde acima). Quando o cliente confirma, a IA cria um pedido em espera — no caixa pressione F10 para cobrar.',
  wsx_ai_store: 'Loja do pedido (onde os pedidos da IA são salvos)',
  wsx_ai_store_auto: 'Automático (primeira loja)',
  wsx_ai_extra: 'Informações extras da loja (horário / delivery / pagamentos — a IA usará ao responder)',
  wsx_ai_kb: 'Base de conhecimento da IA (FAQ / regras / devoluções / o que NÃO dizer — a IA segue à risca)',
  wsx_ai_kb_ph: 'Ex.\nP: Fazem entrega? R: Grátis em Caracas a partir de $20.\nP: Fiado? R: Só clientes conhecidos com aprovação do dono.\nNão prometer datas; sem descontos; não citar concorrentes.',
  wsx_ai_lead_phone: 'Telefone para leads de parceiros / fornecedores',
  wsx_ai_lead_hint: 'Se escreverem sobre parceria, integração, API ou forem fornecedores, a IA para de vender e encaminha a mensagem a este número',
  wsx_ai_save: 'Salvar info',
  wsx_ai_chats_view: 'Ver conversas IA',
  wsx_ai_chats_hide: 'Ocultar conversas',
  wsx_ai_chats_none: 'Sem conversas IA ainda',
  wsx_ai_msgs: 'msgs',
  wsx_ai_on: 'Ativado',
  wsx_ai_enable: 'Ativar',
  wsx_cr_l1: 'Todos os dias às 9:30 AM os créditos são escaneados e um lembrete de WhatsApp é enviado aos clientes vencidos ou por vencer em 3 dias.',
  wsx_cr_int_pre: 'Cada cliente recebe no máximo 1 lembrete a cada ',
  wsx_cr_int_post: ' dias, sem incômodo repetido. Também pode cobrar manualmente na página /admin/credits.',
  dlv_enforce_max: 'Bloquear pedidos fora do alcance',
  dlv_enforce_max_hint: 'Quando ativado, clientes além da distância máxima não podem pedir (requer compartilhar localização)',
  dlv_map_hint: '🗺️ Mapa de cobertura — clique no mapa para fixar a localização da loja',
  dlv_map_legend_max: 'Alcance máximo de entrega',
  dlv_map_legend_free: 'Frete grátis',
  sh_week_hint: 'Horário por dia (ex. domingo meio período ou fechado); dias sem ajuste usam o horário acima',
  sh_mode_default: 'Horário normal',
  sh_mode_custom: 'Personalizado',
  sh_mode_closed: 'Fechado',
  sh_day_mon: 'Segunda', sh_day_tue: 'Terça', sh_day_wed: 'Quarta', sh_day_thu: 'Quinta', sh_day_fri: 'Sexta', sh_day_sat: 'Sábado', sh_day_sun: 'Domingo',
  pl_mode_p1: 'P1 (Varejo)', pl_mode_p2: 'P2 (Atacado)', pl_mode_p3: 'P3 (Atacadão)',
  pl_mode_p1p2: 'P1 + P2', pl_mode_cashea: 'P1 + Cashea', pl_mode_box: 'P1 + Caixa', pl_mode_p1p2box: 'P1 + P2 + Caixa', pl_mode_p1p3: 'P1 + P3', pl_mode_all: 'Os 3 preços',
  pl_instock: 'Com estoque', pl_all: 'Todos', pl_clear: 'Limpar',
  wsx_save_ok: 'Configuração de atacado salva',
  wsx_tiers_btn: 'Preços escalonados',
  wsx_tiers_title: 'Preços de atacado escalonados',
  wsx_tiers_sub: 'Ex: ≥12 pçs $5.00, ≥48 pçs $4.50, ≥144 pçs $4.00. Vazio = usa preço P2. O primeiro nível define o mínimo do produto.',
  wsx_tier_qty: 'Qtd ≥',
  wsx_tier_price: 'Preço $',
  wsx_tiers_saved: 'Preços escalonados salvos',
  wsx_tier_manage: 'Configurar preços escalonados',
  wsx_search_product: 'Buscar produto para preços escalonados...',
  wsx_catalog_btn: 'Catálogo PDF',
  wsx_catalog_with: 'Com preços (clientes aprovados)',
  wsx_catalog_without: 'Sem preços (captar clientes)',
  wsx_catalog_note: 'Registre-se como atacadista para ver preços e pedir',
  wsx_vip_toggle_on: 'Cliente promovido a VIP atacado',
  wsx_vip_toggle_off: 'VIP desativado',
  wsx_guide_title: '📖 Como usar a loja de atacado? Ver tutorial',
  wsx_guide_1: '1️⃣ Ative "Loja atacado" e compartilhe o link /mayor nos grupos de WhatsApp. Varejo e atacado compartilham produtos e estoque; cada entrada pode ser ativada separadamente.',
  wsx_guide_2: '2️⃣ Padrão "Sem aprovação": o cliente se registra (nome + telefone) e já pode ver preços e pedir — ideal para clientes fiados habituais. Para controlar quem vê preços, desative e aprove manualmente em Clientes.',
  wsx_guide_3: '3️⃣ Configure preços escalonados: mais quantidade = menor preço (ex: 12 pçs $5 / 48 pçs $4.5 / 144 pçs $4). Sem escalões usa o preço P2.',
  wsx_guide_4: '4️⃣ Mínimos: com escalões, o primeiro nível é o mínimo; senão vale a quantidade por caixa ou o MOQ padrão, em múltiplos (12, 24, 36…).',
  wsx_guide_5: '5️⃣ Sortido para clientes pequenos: podem combinar estilos até o total mínimo (ex: 36 pçs) sem mínimo por estilo.',
  wsx_guide_6: '6️⃣ Clientes VIP: ative em Clientes para dar % extra de desconto sobre o atacado.',
  wsx_guide_7: '7️⃣ Gere o catálogo PDF: versão "sem preços" para captar clientes, versão "com preços" para clientes aprovados.',
  wsx_guide_8: '8️⃣ Pedidos entram em "Pedidos Online"; imprima fatura A4 de atacado. Clientes com crédito podem pedir fiado com lembrete automático no WhatsApp.',
  wsx_hot_title: 'Mais vendidos no atacado',
  wsx_hot_sold: '{n} pçs em 7 dias',
  wsx_auto_approve: 'Sem aprovação (registro = ver preços e pedir)',
  wsx_pedido_nopay: 'Pedido sem pagamento (atacado)',
  wsx_pedido_nopay_hint: 'O cliente envia o pedido sem pagar nem reservar estoque; imprima o A5 para separação, o estoque desconta ao confirmar e o detalhe vai ao WhatsApp do cliente',
  wsx_salesman: 'WhatsApp do vendedor (pedidos de atacado enviados automático)',
  wsx_wa_target: 'Número ou ID de grupo WhatsApp',
  wsx_send_with: 'Enviar catálogo com preços',
  wsx_send_without: 'Enviar catálogo sem preços',
  wsx_sent_ok: 'Enviado pelo WhatsApp',
  wsx_send_fail: 'Falha no envio — verifique a conexão do WhatsApp',
  wsx_size_mix: 'Sortido de tamanhos (ex: S*4 M*4 L*4)',
  wsx_statement: 'Extrato de conta',
  wsx_only_left: 'Só restam {n}!',
  wsx_load_groups: 'Carregar grupos do WhatsApp',
  wsx_pick_group: 'Escolher grupo',
  wsx_groups_fail: 'Falha — verifique a conexão do WhatsApp',
  wsx_salesman_multi: 'WhatsApp dos vendedores (vários, separados por vírgula)',
  wsx_sm_title: 'Vendedores & Comissões',
  wsx_sm_enable: 'Ativar comissões',
  wsx_sm_add: 'Adicionar vendedor',
  wsx_sm_name: 'Nome',
  wsx_sm_pct: 'Comissão %',
  wsx_sm_link: 'Link pessoal',
  wsx_sm_customers: 'Clientes',
  wsx_sm_orders: 'Pedidos',
  wsx_sm_sales: 'Vendas $',
  wsx_sm_collected: 'Recebido $',
  wsx_sm_comm_sales: 'Comissão (vendas)',
  wsx_sm_comm_coll: 'Comissão (recebido)',
  wsx_sm_none: 'Sem vendedor',
  wsx_sm_unassigned: 'Pedidos sem vendedor',
  wsx_sm_saved: 'Salvo',
  wsx_sm_hint: '💡 Compartilhe o link pessoal de cada vendedor: clientes registrados pelo link ficam no nome dele (também dá para atribuir manualmente em Clientes). Os pedidos dos clientes dele são enviados só para ele.',
  wsx_wechat_copy: 'WeChat / outros apps:',
  wsx_copy_with: 'Copiar texto com preços',
  wsx_copy_without: 'Copiar texto sem preços',
  wsx_copied: 'Texto copiado — cole no grupo e envie',
  wsx_color_theme: 'Cor da loja online',
  wsx_color_hint: 'Escolha e salve — a cor da loja varejo e atacado muda na hora',
  x_nosalary_prompt: '⚠️ Este funcionário não tem salário configurado, não é possível calcular o desconto automaticamente.\nDigite o valor a descontar ($USD). Cancelar = não registrar dívida:',
  x_nosalary_skipped: 'Nenhuma dívida registrada. Dica: configure o salário do funcionário em «Funcionários» para calcular o desconto por falta automaticamente',
  x_free_label: 'GRÁTIS',
  x_credits_unit: 'créditos',
  ci_btn: 'Lista de embalagem',
  ci_title: 'Importar lista de embalagem (contêiner da China)',
  ci_upload_hint: 'Envie a lista de embalagem do fornecedor (Excel .xlsx ou .csv). O modelo padrão importa direto; formatos irregulares são reconhecidos pela IA.',
  ci_choose_file: 'Escolher arquivo',
  ci_analyzing: 'Analisando...',
  ci_download_template: 'Baixar modelo',
  ci_ai_note: 'Apoio de IA: qualquer formato do fornecedor serve — o sistema reconhece as colunas e você pode corrigir antes de importar.',
  ci_ai_used: '✨ A IA mapeou as colunas — revise e confirme',
  ci_ai_mapped: 'Mapeado pela IA',
  ci_analyze_fail: 'Falha ao analisar o arquivo',
  ci_total_rows: 'Linhas de dados',
  ci_mapping_hint: 'Altere o campo de cada coluna acima',
  ci_f_ignore: '— Ignorar —',
  ci_f_code: 'Código',
  ci_f_name: 'Nome',
  ci_f_barcode: 'Código de barras',
  ci_f_cartons: 'Caixas',
  ci_f_per_box: 'Unid./caixa',
  ci_f_qty: 'Qtd. total',
  ci_f_cost_rmb: 'Custo RMB',
  ci_f_cost_usd: 'Custo USD',
  ci_f_retail_usd: 'Varejo USD',
  ci_f_wholesale_usd: 'Atacado USD',
  ci_f_t1_qty: 'Nível1 mín.',
  ci_f_t1_price: 'Nível1 preço$',
  ci_f_t2_qty: 'Nível2 mín.',
  ci_f_t2_price: 'Nível2 preço$',
  ci_f_t3_qty: 'Nível3 mín.',
  ci_f_t3_price: 'Nível3 preço$',
  ci_f_category: 'Categoria',
  ci_f_spec: 'Especificação/cor',
  ci_rmb_rate: 'Taxa RMB→USD',
  ci_live_rate: 'Taxa ao vivo aplicada',
  rmb_card_title: 'Taxa RMB (ao vivo, automática)',
  rmb_auto_note: 'USD→CNY ao vivo, convertido em Bs via BCV/Binance (atualiza a cada 6h)',
  rmb_refresh: 'Atualizar',
  rmb_unavailable: 'Taxa RMB indisponível no momento',
  rmb_example: 'Exemplo',
  ci_shipping: 'Frete total USD (rateado no custo)',
  ci_warehouse: 'Armazém destino',
  ci_wh_default: 'Armazém padrão',
  ci_dup_mode: 'Códigos existentes',
  ci_mode_add: 'Somar estoque + atualizar preços',
  ci_mode_skip: 'Pular',
  ci_commit: 'Confirmar importação',
  ci_back: 'Enviar novamente',
  ci_commit_fail: 'Falha na importação',
  ci_result_created: 'Produtos criados',
  ci_result_updated: 'Estoque somado',
  ci_result_skipped: 'Pulados',
  ci_result_failed: 'Falhados',
  ci_result_units: 'Unidades recebidas',
  ci_ship_per_unit: 'Frete por unidade',
  ci_po_created: 'Ordem de compra recebida gerada (veja o custo do contêiner em Compras)',
  bi_offer: 'Adicione fotos a este lote — venda na loja online já',
  bi_create_link: 'Gerar link de fotos (celular)',
  bi_link_copied: 'Link copiado — abra no celular para tirar fotos',
  bi_copy: 'Copiar link',
  bi_wa_text: '📸 Link de fotos da mercadoria nova (abrir no celular, IA fundo branco):',
  bi_hint: 'Abra o link no celular e fotografe item por item; a IA coloca fundo branco. Original grátis, versão IA cobra créditos por foto. Válido 7 dias.',
  bi_title: 'Fotos do lote novo',
  bi_done_count: 'com foto',
  bi_take_photo: 'Tirar / escolher foto',
  bi_processing: 'IA processando...',
  bi_use_this: 'Usar esta',
  bi_ai_failed: 'IA falhou — use a original',
  bi_retake: 'Repetir foto',
  bi_cancel: 'Voltar à lista',
  bi_style_whitebg: 'Fundo branco',
  bi_style_poster: 'Pôster e-commerce (IA com textos)',
  ci_done: 'Concluído',
  pt_tier_title: 'Preços de atacado por nível (≥qtd → preço$, salvo com o produto)',
  pt_tier_minqty: 'Qtd',
  pt_tier_price: 'Preço',
  pt_tier_hint: 'Ex.: ≥12 $2.80 / ≥60 $2.50 / ≥120 $2.20. Deixe vazio para não usar níveis.',
  pt_tier_save_fail: 'Falha ao salvar níveis — tente na página Atacado',
  wsx_cp_title: 'Desconto inteligente por pagamento antecipado',
  wsx_cp_slogan: 'Slogan (aparece no extrato do cliente)',
  wsx_cp_slogan_ph: 'Ex.: Pague em 30 dias e ganhe 3% de desconto!',
  wsx_cp_days: 'Prazo de crédito padrão (dias)',
  wsx_cp_tier_days: '≤ dias',
  wsx_cp_tier_pct: 'Desc. %',
  wsx_pronto_hint_1: 'Dívida de',
  wsx_days: 'dias',
  wsx_pronto_receive: 'pague agora só',
  wsx_pronto_save: 'economize',
  wsx_pronto_btn: 'Aplicar desconto pagamento antecipado',
  pu_loading: 'Carregando...',
  pu_done_title: 'Pronto!',
  pu_saved_for: 'Foto salva para',
  pu_close_tab: 'Pode fechar esta aba',
  pu_title: 'Enviar foto do produto',
  pu_code: 'Código',
  wsx_banner: 'Banner da loja (imagem superior da loja online)',
  wsx_banner_upload: 'Enviar imagem do banner',
  aisd_btn: 'Design AI',
  pos_ai_logo_btn: 'Criar logo com IA',
  pos_ai_logo_regen: 'Regenerar logo IA',
  aisd_title: 'Designer AI da loja',
  aisd_kind_banner: 'Banner da loja',
  aisd_kind_logo: 'Logo da loja',
  aisd_style: 'Estilo',
  aisd_color_synced: 'Color de la tienda sincronizado con el banner',
  aisd_ref_hint: 'opcional',
  aisd_ref_upload: 'Sube un banner que te guste y la IA copiará su estilo',
  aisd_ref_active: 'Se imitará el estilo de la referencia (con tu nombre y contacto)',
  aisd_style_supermercado: '🛒 Súper Latino',
  aisd_style_modern: 'Moderno',
  aisd_style_anime: '🎌 Anime',
  aisd_style_tech: '⚡ Tecnológico',
  aisd_style_3d: '🧊 3D',
  aisd_style_warm: 'Acolhedor',
  aisd_style_luxury: 'Luxo',
  aisd_style_promo: 'Promoção',
  aisd_style_minimal: 'Minimalista',
  aisd_style_festive: 'Festivo',
  aisd_desc: 'Descrição extra (opcional)',
  aisd_desc_ph: 'Ex: vendo frutas e verduras, quero estilo promocional vermelho',
  aisd_generate: 'Gerar',
  aisd_generating: 'Gerando…',
  aisd_regen: 'Gerar de novo',
  aisd_apply: 'Aplicar à loja',
  aisd_applied: 'Aplicado à sua loja!',
  aisd_cost: 'Custo',
  aisd_credits: 'créditos',
  aisd_balance: 'Saldo',
  aisd_no_credits: 'Créditos AI insuficientes — recarregue em ✨Créditos AI',
  aisd_failed: 'Falha ao gerar — créditos devolvidos, tente de novo',
  aisd_wait_hint: 'Leva 30-90 segundos, não feche a janela',
  shopslug_label: 'URL personalizada da loja',
  shopslug_hint: '3-30 caracteres: letras minúsculas, números e hífens. O link antigo continua funcionando.',
  shopslug_save: 'Salvar URL',
  shopslug_saved: 'URL salva!',
  shopslug_invalid: 'Nome inválido ou já em uso',
  poster_btn: 'Pôster AI',
  poster_title: 'Pôster promocional AI',
  poster_select_hint: 'Marque 1-6 produtos e a AI monta um pôster promocional',
  poster_max6: 'Máximo 6 produtos',
  poster_promo_label: 'Frase promocional (opcional)',
  poster_promo_ph: 'Ex: Mega oferta de fim de semana! Só 3 dias',
  poster_sent: 'Pôster enviado ao WhatsApp:',
  poster_phone_ph: 'Telefone (vazio = número do chefe)',
  poster_wa_hint: 'Chega no seu WhatsApp — reencaminhe aos grupos de clientes',
  poster_download: 'Baixar imagem do pôster',
  hb_toggle: 'Banner festivo automático',
  hb_hint: '5 dias antes do Natal, Black Friday, etc., a AI gera um banner festivo (16 créditos) e manda no WhatsApp para aplicar com 1 clique',
  hb_enabled: 'Banner festivo automático ativado',
  hb_disabled: 'Banner festivo automático desativado',
  gb_title: '🔥 Compra em Grupo',
  payqr_upload: '📷 Enviar QR de cobrança',
  pk_menu: '📦 Expedição',
  vd_menu: '🧳 Vendedores',
  vendedor: 'Vendedor',
  payqr_change: '📷 Trocar QR',
  aiverify_label: '🤖 IA lê capturas de pagamento automaticamente',
  aiverify_hint: 'Ao desativar, os comprovantes vão para revisão manual (sem gastar créditos de IA): o cliente informa a referência + envia captura, você confirma',
  sdc_btn: '🎉 Cartão promo',
  sdc_download: '📥 Baixar imagem',
  sdc_share: 'Compartilhar no WhatsApp',
  sdc_hint: 'Baixe a imagem e publique no seu status do WhatsApp ou envie aos clientes',
  gb_intro: 'Estilo Pinduoduo: defina preço de grupo + tamanho. O cliente inicia um grupo, compartilha no WhatsApp, e os pedidos são criados ao completar. Expira em 24h.',
  gb_enabled: 'Ativado',
  gb_disabled: 'Desativado (clique para ativar)',
  gb_on: 'Compra em grupo ativada!',
  gb_off: 'Compra em grupo desativada',
  gb_add_product: 'Adicionar produto de grupo',
  gb_search_ph: 'Buscar produto por nome/código',
  gb_price: 'Preço de grupo',
  gb_size: 'Pessoas',
  gb_saved: 'Produto de grupo salvo!',
  gb_configured: 'Produtos com compra em grupo',
  gb_none: 'Sem produtos ainda — busque acima para adicionar',
  gb_groups: 'Grupos',
  gb_no_groups: 'Ainda não há grupos iniciados',
  gb_st_completed: 'Completado',
  gb_st_open: 'Em andamento',
  gb_st_expired: 'Expirado',

  wsx_banner_removed: 'Banner removido',
  sx_fiscal_copy_ok: 'Cópia impressa (a nota fiscal já foi emitida; a cópia não tem valor fiscal)',
  sx_last_cost: 'Última compra',
  sx_ocr_menu: 'Escanear fatura (AI)',
  sx_cost_up: 'Subiu vs última compra',
  sx_cheaper_sup: 'Fornecedor mais barato',
  sx_shrink_menu: 'Perdas e Quebras',
  sx_shrink_title: 'Relatório de Perdas e Quebras',
  sx_shrink_sub: 'Diferenças de contagem + quebras declaradas — perdas invisíveis em números claros',
  sx_shrink_stk_loss: 'Faltante (contagem)',
  sx_shrink_declared: 'Quebras declaradas',
  sx_shrink_gain: 'Sobra (contagem)',
  sx_shrink_total: 'Perda total',
  sx_shrink_top: 'Top produtos com perda (por valor)',
  sx_shrink_times: 'Vezes',
  sx_shrink_qty: 'Qtd. faltante',
  sx_shrink_value: 'Perda $',
  sx_shrink_no_data: 'Sem perdas registradas neste período 🎉',
  sx_shrink_wh: 'Armazém',
  sx_shrink_events: 'Detalhe de eventos',
  sx_shrink_source_stk: 'Contagem',
  sx_shrink_source_loss: 'Quebra',
  sx_resq_title: '⚠️ Reordenar códigos — ação perigosa',
  sx_resq_body: 'Isto mudará TODOS os códigos de produtos para 01, 02, 03… por ordem de nome. Os códigos atuais serão substituídos! (O sistema guarda um respaldo automático)',
  sx_resq_type_hint: 'Para continuar, escreva abaixo',
  sx_resq_go: 'Reordenar agora',
  sx_exit_system: 'Sair do sistema',
  sx_ocr2_cur_q: 'Em que moeda estão os preços desta fatura?',
  sx_ocr2_usd: 'Dólares USD',
  sx_ocr2_bs: 'Bolívares Bs',
  sx_ocr2_rate: 'Taxa (Bs ÷ taxa = $)',
  sx_ocr2_rate_hint: 'Os preços em Bs são divididos pela taxa e salvos em USD (prioridade: sua taxa, depois a taxa impressa na fatura)',
  sx_ocr2_usd_hint: 'Se a fatura tem colunas $ e Bs, a IA lê SOMENTE a coluna $; preço por caixa é dividido pelas unidades automaticamente',
  sx_ocr2_rate_req: 'Informe a taxa primeiro',
  sx_ocr2_src_user: 'taxa manual',
  sx_ocr2_src_invoice: 'taxa da fatura',
  sx_ocr2_src_system: 'taxa do sistema',
  sx_ocr2_box_conv: 'Conversão caixa',
  sx_ocr2_units: 'und',
  sx_ocr2_pick: '🔍 Buscar e escolher produto…',
  sx_ocr2_no_pick: 'marcado como correspondência mas sem produto escolhido',
  pm_wait_bank: '⏳ Aguardando aviso do banco (pode levar 1-2 min)…',
  overpay_label: 'Cobrado a mais',
  overpay_return_by: 'Devolver por',
  overpay_cash: '💵 Dinheiro',
  overpay_transfer: '🏦 Transferência',
  overpay_cash_hint: 'Descontado do caixa do operador',
  overpay_transfer_hint: 'Não afeta o dinheiro do caixa',
  aisd_ref_banner: '🖼️ Banner de referência',
  aisd_style_gold3d: 'Ouro 3D',
  aisd_style_mascota: 'Mascote 3D',
  aisd_style_emblema: 'Emblema',
  aisd_style_neon: 'Neon',
  pay_where_transfer: '📍 Onde aparece: checkout da loja online → conta que o cliente vê ao escolher "Transferência" (conta única antiga; prefira a lista "Contas de Recebimento" abaixo, permite várias)',
  pay_where_pm: '📍 Onde aparece: checkout da loja online → dados que o cliente vê ao escolher "Pago Móvil" (conta única antiga; prefira a lista abaixo)',
  pay_where_wa: '📍 Onde aparece: checkout da loja online → o cliente pode pedir pelo WhatsApp para este número',
  pay_where_cashea: '📍 Onde aparece: checkout da loja online → opção de parcelas Cashea',
  pm_edit_auth_action: 'Editar o pagamento requer autorização do gerente (escanear QR ou senha)',
  dlv_charge_customer: 'Cliente paga a entrega',
  dlv_charge_customer_hint: 'Quando ativado, a loja online cobra a entrega no checkout (taxa base + $/km × distância)',
  dlv_free_over: 'Frete GRÁTIS a partir de (US$)',
  dlv_free_over_hint: 'Quando o subtotal do pedido atinge este valor, o frete é grátis; 0 = desativado',
  dlv_free_km: 'Frete GRÁTIS dentro de (km)',
  dlv_free_km_hint: 'Se o cliente estiver a esta distância ou menos da loja, o frete é grátis; 0 = desativado (requer localização do cliente)',
  dlv_banner_toggle: 'Mostrar banner de frete grátis na loja',
  dlv_banner_hint: 'Mostra um banner "Frete GRÁTIS a partir de $X" acima dos produtos',
  oe_edit_auth_action: 'Editar o pedido requer autorização do gerente (escanear QR ou senha)',
  oe_edit_note: 'Editar o pedido ajusta o estoque e fica auditado',
  wa_channel_title: 'Canal de envio',
  wa_channel_platform_title: 'Número da plataforma Sellox (recomendado para lojas novas)',
  wa_channel_platform_desc: 'Sem escanear QR — recibos e avisos saem do número oficial da Sellox com nota "não responder"',
  wa_channel_own_title: 'Seu próprio número (escanear QR abaixo)',
  wa_channel_own_desc: 'Os clientes veem SEU número e podem responder (vendedor IA disponível)',
  wa_channel_meta_title: 'API oficial da Meta (nunca bloqueado)',
  wa_channel_meta_desc: 'Conecte sua própria conta Meta Business — guia passo a passo incluído',
  wa_channel_configure: 'Configurar →',
  wa_channel_on: '✅ Canal plataforma ativado',
  wa_channel_off: '✅ Usando seu próprio número',
  wa_relay_usage_month: '📊 Este mês: {n} mensagens enviadas',
  qs_assigned: 'Atribuído',
  qs_paid: 'Pago',
  qs_due: 'Total',
  qs_hint: '💡 Digite o valor em cada método, 2+ caixas = pagamento dividido',
  qs_missing: 'Falta',
  qs_change: 'Troco',
  x_4ea2dc0c: 'No Safari toque Compartilhar → Adicionar à Tela de Início',
  x_b3f1742d: 'Menu do navegador ⋮ → Adicionar à tela / Instalar app',
  x_c6b0ecc1: 'PROFORMA',
  x_b43540a2: 'Documento de referência — não fiscal. Sujeito a confirmação de estoque.',
  x_d2a5f47d: 'Fora do horário, pedidos pausados. Horário',
  x_79da6318: 'Falha ao criar pedido',
  x_a7387278: 'Meus pedidos',
  x_0134ef91: 'Instalar no celular',
  x_e655a410: 'Instalar',
  x_9f68a807: 'Pontos',
  x_c6a7617b: 'Preço de atacado a partir de 12 un.',
  x_db3c3f79: 'Frete grátis no primeiro pedido!',
  x_92254b8d: 'Oferta em grupo',
  x_1cb0067b: '✨ Novo',
  x_262a5f78: '💥 Oferta',
  x_9789ea3d: 'Esgotado',
  x_7c114133: 'Atacado',
  x_fe0e8bf7: 'Cadastrar',
  x_c5f36f1e: 'Tipo de cadastro',
  x_a634b186: 'Atacadista',
  x_33809226: 'Cliente varejo',
  x_1b21e28e: 'Nome da loja',
  x_abbe4bb4: 'Data de nascimento',
  x_fccc2b4a: 'Janeiro',
  x_c1d13f1d: 'Fevereiro',
  x_c4767bc3: 'Março',
  x_3eaf4b30: 'Abril',
  x_0545f138: 'Maio',
  x_f2422a6e: 'Junho',
  x_464bab7f: 'Julho',
  x_81017142: 'Agosto',
  x_4b592d5e: 'Setembro',
  x_f544c399: 'Outubro',
  x_57c44755: 'Novembro',
  x_c0615eb3: 'Dezembro',
  x_e42b99d5: 'Mês',
  x_465260fe: 'Ano',
  x_a65be661: 'Telefone ou documento',
  x_ab735ef3: 'Clientes da loja podem entrar com telefone ou documento',
  x_5f57ab2b: 'Selecione a data de nascimento completa',
  x_18d9ac63: 'Bem-vindo de volta!',
  x_c94c6645: 'Cadastro concluído!',
  x_c91539c5: 'Você já é cliente! Crie uma senha no primeiro acesso; pontos e histórico são mantidos',
  x_bc490ac9: 'Sem conta? Cadastre-se',
  x_89438cb2: 'Meus pontos',
  x_70c5388d: 'Crédito pendente',
  x_99b7dc82: 'Prazo',
  x_f7013966: '-- Selecione o banco --',
  x_b00a4f4e: 'Frete grátis',
  x_abd7f31c: 'Área de entrega limitada, compartilhe sua localização acima',
  x_df4e7845: 'Compra em grupo',
  x_e77dadaf: 'Pessoas por grupo',
  x_96b165fe: 'Este grupo terminou — abra um novo',
  x_a49dc062: 'Selecione o método de pagamento',
  x_0d6fd032: 'Informe a referência do pagamento (mín. 4 dígitos)',
  x_0025409e: '🎉 Grupo completo! Pedido criado',
  x_934a013a: 'Ocorreu um erro, tente novamente',
  x_918d2e43: 'Grupos em andamento — participe!',
  x_cece7904: 'clientes',
  x_4d99b1b3: 'Entrar →',
  x_7be5df87: '🚀 Criar meu grupo',
  x_02c280bb: 'Seu nome',
  x_a0b92ea7: 'Seu telefone (WhatsApp)',
  x_630a2d4f: '💳 Pague agora para garantir a vaga',
  x_e3648a5b: '📲 Escaneie com o app do banco',
  x_bc7dbf60: 'Referência do pagamento *',
  x_78fbb3b8: 'A loja verifica o pagamento. Reembolso se o grupo não completar em 24h.',
  x_fbf44f79: '💬 Ao completar, combine o pagamento pelo WhatsApp com a loja.',
  x_661f0360: '✅ Entrar no grupo',
  x_a392ec03: '🚀 Criar grupo',
  x_9c401b86: 'Compartilhe o link — pedido confirma automático ao completar. Válido 24h.',
  x_1d7b443a: 'Compartilhar no WhatsApp',
  x_4b7d6310: 'Link copiado',
  x_02b52fdf: 'Grupo completo!',
  x_375ec885: 'OK',
  x_0b4f1582: 'SENIAT - Centro de Controle Fiscal',
  x_a2a6e3a5: 'Gestão fiscal · Relatórios Z/X · Exportar · Auditoria',
  x_466ef11d: 'Relatório X',
  x_aecc6c50: 'Relatório Z (fechamento)',
  x_52f43ce8: 'Contadores',
  x_685de23a: 'Exportar SENIAT',
  x_a722bf43: 'Registro de auditoria',
  x_18f25f32: 'Verificar numeração',
  x_917b67ce: 'Gerar relatório X',
  x_3fca2d1d: 'Gerar relatório Z (fechamento)',
  x_4d020ba3: 'Gerando...',
  x_2a9ce745: 'Relatório Z = fechamento fiscal do dia, gerado uma vez ao fechar.',
  x_6ca3821a: '⚠️ No navegador: a impressora fiscal só funciona no app desktop',
  x_4823e2b3: '📅 Reimprimir cópia Z por data — memória fiscal',
  x_1b1964c7: 'Reimprime a cópia legal do Z salvo de uma data. Não gera novo Z nem altera dados — aceito pelo SENIAT.',
  x_d3955f6a: 'Imprimir na máquina fiscal',
  x_0ef2525d: '⚠️ Somente no app desktop (impressora fiscal)',
  x_a8be906b: 'Nenhum relatório Z gerado ainda',
  x_ade95bda: 'Vendas de hoje',
  x_f4f5a946: 'transações',
  x_ee1689c9: 'IVA cobrado',
  x_52f7f49a: 'Vendas isentas',
  x_f2a378e9: 'Anuladas',
  x_983f27e7: 'Vendas líquidas',
  x_d3c85a4d: 'Nº fatura',
  x_d3a4a490: 'Nº controle',
  x_6cced836: 'Detalhe IVA',
  x_b294fbbf: 'Base tributável',
  x_2bb46698: 'Sem contadores ainda. Criados na primeira venda faturada.',
  x_f74759c0: 'Contador de Nº de controle',
  x_353cab9e: 'Contador de Nº de fatura',
  x_4c9bb426: 'Prefixo',
  x_ca8f0b14: 'Número atual',
  x_f2c71b78: 'Exportar dados fiscais (SENIAT)',
  x_b44c0f33: 'Data inicial',
  x_1d468be9: 'Data final',
  x_55405ea6: 'Exportar',
  x_aa03f534: 'CSV: separado por «;», compatível Excel/SENIAT',
  x_7a5bbc5b: 'TXT: texto separado por | para sistemas SENIAT',
  x_725b5a3e: 'JSON: formato estruturado para integrações API',
  x_1fd02a90: 'Usuário',
  x_79c05840: 'Sem registros de auditoria',
  x_5839aebb: 'Dados de auditoria guardados 10 anos conforme SENIAT.',
  x_43c011c1: 'Verificar numeração',
  x_0410cb00: 'Verificando...',
  x_bc5b83bc: 'Sem datas = verificar tudo. Autoverificação interna.',
  x_7974ad56: '✅ Numeração completa',
  x_8dc2b6cc: '⚠️ Problemas encontrados',
  x_19616fb8: 'faturas · faixa',
  x_9a136985: 'Saltos (números faltando)',
  x_a656f3be: 'Números duplicados',
  x_c258e133: 'Fora de ordem cronológica',
  x_5da53c3a: 'Registro offline / anuladas',
  x_af5eba6e: 'Detalhe de saltos (números faltando)',
  x_d8066277: 'Números de controle duplicados',
  x_351f1da9: 'Faturas fora de ordem cronológica',
  x_8ce24893: 'Gerar relatório Z? Fecha o dia fiscal, uma vez ao dia. Confirmar?',
  x_87d27264: '⚠️ Somente no app desktop',
  x_66823aa3: 'Atribuído a',
  x_89a92538: 'Publicado, entregadores podem pegar',
  x_d02627fe: '✅ Configurações de notificação salvas',
  x_6af47376: '✅ Pedido atualizado',
  x_d3cb9a21: '✅ Faturamento concluído',
  x_cdbe0c92: 'Cancelar este pedido? Estoque liberado, entrega cancelada',
  x_32ff009c: '✅ Pedido cancelado',
  x_a769cdc2: 'Excluir definitivamente? Libera o estoque reservado, irreversível',
  x_2716e6a7: 'Excluir definitivamente este registro? Irreversível',
  x_cbb7bf56: '🗑 Excluído definitivamente',
  x_00e41368: 'Informe a quantidade a devolver',
  x_96c48fd4: '✅ Troca concluída, cobrar do cliente',
  x_7ef40e73: '✅ Devolução concluída, estoque atualizado',
  x_44c198c1: 'Reembolso',
  x_f36ecce3: 'Notificação de novos pedidos',
  x_359ff4db: 'Número WhatsApp para avisos (vazio = não enviar)',
  x_b7656e18: 'Toque',
  x_0d9c291a: 'Suave',
  x_1fdac4c2: 'Forte',
  x_95b9408f: 'Anunciar valor por voz',
  x_f4a35245: 'Testar',
  x_f62dea70: 'Quais contas tocam (nenhuma = todas)',
  x_2026e292: 'PC toca e anuncia por voz o valor do pedido',
  x_2dad819e: 'Reembolsado total',
  x_f67d89db: 'Reembolso parcial',
  x_bc3583b5: 'Faturar',
  x_4efd6a13: 'Enviar ao entregador',
  x_cbfc5ba6: 'Sem estoque: ajuste a qtd, 0 remove o item',
  x_855fb7e2: 'Total confirmado',
  x_d613b1b4: 'Ao confirmar: baixa estoque + crédito ao cliente + comissão ao vendedor',
  x_b59c07ff: '✅ Confirmar faturamento',
  x_897dbdee: 'Editar pedido',
  x_7650487a: 'Endereço',
  x_d2dd7e1c: 'Sem estoque: ajuste a qtd, 0 remove o item',
  x_d99e3dbb: 'Novo total (sem frete)',
  x_926c613a: '⚠️ Pedido já pago, acerte a diferença com o cliente',
  x_84693468: '💾 Salvar alterações',
  x_b163cb6a: 'Devolução de pedido',
  x_a9275c2e: 'Padrão devolve tudo; ajuste para parcial (0 = manter)',
  x_2f656a74: 'Devolvido',
  x_4178e0b6: 'Método de reembolso',
  x_976f94a1: 'Motivo (opcional)',
  x_fd3108f0: 'Ex: produto danificado',
  x_cf55227f: 'Troca (opcional) — outro produto, diferença automática',
  x_33bda28d: 'Buscar produto de troca...',
  x_9854a54a: 'Valor da devolução',
  x_51811a84: 'Valor da troca',
  x_2718ce26: 'Devolver ao cliente',
  x_d1903e50: 'Cliente deve pagar',
  x_1830fefb: 'Ao confirmar: estoque entra + troca sai + registro + aviso WhatsApp',
  x_54945fc4: '✅ Confirmar troca/devolução',
  x_6be8ae78: '✅ Confirmar devolução',
  x_1817ed2a: 'Atribuir a entregador',
  x_dc2c3193: 'Sem entregadores verificados. Registro em sellox.shop/rider.',
  x_727df9ee: 'Publicar para pegarem (sem atribuir)',
  x_c29ce6fd: 'Dinheiro $',
  x_58ef5787: 'Rascunho limpo',
  x_129fe574: 'Nº fatura fornecedor:',
  x_2959bd81: '✅ Rascunho automático diário ativado (7:00)',
  x_e6a85d28: 'Rascunho automático desativado',
  x_a2a843ad: 'Sem produtos populares para repor',
  x_513d596e: '✅ Rascunho confirmado como compra',
  x_0c456ca5: 'Excluir este rascunho?',
  x_9b19d9c6: '⚠️ Selecione um depósito primeiro',
  x_20b73ca7: '💾 Compra salva offline, envia ao voltar a rede',
  x_1922f043: '💾 Recebimento salvo offline, envia ao voltar a rede',
  x_31d1f953: '📋 Produto copiado, mude só nome e código de barras',
  x_673942b6: 'Código de barras já existe',
  x_47e03fd1: 'Código já em uso',
  x_b0007365: 'Sem fornecedor',
  x_e24ce335: 'Rascunho auto: ON',
  x_9cfd9afd: 'Rascunho auto: OFF',
  x_31416882: 'Gerar rascunho agora',
  x_719fb446: 'Buscar fornecedor ou vendedor...',
  x_4091474b: '📝 Rascunho',
  x_d7291e52: 'Moeda do documento',
  x_2ced248f: 'Copiar como novo (mude só nome e código)',
  x_e21626f3: '🗑 Limpar rascunho',
  x_64457c62: 'Clique para mudar categoria',
  x_00ca7c29: 'Sem categoria · clique para definir',
  x_df6d0757: 'un/caixa',
  x_64d9ef93: 'Margem',
  x_9e4dbf03: 'Valor Bs',
  x_77449ea5: 'Taxa (Bs/$)',
  x_5e496273: 'Digite Bs, converte a USD pela taxa do dia (editável)',
  x_be85dc34: 'Referência / Nº operação',
  x_0edbdf53: 'Referência de transferência, confirmação Zelle…',
  x_8f8b954f: 'Ex: dinheiro ao vendedor Juan, sinal parcial…',
  x_f8580966: 'Comprovante de pagamento',
  x_be6f0f22: 'Foto / enviar comprovante',
  x_aa24f2e1: 'Imagem muito grande (máx 8MB)',
  x_94171ce2: 'Comprovante',
  x_3e440694: 'Este código já está em uso',
  x_be607248: 'Este código de barras já existe',
  x_515c0b7e: 'Mudar depósito do documento? Estoque recebido é movido',
  x_15816bc7: 'Mudar o depósito deste documento?',
  x_0e344978: 'Bancos e Caixa',
  x_5bb78d8a: 'Transferir entre contas',
  x_228d2bab: 'Nova conta',
  x_3b186bad: 'Sem contas. Crie contas e os recebimentos entram automáticos.',
  x_6095e59c: 'Movimentos',
  x_348e534e: 'Nº doc / nota',
  x_09e1d043: 'Sem movimentos',
  x_6f484666: 'Editar conta',
  x_f3f18020: 'Nome (ex. BNC principal / Caixa USD)',
  x_f430b947: 'Banco (opcional)',
  x_4d72cab9: 'Últimos 4 dígitos (opcional)',
  x_de35ac7b: 'Saldo inicial',
  x_1f0fca13: 'Métodos de pagamento vinculados',
  x_68e9a989: 'Nota (opcional)',
  x_3e25b5d4: 'Conta origem',
  x_e83fca1c: 'Conta destino',
  x_33ed7cfa: 'Valor a enviar',
  x_30f229d9: 'Valor recebido',
  x_26050b04: 'Confirmar transferência',
  x_9e268a5d: 'Informe o nome',
  x_db8ac4f2: 'Valor inválido',
  x_4ab08f52: 'Registrado',
  x_51e7ba4a: 'Transferência registrada',
  x_3524c978: 'Exportar extrato',
  x_be123473: 'Exportar extrato (Excel/PDF)',
  x_81909158: 'Mês',
  x_37cb3781: 'Resumo',
  x_32f2f705: 'Resumo de fundos',
  x_026d5880: 'Inicial',
  x_361ffa7f: 'Entradas',
  x_37cc0a9a: 'Saídas',
  x_b39409ce: 'Líquido',
  x_d6080990: 'Final',
  x_79ceb63f: 'Caixa da loja',
  x_936cf2c9: 'Aprovações',
  x_5a97be8a: 'Aprovação de valores altos',
  x_6fded8ab: 'Ativar aprovação (acima do limite pede PIN)',
  x_a54fc320: 'Limite USD $ (0 = sem)',
  x_807af4c1: 'Limite Bs (0 = sem)',
  x_c0e9bd0c: 'Novo PIN de 6 dígitos (vazio = manter)',
  x_47217200: 'PIN atual (para alterar)',
  x_9ccb14f1: 'Configurações de aprovação salvas',
  x_d9d6d5ba: '🔐 Requer aprovação do chefe',
  x_be9d2bc1: 'Valor acima do limite, digite o PIN',
  x_0e1667c5: 'PIN de 6 dígitos',
  x_9cc24820: 'PIN incorreto',
  x_b8e32288: 'PIN bloqueado, tente em 15 minutos',
  x_7116e7ec: 'Conta',
  x_e3dea388: 'Sem dados neste período',
  x_767d5ae4: 'Turno não fechado recuperado',
  x_b231f6b0: 'Turno de hoje recuperado, continue',
  x_d5ff526d: 'Há um turno anterior aberto, feche-o antes',
  x_42d9293a: '30 dias',
  x_94903830: '60 dias',
  x_dc491dae: '90 dias',
  x_cba8c4ef: 'Permita janelas pop-up',
  x_6f2838fe: 'Informe o preço',
  x_32a79f1b: 'Produtos parados',
  x_ed320806: 'Mais vendidos',
  x_9e3d9f77: 'Produtos com estoque',
  x_862dacd0: 'Custo parado sem vendas',
  x_70ac9021: 'Custo total do estoque',
  x_966a2e61: 'Meses de estoque',
  x_460e109d: 'Custo parado',
  x_993a1358: 'Última venda',
  x_7098d682: 'Liquidar',
  x_d81bb206: 'Nunca',
  x_0dc5dc88: 'Grupo',
  x_28183523: '💥 Definir preço de liquidação',
  x_baed7f26: '🔥 Liquidar por compra em grupo',
  x_f9c82b80: 'Oferta ativa (etiqueta online + preço POS sincronizado)',
  x_6edc3851: 'Imprimir etiquetas de oferta',
  x_23a605c4: 'Preço oferta (USD) — padrão -15%',
  x_3576efc7: 'Preço de grupo (USD)',
  x_ec798f44: 'Pessoas para completar (2-5)',
  x_3907665a: 'Duração da oferta (preço volta ao expirar)',
  x_d716067e: '7 dias',
  x_d9926871: '15 dias',
  x_853f8cf7: '30 dias',
  x_544cb8d3: 'Muda o preço 1 e adiciona etiqueta OFERTA online',
  x_6ff9fab3: 'Ativa compra em grupo para este produto',
  x_15af542a: '🔒 Informação fiscal administrada pelo provedor. Mudanças: contate o provedor.',
  x_6e0df37b: '🧾 Numeração de faturas',
  x_12923f27: '✅ Numeração ativa',
  x_9aa9020f: '⬜ Desativada (clique para ativar)',
  x_99a06c43: 'Prefixo',
  x_453340fc: 'Dígitos',
  x_f45ac04c: 'Próximo Nº',
  x_02f02875: 'Ao ativar, cada pedido confirmado recebe número consecutivo na fatura.',
  x_eea9deb9: 'Logo da loja (para impressão ou avatar)',
  x_8c57e455: 'Enviar logo',
  x_456885ba: 'Baixar logo',
  x_967d445b: '🕐 Horário de pedidos online',
  x_8a0bbf6e: 'Hora da Venezuela; fora do horário pedidos pausam; POS não é afetado',
  x_2086719a: 'Voltar ao Preço 1 após cada leitura',
  x_b9f9fade: 'Moeda no ticket',
  x_d30839fd: 'Somente Bolívares',
  x_99f08c08: 'Somente Dólares',
  x_75bffa13: 'Bs + $',
  x_09d4c026: '🧑‍💼 Painel do Gerente',
  x_41ebcf52: 'Funções desligadas não aparecem ao gerente',
  x_a2e95088: 'Resumo do dia',
  x_1ae34829: 'Estoque e produtos',
  x_eb479750: 'Inventariar',
  x_e7926cff: 'Despesas',
  x_75e361e0: 'Ganho cambial',
  x_1a7665ae: 'Dinheiro em caixa',
  x_9a127288: 'Contas de funcionários',
  x_d7a96cba: 'Horário',
  x_9ac5ab89: 'Créditos',
  x_c1f80f9b: 'Adicionar produto',
  x_0735fcbc: 'Transferências',
  x_2ff230cf: '📊 Análise de visitantes',
  x_677d39e2: 'Quem visita sua loja, o que vê e compra',
  x_49ea343c: 'Online agora',
  x_36331e50: 'Visitantes hoje',
  x_63568477: 'Visualizações hoje',
  x_f2a70aa0: 'Pedidos hoje',
  x_43798078: 'Tendência de visitantes',
  x_c527743c: 'Conversão em pedido',
  x_852da3f7: 'Visitantes',
  x_88bc4d7a: 'Visualizações',
  x_dd2a2f3b: '🔥 Produtos populares (carrinho)',
  x_f2581824: 'Sem dados — conta quando adicionam ao carrinho',
  x_4f15720f: 'Dispositivos',
  x_e855972e: 'PC',
  x_c77c44eb: 'Sem visitantes — compartilhe o link da loja',
  x_c864ee0a: '14 dias',
  x_fdfd62e8: 'Cadastros hoje',
  x_bd83f3a1: '🛒 Funil de compra',
  x_3c5c43e5: 'Ao carrinho',
  x_423da4b1: 'Pedidos',
  x_6e3a0666: 'vezes no carrinho',
  x_72df3158: '📝 Novos clientes',
  x_1818467a: 'Sem novos cadastros no período',
  x_61dd3548: '👀 Visitantes recentes',
  x_44761c5f: 'Visitante anônimo',
  x_ff6e1828: 'Sem registros de visitas',
  x_e9ac9962: 'visualizações',
  x_381fb5ef: '🔔 Alerta de pico de visitas',
  x_3836004f: 'Aviso WhatsApp quando muitos online — aproveite promoções',
  x_468a206b: 'Online ≥',
  x_60051ff7: 'Número de aviso (vazio = o de pedidos)',
  x_0c18a538: 'Mínimo 60 min entre avisos',
  x_add9c8bf: '⚖️ Trabalhista LOTTT',
  x_a09fe96e: '🧾 Fiscal SENIAT',
  x_e9f30aae: '🏢 Mercantil',
  x_3dcf62b4: 'Pergunte qualquer coisa, por exemplo:',
  x_50a1215a: 'Quanto pagar ao demitir funcionário com 3 anos?',
  x_c9e9a906: 'Como calcular horas extras?',
  x_eb3853bc: '"Quanto ao demitir com 3 anos?" · "Cestaticket atual?"',
  x_b08d2eca: '⚖️ IA consultando a lei…',
  x_323d361d: 'Escreva sua consulta…',
  x_74221fd8: 'Limpar conversa',
  x_2aad6aeb: 'Selecione um funcionário',
  x_842bd876: 'Funcionário',
  x_f48c1e0f: 'De',
  x_0a50a227: 'Até',
  x_60197011: 'IA calculando…',
  x_9945bf6c: 'Folha mensal com IA',
  x_98a98282: 'IA lê dados reais e gera folha conforme LOTTT.',
  x_010a3d9c: '⚖️ IA verificando LOTTT e calculando… (20-40s)',
  x_b7014d64: 'LOTTT · SENIAT · mercantil — IA cita artigos e gera folhas',
  x_1a1d2d4e: 'Saldo de créditos AI',
  x_88426c86: 'Pergunta 1 crédito · Folha 3 créditos',
  x_10d691fd: '💰 Folha AI',
  x_c228ed55: '⏳ Pendente de envio',
  x_95a03b22: '✅ Duplicada - provavelmente já cobrada',
  x_b60c2cbc: '❌ Sem estoque - NÃO registrada',
  x_9ed2da59: '❌ Rejeitada pelo servidor - NÃO registrada',
  x_9c8b638d: 'Nada para sincronizar',
  x_59c10673: 'Fila de sincronização',
  x_963d2f9c: 'Tudo sincronizado, nada pendente',
  x_422e18f2: 'Excluída',
  x_6b1192c7: 'Excluir',
};

Object.assign(pt, {
  refCommNav: '💵 Comissões de Indicação',
  refCommTitle: 'Comissões de Indicação',
  refCommDesc: 'Quando um comércio indicado faz o primeiro pagamento, quem indicou ganha uma comissão em dinheiro (única vez)',
  refCommEnabled: 'Ativar comissões em dinheiro',
  refCommRate: 'Percentual de comissão (%)',
  refCommSave: 'Salvar',
  refCommSettingsSaved: 'Configuração de comissões salva',
  refCommPendingTotal: 'Comissões a pagar',
  refCommPaidTotal: 'Comissões pagas',
  refCommPendingCount: 'pendentes',
  refCommRecords: 'Registros de comissões',
  refCommReferrer: 'Quem indicou',
  refCommReferred: 'Novo comércio',
  refCommAmountPaid: 'Pagamento do cliente',
  refCommAmount: 'Comissão',
  refCommStatus: 'Status',
  refCommPending: 'A pagar',
  refCommPaid: 'Paga',
  refCommCancelled: 'Cancelada',
  refCommMarkPaid: 'Marcar paga',
  refCommPayMethod: 'Método de pagamento',
  refCommPayRef: 'Referência / nota',
  refCommConfirmPay: 'Confirmar pagamento',
  refCommCancelRec: 'Cancelar',
  refCommManualAdd: 'Adicionar comissão manual',
  refCommSelectTenant: 'Selecionar comércio indicado',
  refCommNoEligible: 'Nenhum comércio elegível (deve registrar-se com código de indicação e não ter comissão anterior)',
  refCommNoRecords: 'Sem registros de comissões',
  refCommDate: 'Data',
  refCommClose: 'Fechar',
  refCommMyEarnings: 'Minhas Comissões em Dinheiro',
  refCommPendingBalance: 'A receber',
  refCommReceived: 'Recebido',
  refCommEarnRule: 'Quando um novo cliente se registra com seu código e faz o primeiro pagamento, você ganha {rate}% desse pagamento em dinheiro',
  refCommPayoutNote: '💰 A plataforma paga via Pago Móvil / Zelle / Binance',
  refCommCreatedToast: 'Comissão registrada',
  renewAmountPaid: 'Valor recebido (USD)',
  renewAmountPaidHint: 'Opcional · para registro de pagamento e comissão de indicação',
  renewReferredHint: 'Este comércio se registrou com código de indicação — o primeiro pagamento gerará uma comissão',
  refPosterBtn: 'Cartaz',
  refPosterTitle: 'Cartaz para Compartilhar',
  refPosterDownload: 'Baixar cartaz',
  refPosterDownloaded: 'Cartaz baixado — compartilhe no WhatsApp!',
  refPosterHint: 'Baixe a imagem ou toque em WhatsApp para compartilhar seu link de indicação',
  refProgramNav: '🎁 Indique e Ganhe · Plataforma Sellox',
  refHow2Desc: 'Seu amigo se registra de teste com seu código (ainda sem comissão)',
  refHow3Title: 'Pagou = você ganha',
  refHow3Desc: 'Só quando ele pagar de verdade, você ganha {rate}% do pagamento em dinheiro',
  refStatUses: 'Comércios indicados',
  refStatEarned: 'Comissões acumuladas',
  duTitle: 'Pagamento Direto USDT (Binance)',
  duZeroFee: 'Sem taxas',
  duDesc: 'Envie USDT (TRC20) direto para o endereço da plataforma, cole o TxID e ative na hora. Para transferências internas da Binance use revisão por captura.',
  duBuyLifetime: 'Ativar plano (inclui 1º ano de serviço; depois taxa anual)',
  duMaintenance: 'Renovar manutenção anual',
  duMaintenance12m: 'Manutenção anual · 12 meses',
  duExpiry: 'Vence',
  duCredits: 'Recarregar créditos AI',
  duStep1: 'Passo 1: Envie este valor exato para o endereço (somente rede TRC20)',
  duStep2: 'Passo 2: Cole o hash da transação (TxID) — verificado na blockchain e ativado na hora',
  duTxidPlaceholder: 'Cole o hash de 64 caracteres…',
  duVerifyBtn: 'Verificar e Ativar',
  duPasteTxid: 'Cole o TxID por favor',
  duNetworkWarn: 'Use somente a rede TRC20 (TRON) — rede errada = fundos perdidos!',
  duBinanceInternal: 'Transferência interna da Binance (sem TxID)?',
  duUploadScreenshot: 'Enviar captura para revisão',
  duMyOrders: 'Minhas ordens de pagamento',
  duStPending: 'Pendente',
  duStReview: 'Em revisão',
  duStConfirmed: 'Ativado',
  duStRejected: 'Rejeitado',
  duNav: '💰 Pagamentos USDT Diretos',
  duAdminTitle: 'Ordens de Pagamento USDT Direto',
  duAll: 'Todos',
  duTenant: 'Comércio',
  duUseCase: 'Propósito',
  duApprove: 'Aprovar',
  duRejectNote: 'Motivo da rejeição (opcional)',
  duScreenshot: 'Captura do pagamento',
  duYearFee: 'serviço 1º ano',
  mainSupplier: 'Fornecedor principal (reabastecimento agrupa pedidos por ele)',
  noSupplier: '— Não definido —',
  priceCompare: 'Comparação de fornecedores (histórico de compras, mais barato primeiro)',
  posRejTitle: 'PEDIDO REJEITADO',
  posRejLine1: 'Este pedido NÃO foi salvo! Não aparecerá no sistema',
  posRejLine2: 'NÃO entregue o troco nem a mercadoria ainda!',
  posRejLine3: 'O carrinho continua aí: corrija o problema e cobre de novo',
  posSaveFailTitle: 'NÃO FOI POSSÍVEL SALVAR!',
  posSaveFailLine1: 'O servidor não responde e este aparelho também não conseguiu guardar o pedido',
  posSaveFailLine2: 'Tire foto ou anote o número e o valor acima, avise o chefe',
  posSaveFailLine3: 'NÃO feche esta página! Quando a internet voltar, cobre de novo',
  posShiftWarnTitle: 'Turno iniciado offline',
  posShiftWarnLine1: 'O turno ficou salvo neste aparelho, pode continuar vendendo',
  posShiftWarnLine2: 'Se a internet não voltar, avise o chefe',
  supBasicInfo: 'Informações básicas',
  supExtraInfo: 'Informações adicionais',
  supCategory: 'Categoria',
  supAddCategory: 'Adicionar categoria',
  supTaxId: 'CNPJ / RIF',
  supCurrency: 'Moeda de pagamento',
  supTerms: 'Prazo de pagamento (dias)',
  supEmail: 'E-mail',
  supPostal: 'Código postal',
  supBankName: 'Banco',
  supBankAccount: 'Conta bancária',
  supCarrier: 'Transportadora padrão',
  supCountry: 'País',
  supState: 'Estado',
  supCity: 'Cidade',
  supNotes: 'Notas',
  supAutoGen: 'Gerado automaticamente se vazio',
  supDupName: '⚠️ Este fornecedor já existe',
  supDupCode: '⚠️ Este código já está em uso',
  supSearch: 'Buscar fornecedor por nome/código…',
  supNoMatch: 'Nenhum fornecedor encontrado',
  posAlertSoundTitle: 'Som de alerta POS',
  posAlertSoundHint: 'Toca quando aparece o alerta vermelho (clique para testar)',
  soundBuzzer: 'Buzina (padrão)',
  soundBeep: 'Bip',
  soundChime: 'Sino',
  posSaleSoundTitle: 'Som de venda concluída',
  posSaleSoundHint: 'Toca após cada venda concluída (clique para testar)',
  saleSoundDing: 'Ding',
  saleSoundCash: 'Caixa registradora',
  saleSoundOk: 'Duplo OK',
  pmVoiceTitle: 'Voz ao verificar Pago Móvil / Transferência',
  pmVoiceHint: 'Anuncia o resultado da verificação no caixa: confirmado / com observação / não encontrado',
  pmVoiceShort: 'Só «Pago Móvil confirmado»',
  pmVoiceAmount: '«Confirmado» + valor em Bs',
  soundSiren: 'Sirene',
  soundOff: 'Mudo',
  invLedger: 'Movimentos de estoque',
  ledgerSale: 'Venda',
  ledgerReturn: 'Devolução',
  ledgerPurchase: 'Compra',
  ledgerAdjust: 'Ajuste',
  ledgerLoss: 'Perda',
  ledgerTransfer: 'Transferência',
  ledgerCreate: 'Produto criado',
  ledgerDelete: 'Produto excluído',
  ledgerAllProducts: 'Todos os produtos (criados/excluídos/ajustes)',
  ledgerNoData: 'Sem movimentos no período',
  ledgerCurStock: 'Estoque atual',
  posNoLastOrder: 'Ainda não há recibo para reimprimir (faça uma venda primeiro)',
  posOk: 'ENTENDI',
  verNewWeb: '🆕 Nova versão',
  verClickReload: 'clique para atualizar',
  cat_pdf_btn: 'Catálogo PDF',
  cat_pdf_title: 'Exportar catálogo PDF por categoria',
  cat_pdf_hint: 'Catálogo horizontal com fotos grandes, ideal para grupos de WhatsApp. Preços iguais à loja atacadista.',
  cat_pdf_select_all: 'Todas',
  cat_pdf_clear: 'Nenhuma',
  cat_pdf_hide_inactive: 'Ocultar produtos inativos',
  cat_pdf_hide_oos: 'Ocultar produtos sem estoque',
  cat_pdf_show_prices: 'Mostrar preços',
  cat_pdf_generate: 'Gerar PDF',
  cat_pdf_generating: 'Gerando… (10–30 s com muitas fotos)',
  cat_pdf_done: 'PDF gerado',
  cat_pdf_empty: 'As categorias selecionadas não têm produtos',
  cat_pdf_pick: 'Selecione pelo menos uma categoria',
  cat_pdf_color: 'Cor do catálogo',
  cat_pdf_color_custom: 'Cor personalizada',
  wsx_sm_qr: 'QR da loja',
  wsx_sm_qr_hint: 'O cliente escaneia e entra na loja atacadista; os pedidos ficam em nome deste vendedor.',
  bulto: 'Fardo',
  bultoBoxes: 'Caixas por fardo',
  bultoPrice: 'Preço do fardo',
  bultoHint: 'Fardo = embalagem grande com várias caixas. 0 = sem fardo.',
  bultos: 'fardos',
  wsx_moq_mode: 'Pedido mínimo',
  wsx_moq_mode_box: 'Caixa fechada (múltiplos de caixa)',
  wsx_moq_mode_unit: 'Por unidade (desde 1, botão +1 caixa)',
  wsx_moq_mode_hint: 'Se a sua unidade mínima já é um pacote/caixa, escolha «Por unidade».',
  cat_pdf_products: 'produtos',
  cat_pdf_uncat: 'sem categoria (fora do PDF)',
  cat_pdf_uncat_hint: 'Atribua categoria em Produtos para aparecerem',
  x_svc_staff_pick: 'Quem fez?…',
  x_svc_not_found: 'serviço não encontrado, adicione manualmente',
});

export default pt;
